import React, { useState, useEffect, useRef } from "react";
import MaterialEstimator from "./MaterialEstimator";
import { uploadToS3, getViewUrl, getEmailUrl, extractS3Key } from "./s3";
const JOB_TYPES = ["Solar PV","Battery / ESS","MPU (Panel Upgrade)","Electrical","Service / Repair"];
const MPU_SERVICE_TYPES = ["Underground","Overhead"];
const MPU_EXISTING = ["100A","125A","150A","200A","Other"];
const MPU_NEW = ["100A","125A","200A","225A / 200A Main","225A / 225A Main","400A","Other"];
const ELECTRICAL_TYPES = ["Complete Rewire","Service Upgrade","EV Charger","Dedicated Circuit","Troubleshooting","Home Addition","Subpanel","Other"];
const SERVICE_REPAIR_TYPES = ["Roof Leak Investigation","Stucco Repair","AFCI / GFCI Issue","Electrical Correction","Production Investigation","Line Transfer","Other"];
const ESP_ADDERS = [
  {category:"PV Installation",label:"PV Install",unit:"Per Panel",rate:165,type:"per_panel"},
  {category:"Adders",label:"Attic Conduit Run",unit:"Per Project",rate:250,type:"flat"},
  {category:"Adders",label:"Critter Guard Package",unit:"Per Foot",rate:1.5,type:"per_unit"},
  {category:"Adders",label:"Directory Placards",unit:"Per Project",rate:35,type:"flat"},
  {category:"Adders",label:"Multiple Arrays (>3)",unit:"Per Project",rate:350,type:"flat"},
  {category:"Adders",label:"Removal / Reinstall — PV",unit:"Per Unit",rate:400,type:"per_unit"},
  {category:"Adders",label:"System Size Adder (<13 Panels)",unit:"Per Project",rate:350,type:"flat"},
  {category:"Adders",label:"Trenching — Soil (No Concrete)",unit:"Per Foot",rate:75,type:"per_unit"},
  {category:"Electrical",label:"D-Rate Main",unit:"Per Project",rate:150,type:"flat"},
  {category:"Electrical",label:"EV Charger",unit:"Per Project",rate:500,type:"flat"},
  {category:"Electrical",label:"MPU - Flush - Stucco Repair",unit:"Per Project",rate:2000,type:"flat"},
  {category:"Electrical",label:"Sub Panel Swap",unit:"Per Project",rate:550,type:"flat"},
  {category:"Roof Adder",label:"Flat Roof",unit:"Per Panel",rate:20,type:"per_panel"},
  {category:"Roof Adder",label:"Metal Roof",unit:"Per Panel",rate:20,type:"per_panel"},
  {category:"Roof Adder",label:"Steep Roof",unit:"Per Panel",rate:30,type:"per_panel"},
  {category:"Roof Adder",label:"Tile Roof",unit:"Per Panel",rate:15,type:"per_panel"},
  {category:"Service",label:"Travel (>100 Miles)",unit:"Per Project",rate:250,type:"flat"},
  {category:"Service",label:"Truck Roll — Customer Request",unit:"Per Project",rate:325,type:"flat"},
  {category:"Service",label:"Travel outside 200 Miles",unit:"Per Project",rate:500,type:"flat"},
  {category:"Service",label:"Truck Roll — No Sub-Type",unit:"Per Project",rate:500,type:"flat"},
];
const ESP_BATTERY = [
  {label:"Battery w/ PV — Self Consumption (up to 20kWh)",rate:650},
  {label:"Additional 10kWh Battery (Self Consumption)",rate:325},
  {label:"Battery w/ PV — Partial Home Backup (up to 20kWh)",rate:2000},
  {label:"Additional 10kWh Battery (Partial Backup)",rate:500},
  {label:"Battery w/ PV — Whole Home Backup (up to 20kWh)",rate:2000},
  {label:"Additional 10kWh Battery (Whole Home)",rate:500},
  {label:"Whole Home Backup w/ Tesla Backup Switch (up to 27kWh)",rate:750},
  {label:"Whole Home Backup w/ Enphase Meter Collar (up to 20kWh)",rate:1000},
  {label:"Equipment >15 of MSP",rate:750},
  {label:"Subpanel >15 of BUI",rate:750},
  {label:"Heat Detectors (if required in garage)",rate:500},
];



function NavIcon({ name }) {
  const icons = {
    jobs: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
    pipeline: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
    customers: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    epc: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>,
    subcontractors: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
    reminders: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
    workorders: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
    reports: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
    invoices: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="7" y1="16" x2="12" y2="16"/></svg>,
  };
  return icons[name] || null;
}

// ─── SuntrifyLogo SVG component (dark/light mode aware, transparent background) ──
function SuntrifyLogo({ darkMode = false, height, width, iconOnly = false, style = {} }) {
  const navy  = darkMode ? "#ffffff" : "#01233F";
  const orange = "#E78200";
  const vbW = iconOnly ? 168 : 1330;
  const vbH = 200;
  const ratio = vbW / vbH;
  const h = height || (width ? width / ratio : 28);
  const w = width  || h * ratio;
  return (
    <svg viewBox={`22 17 ${vbW} ${vbH}`} width={w} height={h}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", shapeRendering: "geometricPrecision", flexShrink: 0, ...style }}>
      {/* orange dots */}
      <path fill={orange} d="M82.2,95.4c4.4-3.5,10.4-1.8,13.2,3.8c2.8,5.7,1.6,13.2-2.9,16.7c-2.9,2.3-6.7,2.5-9.7,0.5l0,0c-1.4-0.9-2.7-2.5-3.5-4.1C76.5,106.5,77.8,99.1,82.2,95.4z M75.1,147.7c-1.7,0-3.3-0.5-4.6-1.4c-3-2.1-5.1-6.1-5.1-10.5c0-3.2,0.8-6.2,2.7-8.7c1.8-2.3,4.1-3.8,6.8-3.8c5.1-0.1,9.7,5.3,9.8,11.9C84.5,142,80.3,147.5,75.1,147.7z M84.8,176.2c-4.6-3.2-6.4-10.5-3.9-16.3c2.5-5.8,8.2-8.2,13-4.9c4.6,3.2,6.4,10.5,3.9,16.3C95.3,177.1,89.5,179.3,84.8,176.2z M110.6,114.9c-4.6-3.2-6.4-10.5-3.9-16.3c2.5-5.8,8.2-8.2,13-4.9c4.6,3.2,6.4,10.5,3.9,16.3C121,115.9,115.2,118.2,110.6,114.9z M122.2,174.3c-2.9,2.3-6.7,2.5-9.7,0.5c-1.4-0.9-2.7-2.5-3.5-4.1c-1.4-2.7-1.8-6.1-1.2-9.1c0.6-3.2,1.9-5.8,4.2-7.6c4.2-3.5,10.4-1.8,13.2,3.8C127.9,163.1,126.6,170.7,122.2,174.3z M136.5,142.4c-1.8,2.3-4.2,3.8-6.8,3.8c-1.7,0-3.3-0.4-4.6-1.4c-3-2.1-5.1-6.1-5.1-10.5c0-3.2,0.8-6.2,2.7-8.7c1.8-2.3,4.2-3.8,6.8-3.8c5.1-0.1,9.7,5.3,9.8,11.9C139.2,137,138.2,140.1,136.5,142.4z"/>
      {/* rings */}
      <path fill={navy} d="M97.6,17c-15.3,0.4-27.5,16.3-27.3,35.8c0.2,19.4,13,34.8,28.2,34.6c15.2-0.3,27.5-16.3,27.3-35.8C125.7,32.2,112.9,16.6,97.6,17z M98.5,70.9c-8.1,0.1-14.9-8-15-18.4s6.4-18.9,14.4-19c8.1-0.1,14.9,8,15,18.5C113,62.2,106.6,70.8,98.5,70.9z"/>
      <path fill={navy} d="M169.5,146.4c-13.1-8.9-30.7-2.1-37.7,14.3c-3.5,8.4-4.4,17.7-2.1,26.7c2.1,9.1,6.9,16.3,13.3,20.9c4.2,2.9,8.8,4.3,13.6,4.3c9.9-0.1,19.3-7.3,24-18.5C188,177.1,183,155.8,169.5,146.4z M169.4,186.3c-3.8,8.7-13.1,12.4-20.1,7.6c-3.5-2.3-6.1-6.3-7.2-11.3c-1.1-4.8-0.7-10,1.1-14.3c2.5-5.8,7.4-9.8,12.7-9.8c2.5,0,5.1,0.6,7.3,2.3C170.6,165.7,173.4,177.1,169.4,186.3z"/>
      <path fill={navy} d="M34.6,146.9c-6.4,4.8-10.9,12.3-12.7,21.4s-0.8,18.5,2.8,26.7c5.1,11.1,14.4,17.6,24.5,17.5c4.7-0.1,9.4-1.8,13.5-4.8c6.4-4.8,10.9-12.3,12.7-21.4s0.8-18.5-2.8-26.7C65.3,143.4,47.5,137.5,34.6,146.9z M63.1,182.1c-1,4.8-3.4,8.9-6.9,11.4c-2.3,1.6-4.6,2.5-7.2,2.5c-5.3,0.1-10.4-3.4-13.1-9.2c-1.9-4.3-2.5-9.5-1.6-14.3c1-4.8,3.4-8.9,6.9-11.4c2.1-1.6,4.6-2.5,7.2-2.5c5.3-0.1,10.4,3.4,13.1,9.2C63.5,172.2,64.1,177.3,63.1,182.1z"/>
      {/* wordmark */}
      {!iconOnly && <path fill={navy} d="M265.1,113.3h20c8.1,0,15,0.5,20.6,1.6c5.8,0.8,10.5,2.4,14.5,4.2c3.9,1.8,7,4.2,9.4,7.1c2.3,2.9,4.2,5.9,5.4,9.5c1.2,3.5,2.1,7.5,2.5,11.9c0.5,4.3,0.6,9.3,0.6,14.3l0,0c0,5.1-0.2,9.9-0.9,14.6c-0.6,4.3-1.8,8.7-3.3,12.4c-1.7,3.7-3.8,7.1-6.6,9.9s-6.4,5.5-10.7,7.5c-4.3,1.9-9.4,3.5-15.6,4.7c-6.1,1.1-13.1,1.6-21.2,1.6l0,0h-19.5c-7.4,0-13.7-0.5-19.3-1.3c-5.5-0.8-10.2-1.9-14.2-3.7c-3.9-1.6-7.2-3.7-9.8-6.1c-2.6-2.4-4.8-5.5-6.3-8.8c-1.5-3.4-2.6-7.2-3.2-11.7c-0.6-4.3-0.9-9.3-0.9-14.6l0,0h14.7c0,6.6,0.6,11.7,2,15.4c1.3,3.7,3.6,6.6,6.6,8.3c3.1,1.9,7,3,12,3.5c4.9,0.5,11.2,0.6,18.5,0.6l0,0h19.5c8.6,0,15.6-0.6,21.2-1.8c5.6-1.1,10.1-3,13.5-5.5c3.3-2.6,5.6-5.9,7-10.1c1.3-4.2,2-9.3,2-15.2l0,0c0-5.9-0.5-10.7-1.3-14.8s-2.7-7.1-5.5-9.5c-2.7-2.4-6.7-4-11.6-5.1c-5-0.8-11.6-1.6-19.7-1.6l0,0h-20.1c-8.8,0-16.7-0.5-22.9-1.3c-6.3-0.8-11.8-2.4-16.1-4.2c-4.3-1.8-7.8-4-10.4-6.6c-2.6-2.6-4.5-5.8-6-9.3c-1.3-3.5-2.3-7.2-2.6-11.4c-0.5-4.2-0.6-8.8-0.6-13.6l0,0c0-5.1,0.2-9.9,0.9-14.3s1.8-8.3,3.6-11.9s4.2-6.9,7-9.5c3.1-2.9,6.9-5.1,11.6-7.1c4.8-1.8,10.4-3.4,16.9-4.2c6.6-0.8,14.3-1.3,23.4-1.3l0,0h14.7c7.4,0,13.7,0.5,19.3,1.1s10.2,1.9,14.2,3.5c3.9,1.6,7.2,3.7,9.9,6.1c2.6,2.4,4.8,5.3,6.3,8.8c1.5,3.4,2.6,7.2,3.2,11.7c0.6,4.3,0.9,9,0.9,14.3l0,0h-14.7c0-6.6-0.6-11.7-2-15.4c-1.3-3.7-3.6-6.6-6.6-8.3c-3.1-1.9-7-3-12-3.5c-5-0.5-11.2-0.6-18.5-0.6l0,0H270c-9.8,0-17.7,0.5-24.2,1.6c-6.3,0.8-11.3,2.6-15,5.1c-3.7,2.4-6.3,5.5-7.6,9.5c-1.3,4-2.1,8.8-2.1,14.8l0,0c0,3.7,0.1,6.9,0.5,9.6c0.2,2.9,1.1,5.3,2.1,7.5c1,2.2,2.6,4,4.5,5.5s4.5,2.6,7.8,3.5c3.3,1,7.2,1.6,11.9,1.9C253,113.2,258.5,113.3,265.1,113.3L265.1,113.3z M484.4,39.5h14.7v84.4c0,9.9-0.1,18.9-0.2,27.3c-0.1,8.2-0.7,15.7-1.7,22c-0.9,6.6-2.6,12.2-4.8,17c-2.2,4.8-5.2,8.8-9.2,12.2c-3.9,3-9,5.5-15.1,7.1c-6.1,1.6-13.6,2.4-22.6,2.4l0,0h-34.2c-9,0-16.6-0.8-22.6-2.4c-6.1-1.6-11.2-4-15.1-7.1c-3.9-3.4-7-7.2-9.2-12.2c-2.1-4.8-3.7-10.6-4.8-17c-0.9-6.6-1.5-14-1.7-22c-0.1-8.2-0.2-17.2-0.2-27.3l0,0V39.5h14.7v84.4c0,10.6,0,19.6,0.1,27.1c0.1,7.5,0.6,14,1.2,19.3c0.7,5.3,1.8,9.3,3.3,12.5c1.5,3,3.8,5.5,6.7,7.2s6.6,2.9,11,3.4c4.4,0.6,9.9,0.8,16.6,0.8l0,0h34.2c6.4,0,11.9-0.2,16.3-0.8c4.4-0.5,8.1-1.8,11-3.4c2.9-1.8,5-4.2,6.7-7.2c1.5-3,2.7-7.2,3.6-12.5c0.7-5.3,1.1-11.7,1.2-19.3c0.1-7.5,0.1-16.7,0.1-27.1l0,0V39.5H484.4z M538.2,57.2v151.3h-14.7V39.5h25.6l107.2,147.8V39.5H671v168.9h-19.5L538.2,57.2z M695.3,39.5H827v17.6h-58.5v151.3h-14.7V57.2h-58.5V39.5L695.3,39.5z M985.3,176.9v31.6h-14.5v-31.8c0-5.1,0-9.5-0.1-13.2c-0.1-3.7-0.6-6.9-1.2-9.5c-0.7-2.6-1.8-4.8-3.6-6.4c-1.5-1.6-3.8-2.9-6.7-3.7c-2.9-0.8-6.6-1.6-11-1.8c-4.4-0.2-9.9-0.5-16.3-0.5l0,0h-65.7v66.7h-14.7V39.5H934c8.8,0,16.6,0.5,22.6,1.3c6.1,0.8,11.2,2.2,15.1,4.2c3.9,1.8,7,4.2,9.2,6.9c2.2,2.7,3.7,5.9,4.8,9.5c0.9,3.7,1.5,7.7,1.7,12.4c0.2,4.7,0.2,9.5,0.2,14.9l0,0c0,7.1-0.2,13.2-1.1,18.5c-0.6,5.3-1.8,9.9-3.6,13.6s-3.8,6.9-6.4,9c-2.7,2.2-6.1,3.7-10.1,4.7l0,0c4.2,0.8,7.4,2.4,9.8,4.7s4.3,5.1,5.6,8.7s2.1,7.7,2.6,12.5C985.2,165.2,985.3,170.8,985.3,176.9L985.3,176.9z M866.1,57.2v66.7h68.1c6.6,0,11.9-0.2,16.3-0.5c4.4-0.2,8.1-0.8,11-1.8c2.9-0.8,5.2-2.2,6.7-3.7c1.6-1.4,2.7-3.7,3.6-6.4c0.7-2.6,1.2-5.8,1.2-9.5c0.1-3.7,0.1-8.2,0.1-13.2l0,0c0-4.8,0-8.8-0.1-12.4c-0.1-3.5-0.6-6.4-1.2-8.7c-0.7-2.4-1.8-4.2-3.6-5.5c-1.5-1.3-3.8-2.4-6.7-3.4c-2.9-0.8-6.6-1.3-11-1.6c-4.4-0.2-9.9-0.5-16.3-0.5l0,0L866.1,57.2L866.1,57.2z M1012.3,208.5V39.5h14.7v168.9L1012.3,208.5L1012.3,208.5z M1070.8,208.5H1056V39.5h112.1v17.6h-97.5v56.2h92.6V131h-92.6v77.5H1070.8z M1248.7,138.1l-65.8-98.5h19.5l53.6,82.6l53.6-82.6h19.5l-65.8,98.5v70.3h-14.7v-70.3H1248.7z"/>}
    </svg>
  );
}


// ─── Email ────────────────────────────────────────────────────────────────
const SES_TO  = ["jchacon@suntrify.com", "xchacon@suntrify.com"];
// WhatsApp notifications via CallMeBot (deliberate exception to AWS-only:
// SNS SMS requires 10DLC/toll-free registration + fees)
const WA_PHONE  = "19518662828";
const WA_APIKEY = "2899847";

async function sendWOSMS(wo) {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (isLocal) {
    console.log("[DEV] SMS suppressed on localhost.");
    return;
  }
  try {
    const types = (wo.types || []).slice(0, 2).join(", ") || "Work Order";
    const baseAddr = wo.address || "";
    const addr  = (wo.zip && baseAddr.includes(wo.zip))
      ? baseAddr
      : [baseAddr, wo.city, [wo.state, wo.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    const time  = wo.time ? ` @ ${wo.time}` : "";
    const crew  = wo.crew ? `%0ACrew: ${wo.crew}` : "";
    const msg   = encodeURIComponent(
      `New WO ${wo.woId || ""}\n` +
      `${wo.customerName || "Customer"}\n` +
      `${addr}\n` +
      `${types} | ${wo.date || ""}${time}`
    ) + crew;
    await fetch(`https://api.callmebot.com/whatsapp.php?phone=${WA_PHONE}&text=${msg}&apikey=${WA_APIKEY}`);
  } catch(e) {
    console.error("WhatsApp notification error:", e);
  }
}

function buildAddr(o) {
  const addr = o.address || "";
  const city = o.city || "";
  if (city && addr.includes(city)) return addr;
  return [addr, city, o.state, o.zip].filter(Boolean).join(", ");
}

function buildWONotes(wo) {
  const parts = [];
  if (wo.notes) parts.push(wo.notes);
  if (wo.electricalNotes) parts.push("Electrical: " + wo.electricalNotes);
  if (wo.serviceNotes) parts.push("Service: " + wo.serviceNotes);
  if (wo.inspectionResult && wo.inspectionResult !== "-- Select --") parts.push("Inspection Result: " + wo.inspectionResult);
  if (wo.inspectionNotes) parts.push("Inspection Notes: " + wo.inspectionNotes);
  if (wo.mpuServiceType && wo.mpuServiceType !== "-- Select --") {
    const m = ["MPU: " + wo.mpuServiceType];
    if (wo.mpuExisting && wo.mpuExisting !== "-- Select --") m.push(wo.mpuExisting + " -> " + (wo.mpuNew && wo.mpuNew !== "-- Select --" ? wo.mpuNew : "?"));
    if (wo.mpuMeterSpot && wo.mpuMeterSpot !== "-- Select --") m.push("Meter: " + wo.mpuMeterSpot);
    if (wo.mpuDisconnect && wo.mpuDisconnect !== "-- Select --") m.push("Disconnect: " + wo.mpuDisconnect);
    if (wo.mpuLathResult) m.push("Lath: " + wo.mpuLathResult + (wo.mpuLathNotes ? " - " + wo.mpuLathNotes : ""));
    if (wo.mpuRoughResult) m.push("Rough: " + wo.mpuRoughResult + (wo.mpuRoughNotes ? " - " + wo.mpuRoughNotes : ""));
    parts.push(m.join(", "));
  }
  if (wo.solarPanels) {
    const s = ["Solar: " + wo.solarPanels + " panels"];
    if (wo.systemKw) s.push(wo.systemKw + " kW");
    if (wo.solarInverter) s.push(wo.solarInverter);
    parts.push(s.join(" / "));
  }
  if (wo.batteryQty) parts.push("Battery: " + wo.batteryQty + "x " + (wo.batteryType && wo.batteryType !== "-- Select --" ? wo.batteryType : ""));
  if (wo.lathResult) parts.push("Lath: " + wo.lathResult + (wo.lathNotes ? " - " + wo.lathNotes : ""));
  return parts.join("\n") || "None";
}

async function sendViaSES(toEmails, subject, bodyText, htmlBody) {
  const validTo = (toEmails || []).filter(e => e && e.includes("@"));
  if (!validTo.length) { alert("⚠️ Email error: No valid recipient addresses."); return; }
  let lastErr;
  for (let attempt = 1; attempt <= 2; attempt++) {
    try {
      const res = await fetch(`${AWS_API}/email/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to: validTo, subject, bodyText, bodyHtml: htmlBody }),
      });
      if (!res.ok) { const t = await res.text(); console.error("SES error:", t); alert("⚠️ Email failed: " + t.slice(0,200)); return; }
      console.log("Email sent to:", validTo);
      return;
    } catch(e) {
      lastErr = e;
      console.error(`SES fetch error (attempt ${attempt}):`, e);
      if (attempt < 2) await new Promise(r => setTimeout(r, 1500));
    }
  }
  alert("⚠️ Email error: " + (lastErr?.message || "Network request failed") + "\n\nPlease check your connection and try again.");
}

function buildWOEmailHTML(wo, createdBy, planUrls) {
  const addr = buildAddr(wo);
  const types = (wo.types || []).join(", ") || "N/A";
  const logo = "https://crm.suntrify.com/SUNTRIFY_LOGO.png";
  const mapsUrl = addr ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}` : null;
  const calUrl = (() => {
    if (!wo.date) return null;
    const d = wo.date.replace(/-/g, "");
    const tp = (wo.time || "08:00").split(":");
    const sh = tp[0].padStart(2,"0"), sm = tp[1] ? tp[1].padStart(2,"0") : "00";
    const eh = String(parseInt(sh) + 4).padStart(2,"0");
    const title = encodeURIComponent(`WO - ${wo.customerName||""} - ${(wo.types||[]).join(", ")}`);
    const detailLines = [
      wo.woId||"",
      `Work Types: ${(wo.types||[]).join(", ")||"N/A"}`,
      addr ? `Address: ${addr}` : "",
      wo.crew ? `Crew: ${wo.crew}` : "",
      wo.epcPartnerName ? `EPC: ${wo.epcPartnerName}` : "",
      wo.phone ? `Phone: ${wo.phone}` : "",
      "",
      buildWONotes(wo),
    ].filter(Boolean).join("\n");
    const details = encodeURIComponent(detailLines);
    const loc = encodeURIComponent(addr);
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${d}T${sh}${sm}00/${d}T${eh}${sm}00&details=${details}&location=${loc}`;
  })();
  const r = (label, value) => value ? `<tr><td style="padding:9px 14px;font-size:12px;color:#6a7080;font-weight:600;width:140px;vertical-align:top;border-bottom:1px solid #f0f1f5;">${label}</td><td style="padding:9px 14px;font-size:13px;color:#1a1d25;vertical-align:top;border-bottom:1px solid #f0f1f5;">${value}</td></tr>` : "";
  const sectionBlock = (title, rowsHtml) => rowsHtml ? `<tr><td style="padding:20px 32px 0;"><div style="font-size:11px;font-weight:700;color:#9aa0b4;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:8px;">${title}</div><div style="border-radius:8px;border:1px solid #e0e3eb;overflow:hidden;"><table width="100%" cellpadding="0" cellspacing="0">${rowsHtml}</table></div></td></tr>` : "";
  const noteBlock = (title, value) => value ? `<tr><td style="padding:20px 32px 0;"><div style="font-size:11px;font-weight:700;color:#9aa0b4;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:8px;">${title}</div><div style="font-size:13px;color:#1a1d25;line-height:1.7;white-space:pre-wrap;background:#f9f9fb;border-radius:8px;border:1px solid #e0e3eb;padding:14px 16px;">${value}</div></td></tr>` : "";

  // MPU / Panel Upgrade section
  let mpuRows = "";
  if (wo.mpuServiceType && wo.mpuServiceType !== "-- Select --") {
    mpuRows += r("Service Type", wo.mpuServiceType);
    if (wo.mpuExisting && wo.mpuExisting !== "-- Select --") {
      const mpuNew = (wo.mpuNew && wo.mpuNew !== "-- Select --") ? wo.mpuNew : "?";
      mpuRows += r("Panel Upgrade", `${wo.mpuExisting} &rarr; ${mpuNew}`);
    }
    if (wo.mpuMeterSpot && wo.mpuMeterSpot !== "-- Select --") mpuRows += r("Meter Spot", wo.mpuMeterSpot);
    if (wo.mpuDisconnect && wo.mpuDisconnect !== "-- Select --") mpuRows += r("Disconnect", wo.mpuDisconnect);
    if (wo.mpuLathResult) mpuRows += r("Lath Inspection", wo.mpuLathResult + (wo.mpuLathNotes ? ` &mdash; ${wo.mpuLathNotes}` : ""));
    if (wo.mpuRoughResult) mpuRows += r("Rough Inspection", wo.mpuRoughResult + (wo.mpuRoughNotes ? ` &mdash; ${wo.mpuRoughNotes}` : ""));
  }

  // Solar section
  let solarRows = "";
  if (wo.solarPanels) {
    solarRows += r("Panels", wo.solarPanels);
    if (wo.systemKw) solarRows += r("System Size", wo.systemKw + " kW");
    if (wo.solarInverter) solarRows += r("Inverter", wo.solarInverter);
  }

  // Battery section
  let batteryRows = "";
  if (wo.batteryQty) {
    const bType = (wo.batteryType && wo.batteryType !== "-- Select --") ? wo.batteryType : "";
    batteryRows += r("Battery", wo.batteryQty + "x " + bType);
  }

  // General lath (non-MPU)
  let inspRows = "";
  if (wo.inspectionResult && wo.inspectionResult !== "-- Select --") inspRows += r("Inspection Result", wo.inspectionResult);
  if (wo.lathResult) inspRows += r("Lath Inspection", wo.lathResult + (wo.lathNotes ? ` &mdash; ${wo.lathNotes}` : ""));

  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head>
<body style="margin:0;padding:0;background:#f0f2f5;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background:#f0f2f5;padding:28px 0;">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:10px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.10);">
  <tr><td style="background:#f0a500;padding:6px 0;"></td></tr>
  <tr><td style="background:#ffffff;padding:24px 32px;text-align:center;border-bottom:1px solid #f0f1f5;">
    <img src="${logo}" alt="Suntrify" style="height:52px;display:block;margin:0 auto;" />
    <div style="margin-top:10px;font-size:11px;font-weight:700;color:#6a7080;letter-spacing:0.10em;text-transform:uppercase;">New Work Order Created</div>
  </td></tr>
  <tr><td style="padding:28px 32px 16px;">
    <div style="font-size:22px;font-weight:700;color:#1a1d25;margin-bottom:2px;">${wo.customerName || "Customer"}</div>
    ${wo.phone ? `<div style="font-size:13px;color:#6a7080;margin-bottom:4px;">${wo.phone}</div>` : ""}
    ${addr ? `<div style="font-size:13px;color:#6a7080;margin-bottom:10px;">${mapsUrl ? `<a href="${mapsUrl}" style="color:#3b82f6;text-decoration:none;">${addr}</a>` : addr}</div>` : ""}
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      ${wo.woId ? `<span style="background:#f0a50022;border:1px solid #f0a50066;border-radius:4px;padding:3px 10px;font-size:11px;font-weight:700;color:#d4891f;">${wo.woId}</span>` : ""}
      ${wo.status ? `<span style="background:#3b82f622;border:1px solid #3b82f644;border-radius:4px;padding:3px 10px;font-size:11px;font-weight:700;color:#3b82f6;">${wo.status}</span>` : ""}
    </div>
  </td></tr>
  <tr><td style="padding:0 32px 0;">
    <div style="border-radius:8px;border:1px solid #e0e3eb;overflow:hidden;">
    <table width="100%" cellpadding="0" cellspacing="0">
      ${r("Work Types", `<strong style="color:#1a1d25;">${types}</strong>`)}
      ${r("Date", wo.date || "")}
      ${r("Time", wo.time || "")}
      ${r("Crew", wo.crew || "Not assigned")}
      ${r("EPC Partner", wo.epcPartnerName || "")}
      ${r("Created by", createdBy || "Suntrify")}
    </table>
    </div>
  </td></tr>
  ${sectionBlock("MPU / Panel Upgrade", mpuRows)}
  ${sectionBlock("Solar", solarRows)}
  ${sectionBlock("Battery", batteryRows)}
  ${sectionBlock("Inspection", inspRows)}
  ${noteBlock("Notes", wo.notes || "")}
  ${noteBlock("Electrical Notes", wo.electricalNotes || "")}
  ${noteBlock("Service Notes", wo.serviceNotes || "")}
  ${noteBlock("Inspection Notes", wo.inspectionNotes || "")}
  ${(planUrls && planUrls.length) ? `<tr><td style="padding:20px 32px 0;"><div style="font-size:11px;font-weight:700;color:#9aa0b4;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:8px;">Plan Set</div><div style="border-radius:8px;border:1px solid #e0e3eb;overflow:hidden;padding:12px 16px;">${planUrls.map((url,i)=>{const name=decodeURIComponent(url.split('?')[0].split('/').pop().replace(/^\d+-/,'')).replace(/_/g,' ');return `<div style="margin-bottom:${i<planUrls.length-1?'8px':'0'}"><a href="${url}" target="_blank" style="color:#1d4ed8;font-size:13px;text-decoration:none;font-weight:600;">📄 ${name}</a></div>`;}).join('')}</div></td></tr>` : ""}
  <tr><td style="padding:24px 32px 28px;text-align:center;">
  ${calUrl ? `<a href="${calUrl}" target="_blank" style="display:inline-block;background:#f0a500;color:#000000;font-size:13px;font-weight:700;text-decoration:none;padding:11px 28px;border-radius:7px;letter-spacing:0.01em;margin:0 6px 8px;">Add to Calendar</a>` : ""}
  ${wo.reportToken ? `<a href="https://crm.suntrify.com?report=${wo.reportToken}" target="_blank" style="display:inline-block;background:#1a1d25;color:#ffffff;font-size:13px;font-weight:700;text-decoration:none;padding:11px 28px;border-radius:7px;letter-spacing:0.01em;margin:0 6px 8px;">📷 Upload Field Report</a>` : ""}
  ${wo.companyCamUrl ? `<a href="${wo.companyCamUrl}" target="_blank" style="display:inline-block;background:#f97316;color:#ffffff;font-size:13px;font-weight:700;text-decoration:none;padding:11px 28px;border-radius:7px;letter-spacing:0.01em;margin:0 6px 8px;">📸 View Photos (CompanyCam)</a>` : ""}
  </td></tr>
  <tr><td style="background:#f4f5f7;border-top:1px solid #e0e3eb;padding:20px 32px;text-align:center;">
    <p style="margin:0 0 4px;font-size:12px;font-weight:700;color:#1a1d25;">Suntrify Inc.</p>
    <p style="margin:0;font-size:11px;color:#6a7080;">Lake Elsinore, CA &nbsp;·&nbsp; (951) 866-2828 &nbsp;·&nbsp; CSLB Lic# 1055498</p>
    <p style="margin:6px 0 0;font-size:10px;color:#9aa0b4;">Automated Work Order Notification</p>
  </td></tr>
</table>
</td></tr>
</table>
</body></html>`;
}

function buildWOEmailBody(wo, createdBy, planUrls) {
  const planLines = (planUrls && planUrls.length) ? [
    "",
    "PLAN SET",
    "──────────────────────────────────",
    ...planUrls.map((url, i) => `Plan ${i + 1}: ${url}`),
  ] : [];
  return [
    "NEW WORK ORDER",
    "──────────────────────────────────",
    `WO ID:       ${wo.woId || "N/A"}`,
    `Customer:    ${wo.customerName || ""}`,
    `Address:     ${buildAddr(wo)}`,
    `Date:        ${wo.date || ""}`,
    `Time:        ${wo.time || ""}`,
    `Work Types:  ${(wo.types || []).join(", ") || "N/A"}`,
    `Crew:        ${wo.crew || "Not assigned"}`,
    `EPC Partner: ${wo.epcPartnerName || ""}`,
    `Created by:  ${createdBy || "Suntrify"}`,
    "",
    "NOTES",
    "──────────────────────────────────",
    buildWONotes(wo),
    ...planLines,
    ...(wo.companyCamUrl ? ["", "COMPANYCAM PHOTOS", "──────────────────────────────────", wo.companyCamUrl] : []),
  ].join("\n");
}

async function sendWOEmail(wo, createdBy, planUrls) {
  const types = (wo.types || []).join(", ");
  const subject = `New Work Order${types ? ` — ${types}` : ""} — ${wo.customerName || "Customer"} — ${wo.woId || ""}`;
  const extra = (wo.extraEmails || "").split(",").map(e => e.trim()).filter(e => e.includes("@"));
  const recipients = [...SES_TO, ...extra];
  // Generate 7-day presigned URLs for docs so email recipients can open them
  const emailUrls = await Promise.all((planUrls || []).map(u => getEmailUrl(u).catch(() => u)));
  await sendViaSES(recipients, subject, buildWOEmailBody(wo, createdBy, emailUrls), buildWOEmailHTML(wo, createdBy, emailUrls));
}

function buildCancelEmailHTML(wo, cancelledBy, reason) {
  const addr = buildAddr(wo);
  const types = (wo.types || []).join(", ") || "N/A";
  const logo = "https://crm.suntrify.com/SUNTRIFY_LOGO.png";
  const r = (label, value) => value ? `<tr><td style="padding:9px 14px;font-size:12px;color:#6a7080;font-weight:600;width:130px;vertical-align:top;border-bottom:1px solid #f0f1f5;">${label}</td><td style="padding:9px 14px;font-size:13px;color:#1a1d25;vertical-align:top;border-bottom:1px solid #f0f1f5;">${value}</td></tr>` : "";
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head>
<body style="margin:0;padding:0;background:#f0f2f5;font-family:Helvetica,Arial,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background:#f0f2f5;padding:28px 0;">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:10px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.10);">
  <tr><td style="background:#ef4444;padding:6px 0;"></td></tr>
  <tr><td style="background:#ffffff;padding:24px 32px;text-align:center;border-bottom:1px solid #f0f1f5;">
    <img src="${logo}" alt="Suntrify" style="height:52px;display:block;margin:0 auto;" />
    <div style="margin-top:10px;font-size:11px;font-weight:700;color:#ef4444;letter-spacing:0.10em;text-transform:uppercase;">Work Order Cancelled</div>
  </td></tr>
  <tr><td style="padding:20px 32px 16px;">
    <div style="background:#dc2626;border-radius:8px;padding:14px 20px;text-align:center;margin-bottom:20px;">
      <div style="font-size:15px;font-weight:700;color:#ffffff;letter-spacing:0.04em;">⚠ DO NOT DISPATCH CREW</div>
      <div style="font-size:12px;color:#fecaca;margin-top:4px;font-weight:600;">THIS WORK ORDER HAS BEEN CANCELLED</div>
    </div>
    ${reason ? `<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;font-size:13px;color:#dc2626;margin-bottom:4px;"><strong>Reason:</strong> ${reason}</div>` : ""}
  </td></tr>
  <tr><td style="padding:0 32px 16px;">
    <div style="font-size:22px;font-weight:700;color:#1a1d25;margin-bottom:2px;">${wo.customerName || "Customer"}</div>
    ${wo.phone ? `<div style="font-size:13px;color:#6a7080;margin-bottom:4px;">${wo.phone}</div>` : ""}
    ${addr ? `<div style="font-size:13px;color:#6a7080;margin-bottom:10px;">${addr}</div>` : ""}
    ${wo.woId ? `<span style="background:#ef444422;border:1px solid #ef444444;border-radius:4px;padding:3px 10px;font-size:11px;font-weight:700;color:#ef4444;">${wo.woId}</span>` : ""}
  </td></tr>
  <tr><td style="padding:0 32px 24px;">
    <div style="border-radius:8px;border:1px solid #e0e3eb;overflow:hidden;">
    <table width="100%" cellpadding="0" cellspacing="0">
      ${r("Work Types", types)}
      ${r("Scheduled Date", wo.date || "")}
      ${r("Time", wo.time || "")}
      ${r("Crew", wo.crew || "")}
      ${r("EPC Partner", wo.epcPartnerName || "")}
      ${r("Cancelled by", cancelledBy || "Suntrify")}
    </table>
    </div>
  </td></tr>
  <tr><td style="background:#f4f5f7;border-top:1px solid #e0e3eb;padding:20px 32px;text-align:center;">
    <p style="margin:0 0 4px;font-size:12px;font-weight:700;color:#1a1d25;">Suntrify Inc.</p>
    <p style="margin:0;font-size:11px;color:#6a7080;">Lake Elsinore, CA &nbsp;·&nbsp; (951) 866-2828 &nbsp;·&nbsp; CSLB Lic# 1055498</p>
    <p style="margin:6px 0 0;font-size:10px;color:#9aa0b4;">Automated Work Order Notification</p>
  </td></tr>
</table>
</td></tr>
</table>
</body></html>`;
}

async function sendCancelEmail(wo, cancelledBy, reason) {
  const types = (wo.types || []).join(", ");
  const subject = `Work Order Cancelled${types ? ` — ${types}` : ""} — ${wo.customerName || "Customer"} — ${wo.woId || ""}`;
  const bodyText = [
    "WORK ORDER CANCELLED",
    "──────────────────────────────────",
    `WO ID:        ${wo.woId || "N/A"}`,
    `Customer:     ${wo.customerName || ""}`,
    `Reason:       ${reason || "No reason provided"}`,
    `Work Types:   ${types || "N/A"}`,
    `Date:         ${wo.date || ""}`,
    `Crew:         ${wo.crew || ""}`,
    `Cancelled by: ${cancelledBy || "Suntrify"}`,
  ].join("\n");
  await sendViaSES(SES_TO, subject, bodyText, buildCancelEmailHTML(wo, cancelledBy, reason));
}

function openGoogleCalendar(wo) {
  const date = wo.date ? wo.date.replace(/-/g, "") : "";
  const timeParts = (wo.time || "08:00").split(":");
  const startHour = timeParts[0].padStart(2,"0");
  const startMin = timeParts[1] ? timeParts[1].padStart(2,"0") : "00";
  const startDT = date + "T" + startHour + startMin + "00";
  let endHour = String(parseInt(startHour) + 2).padStart(2,"0");
  const endDT = date + "T" + endHour + startMin + "00";
  const title = encodeURIComponent("WO - " + (wo.customerName||"") + " - " + (wo.types||[]).join(", "));
  const details = encodeURIComponent((wo.woId||"") + "\nAddress: " + buildAddr(wo) + "\nEPC: " + (wo.epcPartnerName||"") + "\nCrew: " + (wo.crew||"") + "\nNotes: " + (wo.notes||""));
  const location = encodeURIComponent(buildAddr(wo));
  const url = "https://calendar.google.com/calendar/render?action=TEMPLATE&text=" + title + "&dates=" + startDT + "/" + endDT + "&details=" + details + "&location=" + location;
  window.open(url, "_blank");
}

function downloadICS(wo) {
  const date = wo.date ? wo.date.replace(/-/g, "") : "";
  const timeParts = (wo.time || "08:00").split(":");
  const startHour = timeParts[0].padStart(2,"0");
  const startMin = timeParts[1] ? timeParts[1].padStart(2,"0") : "00";
  const startDT = date + "T" + startHour + startMin + "00";
  let endHour = String(parseInt(startHour) + 2).padStart(2,"0");
  const endDT = date + "T" + endHour + startMin + "00";
  const title = "WO - " + (wo.customerName||"") + " - " + (wo.types||[]).join(", ");
  const location = buildAddr(wo);
  const description = (wo.woId||"") + "\nEPC: " + (wo.epcPartnerName||"") + "\nCrew: " + (wo.crew||"") + "\nNotes: " + (wo.notes||"");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Suntrify CRM//EN",
    "BEGIN:VEVENT",
    "DTSTART:" + startDT,
    "DTEND:" + endDT,
    "SUMMARY:" + title,
    "LOCATION:" + location,
    "DESCRIPTION:" + description,
    "END:VEVENT",
    "END:VCALENDAR"
  ].join("\r\n");
  const blob = new Blob([ics], {type:"text/calendar"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = (wo.woId||"WO") + ".ics";
  a.click();
  URL.revokeObjectURL(url);
}

const AWS_API = 'https://x01zwa0olf.execute-api.us-east-2.amazonaws.com/prod';

async function sbFetch(path, opts = {}) {
  const isGet = !opts.method || opts.method === "GET";
  const sep = path.includes("?") ? "&" : "?";
  const url = AWS_API + "/" + path + (isGet ? sep + "_t=" + Date.now() : "");
  const res = await fetch(url, { headers: {"Content-Type": "application/json"}, ...opts });
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

async function dbLoad(table) {
  try {
    const r = await sbFetch(table);
    return r.map(x => ({ ...x.data, _dbId: x.id }));
  } catch(e) { console.error(e); return []; }
}

function markDeleted(table, dbId) {
  try { const d = JSON.parse(localStorage.getItem("deleted_"+table)||"[]"); if(!d.includes(dbId)){d.push(dbId);localStorage.setItem("deleted_"+table,JSON.stringify(d));} } catch(e){}
}

async function dbSave(table, item) {
  try {
    const { _dbId, ...data } = item;
    if (_dbId) {
      await sbFetch(table + "?id=eq." + _dbId, { method: "PATCH", prefer: "return=minimal", body: JSON.stringify({ data }) });
      return item;
    } else {
      const r = await sbFetch(table, { method: "POST", body: JSON.stringify({ data }) });
      const newDbId = Array.isArray(r) ? r[0]?.id : r?.id;
      return { ...item, _dbId: newDbId };
    }
  } catch(e) { console.error(e); return item; }
}

async function dbDelete(table, dbId) {
  try { await sbFetch(table + "?id=eq." + dbId, { method: "DELETE" }); } catch(e) { console.error(e); }
}

// ─── Auth ─────────────────────────────────────────────────────────────────
const DEFAULT_USERS = [{ username: "jose", password: "suntrify2024", name: "Jose Chacon", role: "Admin" }];
function loadUsers() { try { const v = localStorage.getItem("crm-users"); return v ? JSON.parse(v) : DEFAULT_USERS; } catch { return DEFAULT_USERS; } }
function saveUsers(u) { try { localStorage.setItem("crm-users", JSON.stringify(u)); } catch {} }
function loadSession() { try { const v = localStorage.getItem("crm-session"); return v ? JSON.parse(v) : null; } catch { return null; } }
function saveSession(u) { try { localStorage.setItem("crm-session", JSON.stringify(u)); } catch {} }
function clearSession() { try { localStorage.removeItem("crm-session"); } catch {} }

// DB-backed user helpers
async function dbLoadUsers() {
  try {
    const rows = await dbLoad("crm_users");
    if (rows.length > 0) return rows;
    // Table empty — seed with default admin so first-run works
    const seeded = await dbSave("crm_users", DEFAULT_USERS[0]);
    return [seeded];
  } catch(e) { return loadUsers(); } // localStorage fallback
}
async function dbSaveUser(user) {
  try { return await dbSave("crm_users", user); } catch(e) { return user; }
}
async function dbRemoveUser(user) {
  try { if (user._dbId) await dbDelete("crm_users", user._dbId); } catch(e) {}
}

// ─── Constants ─────────────────────────────────────────────────────────────
const JOB_STAGES = ["Lead","Proposal","Scheduled","Installation","Service/Corrections","MPU","Inspection","Commissioning","Punch List","Closed","Cancelled"];
const STAGE_COLORS = { Lead:"#3b82f6", Proposal:"#8b5cf6", Scheduled:"#06b6d4", Installation:"#f0a500", "Service/Corrections":"#f97316", MPU:"#8b5cf6", Inspection:"#ec4899", Commissioning:"#0ea5e9", "Punch List":"#f59e0b", Closed:"#22c55e", Cancelled:"#6b7280" };
const ROOF_TYPES = ["Composition Shingles", "Tile Roof (S Tile)", "Tile Roof (W Tile)", "Tile Roof (Flat Tile)", "Comp Shingles (Vaulted)", "Metal Roof", "Flat Roof", "Other"];
const BATTERY_TYPES = ["No Battery", "Enphase 5P", "Enphase 10C", "Tesla Powerwall 3", "Franklin WH", "Other"];
const INVERTER_TYPES = ["Enphase IQ8HC", "Enphase IQ8MC", "Enphase IQ8plus", "Tesla Powerwall 3 (Integrated)", "SolarEdge", "Other"];
const CA_LICENSE_CLASSIFICATIONS = [
  "",
  "(A) General Engineering Contractor",
  "(B) General Building Contractor",
  "(B-2) Residential Remodeling Contractor",
  "C-2 - Insulation and Acoustical Contractor",
  "C-4 - Boiler, Hot Water Heating and Steam Fitting Contractor",
  "C-5 - Framing and Rough Carpentry Contractor",
  "C-6 - Cabinet, Millwork and Finish Carpentry Contractor",
  "C-7 - Low Voltage Systems Contractor",
  "C-8 - Concrete Contractor",
  "C-9 - Drywall Contractor",
  "C-10 - Electrical Contractor",
  "C-11 - Elevator Contractor",
  "C-12 - Earthwork and Paving Contractors",
  "C-13 - Fencing Contractor",
  "C-15 - Flooring and Floor Covering Contractors",
  "C-16 - Fire Protection Contractor",
  "C-17 - Glazing Contractor",
  "C-20 - Warm-Air Heating, Ventilating and Air-Conditioning Contractor",
  "C-21 - Building Moving/Demolition Contractor",
  "C-22 - Asbestos Abatement Contractor",
  "C-23 - Ornamental Metal Contractor",
  "C-27 - Landscaping Contractor",
  "C-28 - Lock and Security Equipment Contractor",
  "C-29 - Masonry Contractor",
  "C-31 - Construction Zone Traffic Control Contractor",
  "C-32 - Parking and Highway Improvement Contractor",
  "C-33 - Painting and Decorating Contractor",
  "C-34 - Pipeline Contractor",
  "C-35 - Lathing and Plastering Contractor",
  "C-36 - Plumbing Contractor",
  "C-38 - Refrigeration Contractor",
  "C-39 - Roofing Contractor",
  "C-42 - Sanitation System Contractor",
  "C-43 - Sheet Metal Contractor",
  "C-45 - Sign Contractor",
  "C-46 - Solar Contractor",
  "C-47 - General Manufactured Housing Contractor",
  "C-49 - Tree and Palm Contractor",
  "C-50 - Reinforcing Steel Contractor",
  "C-51 - Structural Steel Contractor",
  "C-53 - Swimming Pool Contractor",
  "C-54 - Ceramic and Mosaic Tile Contractor",
  "C-55 - Water Conditioning Contractor",
  "C-57 - Well Drilling Contractor",
  "C-60 - Welding Contractor",
  "C-61 - Limited Specialty",
];

// ─── Styles ────────────────────────────────────────────────────────────────
const WO_TYPE_CATEGORIES = [
  { label: "Electrical", icon: "bolt", types: ["Panel Upgrade (MPU)","Rough-in","Trim and Finish","(TI) / Buildout","Design-Build","Bonding and Grounding","Ground Rod","Breaker Swap","Troubleshooting","Electrical Correction","Line Transfer","EV Charger","Dedicated Circuit","Temporary Power","Load Calculation","Sub Panel","Meter Socket Repair"] },
  { label: "Solar", icon: "sun", types: ["PV Install","Battery Install","Commissioning","Optimizer Install","Microinverter Swap","String Inverter Swap","Enphase IQ Gateway","Array Expansion","Solar Removal & Reinstall"] },
  { label: "Service", icon: "tool", types: ["Service Call","Inverter Service","Troubleshooting","Permit Inspection","Final Inspection","Roof Repair","Stucco Repair","Punch List","Warranty Work","Other"] },
  { label: "Inspection", icon: "search", types: ["Fire Inspection","Building Inspection","Electrical Inspection","Solar Inspection","Structural Inspection","Roofing Inspection","Final Inspection","Re-Inspection","Correction Required"] },
  { label: "Sales", icon: "briefcase", types: ["Lead","Site Survey","Sales Appointment","Proposal Sent","Contract Review","Contract Signing","Follow-up","Lost / No Sale"] },
  { label: "Design & Engineering", icon: "compass", types: ["Plan Set","Electrical Drawing","Structural Drawing","Title 24 / Load Calc","Permit Submission","Plan Check Response","Interconnection Application","HOA Approval","As-Built Drawing","System Design / String Layout"] },
];

const SALES_TYPES = ["Lead","Site Survey","Sales Appointment","Proposal Sent","Contract Review","Contract Signing","Follow-up","Lost / No Sale"];
// LEAD_SOURCES moved to line ~789 (job form constants)
const DESIGN_TYPES = ["Plan Set","Electrical Drawing","Structural Drawing","Title 24 / Load Calc","Permit Submission","Plan Check Response","Interconnection Application","HOA Approval","As-Built Drawing","System Design / String Layout"];
const PERMIT_STATUSES = ["Not Submitted","Submitted","Plan Check","Approved","Permit Issued","Corrections Required","Resubmitted","Expired"];
const INTERCONNECT_STATUSES = ["Not Started","Application Submitted","Conditional Approval","Approved","Rejected","On Hold"];
const WO_TYPES = WO_TYPE_CATEGORIES.flatMap(c => c.types);
const WO_STATUS = ["Scheduled","In Progress","Complete","Cancelled"];

const IS = { width: "100%", background: "#f9f9fb", border: "1px solid #dde0ea", borderRadius: 7, color: "#1a1d25", padding: "8px 11px", fontSize: 13, outline: "none", fontFamily: "'DM Sans',sans-serif", boxSizing: "border-box" };

function Pill({ label, color }) {
  return <span style={{ background: color + "22", color, border: "1px solid " + color + "44", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{label}</span>;
}

function Btn({ children, onClick, variant = "primary", small, style: sx = {} }) {
  const base = { border: "none", borderRadius: 7, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: small ? 12 : 13, padding: small ? "5px 10px" : "9px 16px", transition: "opacity .12s" };
  const v = { primary: { background: "#f0a500", color: "#000" }, ghost: { background: "transparent", border: "1px solid #dde0ea", color: "#6a7080" }, danger: { background: "transparent", border: "1px solid #ef444450", color: "#ef4444" }, blue: { background: "#3b82f6", color: "#fff" } };
  return <button onClick={onClick} style={{ ...base, ...v[variant], ...sx }}>{children}</button>;
}

function Icon({ name, size = 14, color = "currentColor", style: sx = {} }) {
  const s = { display:"inline-block", verticalAlign:"middle", flexShrink:0, ...sx };
  const p = { strokeLinecap:"round", strokeLinejoin:"round", strokeWidth:"2", fill:"none", stroke:color };
  const icons = {
    calendar:   <><rect x="3" y="4" width="18" height="18" rx="2" ry="2" {...p}/><line x1="16" y1="2" x2="16" y2="6" {...p}/><line x1="8" y1="2" x2="8" y2="6" {...p}/><line x1="3" y1="10" x2="21" y2="10" {...p}/></>,
    users:      <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" {...p}/><circle cx="9" cy="7" r="4" {...p}/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" {...p}/></>,
    sun:        <><circle cx="12" cy="12" r="5" {...p}/><line x1="12" y1="1" x2="12" y2="3" {...p}/><line x1="12" y1="21" x2="12" y2="23" {...p}/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" {...p}/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" {...p}/><line x1="1" y1="12" x2="3" y2="12" {...p}/><line x1="21" y1="12" x2="23" y2="12" {...p}/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" {...p}/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" {...p}/></>,
    battery:    <><rect x="1" y="8" width="18" height="8" rx="2" ry="2" {...p}/><line x1="23" y1="11" x2="23" y2="13" {...p}/></>,
    search:     <><circle cx="11" cy="11" r="8" {...p}/><line x1="21" y1="21" x2="16.65" y2="16.65" {...p}/></>,
    briefcase:  <><rect x="2" y="7" width="20" height="14" rx="2" ry="2" {...p}/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" {...p}/></>,
    compass:    <><circle cx="12" cy="12" r="10" {...p}/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" {...p}/></>,
    pencil:     <><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" {...p}/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" {...p}/></>,
    clipboard:  <><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" {...p}/><rect x="8" y="2" width="8" height="4" rx="1" ry="1" {...p}/></>,
    mail:       <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" {...p}/><polyline points="22,6 12,13 2,6" {...p}/></>,
    copy:       <><rect x="9" y="9" width="13" height="13" rx="2" ry="2" {...p}/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" {...p}/></>,
    play:       <><polygon points="5 3 19 12 5 21 5 3" {...p}/></>,
    "check-circle": <><path d="M22 11.08V12a10 10 0 11-5.93-9.14" {...p}/><polyline points="22 4 12 14.01 9 11.01" {...p}/></>,
    trash:      <><polyline points="3 6 5 6 21 6" {...p}/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" {...p}/><path d="M10 11v6M14 11v6" {...p}/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" {...p}/></>,
    "file-text": <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" {...p}/><polyline points="14 2 14 8 20 8" {...p}/><line x1="16" y1="13" x2="8" y2="13" {...p}/><line x1="16" y1="17" x2="8" y2="17" {...p}/><polyline points="10 9 9 9 8 9" {...p}/></>,
    bolt:       <><polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" {...p}/></>,
    tool:       <><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" {...p}/></>,
    layers:     <><polygon points="12 2 2 7 12 12 22 7 12 2" {...p}/><polyline points="2 17 12 22 22 17" {...p}/><polyline points="2 12 12 17 22 12" {...p}/></>,
    "map-pin":  <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" {...p}/><circle cx="12" cy="10" r="3" {...p}/></>,
    arrow:      <><line x1="5" y1="12" x2="19" y2="12" {...p}/><polyline points="12 5 19 12 12 19" {...p}/></>,
    star:       <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" {...p}/></>,
    eye:        <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" {...p}/><circle cx="12" cy="12" r="3" {...p}/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" style={s}>{icons[name]||null}</svg>;
}

function F({ label, children }) {
  return <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#8891a4", marginBottom: 4, letterSpacing: "0.08em", textTransform: "uppercase" }}>{label}</label>
    {children}
  </div>;
}

function formatPhone(val) {
  const digits = val.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0,3)})${digits.slice(3)}`;
  return `(${digits.slice(0,3)})${digits.slice(3,6)}-${digits.slice(6)}`;
}
function Inp({ label, value, onChange, type = "text", placeholder }) {
  const handleChange = e => {
    const val = e.target.value;
    onChange(type === "tel" ? formatPhone(val) : val);
  };
  return <F label={label}><input type={type} value={value || ""} onChange={handleChange} placeholder={type==="tel"?"(123)456-7890":placeholder} style={IS} /></F>;
}
function Sel({ label, value, onChange, options }) {
  return <F label={label}><select value={value || ""} onChange={e => onChange(e.target.value)} style={IS}>{options.map(o => typeof o === "string" ? <option key={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>)}</select></F>;
}
function Txt({ label, value, onChange, rows = 3 }) {
  return <F label={label}><textarea value={value || ""} onChange={e => onChange(e.target.value)} rows={rows} style={{ ...IS, resize: "vertical" }} /></F>;
}
function SearchSel({ label, value, onChange, options }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const selected = options.find(o => String(o.value) === String(value) && o.value !== "");
  const q = query.toLowerCase();
  const filtered = options.filter(o => o.value !== "" && o.label.toLowerCase().includes(q));
  return (
    <F label={label}>
      <div ref={ref} style={{ position: "relative" }}>
        {selected ? (
          <div style={{ ...IS, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>{selected.label}</span>
            <button type="button" onClick={() => { onChange(""); setQuery(""); }} style={{ background: "none", border: "none", cursor: "pointer", color: "#9aa0b4", fontSize: 18, lineHeight: 1, padding: "0 2px" }}>×</button>
          </div>
        ) : (
          <input type="text" value={query} onChange={e => { setQuery(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
            placeholder="Search customer…" style={{ ...IS, paddingRight: 30 }} autoComplete="off" />
        )}
        {open && !selected && filtered.length > 0 && (
          <div style={{ position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0, background: "#fff", border: "1px solid #dde0ea", borderRadius: 7, boxShadow: "0 6px 20px rgba(0,0,0,0.10)", zIndex: 200, maxHeight: 220, overflowY: "auto" }}>
            {filtered.map(o => (
              <div key={o.value} onMouseDown={e => { e.preventDefault(); onChange(o.value); setQuery(""); setOpen(false); }}
                style={{ padding: "9px 12px", fontSize: 13, cursor: "pointer", color: "#1a1d25", borderBottom: "1px solid #f4f4f7" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f9f9fb"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                {o.label}
              </div>
            ))}
          </div>
        )}
        {open && !selected && query.length > 0 && filtered.length === 0 && (
          <div style={{ position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0, background: "#fff", border: "1px solid #dde0ea", borderRadius: 7, boxShadow: "0 6px 20px rgba(0,0,0,0.10)", zIndex: 200, padding: "10px 12px", fontSize: 13, color: "#9aa0b4" }}>
            No customers found
          </div>
        )}
      </div>
    </F>
  );
}

function Modal({ open, onClose, children, wide }) {
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: "100%", maxWidth: wide ? 640 : 480, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        {children}
      </div>
    </div>
  );
}

// ─── Login ─────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [signingIn, setSigningIn] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) { setError("Enter your username and password"); return; }
    setSigningIn(true);
    setError("");
    try {
      // Load from DB first, fall back to localStorage if DB unreachable
      let users = [];
      try { users = await dbLoadUsers(); } catch(e) { users = loadUsers(); }
      // Also always allow the hardcoded admin as a safety net
      const localUsers = loadUsers();
      const allUsers = users.length > 0 ? users : localUsers;
      const user = allUsers.find(u => u.username.toLowerCase() === username.toLowerCase() && u.password === password);
      if (user) {
        const { _dbId, ...cleanUser } = user; // strip internal DB id from session
        saveSession(cleanUser);
        onLogin(cleanUser);
      } else {
        setError("Invalid username or password");
      }
    } catch(e) {
      setError("Sign-in error — please try again");
    }
    setSigningIn(false);
  };

  const handleKey = e => { if (e.key === "Enter") handleLogin(); };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#f5f6fa,#e8edf5)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif", padding: 20 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display&display=swap" rel="stylesheet" />
      <div style={{ background: "#fff", borderRadius: 16, padding: "40px 32px", width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,0.1)", border: "1px solid #e0e3eb" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <SuntrifyLogo width={160} style={{margin:"0 auto 14px"}}/>
          <div style={{ fontSize: 11, color: "#9aa0b4", letterSpacing: "0.12em", textTransform:"uppercase" }}>Lake Elsinore · Inland Empire</div>
        </div>
        <Inp label="Username" value={username} onChange={setUsername} placeholder="Enter username" />
        <div onKeyDown={handleKey}>
          <Inp label="Password" value={password} onChange={setPassword} type="password" placeholder="Enter password" />
        </div>
        {error && <div style={{ background: "#fff5f5", border: "1px solid #ef444430", borderRadius: 8, padding: "8px 12px", color: "#ef4444", fontSize: 13, marginBottom: 12 }}>{error}</div>}
        <Btn onClick={handleLogin} style={{ width: "100%", padding: 12, fontSize: 15, opacity: signingIn ? 0.7 : 1 }}>
          {signingIn ? "Signing in…" : "Sign In"}
        </Btn>
      </div>
    </div>
  );
}

// ─── EPC Partner Form ─────────────────────────────────────────────────────
const emptyEPC = { name: "", company: "", phone: "", email: "", licenseNumber: "", licenseClass: "", licenseExpiration: "", licenseStatus: "", serviceArea: "", notes: "", status: "Active" };

function SuntrifyInfoForm({ initial, onSave, onCancel }) {
  const [form, setForm] = useState({...initial});
  const fld = k => v => setForm(x => ({...x, [k]: v}));
  return (
    <div>
      <h2 style={{fontFamily:"'DM Serif Display',serif",color:"#d4891f",fontSize:18,marginBottom:18}}>Suntrify Inc. — Company Info</h2>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <Inp label="Company Name" value={form.company||""} onChange={fld("company")} placeholder="Suntrify Inc."/>
        <Inp label="Contact Name" value={form.contact||""} onChange={fld("contact")} placeholder="e.g. Jose Chacon"/>
        <Inp label="Phone" value={form.phone||""} onChange={fld("phone")} type="tel" placeholder="(951) 866-2828"/>
        <Inp label="Email" value={form.email||""} onChange={fld("email")} placeholder="jchacon@suntrify.com"/>
        <Inp label="Website" value={form.website||""} onChange={fld("website")} placeholder="www.suntrify.com"/>
        <Inp label="License #" value={form.license||""} onChange={fld("license")} placeholder="CSLB #1055498"/>
        <Inp label="License Class" value={form.licenseClass||""} onChange={fld("licenseClass")} placeholder="B, C-10, C-46"/>
        <Inp label="Address" value={form.address||""} onChange={fld("address")} placeholder="29336 Tournament"/>
        <Inp label="City" value={form.city||""} onChange={fld("city")} placeholder="Lake Elsinore"/>
        <Inp label="State" value={form.state||""} onChange={fld("state")} placeholder="CA"/>
        <Inp label="Zip" value={form.zip||""} onChange={fld("zip")} placeholder="92530"/>
      </div>
      <div style={{display:"flex",gap:8,marginTop:16}}>
        <Btn style={{flex:1}} onClick={() => onSave(form)}>Save</Btn>
        <Btn variant="ghost" style={{flex:1}} onClick={onCancel}>Cancel</Btn>
      </div>
    </div>
  );
}

function EPCForm({ initial, onSave, onCancel, title }) {
  const [f, setF] = useState({ ...emptyEPC, ...initial });
  const [verifying, setVerifying] = useState(false);
  const [verifyData, setVerifyData] = useState(null);
  const s = k => v => setF(x => ({ ...x, [k]: v }));

  const verifyLicense = async () => {
    const num = (f.licenseNumber || "").replace(/\D/g, "");
    if (!num) return;
    setVerifying(true); setVerifyData(null);
    try {
      const res = await fetch(`${AWS_API}/cslb/lookup?license=${num}`);
      const data = await res.json();
      if (!res.ok) { setVerifyData({ error: data.error || "Lookup failed" }); return; }
      setVerifyData(data);
      setF(x => ({
        ...x,
        company: x.company || data.businessName || x.company,
        name: x.name || data.businessName || x.name,
        licenseClass: data.classifications?.map(c => c.code).join(", ") || x.licenseClass,
        licenseExpiration: data.expiration || x.licenseExpiration,
        licenseStatus: /active/i.test(data.status || "") ? "Active" : (data.status ? "Inactive" : x.licenseStatus),
      }));
    } catch(e) { setVerifyData({ error: "Network error — try again" }); }
    finally { setVerifying(false); }
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display',serif", color: "#d4891f", fontSize: 18, marginBottom: 18 }}>{title}</h2>
      {f.createdAt && <div style={{fontSize:11,color:"#9aa0b4",marginBottom:12}}>📅 Added: {f.createdAt}</div>}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Inp label="Contact Name *" value={f.name} onChange={s("name")} />
        <Inp label="Company Name *" value={f.company} onChange={s("company")} />
        <Inp label="Phone" value={f.phone} onChange={s("phone")} type="tel" />
        <Inp label="Email" value={f.email} onChange={s("email")} type="email" />
        <div>
          <Inp label="License # (CSLB)" value={f.licenseNumber} onChange={v=>{s("licenseNumber")(v);setVerifyData(null);}} placeholder="e.g. 995150" />
          <div style={{display:"flex",gap:6,marginTop:4}}>
            <button onClick={verifyLicense} disabled={verifying||!(f.licenseNumber||"").replace(/\D/g,"")}
              style={{flex:1,padding:"7px 0",background:"#f0a500",color:"#000",border:"none",borderRadius:6,fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",opacity:verifying||!(f.licenseNumber||"").replace(/\D/g,"")?0.4:1}}>
              {verifying ? "Verifying…" : "Auto-Fill from CSLB"}
            </button>
            <button onClick={()=>{const n=(f.licenseNumber||"").replace(/\D/g,"");if(!n)return;window.open(`https://www2.cslb.ca.gov/OnlineServices/CheckLicenseII/LicenseDetail.aspx?LicNum=${n}`,"_blank");}}
              disabled={!(f.licenseNumber||"").replace(/\D/g,"")}
              style={{flex:1,padding:"7px 0",background:"#0f1e3c",color:"#fff",border:"none",borderRadius:6,fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",opacity:(f.licenseNumber||"").replace(/\D/g,"")?1:0.4}}>
              View on CSLB ↗
            </button>
          </div>
          {verifyData && !verifyData.error && (
            <div style={{marginTop:5,display:"flex",flexWrap:"wrap",gap:4}}>
              <span style={{fontSize:10,fontWeight:700,color:/active/i.test(verifyData.status||"")?"#16a34a":"#dc2626",background:/active/i.test(verifyData.status||"")?"#dcfce7":"#fee2e2",borderRadius:4,padding:"2px 7px"}}>{/active/i.test(verifyData.status||"")?"Active":"Inactive"}</span>
              {verifyData.expiration&&<span style={{fontSize:10,color:"#6a7080",padding:"2px 6px",background:"#f0f1f5",borderRadius:4}}>Exp {verifyData.expiration}</span>}
              {verifyData.classifications?.map(c=><span key={c.code} style={{fontSize:10,fontWeight:700,color:"#fff",background:"#1d4ed8",borderRadius:4,padding:"2px 7px"}} title={c.description}>{c.code}</span>)}
            </div>
          )}
          {verifyData?.error&&<div style={{fontSize:11,color:"#dc2626",marginTop:3}}>⚠ {verifyData.error}</div>}
        </div>
        <Inp label="Service Area" value={f.serviceArea} onChange={s("serviceArea")} placeholder="e.g. LA, OC, IE" />
      </div>
      <Txt label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8 }}>
        <Btn onClick={() => f.name.trim() && onSave(f)} style={{ flex: 1 }}>Save EPC Partner</Btn>
        <Btn onClick={onCancel} variant="ghost" style={{ flex: 1 }}>Cancel</Btn>
      </div>
    </div>
  );
}

// ─── Customer Form ─────────────────────────────────────────────────────────
const emptyCustomer = { name: "", phone: "", email: "", address: "", city: "", state: "CA", zip: "", epcPartnerId: "", epcPartnerName: "", notes: "", status: "Active", customerId: "", createdAt: "" };

function CustomerForm({ initial, onSave, onCancel, title, epcPartners }) {
  const [f, setF] = useState({ ...emptyCustomer, ...initial, createdAt: (initial?.createdAt) || new Date().toISOString().split("T")[0] });
  const s = k => v => setF(x => ({ ...x, [k]: v }));

  const handleEPCChange = (id) => {
    const partner = epcPartners.find(p => String(p.id) === String(id));
    setF(x => ({ ...x, epcPartnerId: id, epcPartnerName: partner ? partner.company || partner.name : "" }));
  };

  const epcOptions = [{ value: "", label: "-- Select EPC Partner --" }, ...epcPartners.map(p => ({ value: String(p.id), label: p.company || p.name }))];

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display',serif", color: "#d4891f", fontSize: 18, marginBottom: 18 }}>{title}</h2>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Inp label="Customer Name *" value={f.name} onChange={s("name")} />
        <Inp label="Date Added" value={f.createdAt} onChange={s("createdAt")} type="date" />
        <Inp label="Phone" value={f.phone} onChange={s("phone")} type="tel" />
        <Inp label="Email" value={f.email} onChange={s("email")} type="email" />
      </div>
      <Inp label="Address" value={f.address} onChange={s("address")} />
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 10 }}>
        <Inp label="City" value={f.city} onChange={s("city")} />
        <Inp label="State" value={f.state} onChange={s("state")} />
        <Inp label="Zip" value={f.zip} onChange={s("zip")} />
      </div>
      <Txt label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8 }}>
        <Btn onClick={() => f.name.trim() && onSave(f)} style={{ flex: 1 }}>Save Customer</Btn>
        <Btn onClick={onCancel} variant="ghost" style={{ flex: 1 }}>Cancel</Btn>
      </div>
    </div>
  );
}

// ─── Job Form ─────────────────────────────────────────────────────────────
const emptyJob = { customerId: "", customerName: "", epcPartnerId: "", epcPartnerName: "", contractType: "epc", address: "", stage: "Lead", jobTypes:[], estimatedKw: 0, leadSource: "", assignedTo: "", financingType: "", utilityCompany: "", monthlyBill: 0, proposalAmount: 0, followUpDate: "", salesNotes: "", contractValue: 0, paid: 0, startDate: "", endDate: "", notes: "", milestones: [], subcontractors: [], suntrifyAdders:{}, suntrifyBattery:{}, suntrifyTotal:0, epcCustomerId:"" };
const LEAD_SOURCES = ["", "Referral", "EPC Partner", "Door to Door", "Online / Web", "Social Media", "Repeat Customer", "Event / Expo", "Other"];
const FINANCING_TYPES = ["", "Cash", "Loan", "PPA", "Lease", "PACE", "TBD"];

function genSuntrifyId(existingCustomers) {
  const ids = (existingCustomers||[]).map(c => parseInt((c.suntrifyId||"SUN-1000").replace("SUN-",""))||1000);
  const max = ids.length > 0 ? Math.max(...ids) : 1000;
  return "SUN-" + (max + 1);
}

function calcESPTotal(suntrifyAdders, suntrifyBattery, panels) {
  let total = 0;
  ESP_ADDERS.forEach(a => {
    const val = suntrifyAdders[a.label]||0;
    if(val>0) {
      if(a.type==="flat") total += a.rate;
      else if(a.type==="per_panel") total += a.rate * (panels||0);
      else total += a.rate * val;
    }
  });
  ESP_BATTERY.forEach(b => {
    if(suntrifyBattery[b.label]) total += b.rate;
  });
  return total;
}

function JobForm({ initial, onSave, onCancel, title, customers, epcPartners }) {
  const [f, setF] = useState({ ...emptyJob, ...initial });
  const [milIn, setMilIn] = useState("");
  const s = k => v => setF(x => ({ ...x, [k]: v }));

  const handleCustomerChange = (id) => {
    const c = customers.find(x => String(x.id) === String(id));
    if (c) {
      setF(x => ({ ...x, customerId: id, customerName: c.name, address: c.address + (c.city ? ", " + c.city : "") + (c.state ? ", " + c.state : "") + (c.zip ? " " + c.zip : ""), epcPartnerId: c.epcPartnerId, epcPartnerName: c.epcPartnerName }));
    } else {
      setF(x => ({ ...x, customerId: id }));
    }
  };

  const addMil = () => {
    const l = milIn.trim();
    if (l) { setF(x => ({ ...x, milestones: [...(x.milestones || []), { id: Date.now(), label: l, done: false }] })); setMilIn(""); }
  };
  const toggleMil = id => setF(x => ({ ...x, milestones: x.milestones.map(m => m.id === id ? { ...m, done: !m.done } : m) }));
  const removeMil = id => setF(x => ({ ...x, milestones: x.milestones.filter(m => m.id !== id) }));

  const customerOptions = [{ value: "", label: "-- Select Customer --" }, ...customers.map(c => ({ value: String(c.id), label: c.name + (c.city ? " · " + c.city : "") }))];
  const epcOptions = [{ value: "", label: "-- Select EPC Partner --" }, ...epcPartners.map(p => ({ value: String(p.id), label: p.company || p.name }))];

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display',serif", color: "#d4891f", fontSize: 18, marginBottom: 18 }}>{title}</h2>
      <SearchSel label="Customer *" value={String(f.customerId)} onChange={handleCustomerChange} options={customerOptions} />
      <F label="Contract Type">
        <div style={{display:"flex",gap:8,marginBottom:4}}>
          {[{v:"epc",label:"🤝 EPC Sub",sub:"Working under an EPC partner"},{v:"direct",label:"🏠 Direct Sale",sub:"Suntrify sells to homeowner"}].map(opt=>(
            <button key={opt.v} type="button" onClick={()=>setF(x=>({...x,contractType:opt.v,epcPartnerId:opt.v==="direct"?"":x.epcPartnerId,epcPartnerName:opt.v==="direct"?"Suntrify (Direct)":x.epcPartnerName}))}
              style={{flex:1,padding:"8px 12px",borderRadius:8,border:"1px solid "+((f.contractType||"epc")===opt.v?"#f0a500":"#dde0ea"),background:(f.contractType||"epc")===opt.v?"#f0a50015":"transparent",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <div style={{fontWeight:700,fontSize:13,color:(f.contractType||"epc")===opt.v?"#d4891f":"#1a1d25"}}>{opt.label}</div>
              <div style={{fontSize:11,color:"#9aa0b4",marginTop:2}}>{opt.sub}</div>
            </button>
          ))}
        </div>
      </F>
      {(f.contractType||"epc")==="epc"&&<Sel label="EPC Partner *" value={String(f.epcPartnerId)} onChange={v => { const p = epcPartners.find(x => String(x.id) === String(v)); setF(x => ({ ...x, epcPartnerId: v, epcPartnerName: p ? p.company || p.name : "" })); }} options={epcOptions} />}
      {(f.contractType||"epc")==="epc"&&<Inp label="EPC Customer ID" value={f.epcCustomerId||""} onChange={s("epcCustomerId")} placeholder="e.g. 50886"/>}
      <Inp label="Address / Site" value={f.address} onChange={s("address")} />
      <F label="Scope (select all that apply)">
        <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
          {JOB_TYPES.map(t=><button key={t} type="button" onClick={()=>setF(x=>({...x,jobTypes:(x.jobTypes||[]).includes(t)?(x.jobTypes||[]).filter(v=>v!==t):[...(x.jobTypes||[]),t]}))} style={{background:(f.jobTypes||[]).includes(t)?"#f0a500":"transparent",border:"1px solid "+((f.jobTypes||[]).includes(t)?"#f0a500":"#dde0ea"),borderRadius:6,padding:"5px 12px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:(f.jobTypes||[]).includes(t)?"#000":"#6a7080",fontWeight:(f.jobTypes||[]).includes(t)?700:400}}>{t}</button>)}
        </div>
        {(f.jobTypes||[]).includes("Solar PV")&&<Inp label="Estimated kW" value={f.estimatedKw||0} onChange={v=>s("estimatedKw")(Number(v))} type="number"/>}
      </F>
      <Sel label="Stage" value={f.stage} onChange={s("stage")} options={JOB_STAGES} />
      <div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase",letterSpacing:1}}>Sales Tracking</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Sel label="Lead Source" value={f.leadSource||""} onChange={s("leadSource")} options={LEAD_SOURCES}/>
          <Inp label="Assigned To" value={f.assignedTo||""} onChange={s("assignedTo")} placeholder="Sales rep name"/>
          <Sel label="Financing Type" value={f.financingType||""} onChange={s("financingType")} options={FINANCING_TYPES}/>
          <Inp label="Utility Company" value={f.utilityCompany||""} onChange={s("utilityCompany")}/>
          <Inp label="Monthly Bill $" value={f.monthlyBill||0} onChange={v=>s("monthlyBill")(Number(v))} type="number"/>
          <Inp label="Proposal Amount $" value={f.proposalAmount||0} onChange={v=>s("proposalAmount")(Number(v))} type="number"/>
          <Inp label="Follow-Up Date" value={f.followUpDate||""} onChange={s("followUpDate")} type="date"/>
        </div>
        <Txt label="Sales Notes" value={f.salesNotes||""} onChange={s("salesNotes")}/>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Inp label="Contract Value $" value={f.contractValue} onChange={v => s("contractValue")(Number(v))} type="number" />
        <Inp label="Amount Paid $" value={f.paid} onChange={v => s("paid")(Number(v))} type="number" />
        <Inp label="Start Date" value={f.startDate} onChange={s("startDate")} type="date" />
        <Inp label="End Date" value={f.endDate} onChange={s("endDate")} type="date" />
      </div>
      <Txt label="Notes" value={f.notes} onChange={s("notes")} />

      <F label="Milestones">
        <div style={{ marginBottom: 8 }}>
          {(f.milestones || []).map(m => (
            <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <input type="checkbox" checked={m.done} onChange={() => toggleMil(m.id)} style={{ accentColor: "#f0a500" }} />
              <span style={{ flex: 1, fontSize: 13, color: m.done ? "#9aa0b4" : "#1a1d25", textDecoration: m.done ? "line-through" : "none" }}>{m.label}</span>
              <span onClick={() => removeMil(m.id)} style={{ color: "#ef4444", cursor: "pointer", fontSize: 12 }}>✕</span>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <input value={milIn} onChange={e => setMilIn(e.target.value)} onKeyDown={e => e.key === "Enter" && addMil()} placeholder="Add milestone…" style={{ ...IS, flex: 1 }} />
          <Btn onClick={addMil} small>+</Btn>
        </div>
      </F>
      <div style={{ display: "flex", gap: 8 }}>
        <Btn onClick={() => onSave(f)} style={{ flex: 1 }}>Save Job</Btn>
        <Btn onClick={onCancel} variant="ghost" style={{ flex: 1 }}>Cancel</Btn>
      </div>
    </div>
  );
}

// ─── Subcontractor Form ────────────────────────────────────────────────────
const emptySub = { name: "", company: "", phone: "", email: "", licenseNumber: "", licenseClass: "", licenseStatus: "", licenseExpiration: "", address: "", city: "", state: "CA", zip: "", notes: "", status: "Active" };

function SubcontractorForm({ initial, onSave, onCancel, title }) {
  const [f, setF] = useState({ ...emptySub, ...initial });
  const [verifying, setVerifying] = useState(false);
  const [verifyData, setVerifyData] = useState(null);
  const s = k => v => setF(x => ({ ...x, [k]: v }));

  const verifyLicense = async () => {
    const num = (f.licenseNumber || "").replace(/\D/g, "");
    if (!num) return;
    setVerifying(true); setVerifyData(null);
    try {
      const res = await fetch(`${AWS_API}/cslb/lookup?license=${num}`);
      const data = await res.json();
      if (!res.ok) { setVerifyData({ error: data.error || "Lookup failed" }); return; }
      setVerifyData(data);
      setF(x => ({
        ...x,
        company: x.company || data.businessName || x.company,
        name: x.name || data.businessName || x.name,
        licenseClass: data.classifications?.map(c => c.code).join(", ") || x.licenseClass,
        licenseExpiration: data.expiration || x.licenseExpiration,
        licenseStatus: /active/i.test(data.status || "") ? "Active" : (data.status ? "Inactive" : x.licenseStatus),
      }));
    } catch(e) { setVerifyData({ error: "Network error — try again" }); }
    finally { setVerifying(false); }
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display',serif", color: "#d4891f", fontSize: 18, marginBottom: 18 }}>{title}</h2>
      {f.createdAt && <div style={{fontSize:11,color:"#9aa0b4",marginBottom:12}}>📅 Added: {f.createdAt}</div>}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Inp label="Name *" value={f.name} onChange={s("name")} />
        <Inp label="Company" value={f.company} onChange={s("company")} />
        <Inp label="Phone" value={f.phone} onChange={s("phone")} type="tel" />
        <Inp label="Email" value={f.email} onChange={s("email")} type="email" />
        <div>
          <Inp label="License # (CSLB)" value={f.licenseNumber} onChange={v=>{s("licenseNumber")(v);setVerifyData(null);}} placeholder="e.g. 1055498" />
          <div style={{display:"flex",gap:6,marginTop:4}}>
            <button onClick={verifyLicense} disabled={verifying||!(f.licenseNumber||"").replace(/\D/g,"")}
              style={{flex:1,padding:"7px 0",background:"#f0a500",color:"#000",border:"none",borderRadius:6,fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",opacity:verifying||!(f.licenseNumber||"").replace(/\D/g,"")?0.4:1}}>
              {verifying ? "Verifying…" : "Auto-Fill from CSLB"}
            </button>
            <button onClick={()=>{const n=(f.licenseNumber||"").replace(/\D/g,"");if(!n)return;window.open(`https://www2.cslb.ca.gov/OnlineServices/CheckLicenseII/LicenseDetail.aspx?LicNum=${n}`,"_blank");}}
              disabled={!(f.licenseNumber||"").replace(/\D/g,"")}
              style={{flex:1,padding:"7px 0",background:"#0f1e3c",color:"#fff",border:"none",borderRadius:6,fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",opacity:(f.licenseNumber||"").replace(/\D/g,"")?1:0.4}}>
              View on CSLB ↗
            </button>
          </div>
          {verifyData && !verifyData.error && (
            <div style={{marginTop:5,display:"flex",flexWrap:"wrap",gap:4}}>
              <span style={{fontSize:10,fontWeight:700,color:/active/i.test(verifyData.status||"")?"#16a34a":"#dc2626",background:/active/i.test(verifyData.status||"")?"#dcfce7":"#fee2e2",borderRadius:4,padding:"2px 7px"}}>{/active/i.test(verifyData.status||"")?"Active":"Inactive"}</span>
              {verifyData.expiration&&<span style={{fontSize:10,color:"#6a7080",padding:"2px 6px",background:"#f0f1f5",borderRadius:4}}>Exp {verifyData.expiration}</span>}
              {verifyData.classifications?.map(c=><span key={c.code} style={{fontSize:10,fontWeight:700,color:"#fff",background:"#1d4ed8",borderRadius:4,padding:"2px 7px"}} title={c.description}>{c.code}</span>)}
            </div>
          )}
          {verifyData?.error&&<div style={{fontSize:11,color:"#dc2626",marginTop:3}}>⚠ {verifyData.error}</div>}
        </div>
        <div/>
      </div>
      <Sel label="CA License Classification" value={f.licenseClass||""} onChange={s("licenseClass")} options={CA_LICENSE_CLASSIFICATIONS} />
      <Inp label="Address" value={f.address||""} onChange={s("address")} placeholder="Street address" />
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 10 }}>
        <Inp label="City" value={f.city||""} onChange={s("city")} />
        <Inp label="State" value={f.state||""} onChange={s("state")} />
        <Inp label="ZIP" value={f.zip||""} onChange={s("zip")} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
      </div>
      <Txt label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8 }}>
        <Btn onClick={() => f.name.trim() && onSave(f)} style={{ flex: 1 }}>Save Subcontractor</Btn>
        <Btn onClick={onCancel} variant="ghost" style={{ flex: 1 }}>Cancel</Btn>
      </div>
    </div>
  );
}

// ─── Card Components ────────────────────────────────────────────────────────
function JobCard({ job, onClick }) {
  const sc = STAGE_COLORS[job.stage] || "#6b7280";
  const pct = job.contractValue > 0 ? Math.min(100, Math.round((job.paid / job.contractValue) * 100)) : 0;
  const owed = (job.contractValue || 0) - (job.paid || 0);
  return (
    <div onClick={onClick} style={{ background: "#fff", border: "1px solid #e0e3eb", borderRadius: 10, padding: "14px 16px", cursor: "pointer", marginBottom: 8, transition: "border-color .12s" }}
      onMouseEnter={e => e.currentTarget.style.borderColor = sc}
      onMouseLeave={e => e.currentTarget.style.borderColor = "#e0e3eb"}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 5 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1d25", fontFamily: "'DM Serif Display',serif" }}>{job.customerName || "Unknown Customer"}</div>
          <div style={{ fontSize: 12, color: "#6a7080" }}>{job.address}</div>
        </div>
        <Pill label={job.stage} color={sc} />
      </div>
      <div style={{ display: "flex", gap: 8, fontSize: 12, color: "#8891a4", marginBottom: (job.jobTypes||[]).length > 0 || job.proposalAmount > 0 ? 6 : 0, flexWrap: "wrap", alignItems: "center" }}>
        {job.epcPartnerName && <span style={{color:"#6a7080"}}>🤝 {job.epcPartnerName}</span>}
        {(job.jobTypes||[]).map(t=><span key={t} style={{background:"#f0f1f5",borderRadius:4,padding:"1px 7px",fontSize:11,color:"#4a5060"}}>{t}</span>)}
        {job.estimatedKw > 0 && <span style={{color:"#d4891f",fontSize:11}}>~{job.estimatedKw} kW</span>}
      </div>
      {job.proposalAmount > 0 && <div style={{fontSize:12,color:"#d4891f",fontWeight:600,marginBottom:6}}>${job.proposalAmount.toLocaleString()} proposal{job.leadSource?" · "+job.leadSource:""}</div>}
      {job.contractValue > 0 && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#8891a4", marginBottom: 3 }}>
            <span style={{ color: "#22c55e" }}>${(job.paid || 0).toLocaleString()} paid</span>
            <span style={{ color: owed > 0 ? "#f0a500" : "#22c55e" }}>${owed.toLocaleString()} owed · ${job.contractValue.toLocaleString()}</span>
          </div>
          <div style={{ height: 4, background: "#f0f1f5", borderRadius: 2 }}>
            <div style={{ height: "100%", width: pct + "%", background: pct === 100 ? "#22c55e" : "#f0a500", borderRadius: 2 }} />
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Pipeline ──────────────────────────────────────────────────────────────
function Pipeline({ jobs, onJobClick, onAddJob, viewMode, epcPartners }) {
  if (viewMode === "status") {
    const thS = { padding:"10px 14px", textAlign:"left", fontWeight:700, fontSize:11, color:"#9aa0b4", textTransform:"uppercase", letterSpacing:"0.06em", whiteSpace:"nowrap", background:"#f8f9fb" };
    const tdS = { padding:"10px 14px", borderBottom:"1px solid #f0f2f5", verticalAlign:"middle" };

    const allRows = [];
    JOB_STAGES.forEach(stage => {
      const col = jobs.filter(j => j.stage === stage);
      if (col.length === 0) return;
      const total = col.reduce((s, j) => s + (j.contractValue || 0), 0);
      allRows.push({ type: "group", stage, count: col.length, total });
      col.forEach(j => allRows.push({ type: "job", job: j }));
    });

    if (allRows.length === 0) return <div style={{textAlign:"center",color:"#9aa0b4",padding:"60px 0"}}>No active jobs.</div>;

    return (
      <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr style={{borderBottom:"2px solid #e0e3eb"}}>
              <th style={{...thS,width:36}}></th>
              <th style={thS}>Job #</th>
              <th style={thS}>Customer</th>
              <th style={thS}>Address</th>
              <th style={thS}>EPC Partner</th>
              <th style={thS}>Types</th>
              <th style={{...thS,textAlign:"right"}}>Value</th>
            </tr>
          </thead>
          <tbody>
            {allRows.map((row, i) => {
              if (row.type === "group") {
                const color = STAGE_COLORS[row.stage] || "#6a7080";
                return (
                  <tr key={"g-"+row.stage} style={{background:"#f5f7fa", borderTop: i > 0 ? "2px solid #e0e3eb" : "none"}}>
                    <td colSpan={7} style={{padding:"8px 14px"}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <div style={{width:9,height:9,borderRadius:"50%",background:color,flexShrink:0}}/>
                        <span style={{fontFamily:"'DM Serif Display',serif",fontWeight:700,fontSize:14,color:"#1a1d25"}}>{row.stage}</span>
                        <span style={{background:"#e0e3eb",color:"#6a7080",borderRadius:10,padding:"1px 8px",fontSize:11,fontWeight:600}}>{row.count} job{row.count!==1?"s":""}</span>
                        {row.total>0&&<span style={{marginLeft:"auto",color:"#22c55e",fontWeight:700,fontSize:13}}>${row.total.toLocaleString()}</span>}
                        <button onClick={()=>onAddJob(row.stage)} style={{marginLeft:row.total>0?0:"auto",padding:"3px 10px",border:"1px dashed #c0c5d5",borderRadius:6,background:"transparent",color:"#9aa0b4",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>+ Add</button>
                      </div>
                    </td>
                  </tr>
                );
              }
              const j = row.job;
              const cancelled = j.stage==="Cancelled"||j.stage==="Closed";
              const value = j.contractValue||0;
              return (
                <tr key={j._dbId||j.id}
                  onClick={()=>onJobClick(j)}
                  style={{borderBottom:"1px solid #f0f2f5",cursor:"pointer",opacity:cancelled?0.45:1}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f0f4ff"}
                  onMouseLeave={e=>e.currentTarget.style.background=""}>
                  <td style={{...tdS,textAlign:"center",width:36}}>
                    <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:27,height:27,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                      <Icon name="eye" size={12} color="#6a7080"/>
                    </span>
                  </td>
                  <td style={{...tdS,fontFamily:"monospace",fontWeight:700,fontSize:11,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.sunJobId||"—"}</td>
                  <td style={{...tdS,fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.customerName||"—"}</td>
                  <td style={{...tdS,color:"#6a7080",fontSize:12}}>{j.address||"—"}</td>
                  <td style={{...tdS,color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{j.epcPartnerName||"—"}</td>
                  <td style={tdS}>
                    <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
                      {(j.jobTypes||[]).map(t=><span key={t} style={{background:"#f0f1f5",color:"#1a1d25",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 6px",fontSize:10,fontWeight:600,whiteSpace:"nowrap"}}>{t}</span>)}
                      {j.estimatedKw>0&&<span style={{background:"#f0f1f5",color:"#6a7080",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 6px",fontSize:10,whiteSpace:"nowrap"}}>{j.estimatedKw} kW</span>}
                    </div>
                  </td>
                  <td style={{...tdS,textAlign:"right",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{value>0?"$"+value.toLocaleString():"—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  // By EPC Partner — table view
  const partners = [{ id: "suntrify", name: "Suntrify (Direct)", color: "#f0a500" }, ...epcPartners.map(p => ({ id: String(p.id || p._dbId), name: p.company || p.name, color: "#3b82f6" }))];
  const thS = { padding:"10px 14px", textAlign:"left", fontWeight:700, fontSize:11, color:"#9aa0b4", textTransform:"uppercase", letterSpacing:"0.06em", whiteSpace:"nowrap", background:"#f8f9fb" };
  const tdS = { padding:"10px 14px", borderBottom:"1px solid #f0f2f5", verticalAlign:"middle" };
  const fmtD = d => { if(!d) return "—"; const [y,m,dy]=d.split("-"); return `${m}-${dy}-${y}`; };

  const allRows = [];
  partners.forEach(partner => {
    const pJobs = partner.id === "suntrify"
      ? jobs.filter(j => j.contractType === "direct" || !j.epcPartnerId || j.epcPartnerName === "Suntrify")
      : jobs.filter(j => String(j.epcPartnerId) === partner.id || String(j._epcDbId) === partner.id);
    if (pJobs.length === 0) return;
    const total = pJobs.reduce((s, j) => s + (j.contractValue || 0), 0);
    allRows.push({ type: "group", partner, count: pJobs.length, total });
    pJobs.forEach(j => allRows.push({ type: "job", job: j, partnerColor: partner.color }));
  });

  if (allRows.length === 0) return <div style={{textAlign:"center",color:"#9aa0b4",padding:"60px 0"}}>No active jobs.</div>;

  return (
    <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
        <thead>
          <tr style={{borderBottom:"2px solid #e0e3eb"}}>
            <th style={{...thS,width:36}}></th>
            <th style={thS}>Job #</th>
            <th style={thS}>Stage</th>
            <th style={thS}>Customer</th>
            <th style={thS}>Address</th>
            <th style={thS}>EPC Job #</th>
            <th style={thS}>Types</th>
            <th style={{...thS,textAlign:"right"}}>Value</th>
          </tr>
        </thead>
        <tbody>
          {allRows.map((row, i) => {
            if (row.type === "group") {
              return (
                <tr key={"g-"+row.partner.id} style={{background:"#f5f7fa",borderTop: i > 0 ? "2px solid #e0e3eb" : "none"}}>
                  <td colSpan={8} style={{padding:"8px 14px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:9,height:9,borderRadius:"50%",background:row.partner.color,flexShrink:0}}/>
                      <span style={{fontFamily:"'DM Serif Display',serif",fontWeight:700,fontSize:14,color:"#1a1d25"}}>{row.partner.name}</span>
                      <span style={{background:"#e0e3eb",color:"#6a7080",borderRadius:10,padding:"1px 8px",fontSize:11,fontWeight:600}}>{row.count} job{row.count!==1?"s":""}</span>
                      {row.total>0&&<span style={{marginLeft:"auto",color:"#22c55e",fontWeight:700,fontSize:13}}>${row.total.toLocaleString()}</span>}
                    </div>
                  </td>
                </tr>
              );
            }
            const j = row.job;
            const cancelled = j.stage==="Cancelled"||j.stage==="Closed";
            const value = j.contractValue||0;
            return (
              <tr key={j._dbId||j.id}
                onClick={() => onJobClick(j)}
                style={{borderBottom:"1px solid #f0f2f5",cursor:"pointer",opacity:cancelled?0.45:1}}
                onMouseEnter={e=>e.currentTarget.style.background="#f0f4ff"}
                onMouseLeave={e=>e.currentTarget.style.background=""}>
                <td style={{...tdS,textAlign:"center",width:36}}>
                  <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:27,height:27,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                    <Icon name="eye" size={12} color="#6a7080"/>
                  </span>
                </td>
                <td style={{...tdS,fontFamily:"monospace",fontWeight:700,fontSize:11,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.sunJobId||"—"}</td>
                <td style={{...tdS,whiteSpace:"nowrap"}}>
                  <span style={{background:"#f0f1f5",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700,color:STAGE_COLORS[j.stage]||"#1a1d25"}}>{j.stage||"Lead"}</span>
                </td>
                <td style={{...tdS,fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.customerName||"—"}</td>
                <td style={{...tdS,color:"#6a7080",fontSize:12}}>{j.address||"—"}</td>
                <td style={{...tdS,color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{j.epcCustomerId||"—"}</td>
                <td style={tdS}>
                  <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
                    {(j.jobTypes||[]).map(t=><span key={t} style={{background:"#f0f1f5",color:"#1a1d25",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 6px",fontSize:10,fontWeight:600,whiteSpace:"nowrap"}}>{t}</span>)}
                    {j.estimatedKw>0&&<span style={{background:"#f0f1f5",color:"#6a7080",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 6px",fontSize:10,whiteSpace:"nowrap"}}>{j.estimatedKw} kW</span>}
                  </div>
                </td>
                <td style={{...tdS,textAlign:"right",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{value>0?"$"+value.toLocaleString():"—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ─── Reminders ─────────────────────────────────────────────────────────────
function Reminders({ jobs, customers, onJobClick }) {
  const today = new Date().toISOString().split("T")[0];
  const unpaid = jobs.filter(j => (j.contractValue || 0) > (j.paid || 0) && j.stage !== "Lead" && j.stage !== "Cancelled");
  const overdue = jobs.filter(j => j.endDate && j.endDate < today && j.stage !== "Closed" && j.stage !== "Cancelled");
  const inProgress = jobs.filter(j => j.stage === "In Progress");

  // Build unified rows with a type tag
  const rows = [
    ...unpaid.map(j => ({ ...j, _reminderType: "payment" })),
    ...overdue.filter(j => !unpaid.find(u => u._dbId === j._dbId)).map(j => ({ ...j, _reminderType: "overdue" })),
    ...inProgress.filter(j => !unpaid.find(u => u._dbId === j._dbId) && !overdue.find(o => o._dbId === j._dbId)).map(j => ({ ...j, _reminderType: "active" })),
  ];

  const fmtDate = d => { if(!d) return "—"; const [y,m,dy] = d.split("-"); return `${m}-${dy}-${y}`; };

  const typeConfig = {
    payment: { label: "Payment Due", bg: "#ef444418", color: "#ef4444", border: "#ef444440" },
    overdue:  { label: "Overdue",      bg: "#f59e0b18", color: "#f59e0b", border: "#f59e0b40" },
    active:   { label: "Active",       bg: "#3b82f618", color: "#3b82f6", border: "#3b82f640" },
  };

  if (rows.length === 0) return (
    <div style={{ textAlign: "center", padding: "60px 0", color: "#6a7080" }}>
      <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
      <div>All caught up!</div>
    </div>
  );

  return (
    <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
        <thead>
          <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
            <th style={{width:40,padding:"10px 12px"}}></th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Alert</th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Job #</th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Customer</th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Address</th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>EPC Partner</th>
            <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Detail</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(j => {
            const cfg = typeConfig[j._reminderType];
            const detail = j._reminderType === "payment"
              ? `$${((j.contractValue||0)-(j.paid||0)).toLocaleString()} owed`
              : j._reminderType === "overdue"
              ? `Due ${fmtDate(j.endDate)}`
              : j.stage;
            return (
              <tr key={j._dbId + j._reminderType}
                onClick={() => onJobClick(j)}
                style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer"}}
                onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                onMouseLeave={e=>e.currentTarget.style.background=""}>
                <td style={{padding:"8px 12px",textAlign:"center"}}>
                  <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                    <Icon name="eye" size={13} color="#6a7080"/>
                  </span>
                </td>
                <td style={{padding:"10px 14px",whiteSpace:"nowrap"}}>
                  <span style={{background:cfg.bg,color:cfg.color,border:"1px solid "+cfg.border,borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{cfg.label}</span>
                </td>
                <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:700,fontSize:11,color:"#1a1d25",fontFamily:"monospace"}}>{j.sunJobId||"—"}</td>
                <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.customerName||"—"}</td>
                <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{j.address||"—"}</td>
                <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap",fontSize:12}}>{j.epcPartnerName||"—"}</td>
                <td style={{padding:"10px 14px",fontWeight:700,color:cfg.color,whiteSpace:"nowrap"}}>{detail}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ─── Sidebar ───────────────────────────────────────────────────────────────
function Sidebar({ tab, setTab, jobs, epcPartners, customers, subcontractors, workOrders=[], currentUser, onLogout, onManageUsers, darkMode=false, setDarkMode, setGlobalSearch }) {
  const woBackChargeTotal = workOrders.filter(w => w.backCharge && w.chargeAmount > 0).reduce((s, w) => s + (w.chargeAmount || 0), 0);
  const woCollected = workOrders.filter(w => w.backCharge && w.chargeAmount > 0 && w.status === "Complete").reduce((s, w) => s + (w.chargeAmount || 0), 0);
  const totalPipeline = jobs.filter(j => j.stage !== "Closed" && j.stage !== "Cancelled").reduce((s, j) => s + (j.contractValue || 0), 0) + woBackChargeTotal;
  const totalCollected = jobs.reduce((s, j) => s + (j.paid || 0), 0) + woCollected;
  const unpaidCount = jobs.filter(j => (j.contractValue || 0) > (j.paid || 0) && j.stage !== "Lead" && j.stage !== "Cancelled").length;

  const navItems = [
    { id: "dashboard", icon: "dashboard", label: "Dashboard" },
    { id: "pipeline", icon: "pipeline", label: "Pipeline", count: jobs.filter(j => j.stage !== "Closed" && j.stage !== "Cancelled").length },
    { id: "customers", icon: "customers", label: "Customers", count: customers.length },
    { id: "jobs", icon: "jobs", label: "Jobs", count: jobs.length },
    { id: "workorders", icon: "workorders", label: "Work Orders", count: workOrders.length },
    { id: "photos", icon: "reports", label: "Photos" },
    { id: "epc", icon: "epc", label: "EPC Partners", count: epcPartners.length },
    { id: "subcontractors", icon: "subcontractors", label: "Subcontractors", count: subcontractors.length },
    { id: "reminders", icon: "reminders", label: "Reminders", count: unpaidCount, alert: unpaidCount > 0 },
    { id: "reports", icon: "reports", label: "Reports" },
    { id: "proposals", icon: "invoices", label: "Proposals" },
    { id: "invoices", icon: "invoices", label: "Invoices" },
    { id: "estimator", icon: "reports", label: "Estimator" },
  ];

  return (
    <div style={{ width: 220, minWidth: 220, background: "#fff", borderRight: "1px solid #e0e3eb", display: "flex", flexDirection: "column", height: "100vh", fontFamily: "'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display&display=swap" rel="stylesheet" />
      <div style={{ WebkitAppRegion: "drag", padding: "20px 16px 14px", borderBottom: "1px solid #e0e3eb" }}>
        <div style={{ marginTop: 16, marginBottom: 4 }}>
          <SuntrifyLogo darkMode={darkMode} height={22}/>
          <div style={{ fontSize: 9, color: "#9aa0b4", letterSpacing: "0.1em", marginTop:4, textTransform:"uppercase" }}>CRM</div>
        </div>
      </div>
      <div style={{ padding: "10px 8px", flex: 1, overflowY: "auto" }}>
        {navItems.map(item => (
          <button key={item.id} onClick={() => setTab(item.id)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", borderRadius: 8, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: tab === item.id ? 700 : 400, border: "none", background: tab === item.id ? "#f0a50015" : "transparent", color: tab === item.id ? "#d4891f" : "#6a7080", marginBottom: 2, textAlign: "left", position: "relative" }}>
            <NavIcon name={item.icon}/>
            <span style={{ flex: 1 }}>{item.label}</span>
            {item.count > 0 && <span style={{ background: item.alert ? "#ef4444" : (tab === item.id ? "#f0a50022" : "#f0f1f5"), color: item.alert ? "#fff" : (tab === item.id ? "#d4891f" : "#6a7080"), borderRadius: 10, padding: "1px 7px", fontSize: 11, fontWeight: 700 }}>{item.count}</span>}
          </button>
        ))}
      </div>
      <div style={{ padding: "12px 14px", borderTop: "1px solid #e0e3eb" }}>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 9, color: "#9aa0b4", letterSpacing: "0.1em", textTransform: "uppercase" }}>Pipeline</div>
          <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, color: "#f0a500", fontWeight: 700 }}>${totalPipeline.toLocaleString()}</div>
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 9, color: "#9aa0b4", letterSpacing: "0.1em", textTransform: "uppercase" }}>Collected</div>
          <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, color: "#22c55e", fontWeight: 700 }}>${totalCollected.toLocaleString()}</div>
        </div>
        <div style={{ fontSize: 11, color: "#1a1d25", fontWeight: 700, marginBottom: 2 }}>{currentUser?.name}</div>
        <div style={{ fontSize: 10, color: "#9aa0b4", marginBottom: 10 }}>{currentUser?.role}</div>
        {currentUser?.role === "Admin" && (
          <button onClick={onManageUsers} style={{ width: "100%", background: "transparent", border: "1px solid #e0e3eb", borderRadius: 7, color: "#6a7080", fontSize: 11, padding: "6px", cursor: "pointer", fontFamily: "'DM Sans',sans-serif", marginBottom: 6 }}>👥 Manage Users</button>
        )}
        <button onClick={() => { if(setDarkMode) setDarkMode(d => !d); }} style={{ width: "100%", padding: "8px 10px", border: "none", background: "transparent", cursor: "pointer", color: "#9aa0b4", fontSize: 13, textAlign: "left", fontFamily: "inherit", marginBottom: 4 }}>
          {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
        </button>
        <button onClick={() => { if(setGlobalSearch) setGlobalSearch(true); }} style={{ width: "100%", padding: "8px 10px", border: "none", background: "transparent", cursor: "pointer", color: "#9aa0b4", fontSize: 13, textAlign: "left", fontFamily: "inherit", marginBottom: 4 }}>
          🔍 Search Everything
        </button>
        <button onClick={onLogout} style={{ width: "100%", background: "transparent", border: "1px solid #ef444430", borderRadius: 7, color: "#ef4444", fontSize: 11, padding: "6px", cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>Sign Out</button>
      </div>
    </div>
  );
}

// ─── Main App ─────────────────────────────────────────────────────────────
// ── WO Calendar ──────────────────────────────────────────────────────────────
function WOCalendar({ workOrders, darkMode, card, borderColor, textColor, mutedColor, onWOClick }) {
  const [month, setMonth] = React.useState(new Date());
  const year = month.getFullYear(), mon = month.getMonth();
  const firstDay = new Date(year, mon, 1).getDay();
  const daysInMonth = new Date(year, mon + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  const woByDay = {};
  workOrders.forEach(w => {
    if (w.date) {
      const [y, m2, d] = w.date.split("-");
      if (+y === year && +m2 - 1 === mon) {
        if (!woByDay[+d]) woByDay[+d] = [];
        woByDay[+d].push(w);
      }
    }
  });
  const todayDate = new Date().getDate(), todayMonth = new Date().getMonth(), todayYear = new Date().getFullYear();
  const isToday = (d) => d === todayDate && mon === todayMonth && year === todayYear;
  const bg = darkMode ? "#0f1117" : "#f5f6fa";
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: 22, fontWeight: 800, color: textColor }}>WO Calendar — {month.toLocaleString("default", { month: "long", year: "numeric" })}</div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => setMonth(new Date(year, mon - 1, 1))} style={{ padding: "6px 14px", border: "1px solid " + borderColor, borderRadius: 8, background: card, cursor: "pointer", fontFamily: "inherit", color: textColor }}>‹ Prev</button>
          <button onClick={() => setMonth(new Date())} style={{ padding: "6px 14px", border: "1px solid " + borderColor, borderRadius: 8, background: card, cursor: "pointer", fontFamily: "inherit", color: textColor }}>Today</button>
          <button onClick={() => setMonth(new Date(year, mon + 1, 1))} style={{ padding: "6px 14px", border: "1px solid " + borderColor, borderRadius: 8, background: card, cursor: "pointer", fontFamily: "inherit", color: textColor }}>Next ›</button>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4, marginBottom: 8 }}>
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: mutedColor, padding: "4px 0" }}>{d}</div>)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4 }}>
        {cells.map((d, i) => {
          if (!d) return <div key={i} />;
          const wos = woByDay[d] || [];
          return (
            <div key={d} style={{ minHeight: 80, background: isToday(d) ? (darkMode ? "#1e2d1a" : "#f0fdf4") : card, borderRadius: 8, padding: 6, border: "1px solid " + (isToday(d) ? "#22c55e" : borderColor) }}>
              <div style={{ fontWeight: isToday(d) ? 700 : 400, color: isToday(d) ? "#22c55e" : mutedColor, fontSize: 12, marginBottom: 4 }}>{d}</div>
              {wos.slice(0, 3).map(w => {
                const c = w.status === "Complete" ? "#22c55e" : w.status === "In Progress" ? "#f59e0b" : "#3b82f6";
                return <div key={w._dbId} onClick={e=>{e.stopPropagation();if(onWOClick)onWOClick(w);}} style={{ background: c + "22", borderLeft: "3px solid " + c, borderRadius: 3, padding: "2px 5px", fontSize: 9, color: c, marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 600, cursor:"pointer" }}>{w.customerName}</div>;
              })}
              {wos.length > 3 && <div style={{ fontSize: 9, color: mutedColor }}>+{wos.length - 3} more</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Global Search ─────────────────────────────────────────────────────────────
function GlobalSearch({ jobs, workOrders, customers, invoices, onClose, setTab, darkMode }) {
  const [q, setQ] = React.useState("");
  const card = darkMode ? "#1a1d25" : "#ffffff";
  const bg = darkMode ? "#0f1117" : "#f5f6fa";
  const textColor = darkMode ? "#e2e8f0" : "#1a1d25";
  const mutedColor = darkMode ? "#64748b" : "#9aa0b4";
  const borderColor = darkMode ? "#2d3748" : "#e0e3eb";
  const results = React.useMemo(() => {
    if (!q || q.length < 2) return { jobs: [], workOrders: [], customers: [], invoices: [] };
    const qq = q.toLowerCase();
    return {
      jobs: jobs.filter(j => [j.customerName, j.address, j.epcPartnerName, j.stage].join(" ").toLowerCase().includes(qq)).slice(0, 5),
      workOrders: workOrders.filter(w => [w.woId, w.customerName, w.address, (w.types || []).join(" "), w.epcPartnerName].join(" ").toLowerCase().includes(qq)).slice(0, 5),
      customers: customers.filter(c => [c.name, c.phone, c.email, c.suntrifyId, c.city].join(" ").toLowerCase().includes(qq)).slice(0, 5),
      invoices: invoices.filter(i => [i.invNumber, i.epcPartnerName].join(" ").toLowerCase().includes(qq)).slice(0, 5),
    };
  }, [q, jobs, workOrders, customers, invoices]);
  const total = Object.values(results).reduce((s, a) => s + a.length, 0);
  React.useEffect(() => {
    const handler = e => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 2000, display: "flex", alignItems: "flex-start", justifyContent: "center", paddingTop: 80 }}>
      <div style={{ background: card, borderRadius: 16, width: "100%", maxWidth: 580, padding: 20, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search jobs, WOs, customers, invoices..." style={{ width: "100%", border: "1px solid " + borderColor, borderRadius: 10, padding: "10px 16px", fontSize: 15, fontFamily: "inherit", background: bg, color: textColor, outline: "none", boxSizing: "border-box" }} />
        {q.length > 1 && (
          <div style={{ marginTop: 12, maxHeight: 400, overflowY: "auto" }}>
            {total === 0 && <div style={{ textAlign: "center", padding: 20, color: mutedColor, fontSize: 13 }}>No results for "{q}"</div>}
            {[
              { key: "jobs", label: "Jobs", color: "#f0a500", fn: item => item.customerName + " · " + item.address + " · " + item.stage, tab: "jobs" },
              { key: "workOrders", label: "Work Orders", color: "#3b82f6", fn: item => (item.woId || "") + " · " + item.customerName + " · " + (item.types || []).join(", "), tab: "workorders" },
              { key: "customers", label: "Customers", color: "#22c55e", fn: item => item.name + " · " + (item.phone || "") + " · " + (item.city || ""), tab: "customers" },
              { key: "invoices", label: "Invoices", color: "#f59e0b", fn: item => "#" + item.invNumber + " · " + item.epcPartnerName, tab: "invoices" },
            ].map(sec => {
              const items = results[sec.key];
              if (!items || !items.length) return null;
              return (
                <div key={sec.key} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: mutedColor, textTransform: "uppercase", marginBottom: 6 }}>{sec.label}</div>
                  {items.map((item, i) => (
                    <div key={i} onClick={() => { setTab(sec.tab); onClose(); }} style={{ padding: "8px 12px", borderRadius: 8, cursor: "pointer", fontSize: 13, color: textColor, marginBottom: 2, border: "1px solid " + borderColor, background: "transparent" }}
                      onMouseEnter={e => e.currentTarget.style.background = bg}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <span style={{ color: sec.color, fontWeight: 700, marginRight: 6 }}>●</span>{sec.fn(item)}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
        <div style={{ marginTop: 12, fontSize: 11, color: mutedColor, textAlign: "center" }}>Press ESC to close · ⌘K to open</div>
      </div>
    </div>
  );
}


// ── S3 File Upload ────────────────────────────────────────────────────────────
function FileUpload({ folder, existingFiles=[], onFilesChange }) {
  const [uploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [lightbox, setLightbox] = React.useState(null); // index of image being viewed
  const [isDragging, setIsDragging] = React.useState(false);
  const [resolvedUrls, setResolvedUrls] = React.useState({});
  const touchStartX = React.useRef(null);
  const touchEndX = React.useRef(null);

  // Resolve S3 keys / old S3 URLs to presigned view URLs
  React.useEffect(() => {
    const unresolved = existingFiles.filter(u => !resolvedUrls[u] && (extractS3Key(u) || u.includes('suntrify-docs.s3')));
    if (!unresolved.length) return;
    unresolved.forEach(u => {
      getViewUrl(u).then(v => setResolvedUrls(prev => ({...prev, [u]: v}))).catch(()=>{});
    });
  }, [existingFiles]); // eslint-disable-line

  const resolve = u => resolvedUrls[u] || (u.startsWith('http') ? u : null);
  const handleTouchStart = e => { touchStartX.current = e.targetTouches[0].clientX; };
  const handleTouchEnd = e => {
    touchEndX.current = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setLightbox(l => l < images.length-1 ? l+1 : 0);
      else setLightbox(l => l > 0 ? l-1 : images.length-1);
    }
  };
  const fileRef = React.useRef();

  const isImage = url => /\.(jpg|jpeg|png|gif|webp)$/i.test(url.split("?")[0]);
  const isPDF = url => /\.pdf$/i.test(url.split("?")[0]);
  const images = existingFiles.filter(isImage);
  const docs = existingFiles.filter(u => !isImage(u));

  React.useEffect(() => {
    if (lightbox === null) return;
    const handler = e => {
      if (e.key === "ArrowRight") setLightbox(l => l < images.length-1 ? l+1 : 0);
      if (e.key === "ArrowLeft")  setLightbox(l => l > 0 ? l-1 : images.length-1);
      if (e.key === "Escape")     setLightbox(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightbox, images.length]);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    setError("");
    try {
      const urls = await Promise.all(files.map(f => uploadToS3(f, folder)));
      onFilesChange([...existingFiles, ...urls]);
    } catch(err) {
      setError("Upload failed: " + err.message);
    }
    setUploading(false);
    fileRef.current.value = "";
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    if (!files.length) return;
    setUploading(true);
    setError("");
    try {
      const urls = await Promise.all(files.map(f => uploadToS3(f, folder)));
      onFilesChange([...existingFiles, ...urls]);
    } catch(err) {
      setError("Upload failed: " + err.message);
    }
    setUploading(false);
  };
  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = (e) => { if (!e.currentTarget.contains(e.relatedTarget)) setIsDragging(false); };

  const getName = url => decodeURIComponent((url.split("?")[0]).split("/").pop().replace(/^\d+-/, "")).replace(/_/g, " ");

  return (
    <div style={{marginBottom:12}}>
      <div style={{fontSize:10,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>📎 Documents & Photos</div>

      {/* Photo Grid */}
      {images.length>0&&(
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(80px,1fr))",gap:6,marginBottom:8}}>
          {images.map((url,i)=>(
            <div key={url} style={{position:"relative",aspectRatio:"1",borderRadius:6,overflow:"hidden",border:"1px solid #e0e3eb",cursor:"pointer"}} onClick={()=>setLightbox(i)}>
              {resolve(url) ? <img src={resolve(url)} alt={getName(url)} style={{width:"100%",height:"100%",objectFit:"cover"}}/> : <div style={{width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>🖼️</div>}
              <button onClick={e=>{e.stopPropagation();onFilesChange(existingFiles.filter(u=>u!==url));}} style={{position:"absolute",top:2,right:2,background:"rgba(0,0,0,0.6)",border:"none",borderRadius:"50%",color:"#fff",width:18,height:18,fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1}}>×</button>
            </div>
          ))}
        </div>
      )}

      {/* Docs list */}
      {docs.length>0&&<div style={{marginBottom:8}}>
        {docs.map((url)=>(
          <div key={url} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 8px",background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:6,marginBottom:4,fontSize:12}}>
            <span onClick={async()=>{try{const v=await getViewUrl(url);window.open(v,"_blank");}catch{window.open(url,"_blank");}}} style={{color:"#3b82f6",textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:"80%",cursor:"pointer"}}>
              {isPDF(url)?"📄":"📎"} {getName(url)}
            </span>
            <button onClick={()=>onFilesChange(existingFiles.filter(u=>u!==url))} style={{background:"transparent",border:"none",cursor:"pointer",color:"#ef4444",fontSize:14,padding:"0 4px"}}>×</button>
          </div>
        ))}
      </div>}

      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{border:`2px dashed ${isDragging?"#d4891f":"#dde0ea"}`,borderRadius:8,padding:"16px 12px",textAlign:"center",background:isDragging?"rgba(212,137,31,0.07)":"transparent",transition:"border-color 0.15s,background 0.15s"}}
      >
        <input ref={fileRef} type="file" multiple onChange={handleUpload} style={{display:"none"}} accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.doc,.docx,.xls,.xlsx"/>
        {uploading ? (
          <div style={{fontSize:12,color:"#d4891f",fontWeight:600}}>⏳ Uploading...</div>
        ) : (
          <>
            <div style={{fontSize:12,color:"#9aa0b4",marginBottom:8}}>{isDragging ? "Drop files here" : "Drag & drop files here"}</div>
            <button onClick={()=>fileRef.current.click()} style={{padding:"6px 16px",border:"1px solid #d4891f",borderRadius:6,background:"transparent",cursor:"pointer",fontSize:12,color:"#d4891f",fontFamily:"inherit",fontWeight:600}}>
              Choose File or Photo
            </button>
          </>
        )}
        {error&&<div style={{fontSize:11,color:"#ef4444",marginTop:6}}>{error}</div>}
      </div>

      {/* Lightbox */}
      {lightbox!==null&&(
        <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:9999,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"60px 0 80px"}}>
          {/* Close */}
          <button onClick={()=>setLightbox(null)} style={{position:"absolute",top:12,right:12,background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:40,height:40,color:"#fff",fontSize:20,cursor:"pointer",zIndex:10}}>✕</button>
          {/* Counter */}
          <div style={{position:"absolute",top:16,left:0,right:0,textAlign:"center",color:"rgba(255,255,255,0.6)",fontSize:12}}>{lightbox+1} / {images.length} · ← → keys or swipe to navigate · Esc to close</div>
          {/* Image */}
          <img onClick={e=>e.stopPropagation()} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} src={resolve(images[lightbox])||images[lightbox]} alt={getName(images[lightbox])} style={{maxWidth:"100vw",maxHeight:"calc(100vh - 140px)",objectFit:"contain",userSelect:"none"}}/>
          {/* Bottom bar */}
          <div style={{position:"absolute",bottom:0,left:0,right:0,display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",background:"rgba(0,0,0,0.7)"}}>
            <button onClick={e=>{e.stopPropagation();setLightbox(l=>l>0?l-1:images.length-1);}} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,width:44,height:44,color:"rgba(255,255,255,0.4)",fontSize:24,cursor:"pointer"}}>‹</button>
            <div style={{display:"flex",gap:8}}>
              <a href={images[lightbox]} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{background:"#3b82f6",color:"#fff",borderRadius:6,padding:"8px 16px",fontSize:13,textDecoration:"none",fontWeight:600}}>⬇</a>
              <button onClick={e=>{e.stopPropagation();onFilesChange(existingFiles.filter(u=>u!==images[lightbox]));setLightbox(null);}} style={{background:"#ef4444",color:"#fff",border:"none",borderRadius:6,padding:"8px 16px",fontSize:13,cursor:"pointer",fontWeight:600}}>🗑</button>
            </div>
            <button onClick={e=>{e.stopPropagation();setLightbox(l=>l<images.length-1?l+1:0);}} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,width:44,height:44,color:"rgba(255,255,255,0.4)",fontSize:24,cursor:"pointer"}}>›</button>
          </div>
        </div>
      )}
    </div>
  );
}


// ── Address Link (tap/click → GPS chooser, all platforms) ───────────────────
function AddressLink({ address, style, children }) {
  const [open, setOpen] = React.useState(false);
  const display = children || address;
  if (!address) return <span style={style}>{display}</span>;
  const enc = encodeURIComponent(address);

  const apps = [
    {
      name: "Apple Maps",
      url: `maps://maps.apple.com/?q=${enc}`,
      fallback: `https://maps.apple.com/?q=${enc}`,
      bg: "#000", color: "#fff",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          <circle cx="12" cy="9" r="2.5" fill="currentColor" stroke="none"/>
        </svg>
      ),
    },
    {
      name: "Google Maps",
      url: `https://maps.google.com/?q=${enc}`,
      bg: "#fff", color: "#1a1d25",
      border: "#e0e3eb",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EA4335"/>
          <circle cx="12" cy="9" r="2.5" fill="#fff"/>
        </svg>
      ),
    },
    {
      name: "Waze",
      url: `https://waze.com/ul?q=${enc}&navigate=yes`,
      bg: "#05C8F7", color: "#fff",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="10" r="7"/>
          <path d="M8.5 13c.5 1.5 2 2.5 3.5 2.5s3-1 3.5-2.5" strokeLinecap="round"/>
          <circle cx="9.5" cy="9" r="1" fill="currentColor" stroke="none"/>
          <circle cx="14.5" cy="9" r="1" fill="currentColor" stroke="none"/>
          <path d="M12 17v4" strokeLinecap="round"/>
        </svg>
      ),
    },
  ];

  return (
    <>
      <span onClick={e => { e.stopPropagation(); setOpen(true); }}
            style={{ ...style, cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted", textUnderlineOffset: 3 }}>
        {display}
      </span>
      {open && (
        <div onClick={() => setOpen(false)}
             style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:99999, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div onClick={e => e.stopPropagation()}
               style={{ background:"#fff", width:"100%", maxWidth:360, borderRadius:18, padding:"24px 20px 20px", fontFamily:"'DM Sans',sans-serif", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
            <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:16 }}>
              <div>
                <div style={{ fontWeight:700, fontSize:16, color:"#1a1d25", marginBottom:4 }}>Navigate to</div>
                <div style={{ fontSize:12, color:"#6a7080", lineHeight:1.4 }}>{address}</div>
              </div>
              <button onClick={() => setOpen(false)} style={{ background:"#f0f1f5", border:"none", borderRadius:"50%", width:28, height:28, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginLeft:12 }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6a7080" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {apps.map(app => (
                <a key={app.name}
                   href={app.url} target="_blank" rel="noreferrer"
                   onClick={() => setOpen(false)}
                   style={{ display:"flex", alignItems:"center", gap:14, padding:"13px 16px", border:"1px solid "+(app.border||"transparent"), borderRadius:12, textDecoration:"none", background:app.bg, color:app.color, fontWeight:600, fontSize:14 }}>
                  <span style={{ flexShrink:0 }}>{app.icon}</span>
                  {app.name}
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginLeft:"auto", opacity:0.5 }}><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ── Photos Gallery ────────────────────────────────────────────────────────────
function PhotosGallery({ jobs, workOrders, installReports=[] }) {
  const [search, setSearch] = React.useState("");
  const [filter, setFilter] = React.useState("all");
  const [dateFrom, setDateFrom] = React.useState("");
  const [dateTo, setDateTo] = React.useState("");
  const [selectedJob, setSelectedJob] = React.useState(null); // null = job list, string = customer name
  const [lightbox, setLightbox] = React.useState(null);
  const touchStartX = React.useRef(null);

  // Collect all photos with source info
  const allPhotos = React.useMemo(() => {
    const photos = [];
    workOrders.forEach(w => {
      (w.documents||[]).filter(u => /\.(jpg|jpeg|png|gif|webp)/i.test(u)).forEach(url => {
        photos.push({ url, source: "WO", label: w.woId||"WO", customer: w.customerName||"Unknown", date: w.date||"", address: w.address||"" });
      });
      (w.correctionPhotos||[]).forEach(url => {
        photos.push({ url, source: "Correction", label: w.woId||"WO", customer: w.customerName||"Unknown", date: w.date||"", address: w.address||"" });
      });
    });
    jobs.forEach(j => {
      (j.documents||[]).filter(u => /\.(jpg|jpeg|png|gif|webp)/i.test(u)).forEach(url => {
        photos.push({ url, source: "Job", label: j.stage||"Job", customer: j.customerName||"Unknown", date: j.startDate||"", address: j.address||"" });
      });
    });
    installReports.forEach(ir => {
      const job = jobs.find(j=>String(j._dbId)===String(ir.jobId));
      // Fall back to WO lookup when jobId is missing or doesn't match a job
      const wo = !job ? workOrders.find(w => w.woId === ir.woId || String(w._dbId) === String(ir.woId)) : null;
      const customer = job?.customerName || wo?.customerName || ir.customerName || ir.woId || "Unknown";
      const address = job?.address || wo?.address || "";
      Object.entries(ir.photos||{}).forEach(([section, urls]) => {
        (urls||[]).forEach(url => {
          if(!url) return;
          const reportDate = ir.date || (ir.updatedAt ? ir.updatedAt.slice(0,10) : "");
          photos.push({ url, source: "Report", label: section.replace(/_/g," "), customer, date: reportDate, address });
        });
      });
    });
    return photos;
  }, [jobs, workOrders, installReports]);

  // Apply search + filter + date (used in both list and detail views)
  const filtered = allPhotos.filter(p => {
    const q = search.toLowerCase();
    const matchSearch = !search ||
      (p.customer||"").toLowerCase().includes(q) ||
      (p.address||"").toLowerCase().includes(q) ||
      (p.label||"").toLowerCase().includes(q);
    const matchFilter = filter === "all" || p.source === filter;
    const matchFrom = !dateFrom || p.date >= dateFrom;
    const matchTo = !dateTo || p.date <= dateTo;
    return matchSearch && matchFilter && matchFrom && matchTo;
  });

  // Group by customer for the job list
  const byCustomer = React.useMemo(() => {
    const map = {};
    filtered.forEach(p => {
      const key = p.customer || "Unknown";
      if (!map[key]) map[key] = { customer: key, address: p.address, photos: [] };
      map[key].photos.push(p);
      if (!map[key].address && p.address) map[key].address = p.address;
    });
    return Object.values(map).sort((a,b) => a.customer.localeCompare(b.customer));
  }, [filtered]);

  // Photos for selected job
  const jobPhotos = selectedJob ? filtered.filter(p => p.customer === selectedJob) : [];

  const handleTouchStart = e => { touchStartX.current = e.targetTouches[0].clientX; };
  const handleTouchEnd = e => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      const list = selectedJob ? jobPhotos : filtered;
      if (diff > 0) setLightbox(l => l < list.length-1 ? l+1 : 0);
      else setLightbox(l => l > 0 ? l-1 : list.length-1);
    }
  };
  React.useEffect(() => {
    if (lightbox === null) return;
    const list = selectedJob ? jobPhotos : filtered;
    const handler = e => {
      if (e.key === "ArrowRight") setLightbox(l => l < list.length-1 ? l+1 : 0);
      if (e.key === "ArrowLeft")  setLightbox(l => l > 0 ? l-1 : list.length-1);
      if (e.key === "Escape")     setLightbox(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightbox, selectedJob, jobPhotos, filtered]);

  const sourceBadgeColor = s => ({WO:"#3b82f6",Job:"#8b5cf6",Report:"#22c55e",Correction:"#f59e0b"}[s]||"#9aa0b4");

  return (
    <div style={{padding:"20px"}}>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
        {selectedJob&&(
          <button onClick={()=>{setSelectedJob(null);setLightbox(null);}} style={{background:"transparent",border:"1px solid #dde0ea",borderRadius:8,padding:"7px 12px",fontSize:12,cursor:"pointer",color:"#6a7080",fontFamily:"inherit",display:"flex",alignItems:"center",gap:5}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back
          </button>
        )}
        <div>
          <div style={{fontFamily:"'DM Serif Display',serif",fontSize:22,fontWeight:800,color:"#1a1d25",display:"flex",alignItems:"center",gap:8}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d4891f" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            {selectedJob ? selectedJob : "Photos"}
          </div>
          {selectedJob && <div style={{fontSize:12,color:"#9aa0b4",marginTop:2}}>{byCustomer.find(j=>j.customer===selectedJob)?.address||""}</div>}
        </div>
      </div>

      {/* Search + Filter — always visible */}
      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:16}}>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <div style={{position:"relative",flex:1,minWidth:200}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by customer, address, label..." style={{width:"100%",border:"1px solid #dde0ea",borderRadius:8,padding:"9px 12px 9px 36px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9aa0b4" strokeWidth="2" style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)"}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            {search&&<button onClick={()=>setSearch("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"transparent",border:"none",cursor:"pointer",color:"#9aa0b4",fontSize:15}}>✕</button>}
          </div>
          <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
            {["all","WO","Job","Report","Correction"].map(f=>(
              <button key={f} onClick={()=>setFilter(f==="all"?"all":f)} style={{padding:"8px 13px",border:"1px solid "+(filter===f?"#f0a500":"#dde0ea"),borderRadius:7,background:filter===f?"#f0a50015":"transparent",color:filter===f?"#d4891f":"#6a7080",fontSize:12,cursor:"pointer",fontFamily:"inherit",fontWeight:filter===f?700:400}}>
                {f==="all"?"All":f}
              </button>
            ))}
          </div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            <label style={{fontSize:12,color:"#9aa0b4",whiteSpace:"nowrap"}}>From</label>
            <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:7,padding:"6px 10px",fontSize:12,fontFamily:"inherit",color:"#1a1d25"}}/>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            <label style={{fontSize:12,color:"#9aa0b4",whiteSpace:"nowrap"}}>To</label>
            <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:7,padding:"6px 10px",fontSize:12,fontFamily:"inherit",color:"#1a1d25"}}/>
          </div>
          {(dateFrom||dateTo)&&<button onClick={()=>{setDateFrom("");setDateTo("");}} style={{padding:"6px 10px",border:"1px solid #dde0ea",borderRadius:7,background:"transparent",fontSize:12,color:"#9aa0b4",cursor:"pointer",fontFamily:"inherit"}}>✕ Clear dates</button>}
          <div style={{marginLeft:"auto",fontSize:12,color:"#9aa0b4"}}>
            {selectedJob ? `${jobPhotos.length} photo${jobPhotos.length!==1?"s":""}` : `${byCustomer.length} job${byCustomer.length!==1?"s":""} · ${filtered.length} photo${filtered.length!==1?"s":""}`}
          </div>
        </div>
      </div>

      {/* ── JOB LIST VIEW ── */}
      {!selectedJob&&(
        <>
          {byCustomer.length===0&&<div style={{textAlign:"center",padding:"60px 0",color:"#9aa0b4",fontSize:14}}>No photos found</div>}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
            {byCustomer.map(job=>{
              const sources = [...new Set(job.photos.map(p=>p.source))];
              const previews = job.photos.slice(0,4);
              const latest = job.photos.map(p=>p.date).filter(Boolean).sort().reverse()[0];
              return (
                <div key={job.customer} onClick={()=>setSelectedJob(job.customer)}
                  style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,overflow:"hidden",cursor:"pointer",transition:"box-shadow 0.15s,transform 0.15s"}}
                  onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 4px 20px rgba(0,0,0,0.10)";e.currentTarget.style.transform="translateY(-2px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.boxShadow="";e.currentTarget.style.transform="";}}>
                  {/* Thumbnail strip */}
                  <div style={{display:"grid",gridTemplateColumns:`repeat(${Math.min(previews.length,4)},1fr)`,height:120,background:"#f0f1f5"}}>
                    {previews.map((p,i)=>(
                      <div key={i} style={{overflow:"hidden",borderRight:i<previews.length-1?"1px solid #e0e3eb":"none"}}>
                        <img src={p.url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                      </div>
                    ))}
                    {previews.length===0&&<div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",justifyContent:"center",color:"#c0c4d0",fontSize:28}}>📷</div>}
                  </div>
                  {/* Info */}
                  <div style={{padding:"12px 14px"}}>
                    <div style={{fontWeight:700,fontSize:14,color:"#1a1d25",marginBottom:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{job.customer}</div>
                    {job.address&&<div style={{fontSize:11,color:"#9aa0b4",marginBottom:8,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{job.address}</div>}
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                      <div style={{display:"flex",gap:4}}>
                        {sources.map(s=>(
                          <span key={s} style={{fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:10,background:sourceBadgeColor(s)+"22",color:sourceBadgeColor(s)}}>{s}</span>
                        ))}
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        {latest&&<span style={{fontSize:11,color:"#9aa0b4"}}>{latest}</span>}
                        <span style={{fontSize:12,fontWeight:700,color:"#6a7080",background:"#f0f1f5",borderRadius:8,padding:"2px 8px"}}>{job.photos.length} 📷</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* ── JOB DETAIL VIEW ── */}
      {selectedJob&&(
        <>
          {jobPhotos.length===0&&<div style={{textAlign:"center",padding:"60px 0",color:"#9aa0b4",fontSize:14}}>No photos match your filters</div>}
          {/* Group by source section */}
          {(()=>{
            const bySrc = jobPhotos.reduce((acc,p)=>{ (acc[p.source]||(acc[p.source]=[])).push(p); return acc; },{});
            return Object.entries(bySrc).map(([src, photos])=>(
              <div key={src} style={{marginBottom:28}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                  <span style={{fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:10,background:sourceBadgeColor(src)+"22",color:sourceBadgeColor(src)}}>{src}</span>
                  <span style={{fontSize:11,color:"#9aa0b4"}}>{photos.length} photo{photos.length!==1?"s":""}</span>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:8}}>
                  {photos.map((p,i)=>(
                    <div key={p.url+i} onClick={()=>setLightbox(jobPhotos.indexOf(p))}
                      style={{position:"relative",aspectRatio:"1",borderRadius:10,overflow:"hidden",cursor:"pointer",border:"1px solid #e0e3eb"}}
                      onMouseEnter={e=>e.currentTarget.style.opacity="0.85"}
                      onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                      <img src={p.url} alt={p.label} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                      <div style={{position:"absolute",bottom:0,left:0,right:0,background:"linear-gradient(transparent,rgba(0,0,0,0.65))",padding:"18px 6px 5px"}}>
                        <div style={{fontSize:9,color:"#fff",fontWeight:600}}>{p.label}</div>
                        {p.date&&<div style={{fontSize:8,color:"rgba(255,255,255,0.6)"}}>{p.date}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ));
          })()}
        </>
      )}

      {/* Lightbox */}
      {lightbox!==null&&(()=>{
        const list = selectedJob ? jobPhotos : filtered;
        const photo = list[lightbox];
        if(!photo) return null;
        return (
          <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.96)",zIndex:9999,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"60px 0 80px"}}>
            <button onClick={()=>setLightbox(null)} style={{position:"absolute",top:12,right:12,background:"rgba(255,255,255,0.15)",border:"none",borderRadius:"50%",width:40,height:40,color:"#fff",fontSize:20,cursor:"pointer",zIndex:10}}>✕</button>
            <div style={{position:"absolute",top:14,left:0,right:0,textAlign:"center"}}>
              <div style={{color:"#fff",fontWeight:700,fontSize:13}}>{photo.customer}</div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:11}}>{photo.source} · {photo.label} · {lightbox+1}/{list.length}</div>
            </div>
            <img onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onClick={e=>e.stopPropagation()} src={photo.url} alt={photo.customer} style={{maxWidth:"100vw",maxHeight:"calc(100vh - 140px)",objectFit:"contain",userSelect:"none"}}/>
            <div style={{position:"absolute",bottom:0,left:0,right:0,display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",background:"rgba(0,0,0,0.7)"}}>
              <button onClick={e=>{e.stopPropagation();setLightbox(l=>l>0?l-1:list.length-1);}} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,width:44,height:44,color:"rgba(255,255,255,0.8)",fontSize:28,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
              <a href={photo.url} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{background:"#3b82f6",color:"#fff",borderRadius:6,padding:"8px 20px",fontSize:13,textDecoration:"none",fontWeight:600}}>⬇ Download</a>
              <button onClick={e=>{e.stopPropagation();setLightbox(l=>l<list.length-1?l+1:0);}} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,width:44,height:44,color:"rgba(255,255,255,0.8)",fontSize:28,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
            </div>
          </div>
        );
      })()}
    </div>
  );
}


// ── WO Field Report ───────────────────────────────────────────────────────────
// ── WO Report Photo Section (top-level to prevent re-mount on state change) ──
function WOPhotoSection({ label, section, photos, onUpload, onRemove }) {
  const [uploading, setUploading] = React.useState(false);
  const [isDragging, setIsDragging] = React.useState(false);
  const ref = React.useRef();
  const doUpload = async (e) => {
    setUploading(true);
    await onUpload(section, e.target.files);
    setUploading(false);
    ref.current.value = "";
  };
  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    setUploading(true);
    await onUpload(section, e.dataTransfer.files);
    setUploading(false);
  };
  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = (e) => { if (!e.currentTarget.contains(e.relatedTarget)) setIsDragging(false); };
  return (
    <div style={{marginBottom:14}}>
      <div style={{fontSize:11,fontWeight:700,color:"#6a7080",marginBottom:6}}>{label}</div>
      {photos.length>0&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(70px,1fr))",gap:4,marginBottom:6}}>
        {photos.map((url,i)=>(
          <div key={url+i} style={{position:"relative",aspectRatio:"1",borderRadius:6,overflow:"hidden",border:"1px solid #e0e3eb"}}>
            <img src={url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
            <button onClick={()=>onRemove(section,i)} style={{position:"absolute",top:2,right:2,background:"rgba(0,0,0,0.6)",border:"none",borderRadius:"50%",color:"#fff",width:16,height:16,fontSize:10,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
          </div>
        ))}
      </div>}
      <input ref={ref} type="file" multiple accept="image/*,.pdf" onChange={doUpload} style={{display:"none"}}/>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{border:`1.5px dashed ${isDragging?"#d4891f":"#dde0ea"}`,borderRadius:6,padding:"10px 8px",textAlign:"center",background:isDragging?"rgba(212,137,31,0.07)":"transparent",transition:"border-color 0.15s,background 0.15s"}}
      >
        {uploading ? (
          <div style={{fontSize:11,color:"#d4891f",fontWeight:600}}>⏳ Uploading...</div>
        ) : (
          <>
            <div style={{fontSize:10,color:"#9aa0b4",marginBottom:5}}>{isDragging ? "Drop photos here" : "Drag & drop or"}</div>
            <button onClick={()=>ref.current.click()} style={{padding:"4px 10px",border:"1px solid #d4891f",borderRadius:5,background:"transparent",cursor:"pointer",fontSize:11,color:"#d4891f",fontFamily:"inherit"}}>
              Choose File or Photo
            </button>
          </>
        )}
      </div>
    </div>
  );
}


function WRSection({title,children}) {
  return (
    <div style={{marginBottom:20}}>
      <div style={{background:"#1a1d25",color:"#fff",padding:"6px 12px",fontSize:11,fontWeight:700,textTransform:"uppercase",borderRadius:"6px 6px 0 0",letterSpacing:"0.05em"}}>{title}</div>
      <div style={{border:"1px solid #e0e3eb",borderTop:"none",borderRadius:"0 0 6px 6px",padding:"12px"}}>{children}</div>
    </div>
  );
}
function WRChk({label,field,checklist,onChange}) {
  return (
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid #f0f1f5",fontSize:12}}>
      <span style={{color:"#1a1d25",flex:1}}>{label}</span>
      <select value={checklist?.[field]||""} onChange={e=>onChange(field,e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:5,padding:"3px 8px",fontSize:11,fontFamily:"inherit",background:"#fff",minWidth:80}}>
        <option value="">--</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="N/A">N/A</option>
      </select>
    </div>
  );
}
function WRInp({label,field,report,onChange,type="text",placeholder=""}) {
  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>{label}</div>
      <input type={type} value={report[field]||""} onChange={e=>onChange(field,e.target.value)} placeholder={placeholder} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",boxSizing:"border-box"}}/>
    </div>
  );
}
function WRTxta({label,field,report,onChange,placeholder=""}) {
  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>{label}</div>
      <textarea value={report[field]||""} onChange={e=>onChange(field,e.target.value)} placeholder={placeholder} rows={3} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
    </div>
  );
}


function WOReport({ wo, jobs, onClose, publicMode=false }) {
  const job = jobs.find(j=>j.customerName===wo.customerName) || {};
  const [reportType, setReportType] = React.useState(wo.reportType || "");
  const [report, setReport] = React.useState({});
  const [saving, setSaving] = React.useState(false);
  const reportRef = React.useRef(report);
  const autoSaveTimer = React.useRef(null);
  const isDirty = React.useRef(false);
  const [refreshTick, setRefreshTick] = React.useState(0);
  const [saved, setSaved] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  const loadReport = React.useCallback(() => {
    const woKey = wo.woId || String(wo._dbId);
    // Fetch all recent reports and filter client-side to avoid JSONB query issues
    fetch(`${AWS_API}/installation_reports`).then(r=>r.json()).then(rows => {
      if(!Array.isArray(rows)) return;
      const match = rows.find(r => r.data && (r.data.woId === woKey || r.data.woId === wo.woId || r.data.woId === String(wo._dbId)));
      if (match) {
        const serverData = {...match.data, _dbId: match.id};
        setReport(prev => {
          // Merge server photos with any local photos that may not be saved yet
          const localPhotos = prev.photos || {};
          const serverPhotos = serverData.photos || {};
          const mergedPhotos = {...serverPhotos};
          Object.keys(localPhotos).forEach(sec => {
            const localUrls = localPhotos[sec] || [];
            const serverUrls = serverPhotos[sec] || [];
            // Add any local URLs not yet in server data
            const extra = localUrls.filter(u => !serverUrls.includes(u));
            if (extra.length) mergedPhotos[sec] = [...serverUrls, ...extra];
          });
          // If user is actively typing unsaved changes, only update _dbId + photos — never clobber text fields
          if (isDirty.current) {
            return {...prev, _dbId: serverData._dbId || prev._dbId, photos: mergedPhotos};
          }
          return {...prev, ...serverData, checklist: serverData.checklist||prev.checklist||{}, photos: mergedPhotos};
        });
      } else {
        // Don't wipe local state if we already have photos or a _dbId pending save
        setReport(prev => {
          if (prev._dbId || Object.keys(prev.photos||{}).some(k=>(prev.photos[k]||[]).length>0)) return prev;
          return { woId: woKey, reportType, jobId: String(job._dbId||""), crew: wo.crew||"", date: wo.date||"", checklist:{}, photos:{} };
        });
      }
    }).catch(e => console.error("loadReport error:", e));
  }, [wo.woId, wo._dbId]);

  React.useEffect(() => {
    loadReport();
    if (publicMode) return; // no polling in public field report mode
    const interval = setInterval(loadReport, 20000);
    return () => clearInterval(interval);
  }, [loadReport, refreshTick, publicMode]);

  React.useEffect(() => { reportRef.current = report; }, [report]);

  const scheduleAutoSave = (updated) => {
    reportRef.current = updated;
    if (autoSaveTimer.current) clearTimeout(autoSaveTimer.current);
    autoSaveTimer.current = setTimeout(async () => {
      const saved = await saveReport(reportRef.current);
      isDirty.current = false;
      if (saved && saved._dbId) setReport(x => ({...x, _dbId: saved._dbId}));
    }, 800);
  };

  const setField = (k, v) => {
    isDirty.current = true;
    const updated = {...reportRef.current, [k]: v};
    setReport(updated);
    scheduleAutoSave(updated);
  };
  const setCheck = (k, v) => {
    isDirty.current = true;
    const updated = {...reportRef.current, checklist: {...reportRef.current.checklist, [k]: v}};
    setReport(updated);
    scheduleAutoSave(updated);
  };

  const saveReport = async (updatedReport) => {
    const payload = {...updatedReport, reportType: updatedReport.reportType||reportType, woId: wo.woId||String(wo._dbId), jobId: updatedReport.jobId||String(job._dbId||""), customerName: updatedReport.customerName||wo.customerName||"", address: updatedReport.address||wo.address||"", updatedAt: new Date().toISOString()};
    if (updatedReport._dbId) {
      const {_dbId,...data} = payload;
      await fetch(`${AWS_API}/installation_reports/${updatedReport._dbId}`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({data})});
    } else {
      const res = await fetch(`${AWS_API}/installation_reports`, {
        method:"POST", headers:{"Content-Type":"application/json","Prefer":"return=representation"},
        body: JSON.stringify({data:payload})
      }).then(r=>r.json());
      if(res[0]) return {...updatedReport, _dbId: res[0].id};
    }
    return updatedReport;
  };

  const uploadSection = async (section, fileList) => {
    const files = Array.from(fileList);
    const folder = `field-reports/${wo.woId||wo._dbId}/${section.replace(/[^a-z0-9]/gi,"_")}`;
    const urls = await Promise.all(files.map(f=>uploadToS3(f,folder)));
    const updated = {...reportRef.current, photos:{...reportRef.current.photos,[section]:[...(reportRef.current.photos?.[section]||[]),...urls]}};
    reportRef.current = updated; // sync update so rapid uploads don't overwrite each other
    setReport(updated);
    const saved = await saveReport(updated);
    if(saved && saved._dbId) {
      reportRef.current = {...reportRef.current, _dbId: saved._dbId};
      setReport(x=>({...x, _dbId:saved._dbId}));
    }
  };

  const removePhoto = (section, idx) => {
    const updated = {
      ...reportRef.current,
      photos: {
        ...reportRef.current.photos,
        [section]: (reportRef.current.photos?.[section]||[]).filter((_,i) => i !== idx)
      }
    };
    setReport(updated);
    reportRef.current = updated;
    saveReport(updated).then(saved => {
      if (saved && saved._dbId) setReport(x => ({...x, _dbId: saved._dbId}));
    });
  };

  const handleSave = async () => {
    setSaving(true);
    // Use reportRef.current to capture latest state including any recently uploaded photos
    const current = reportRef.current;
    const payload = {...current, reportType: reportType, woId: wo.woId||String(wo._dbId), jobId: String(job._dbId||""), customerName: wo.customerName||"", address: wo.address||"", updatedAt: new Date().toISOString()};
    if (current._dbId) {
      const {_dbId,...data} = payload;
      await fetch(`${AWS_API}/installation_reports/${current._dbId}`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({data})});
    } else {
      const res = await fetch(`${AWS_API}/installation_reports`, {
        method:"POST", headers:{"Content-Type":"application/json","Prefer":"return=representation"},
        body: JSON.stringify({data:payload})
      }).then(r=>r.json());
      if(res[0]) {
        reportRef.current = {...reportRef.current, _dbId: res[0].id};
        setReport(r=>({...r,_dbId:res[0].id}));
      }
    }
    isDirty.current = false;
    setSaving(false);
    setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const handleComplete = async () => {
    await handleSave();
    const subject = `Field Report – ${wo.customerName} · ${typeLabels[reportType]||reportType} · ${wo.date||""}`;
    const bodyText = `Field report completed.\nCustomer: ${wo.customerName}\nAddress: ${wo.address||""}\nDate: ${wo.date||""}\nCrew: ${wo.crew||""}\nType: ${typeLabels[reportType]||reportType}`;
    sendViaSES(SES_TO, subject, bodyText, buildReportEmailHTML());
    handlePrint();
  };

  const handleClear = () => {
    if (!window.confirm("Clear all checklist answers, notes, and photos? This cannot be undone.")) return;
    const blank = { woId: wo.woId||String(wo._dbId), reportType, jobId: String(job._dbId||""), crew: wo.crew||"", date: wo.date||"", checklist:{}, photos:{} };
    if (report._dbId) blank._dbId = report._dbId;
    setReport(blank);
    reportRef.current = blank;
    if (report._dbId) {
      const { _dbId, ...data } = blank;
      fetch(`${AWS_API}/installation_reports/${report._dbId}`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({data}) });
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Permanently delete this report? This cannot be undone.")) return;
    if (report._dbId) {
      await fetch(`${AWS_API}/installation_reports/${report._dbId}`, { method:'DELETE' });
    }
    onClose();
  };



  const typeLabels = {solar:"Solar + Battery Installation",mpu:"MPU (Panel Upgrade)",inspection:"Inspection",service:"Service Call",inverter:"Inverter Service"};

  const buildReportEmailHTML = () => {
    const PH = report.photos||{};
    const C = report.checklist||{};
    const logo = "https://crm.suntrify.com/SUNTRIFY_LOGO.png";
    const typeNames = {solar:"Solar + Battery Installation",mpu:"MPU (Panel Upgrade)",inspection:"Inspection",service:"Service Call",inverter:"Inverter Service"};
    const sec = (t) => `<div style="background:#1a1d25;color:#fff;padding:6px 12px;font-size:11px;font-weight:bold;text-transform:uppercase;margin:16px 0 6px;border-radius:3px">${t}</div>`;
    const row = (l,v) => {
      const color = v==="Yes"?"#16a34a":v==="No"?"#dc2626":"#374151";
      return `<tr><td style="padding:5px 10px;border-bottom:1px solid #f0f0f0;font-size:12px;width:65%;color:#374151">${l}</td><td style="padding:5px 10px;border-bottom:1px solid #f0f0f0;font-size:12px;font-weight:700;color:${color}">${v||"—"}</td></tr>`;
    };
    const note = (label, text, color="#999") => text ? `<div style="margin:6px 0;padding:8px 10px;background:#f8f8f8;border-left:3px solid ${color};font-size:12px"><strong>${label}:</strong> ${text}</div>` : "";
    const photoGrid = (section) => {
      const urls = PH[section]||[];
      if(!urls.length) return "";
      return `<div style="margin:6px 0 12px"><div style="font-size:10px;font-weight:bold;text-transform:uppercase;color:#555;margin-bottom:6px">${section} (${urls.length})</div>
        <div style="display:flex;flex-wrap:wrap;gap:6px">${urls.map(u=>`<img src="${u}" width="150" height="110" style="object-fit:cover;border-radius:4px;border:1px solid #ddd" />`).join("")}</div></div>`;
    };

    let h = `<!DOCTYPE html><html><body style="font-family:Arial,sans-serif;font-size:12px;color:#111;max-width:680px;margin:0 auto;padding:24px">`;
    h += `<div style="display:flex;justify-content:space-between;align-items:center;border-bottom:3px solid #000;padding-bottom:12px;margin-bottom:16px">
      <img src="${logo}" height="46" style="display:block"/>
      <div style="text-align:right;font-size:10px;color:#555;line-height:1.8"><div style="font-weight:700;font-size:12px">Suntrify Inc.</div><div>CSLB #1055498 | Lic. B, C-10, C-46</div><div>(951) 866-2828 | www.suntrify.com</div></div>
    </div>`;
    h += sec("Report Information");
    h += `<table style="width:100%;border-collapse:collapse">${row("Report Type",typeNames[reportType]||reportType)}${row("WO ID",wo.woId||"")}${row("Date",wo.date||"")}${row("Crew",wo.crew||"")}${row("Customer",wo.customerName)}${row("Address",wo.address||"")}</table>`;

    if(reportType==="solar") {
      h += sec("Pre-Installation Checklist");
      h += `<table style="width:100%;border-collapse:collapse">${row("Engineering notes reviewed",C.engNotes)}${row("Module count matches plan set",C.moduleCount)}${row("Inverter type/count matches plan set",C.inverterCount)}${row("Materials match plan set",C.materials)}${row("Measurements match plan set",C.measurements)}${row("Roof framing verified",C.roofFraming)}${row("Point of connection verified",C.pointOfConnection)}${row("MSP condition verified",C.mspCondition)}${row("Pre-existing conditions",C.preExisting)}</table>`;
      h += note("Pre-Install Notes", report.preNotes);
      h += sec("Installation Checklist");
      h += `<table style="width:100%;border-collapse:collapse">${row("Array layout matches plans",C.arrayLayout)}${row("Battery job",C.batteryJob)}${C.batteryJob==="Yes"?row("Tesla Battery",C.teslaBattery):""}${C.batteryJob==="Yes"?row("Backup Panel Required",C.backupPanel):""}${row("Sub Panel Required",C.subPanel)}${row("AC Disco Present",C.acDisco)}${row("MPU Present",C.mpu)}${C.mpu==="Yes"?row("MPU Complete",C.mpuComplete):""}${row("System commissioned",C.commissioned)}${row("Cell Kit/Zigbee installed",C.cellKit)}${row("Inspection ready",C.inspectionReady)}${row("Property damage",C.propertyDamage)}${row("Tiles broken",C.tilesBroken)}${row("Yard sign received",C.yardSign)}</table>`;
      h += note("Post-Install Notes", report.postNotes);
    } else if(reportType==="mpu") {
      h += sec("MPU Checklist");
      h += `<table style="width:100%;border-collapse:collapse">${row("Pre-existing conditions",C.preExisting)}${row("Battery job",C.batteryJob)}${row("Anything NOT working before MPU",C.notWorking)}${row("Oversized breakers",C.oversizedBreakers)}${row("Debris removed",C.debrisRemoved)}${row("Grounding/bonding in place",C.grounding)}${row("Wires torqued to spec",C.torqued)}${row("MSP labeled properly",C.mspLabeled)}${row("Solar tied in",C.solarTiedIn)}${row("All Rooms working",C.allRooms)}${row("Garage working",C.garage)}${row("Plugs working",C.plugs)}${row("Lights working",C.lights)}</table>`;
      h += note("Notes", report.preNotes);
    } else if(reportType==="inspection") {
      h += sec("Inspection Checklist");
      h += `<table style="width:100%;border-collapse:collapse">${row("PV tie-in at final",C.pvTieIn)}${row("System has battery",C.hasBattery)}${row("Sub panel installed",C.subPanel)}${row("PCS setting required",C.pcsRequired)}${row("Inspection Result",C.inspectionPass||"—")}</table>`;
      h += note("Field Notes", report.fieldNotes);
      if(C.inspectionPass==="Fail") h += note("Failure Notes", report.failureNotes, "#dc2626");
    } else {
      h += sec("Service Details");
      h += `<table style="width:100%;border-collapse:collapse">${row("Issue resolved",C.resolved)}${row("Return visit needed",C.returnVisit)}</table>`;
      h += note("Problem Description", report.problemDesc, "#f0a500");
      h += note("Work Performed", report.workPerformed, "#22c55e");
      h += note("Parts Used", report.partsUsed, "#3b82f6");
      h += note("Notes", report.serviceNotes);
    }

    const photoSections = Object.keys(PH).filter(s => (PH[s]||[]).length > 0);
    if(photoSections.length) {
      h += sec(`Photos (${photoSections.reduce((n,s)=>n+(PH[s]||[]).length,0)} total)`);
      photoSections.forEach(s => { h += photoGrid(s); });
    }

    h += `<div style="margin-top:24px;padding-top:12px;border-top:1px solid #ddd;font-size:10px;color:#888;text-align:center">Suntrify Inc. · CSLB #1055498 · jchacon@suntrify.com · (951) 866-2828<br/>Generated ${new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</div>`;
    h += `</body></html>`;
    return h;
  };

  const handlePrint = () => {
    const PH = report.photos||{};
    const C = report.checklist||{};
    const chk = (l,v) => `<tr><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:11px;width:65%">${l}</td><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:11px;font-weight:bold">${v||"-"}</td></tr>`;
    const photoBlock = (section, win2, hdr2) => {
      const urls = PH[section]||[];
      if(!urls.length) return;
      for(let p=0;p<urls.length;p+=9){
        if(p>0){win2.document.write(`</div><div class="page">${hdr2}`);}
        const batch=urls.slice(p,p+9);
        for(let i=0;i<batch.length;i+=3){
          const row=batch.slice(i,i+3);
          win2.document.write(`<div style="display:flex;gap:6px;margin-bottom:6px">${row.map(u=>`<div style="flex:1"><img src="${u}" style="width:100%;height:200px;object-fit:cover;display:block;border-radius:3px;border:1px solid #eee"/></div>`).join("")}</div>`);
        }
      }
    };
    const photoLabel = (s) => `<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase;break-after:avoid">${s}</div>`;
    const logo = window.location.origin+"/SUNTRIFY_LOGO.png";
    const addrParts = (wo.address||"").split(",");
    const streetAddr = addrParts[0]||"";
    const cityStateZip = addrParts.slice(1).join(",").trim() + (wo.zip&&!(wo.address||"").includes(wo.zip)?" "+wo.zip:"");
    const fullAddr = streetAddr + (cityStateZip?"<br/>"+cityStateZip:"");
    const fullAddrText = streetAddr + (cityStateZip?", "+cityStateZip:"");
    const hdr = `<div style="border-bottom:3px solid #000;padding-bottom:12px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:center">
      <img src="${logo}" style="height:52px;display:block"/>
      <div style="text-align:right;font-size:10px;color:#333;line-height:2">
        <div style="font-weight:700;font-size:12px">Suntrify Inc.</div>
        <div>CSLB #1055498 | Lic. B, C-10, C-46</div>
        <div>(951) 866-2828 | www.suntrify.com</div>
        <div>${new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</div>
      </div>
    </div>`;
    const typeLabels2 = {solar:"Solar + Battery Installation",mpu:"MPU (Panel Upgrade)",inspection:"Inspection",service:"Service Call",inverter:"Inverter Service"};
    const css = `*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;font-size:12px;color:#000;padding:0.6in}@page{size:letter;margin:0}.page{page-break-after:always;padding-bottom:20px}.page:last-child{page-break-after:auto}.section-title{background:#000;color:#fff;padding:5px 10px;font-size:11px;font-weight:bold;text-transform:uppercase;margin:12px 0 6px;break-inside:avoid}.info-table{width:100%;border-collapse:collapse}.photo-block{break-inside:avoid;page-break-inside:avoid;margin-bottom:14px}img{max-width:100%}`;
    const win = window.open("","_blank","width=900,height=700");
    win.document.write(`<!DOCTYPE html><html><head><title>Field Report - ${wo.customerName}</title><style>${css}</style></head><body><div class="page">${hdr}`);
    win.document.write(`<div class="section-title">Report Information</div><table class="info-table">
      ${chk("Report Type", typeLabels2[reportType]||reportType)}
      ${chk("WO ID", wo.woId||"")}
      ${chk("Date", wo.date||"")}
      ${chk("Crew", wo.crew||"")}
      ${chk("Customer", wo.customerName)}
      ${chk("Address", fullAddr)}
    </table>`);

    if(reportType==="solar") {
      win.document.write(`<div class="section-title">System Information</div><table class="info-table">${chk("Modules",job.panels)}${chk("System Size",job.kw+" kW")}${chk("Inverter",job.inverter)}${chk("Battery",job.battery?(job.batteryQty+"x "+job.battery):"None")}${chk("Existing PV",report.existingPV||"No")}</table>`);
      win.document.write(`<div class="section-title">Pre-Installation Checklist</div><table class="info-table">${chk("Engineering notes reviewed",C.engNotes)}${chk("Module count matches plan set",C.moduleCount)}${chk("Inverter type/count matches plan set",C.inverterCount)}${chk("Materials match plan set",C.materials)}${chk("Measurements match plan set",C.measurements)}${chk("Roof framing verified",C.roofFraming)}${chk("Rafters verified",C.rafters)}${chk("Point of connection verified",C.pointOfConnection)}${chk("MSP condition verified",C.mspCondition)}${chk("Solar breaker amperage verified",C.solarBreaker)}${chk("Main service ground checked",C.mainServiceGround)}${chk("Existing solar ground checked",C.existingSolarGround)}${chk("Service grounding",C.serviceGrounding)}${chk("Pre-existing conditions",C.preExisting)}</table>`);
      if(report.preNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px"><strong>Notes:</strong> ${report.preNotes}</div>`);
      win.document.write(`</div><div class="page">${hdr}<div class="section-title">Pre-Installation Photos</div>`);
      ["Home Address","Crew Truck","Suntrify Safety Gear","Safety Harness","Suntrify Flag"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">Installation Photos</div>`);
      ["Exclusion Zone","MSP Wiring Pull Back","Array Flashings","Rail Grounding","Rail Side Profile","Rail Splice Label","Wire Management Pre-Panels","Module Labels","Optimizer Labels","Wire Management Under Array","Array","Array Fire Setback","Glass Level","Module Clamp","Module Grounding","J-Box","EGC Path","Conduit Run","Optimizer Map","Pitch Finder","Existing Ground UFER"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`</div><div class="page">${hdr}<div class="section-title">Battery Installation</div><table class="info-table">${chk("Battery Job",C.batteryJob)}${chk("Tesla Battery",C.teslaBattery)}${chk("Battery Configuration",report.batteryConfig)}${chk("Backup Panel Required",C.backupPanel)}${chk("Sub Panel Required",C.subPanel)}${chk("AC Disco Present",C.acDisco)}</table>`);
      ["Tesla Heat Shield","Tesla Ferrite Core","Tesla Bracket","Tesla Registration Screenshot","Battery Label Serial","Battery Communications","Backup Panel Interior","Backup Panel Deadfront","Photo of Panel Post Load Relocation","Consumption Meter","Battery Backup Panel","BOS Pullback","Inverter Location","Inverter Label Serial","Voltage Measurement","Inverter Interior","Conduit Support","Conduit Penetrations","AC Disco","Sub-Panel Breakers","Sub-Panel Wiring","Sub-Panel Exterior"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">SetApp Screens</div>`);
      ["SetApp Firmware","SetApp RS485","SetApp Meter 1","SetApp Meter 2","SetApp Battery Info","SetApp Battery Self Test","SetApp Storage Control","SetApp Energy Manager","SetApp System Status 1","SetApp System Status 2","SetApp CT Config"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">MPU &amp; Post Installation</div><table class="info-table">${chk("MPU Present",C.mpu)}${chk("MPU Complete",C.mpuComplete)}${chk("MSP Label Present",C.mspLabel)}${chk("System commissioned",C.commissioned)}${chk("Cell Kit/Zigbee installed",C.cellKit)}${report.cellImei?chk("IMEI",report.cellImei):""}${chk("Inspection ready",C.inspectionReady)}${chk("Property damage",C.propertyDamage)}${chk("Tiles broken",C.tilesBroken)}${chk("Yard sign received",C.yardSign)}</table>`);
      if(report.postNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px"><strong>Post Notes:</strong> ${report.postNotes}</div>`);
      ["Main Service Panel Breakers","Main Service Panel Label","Solar Main Breaker Close-Up","Property Damage Photos","Broken Tiles","Installed Yard Sign","Proof of Profile Setting","CT Photos","Reference Measurements","Clean Site"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
    } else if(reportType==="mpu") {
      win.document.write(`<div class="section-title">MPU Pre-Review</div><table class="info-table">${chk("Pre-existing conditions",C.preExisting)}${chk("Battery job",C.batteryJob)}${chk("Anything NOT working before MPU",C.notWorking)}</table>`);
      if(report.preNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px"><strong>Notes:</strong> ${report.preNotes}</div>`);
      ["Home Address","Existing MSP and New Location","Existing Breakers","Existing Riser"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">MPU Checklist</div><table class="info-table">${chk("Oversized breakers",C.oversizedBreakers)}${chk("Debris removed",C.debrisRemoved)}${chk("Grounding/bonding in place",C.grounding)}${chk("Wires torqued to spec",C.torqued)}${chk("MSP labeled properly",C.mspLabeled)}${chk("Solar tied in",C.solarTiedIn)}${chk("Drywall damage",C.drywallDamage)}${chk("Stucco/siding complete",C.stuccoComplete)}${chk("All Rooms working",C.allRooms)}${chk("Garage working",C.garage)}${chk("Plugs working",C.plugs)}${chk("Lights working",C.lights)}${chk("Pool/Spa working",C.poolSpa)}</table>`);
      ["New MSP Mounted","Bracket Supporting Main Panel","Riser Support Strap","Manufacturer Label Inside MSP","Breakers Without Deadfront","Breakers With Deadfront","Main Breaker","Surge Protector","Meter Socket","Cold Hot Bonding Grounding","New Riser Conduit Run","PV Tie In","Close Up PV Breaker","Close Up Inverter Serial","CT Monitoring Screen"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">Inspection</div><table class="info-table">${chk("Inspection Result",C.inspectionPass||"-")}</table>`);
      if(report.inspectionNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px"><strong>Notes:</strong> ${report.inspectionNotes}</div>`);
      ["Rough Inspection Photos","Stucco Photo of MSP","Lath Before Stucco","Completed Stucco with Paint"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
    } else if(reportType==="inspection") {
      win.document.write(`<div class="section-title">Inspection Checklist</div><table class="info-table">${chk("PV tie-in at final inspection",C.pvTieIn)}${chk("System has battery",C.hasBattery)}${chk("Sub panel installed",C.subPanel)}${chk("PCS setting required",C.pcsRequired)}</table>`);
      ["Signed Off Job Card","Home Address","Main Panel Placards and Meter","Main Service Panel Breakers","Solar And Main Breaker Close-Up","Main Service Panel Label","MSP Wiring Pull Back","Crimp to Ufer Ground MSP","Conduit Run Color Match"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
      win.document.write(`<div class="section-title">Post Inspection Review</div><table class="info-table">${chk("Inspection Result",C.inspectionPass||"-")}${chk("Battery configuration",report.batteryConfig)}</table>`);
      if(report.fieldNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px"><strong>Field Notes:</strong> ${report.fieldNotes}</div>`);
      if(C.inspectionPass==="Fail"){if(report.failureNotes)win.document.write(`<div style="margin:8px 0;padding:8px;background:#fff3f3;border-left:3px solid #ef4444;font-size:11px"><strong>Failure Notes:</strong> ${report.failureNotes}</div>`);win.document.write(`${chk("Correction Completed",C.correctionDone)}${C.returnScheduled?chk("Return Date Scheduled",C.returnScheduled):""}${report.returnDate?chk("Return Date",report.returnDate):""}`);}
      ["CT Photos","Array","Inverter Combiner Interior","Cell Card Modem","Fully Wired Inverter Compartment","AC Disco Exterior Interior","Voltage Measurement Each String","BOS Pullback","Equipment Pull Back","Failure Photos"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
    } else if(reportType==="service") {
      win.document.write(`<div class="section-title">Service Details</div><table class="info-table">${chk("Issue resolved",C.resolved)}${chk("Return visit needed",C.returnVisit)}</table>`);
      if(report.problemDesc) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #f0a500;font-size:11px"><strong>Problem:</strong> ${report.problemDesc}</div>`);
      if(report.workPerformed) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #22c55e;font-size:11px"><strong>Work Performed:</strong> ${report.workPerformed}</div>`);
      if(report.partsUsed) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #3b82f6;font-size:11px"><strong>Parts Used:</strong> ${report.partsUsed}</div>`);
      if(report.serviceNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #6b7280;font-size:11px"><strong>Notes:</strong> ${report.serviceNotes}</div>`);
      ["Before Photos","After Photos","Parts Photos","Additional Photos"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
    } else if(reportType==="inverter") {
      win.document.write(`<div class="section-title">Inverter Information</div><table class="info-table">${chk("Brand",report.inverterBrand)}${chk("Model",report.inverterModel)}${chk("Serial",report.inverterSerial)}${chk("Production Status",report.productionStatus)}${chk("Fault Code",report.faultCode||"None")}${chk("Reported By",report.issueReportedBy)}</table>`);
      if(report.inverterIssueDesc) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #f0a500;font-size:11px"><strong>Issue:</strong> ${report.inverterIssueDesc}</div>`);
      win.document.write(`<div class="section-title">On-Site Diagnostics</div><table class="info-table">${chk("AC Voltage OK",C.acVoltageOk)}${chk("DC Voltage OK",C.dcVoltageOk)}${chk("Breakers Tripped",C.breakersTripped)}${chk("Physical Damage",C.physicalDamage)}${chk("Shading Found",C.shadingFound)}${chk("Monitoring Connected",C.commConnected)}${chk("AC Voltage Reading",report.acVoltageReading||"—")}${chk("DC Voltage Reading",report.dcVoltageReading||"—")}</table>`);
      if(report.diagNotes) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #6b7280;font-size:11px"><strong>Diagnostic Notes:</strong> ${report.diagNotes}</div>`);
      win.document.write(`<div class="section-title">Action Taken</div><table class="info-table">${chk("Reset Performed",C.resetDone)}${chk("Unit Replaced",C.unitReplaced)}${C.unitReplaced==="Yes"?chk("Replacement Part #",report.replacementPartNum)+chk("Replacement Serial",report.replacementSerial):""}${chk("Firmware Updated",C.firmwareUpdated)}${chk("Warranty Claim Filed",C.warrantyClaim)}${report.rmaNumber?chk("RMA / Ticket #",report.rmaNumber):""}${chk("Monitoring Restored",C.monitoringRestored)}${chk("Parts On Order",C.partsOnOrder)}${report.partsOrdered?chk("Parts Ordered",report.partsOrdered):""}${chk("Escalated to Manufacturer",C.escalatedToMfg)}${chk("Issue Resolved On Site",C.inverterResolved)}${chk("Return Visit Needed",C.inverterReturn)}</table>`);
      if(report.inverterWorkPerformed) win.document.write(`<div style="margin:8px 0;padding:8px;background:#f5f5f5;border-left:3px solid #22c55e;font-size:11px"><strong>Work Performed:</strong> ${report.inverterWorkPerformed}</div>`);
      ["Inverter Display","Inverter Disconnect","Monitoring Before","Monitoring After","Replaced Unit Label","Inverter Additional"].forEach(s=>{if(PH[s]?.length){win.document.write(`<div style="font-size:10px;font-weight:bold;color:#333;margin:10px 0 4px;text-transform:uppercase">${s}</div>`); photoBlock(s, win, hdr);;}});
    }
    win.document.write(`</div></body></html>`);
    win.document.close();
    win.focus();
    setTimeout(()=>win.print(),1000);
  };

  // Public submit success screen
  if (publicMode && submitted) return (
    <div style={{minHeight:"100vh",background:"#f5f6fa",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif",padding:"20px"}}>
      <div style={{textAlign:"center",background:"#fff",borderRadius:16,padding:"48px 32px",boxShadow:"0 4px 24px rgba(0,0,0,0.08)",maxWidth:400,width:"100%"}}>
        <div style={{fontSize:64,marginBottom:16}}>✅</div>
        <div style={{fontFamily:"'DM Serif Display',serif",fontSize:22,fontWeight:800,color:"#1a1d25",marginBottom:8}}>Report Submitted!</div>
        <div style={{fontSize:14,color:"#6a7080",marginBottom:6}}>{wo.customerName}</div>
        <div style={{fontSize:12,color:"#9aa0b4",marginBottom:28}}>{wo.date} · {wo.woId}</div>
        <div style={{fontSize:13,color:"#22c55e",fontWeight:600,background:"#22c55e10",border:"1px solid #22c55e33",borderRadius:10,padding:"12px"}}>
          Suntrify has been notified. You can close this tab.
        </div>
      </div>
    </div>
  );

  return (
    <div style={publicMode ? {minHeight:"100vh",background:"#f5f6fa",overflowY:"auto",padding:"16px"} : {position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:2000,overflowY:"auto",padding:"20px 16px"}}>
      <div style={{background:"#f9f9fb",borderRadius:12,maxWidth:680,margin:"0 auto",padding:20,minHeight:publicMode?"auto":"80vh"}}>
        {publicMode&&(
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16,paddingBottom:16,borderBottom:"1px solid #e0e3eb"}}>
            <SuntrifyLogo height={36}/>
          </div>
        )}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div>
            <div style={{fontFamily:"'DM Serif Display',serif",fontSize:18,fontWeight:800,color:"#1a1d25",display:"flex",alignItems:"center",gap:8}}><Icon name="clipboard" size={18} color="#1a1d25"/> Field Report</div>
            <div style={{fontSize:12,color:"#9aa0b4"}}>{wo.customerName} · <AddressLink address={wo.address} style={{color:"#9aa0b4",fontSize:12}}/> · {wo.date}</div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <button onClick={()=>setRefreshTick(t=>t+1)} style={{background:"#f0a500",border:"none",borderRadius:6,padding:"5px 12px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#000",fontWeight:700,zIndex:9999,position:"relative"}}>🔄 Refresh</button>
            {publicMode
              ? null
              : <button onClick={onClose} style={{background:"transparent",border:"none",fontSize:20,cursor:"pointer",color:"#9aa0b4"}}>✕</button>
            }
          </div>
        </div>
        <div style={{marginBottom:16}}>
          <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>Select Report Type</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {[["solar","Solar + Battery"],["mpu","MPU"],["inspection","Inspection"],["service","Service Call"],["inverter","Inverter Service"]].map(([val,label])=>(
              <button key={val} onClick={()=>setReportType(val)} style={{padding:"10px 8px",border:"2px solid "+(reportType===val?"#f0a500":"#e0e3eb"),borderRadius:8,background:reportType===val?"#f0a50015":"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:13,fontWeight:reportType===val?700:400,color:reportType===val?"#d4891f":"#6a7080"}}>
                {label}
              </button>
            ))}
          </div>
        </div>
        {!reportType&&<div style={{textAlign:"center",padding:"40px 0",color:"#9aa0b4",fontSize:14}}>Select a report type above to begin</div>}

        {/* SOLAR REPORT */}
        {reportType==="solar"&&<>
          <WRSection title="Pre-Installation Review">
            <WOPhotoSection label="Home Address" section="Home Address" photos={report.photos?.["Home Address"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Photo of Crew Truck" section="Crew Truck" photos={report.photos?.["Crew Truck"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Crew Wearing Suntrify Safety Gear" section="Suntrify Safety Gear" photos={report.photos?.["Suntrify Safety Gear"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Safety Harness" section="Safety Harness" photos={report.photos?.["Safety Harness"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Suntrify Flag on Site" section="Suntrify Flag" photos={report.photos?.["Suntrify Flag"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Existing PV Installation?</div>
              <select value={report.existingPV||"No"} onChange={e=>setField("existingPV",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",width:"100%"}}>
                <option>No</option><option>Yes</option>
              </select>
            </div>
            <WRTxta label="Pre-Install Notes / Pre-existing conditions" field="preNotes" report={report} onChange={setField}/>
            <WOPhotoSection label="Pre-existing Condition Photos" section="Pre-existing Conditions" photos={report.photos?.["Pre-existing Conditions"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
          </WRSection>
          <WRSection title="Pre-Installation Checklist">
            <WRChk label="Engineering notes reviewed" field="engNotes" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Module count matches plan set" field="moduleCount" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Inverter type/count matches plan set" field="inverterCount" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Materials match plan set and PO" field="materials" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Measurements match plan set" field="measurements" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Roof framing and condition verified" field="roofFraming" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Rafters direction and spacing match plan set" field="rafters" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Point of connection verified" field="pointOfConnection" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="MSP condition verified (if not MPU scoped)" field="mspCondition" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Solar breaker amperage matches plan set" field="solarBreaker" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Main service ground checked (EGC-GEC)" field="mainServiceGround" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Existing solar system ground checked" field="existingSolarGround" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Service grounding if unlocked" field="serviceGrounding" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Other pre-existing conditions on site" field="preExisting" checklist={report.checklist} onChange={setCheck}/>
          </WRSection>
          <WRSection title="Installation Photos">
            {["Exclusion Zone","MSP Wiring Pull Back","Array Flashings","Rail Grounding","Rail Side Profile","Rail Splice Label","Wire Management Pre-Panels","Module Labels","Optimizer Labels","Wire Management Under Array","Array","Array Fire Setback","Glass Level","Module Clamp","Module Grounding","J-Box","EGC Path","Conduit Run","Optimizer Map","Pitch Finder","Existing Ground UFER"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
            <WRChk label="Installed array layout matches plans" field="arrayLayout" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Breakers relocated for tie-in" field="breakersRelocated" checklist={report.checklist} onChange={setCheck}/>
          </WRSection>
          <WRSection title="Battery Installation">
            <WRChk label="Is this a Battery Job?" field="batteryJob" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.batteryJob==="Yes"&&<>
              <WRChk label="Tesla Battery?" field="teslaBattery" checklist={report.checklist} onChange={setCheck}/>
              <div style={{marginBottom:10}}>
                <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Battery Configuration</div>
                <select value={report.batteryConfig||"Self Consumption"} onChange={e=>setField("batteryConfig",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",width:"100%"}}>
                  <option>Self Consumption</option><option>Backup Only</option><option>TOU</option><option>N/A</option>
                </select>
              </div>
              {report.checklist?.teslaBattery==="Yes"&&["Tesla Heat Shield","Tesla Ferrite Core","Tesla Bracket","Tesla Registration Screenshot"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
              {["Battery Label Serial","Battery Communications"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
              <WRChk label="Backup Panel Required?" field="backupPanel" checklist={report.checklist} onChange={setCheck}/>
              {report.checklist?.backupPanel==="Yes"&&["Backup Panel Interior","Backup Panel Deadfront","Photo of Panel Post Load Relocation"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
              {["Consumption Meter","Battery Backup Panel"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
            </>}
            <WRChk label="Sub Panel Required?" field="subPanel" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.subPanel==="Yes"&&["Sub-Panel Breakers","Sub-Panel Wiring","Sub-Panel Exterior"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
            <WRChk label="AC Disco Present?" field="acDisco" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.acDisco==="Yes"&&<WOPhotoSection label="AC Disco Exterior and Interior" section="AC Disco" photos={report.photos?.["AC Disco"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>}
            {["BOS Pullback","Inverter Location","Inverter Label Serial","Voltage Measurement","Inverter Interior","Conduit Support","Conduit Penetrations"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
          </WRSection>
          <WRSection title="SetApp Screens">
            {["SetApp Firmware","SetApp RS485","SetApp Meter 1","SetApp Meter 2","SetApp Battery Info","SetApp Battery Self Test","SetApp Storage Control","SetApp Energy Manager","SetApp System Status 1","SetApp System Status 2","SetApp CT Config"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
            <WRInp label="Cell Card / Modem IMEI #" field="cellImei" report={report} onChange={setField}/>
          </WRSection>
          <WRSection title="MPU (if applicable)">
            <WRChk label="Is there an MPU?" field="mpu" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.mpu==="Yes"&&<>
              <WRChk label="MPU Complete?" field="mpuComplete" checklist={report.checklist} onChange={setCheck}/>
              <WRChk label="MSP Label Present?" field="mspLabel" checklist={report.checklist} onChange={setCheck}/>
              {["Main Service Panel Breakers","Main Service Panel Label","Solar Main Breaker Close-Up"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
            </>}
          </WRSection>
          <WRSection title="Post Installation Review">
            <WRChk label="System commissioned on site?" field="commissioned" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Cell Kit/Zigbee installed?" field="cellKit" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Is install inspection ready?" field="inspectionReady" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.inspectionReady==="No"&&<WRTxta label="What items remain?" field="itemsRemaining" report={report} onChange={setField}/>}
            <WRChk label="Property damage?" field="propertyDamage" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.propertyDamage==="Yes"&&<>
              <WRTxta label="Property Damage Description" field="propertyDamageDesc" report={report} onChange={setField}/>
              <WOPhotoSection label="Property Damage Photos" section="Property Damage Photos" photos={report.photos?.["Property Damage Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            </>}
            <WRChk label="Tiles broken during install?" field="tilesBroken" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.tilesBroken==="Yes"&&<WOPhotoSection label="Photos of Broken Tiles" section="Broken Tiles" photos={report.photos?.["Broken Tiles"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>}
            <WRChk label="Yard sign received?" field="yardSign" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.yardSign==="Yes"&&<WOPhotoSection label="Photo of Installed Yard Sign" section="Installed Yard Sign" photos={report.photos?.["Installed Yard Sign"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>}
            <WRChk label="Deadfront missing?" field="deadfront" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Return visit scheduled?" field="returnVisit" checklist={report.checklist} onChange={setCheck}/>
            {!publicMode&&report.checklist?.returnVisit==="Yes"&&<WRInp label="Return Date" field="returnDate" type="date" report={report} onChange={setField}/>}
            <WRTxta label="Post-Install Notes" field="postNotes" report={report} onChange={setField}/>
            {["Clean Site","CT Photos","Reference Measurements","Proof of Profile Setting"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
          </WRSection>
        </>}

        {/* MPU REPORT */}
        {reportType==="mpu"&&<>
          <WRSection title="MPU Pre-Review">
            <WRChk label="Pre-existing conditions?" field="preExisting" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Is this a battery job?" field="batteryJob" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Anything NOT working before MPU?" field="notWorking" checklist={report.checklist} onChange={setCheck}/>
            <WRTxta label="Pre-existing condition notes / photos explanation" field="preNotes" report={report} onChange={setField}/>
            {["Home Address","Existing MSP and New Location","Existing Breakers","Existing Riser"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
          </WRSection>
          <WRSection title="MPU Checklist">
            <WRChk label="Any circuits with oversized breakers?" field="oversizedBreakers" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="All debris from MPU removed" field="debrisRemoved" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="All grounding/bonding in place" field="grounding" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Wires torqued to spec" field="torqued" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="MSP labeled properly" field="mspLabeled" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Solar tied in" field="solarTiedIn" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Drywall damage" field="drywallDamage" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Stucco/siding complete" field="stuccoComplete" checklist={report.checklist} onChange={setCheck}/>
            <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",margin:"10px 0 6px"}}>Post Panel Upgrade Walkthrough</div>
            <WRChk label="All Rooms working" field="allRooms" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Garage working" field="garage" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Plugs working" field="plugs" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Lights working" field="lights" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Pool/Spa working" field="poolSpa" checklist={report.checklist} onChange={setCheck}/>
          </WRSection>
          <WRSection title="MPU Photos">
            {["New MSP Mounted","Bracket Supporting Main Panel","Riser Support Strap","Manufacturer Label Inside MSP","Breakers Without Deadfront","Breakers With Deadfront","Main Breaker","Surge Protector","Meter Socket","Cold Hot Bonding Grounding","New Riser Conduit Run","PV Tie In","Close Up PV Breaker","Close Up Inverter Serial","CT Monitoring Screen"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
          </WRSection>
          <WRSection title="Inspection">
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Did Inspection Pass or Fail?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("inspectionPass","Pass")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.inspectionPass==="Pass"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.inspectionPass==="Pass"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.inspectionPass==="Pass"?"#22c55e":"#6a7080"}}>✅ Pass</button>
                <button onClick={()=>setCheck("inspectionPass","Fail")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.inspectionPass==="Fail"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.inspectionPass==="Fail"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.inspectionPass==="Fail"?"#ef4444":"#6a7080"}}>❌ Fail</button>
              </div>
            </div>
            {report.checklist?.inspectionPass==="Fail"&&<>
              <WRTxta label="Required Corrections" field="inspectionNotes" report={report} onChange={setField}/>
              {report.checklist?.correctionDone==="Yes"&&<WOPhotoSection label="Correction Completed Photos" section="Correction Completed" photos={report.photos?.["Correction Completed"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>}
            </>}
            <WRTxta label="If No - required corrections" field="inspectionNotes" report={report} onChange={setField}/>
            {["Rough Inspection Photos","Stucco Photo of MSP","Lath Before Stucco","Completed Stucco with Paint"].map(s=>(
              <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            ))}
          </WRSection>
        </>}

        {/* INSPECTION REPORT */}
        {reportType==="inspection"&&<>
          <WRSection title="Inspection Checklist">
            <WOPhotoSection label="Signed Off Job Card" section="Signed Off Job Card" photos={report.photos?.["Signed Off Job Card"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Home Address" section="Home Address" photos={report.photos?.["Home Address"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Main Panel Placards and Meter with Legible Meter Number" section="Main Panel Placards and Meter" photos={report.photos?.["Main Panel Placards and Meter"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Is the PV tie-in getting completed at the final inspection?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("pvTieIn","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.pvTieIn==="Yes"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.pvTieIn==="Yes"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.pvTieIn==="Yes"?"#22c55e":"#6a7080"}}>✅ Yes</button>
                <button onClick={()=>setCheck("pvTieIn","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.pvTieIn==="No"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.pvTieIn==="No"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.pvTieIn==="No"?"#ef4444":"#6a7080"}}>❌ No</button>
              </div>
            </div>
            {report.checklist?.pvTieIn==="Yes"&&<>
              {["Main Service Panel Breakers","Solar And Main Breaker Close-Up","Main Service Panel Label","MSP Wiring Pull Back","Crimp to Existing Ufer/Ground Inside Main MSP","Conduit Run Color Match"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
            </>}
            {report.checklist?.pvTieIn==="No"&&<>
              {["Main Service Panel Breakers","Solar And Main Breaker Close-Up","Main Service Panel Label"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
            </>}

          </WRSection>
          <WRSection title="Post Inspection Review">
            <WOPhotoSection label="CT Photos" section="CT Photos" photos={report.photos?.["CT Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Proof of Commissioning" section="Proof of Commissioning" photos={report.photos?.["Proof of Commissioning"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Does this Job require PCS Setting?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("pcsRequired","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.pcsRequired==="Yes"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.pcsRequired==="Yes"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.pcsRequired==="Yes"?"#22c55e":"#6a7080"}}>✅ Yes</button>
                <button onClick={()=>setCheck("pcsRequired","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.pcsRequired==="No"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.pcsRequired==="No"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.pcsRequired==="No"?"#ef4444":"#6a7080"}}>❌ No</button>
              </div>
            </div>
            {report.checklist?.pcsRequired==="Yes"&&<WOPhotoSection label="PCS Setting Photos" section="PCS Setting Photos" photos={report.photos?.["PCS Setting Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>}
            <WOPhotoSection label="Array(s)" section="Array" photos={report.photos?.["Array"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Inverter/Combiner Interior" section="Inverter Combiner Interior" photos={report.photos?.["Inverter Combiner Interior"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Cell Card / Modem" section="Cell Card Modem" photos={report.photos?.["Cell Card Modem"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Fully Wired Inverter Wiring Compartment" section="Fully Wired Inverter Compartment" photos={report.photos?.["Fully Wired Inverter Compartment"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="AC Disco Exterior & Interior" section="AC Disco Exterior Interior" photos={report.photos?.["AC Disco Exterior Interior"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Voltage Measurement of Each String" section="Voltage Measurement Each String" photos={report.photos?.["Voltage Measurement Each String"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Is there a sub panel installed?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("subPanel","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.subPanel==="Yes"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.subPanel==="Yes"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.subPanel==="Yes"?"#22c55e":"#6a7080"}}>✅ Yes</button>
                <button onClick={()=>setCheck("subPanel","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.subPanel==="No"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.subPanel==="No"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.subPanel==="No"?"#ef4444":"#6a7080"}}>❌ No</button>
              </div>
            </div>
            {report.checklist?.subPanel==="Yes"&&<>
              {["Sub Panel Breakers","Sub Panel Wiring","Sub Panel Exterior"].map(s=>(
                <WOPhotoSection key={s} label={s} section={s} photos={report.photos?.[s]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              ))}
            </>}
            <WOPhotoSection label="BOS Pullback" section="BOS Pullback" photos={report.photos?.["BOS Pullback"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Equipment Pull Back" section="Equipment Pull Back" photos={report.photos?.["Equipment Pull Back"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>System has Battery?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("hasBattery","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.hasBattery==="Yes"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.hasBattery==="Yes"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.hasBattery==="Yes"?"#22c55e":"#6a7080"}}>✅ Yes</button>
                <button onClick={()=>setCheck("hasBattery","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.hasBattery==="No"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.hasBattery==="No"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.hasBattery==="No"?"#ef4444":"#6a7080"}}>❌ No</button>
              </div>
            </div>
            {report.checklist?.hasBattery==="Yes"&&<>
              <div style={{marginBottom:10}}>
                <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Battery Configuration</div>
                <select value={report.batteryConfig||""} onChange={e=>setField("batteryConfig",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
                  <option value="">-- Select --</option>
                  <option value="Self Consumption">Self Consumption</option>
                  <option value="Partial Backup">Partial Backup</option>
                  <option value="Whole Home Backup">Whole Home Backup</option>
                </select>
              </div>
              {report.batteryConfig==="Self Consumption"&&<>
                <WOPhotoSection label="Battery Label and Serial Number" section="Battery Label Serial" photos={report.photos?.["Battery Label Serial"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Pull Back Photo" section="BOS Pullback" photos={report.photos?.["BOS Pullback"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Communications" section="Battery Communications" photos={report.photos?.["Battery Communications"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              </>}
              {(report.batteryConfig==="Partial Backup"||report.batteryConfig==="Whole Home Backup")&&<>
                <WOPhotoSection label="Battery Label and Serial Number" section="Battery Label Serial" photos={report.photos?.["Battery Label Serial"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Pull Back Photo" section="BOS Pullback" photos={report.photos?.["BOS Pullback"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Communications" section="Battery Communications" photos={report.photos?.["Battery Communications"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Backup Panel" section="Battery Backup Panel" photos={report.photos?.["Battery Backup Panel"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Backup Panel Interior" section="Battery Backup Panel Interior" photos={report.photos?.["Battery Backup Panel Interior"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
                <WOPhotoSection label="Battery Backup Panel: Deadfront and Labels" section="Battery Backup Panel Deadfront" photos={report.photos?.["Battery Backup Panel Deadfront"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              </>}
            </>}
            <WRTxta label="Field Notes" field="fieldNotes" report={report} onChange={setField}/>
          </WRSection>
          <WRSection title="Inspection Pass/Fail">
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Did Inspection Pass or Fail?</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setCheck("inspectionPass","Pass")} style={{flex:1,padding:"10px",border:"2px solid "+(report.checklist?.inspectionPass==="Pass"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.inspectionPass==="Pass"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.inspectionPass==="Pass"?"#22c55e":"#6a7080",fontSize:14}}>✅ Pass</button>
                <button onClick={()=>setCheck("inspectionPass","Fail")} style={{flex:1,padding:"10px",border:"2px solid "+(report.checklist?.inspectionPass==="Fail"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.inspectionPass==="Fail"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.inspectionPass==="Fail"?"#ef4444":"#6a7080",fontSize:14}}>❌ Fail</button>
              </div>
            </div>
            {report.checklist?.inspectionPass==="Fail"&&<>
              <WRTxta label="Failure Notes / Corrections Needed" field="failureNotes" report={report} onChange={setField}/>
              <WOPhotoSection label="Failure Photos (Required)" section="Failure Photos" photos={report.photos?.["Failure Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              <div style={{marginBottom:10}}>
                <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Was the correction completed?</div>
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setCheck("correctionDone","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.correctionDone==="Yes"?"#22c55e":"#e0e3eb"),borderRadius:8,background:report.checklist?.correctionDone==="Yes"?"#22c55e15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.correctionDone==="Yes"?"#22c55e":"#6a7080"}}>✅ Yes</button>
                  <button onClick={()=>setCheck("correctionDone","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.correctionDone==="No"?"#ef4444":"#e0e3eb"),borderRadius:8,background:report.checklist?.correctionDone==="No"?"#ef444415":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.correctionDone==="No"?"#ef4444":"#6a7080"}}>❌ No</button>
                </div>
              </div>
              {report.checklist?.correctionDone==="Yes"&&<>
                <WOPhotoSection label="Correction Completed Photos" section="Correction Completed" photos={report.photos?.["Correction Completed"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
              </>}
              {report.checklist?.correctionDone==="No"&&<>
                <div style={{marginBottom:10}}>
                  <div style={{fontSize:11,color:"#9aa0b4",marginBottom:6}}>Has a return date been scheduled?</div>
                  <div style={{display:"flex",gap:10,marginBottom:8}}>
                    <button onClick={()=>setCheck("returnScheduled","Yes")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.returnScheduled==="Yes"?"#3b82f6":"#e0e3eb"),borderRadius:8,background:report.checklist?.returnScheduled==="Yes"?"#3b82f615":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.returnScheduled==="Yes"?"#3b82f6":"#6a7080"}}>✅ Yes</button>
                    <button onClick={()=>setCheck("returnScheduled","No")} style={{flex:1,padding:"8px",border:"2px solid "+(report.checklist?.returnScheduled==="No"?"#f59e0b":"#e0e3eb"),borderRadius:8,background:report.checklist?.returnScheduled==="No"?"#f59e0b15":"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,color:report.checklist?.returnScheduled==="No"?"#f59e0b":"#6a7080"}}>⏳ Not Yet</button>
                  </div>
                  {!publicMode&&report.checklist?.returnScheduled==="Yes"&&<WRInp label="Return Date" field="returnDate" type="date" report={report} onChange={setField}/>}
                </div>
              </>}
            </>}
          </WRSection>
        </>}

        {/* SERVICE CALL REPORT */}
        {reportType==="service"&&<>
          <WRSection title="Service Call Details">
            <WOPhotoSection label="Home Address / Job Site" section="Home Address" photos={report.photos?.["Home Address"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WRTxta label="Problem Description" field="problemDesc" report={report} onChange={setField} placeholder="Describe the issue reported by customer..."/>
            <WRTxta label="Work Performed" field="workPerformed" report={report} onChange={setField} placeholder="Describe all work done on site..."/>
            <WRTxta label="Parts Used / Materials" field="partsUsed" report={report} onChange={setField} placeholder="List any parts or materials used..."/>
            <WRChk label="Issue fully resolved?" field="resolved" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Return visit needed?" field="returnVisit" checklist={report.checklist} onChange={setCheck}/>
            {!publicMode&&<WRInp label="Return Visit Date (if needed)" field="returnDate" report={report} onChange={setField} type="date"/>}
            <WRTxta label="Additional Notes" field="serviceNotes" report={report} onChange={setField}/>
          </WRSection>
          <WRSection title="Service Photos">
            <WOPhotoSection label="Before Photos" section="Before Photos" photos={report.photos?.["Before Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="After Photos" section="After Photos" photos={report.photos?.["After Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Parts / Materials Used" section="Parts Photos" photos={report.photos?.["Parts Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Additional Photos" section="Additional Photos" photos={report.photos?.["Additional Photos"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
          </WRSection>
        </>}

        {/* ── INVERTER SERVICE REPORT ── */}
        {reportType==="inverter"&&<>
          <WRSection title="Inverter Information">
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Inverter Brand</div>
              <select value={report.inverterBrand||""} onChange={e=>setField("inverterBrand",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",width:"100%"}}>
                <option value="">-- Select --</option>
                {["Enphase","SolarEdge","SMA","Fronius","Growatt","Hoymiles","APsystems","Generac/PWRcell","Tesla","Other"].map(b=><option key={b}>{b}</option>)}
              </select>
            </div>
            <WRInp label="Model / Part Number" field="inverterModel" report={report} onChange={setField} placeholder="e.g. IQ8A-72-2-US"/>
            <WRInp label="Serial Number" field="inverterSerial" report={report} onChange={setField}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Production Status</div>
              <select value={report.productionStatus||""} onChange={e=>setField("productionStatus",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",width:"100%"}}>
                <option value="">-- Select --</option>
                {["Not Generating","Generating Below Expectation","Intermittent","Not Communicating","Error / Fault Code","Other"].map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <WRInp label="Error / Fault Code (if any)" field="faultCode" report={report} onChange={setField} placeholder="e.g. F401, P111"/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>How was issue reported?</div>
              <select value={report.issueReportedBy||""} onChange={e=>setField("issueReportedBy",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",width:"100%"}}>
                <option value="">-- Select --</option>
                {["Monitoring Alert","Customer Call","Routine Inspection","EPC Partner","Other"].map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <WRTxta label="Issue Description" field="inverterIssueDesc" report={report} onChange={setField} placeholder="Describe the issue in detail..."/>
          </WRSection>

          <WRSection title="On-Site Diagnostics">
            <WRChk label="AC voltage at disconnect — Normal?" field="acVoltageOk" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="DC voltage at inverter — Normal?" field="dcVoltageOk" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Breakers tripped?" field="breakersTripped" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Physical damage visible?" field="physicalDamage" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Shading or obstruction found?" field="shadingFound" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Communication / monitoring connected?" field="commConnected" checklist={report.checklist} onChange={setCheck}/>
            <WRInp label="AC Voltage Reading (V)" field="acVoltageReading" report={report} onChange={setField} placeholder="e.g. 240V"/>
            <WRInp label="DC Voltage Reading (V)" field="dcVoltageReading" report={report} onChange={setField} placeholder="e.g. 380V"/>
            <WRTxta label="Diagnostic Notes" field="diagNotes" report={report} onChange={setField} placeholder="Additional observations on site..."/>
          </WRSection>

          <WRSection title="Action Taken">
            <WRChk label="System reset performed?" field="resetDone" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Unit replaced?" field="unitReplaced" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.unitReplaced==="Yes"&&<>
              <WRInp label="Replacement Unit — Part Number" field="replacementPartNum" report={report} onChange={setField}/>
              <WRInp label="Replacement Unit — Serial Number" field="replacementSerial" report={report} onChange={setField}/>
            </>}
            <WRChk label="Firmware updated?" field="firmwareUpdated" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Warranty claim filed?" field="warrantyClaim" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.warrantyClaim==="Yes"&&<WRInp label="RMA / Ticket Number" field="rmaNumber" report={report} onChange={setField}/>}
            <WRChk label="Monitoring restored?" field="monitoringRestored" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Parts on order?" field="partsOnOrder" checklist={report.checklist} onChange={setCheck}/>
            {report.checklist?.partsOnOrder==="Yes"&&<WRInp label="Parts Ordered (description)" field="partsOrdered" report={report} onChange={setField}/>}
            <WRChk label="Escalated to manufacturer?" field="escalatedToMfg" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Issue fully resolved on site?" field="inverterResolved" checklist={report.checklist} onChange={setCheck}/>
            <WRChk label="Return visit needed?" field="inverterReturn" checklist={report.checklist} onChange={setCheck}/>
            <WRTxta label="Work Performed Summary" field="inverterWorkPerformed" report={report} onChange={setField} placeholder="Describe all work done on site..."/>
          </WRSection>

          <WRSection title="Inverter Photos">
            <WOPhotoSection label="Inverter Display / Error Screen" section="Inverter Display" photos={report.photos?.["Inverter Display"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="AC / DC Disconnect" section="Inverter Disconnect" photos={report.photos?.["Inverter Disconnect"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Monitoring Screenshot (Before)" section="Monitoring Before" photos={report.photos?.["Monitoring Before"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Monitoring Screenshot (After)" section="Monitoring After" photos={report.photos?.["Monitoring After"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Replaced Unit Label / Serial" section="Replaced Unit Label" photos={report.photos?.["Replaced Unit Label"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
            <WOPhotoSection label="Additional Photos" section="Inverter Additional" photos={report.photos?.["Inverter Additional"]||[]} onUpload={uploadSection} onRemove={removePhoto}/>
          </WRSection>
        </>}

        {/* Save / Complete / Clear / Delete */}
        <div style={{display:"flex",flexDirection:"column",gap:8,marginTop:20}}>
          {publicMode ? (
            // Phone / public mode — Save + Submit only
            <div style={{display:"flex",gap:8}}>
              <button onClick={handleSave} disabled={saving} style={{flex:1,padding:"14px",background:"#f0a500",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:saving?"wait":"pointer",fontFamily:"inherit",color:"#000"}}>
                {saving?"⏳ Saving...":saved?"✅ Saved!":"💾 Save Report"}
              </button>
              <button onClick={async()=>{
                await handleSave();
                const subject = `Field Report – ${wo.customerName} · ${(typeLabels&&typeLabels[reportType])||reportType} · ${wo.date||""}`;
                const bodyText = `Field report submitted.\nCustomer: ${wo.customerName}\nAddress: ${wo.address||""}\nDate: ${wo.date||""}\nCrew: ${wo.crew||""}\nType: ${(typeLabels&&typeLabels[reportType])||reportType}\n\nView in CRM: https://crm.suntrify.com`;
                sendViaSES(SES_TO, subject, bodyText);
                setSubmitted(true);
              }} disabled={saving} style={{flex:1,padding:"14px",background:"#22c55e",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:saving?"wait":"pointer",fontFamily:"inherit",color:"#fff"}}>
                {saving?"⏳ Saving...":"Submit ✓"}
              </button>
            </div>
          ) : (
            // CRM mode — full buttons
            <>
              <div style={{display:"flex",gap:8}}>
                <button onClick={handleSave} disabled={saving} style={{flex:1,padding:"12px",background:"#f0a500",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#000"}}>
                  {saving?"⏳ Saving...":saved?"✅ Saved!":"💾 Save Report"}
                </button>
                <button onClick={handleComplete} disabled={saving} style={{flex:1,padding:"12px",background:"#22c55e",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:saving?"not-allowed":"pointer",fontFamily:"inherit",color:"#fff"}}>
                  ✅ Complete & Save PDF
                </button>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={handleClear} style={{flex:1,padding:"10px",background:"transparent",border:"1.5px solid #d4891f",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#d4891f"}}>
                  🔄 Clear Report
                </button>
                <button onClick={handleDelete} style={{flex:1,padding:"10px",background:"transparent",border:"1.5px solid #ef4444",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#ef4444"}}>
                  🗑 Delete Report
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


function Dashboard({ jobs, workOrders, customers, invoices, setTab }) {
  const today2 = new Date().toISOString().slice(0,10);

  // ── Financial KPIs ──────────────────────────────────────────────────────────
  const activeJobs    = jobs.filter(j => !["Closed","Cancelled"].includes(j.stage));
  const totalContract = activeJobs.reduce((s,j) => s+(j.contractValue||0), 0);
  const totalPaid     = jobs.reduce((s,j) => s+(j.paid||0), 0);
  const balanceOwed   = jobs.reduce((s,j) => s+Math.max(0,(j.contractValue||0)-(j.paid||0)), 0);
  const backChargeTotal = workOrders.filter(w=>w.backCharge&&w.chargeAmount>0).reduce((s,w)=>s+(w.chargeAmount||0),0);
  const backChargePending = workOrders.filter(w=>w.backCharge&&w.chargeAmount>0&&w.status!=="Complete").reduce((s,w)=>s+(w.chargeAmount||0),0);

  // ── Invoice KPIs ────────────────────────────────────────────────────────────
  const openInvoices  = invoices.filter(i=>i.status!=="Paid");
  const openInvTotal  = openInvoices.reduce((s,i)=>s+(i.total||0),0);
  const overdueInv    = openInvoices.filter(i=>{ if(!i.date) return false; const d=new Date(i.date); d.setDate(d.getDate()+30); return d.toISOString().slice(0,10)<today2; });

  // ── WO KPIs ─────────────────────────────────────────────────────────────────
  const scheduledWOs  = workOrders.filter(w=>w.status==="Scheduled");
  const todayWOs      = workOrders.filter(w=>w.date===today2);
  const upcomingWOs   = workOrders.filter(w=>w.status==="Scheduled"&&w.date>=today2).sort((a,b)=>a.date.localeCompare(b.date)).slice(0,8);

  // ── Stage chart ─────────────────────────────────────────────────────────────
  const stageCounts={};
  jobs.forEach(j=>{stageCounts[j.stage]=(stageCounts[j.stage]||0)+1;});
  const sc={"Lead":"#6b7280","Site Survey":"#8b5cf6","Permit Submitted":"#f59e0b","Permit Approved":"#3b82f6","Installation":"#f0a500","Final Inspection":"#ec4899","PTO Submitted":"#06b6d4","Closed":"#22c55e","Cancelled":"#ef4444"};

  // ── Revenue bars ────────────────────────────────────────────────────────────
  const months=[];
  for(let i=5;i>=0;i--){const d=new Date();d.setMonth(d.getMonth()-i);months.push({key:d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0"),label:d.toLocaleString("default",{month:"short"})});}
  const maxRev=Math.max(...months.map(m=>jobs.filter(j=>(j.startDate||j.endDate||"").startsWith(m.key)).reduce((s,j)=>s+(j.contractValue||0),0)),1);

  const fmtD = d=>{if(!d)return"—";const dt=new Date(d+"T12:00:00");return dt.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",year:"numeric"});};
  const fmtAmt = n => n>=1000000?"$"+(n/1000000).toFixed(1)+"M":n>=1000?"$"+(n/1000).toFixed(0)+"K":"$"+n.toLocaleString();

  // KPI card component (inline)
  const KPI = ({label, value, sub, accent, onClick, warn}) => (
    <div onClick={onClick} style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"16px 18px",flex:1,minWidth:150,cursor:onClick?"pointer":"default",position:"relative",overflow:"hidden",transition:"box-shadow .15s"}}
      onMouseEnter={e=>{if(onClick)e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.08)";}}
      onMouseLeave={e=>{e.currentTarget.style.boxShadow="none";}}>
      <div style={{position:"absolute",top:0,left:0,bottom:0,width:4,background:accent,borderRadius:"12px 0 0 12px"}}/>
      <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,letterSpacing:".06em",marginBottom:8}}>{label}</div>
      <div style={{fontSize:24,fontWeight:800,color:warn?"#ef4444":accent,lineHeight:1,marginBottom:4}}>{value}</div>
      {sub&&<div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>{sub}</div>}
    </div>
  );

  return (
    <div style={{paddingBottom:24}}>
      <div style={{fontFamily:"'DM Serif Display',serif",fontSize:22,color:"#1a1d25",marginBottom:20}}>Dashboard</div>

      {/* ── Row 1: Financial ── */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:12}}>
        <KPI label="Pipeline Value"  value={fmtAmt(totalContract)}  accent="#f0a500" sub={`${activeJobs.length} active jobs`}          onClick={()=>setTab("pipeline")}/>
        <KPI label="Collected"       value={fmtAmt(totalPaid)}      accent="#22c55e" sub={`${jobs.length} total jobs`}                  onClick={()=>setTab("jobs")}/>
        <KPI label="Balance Owed"    value={fmtAmt(balanceOwed)}    accent="#ef4444" sub="contract minus collected"                     warn={balanceOwed>0}/>
        <KPI label="Back Charges"    value={fmtAmt(backChargeTotal)} accent="#d4891f" sub={`$${backChargePending.toLocaleString()} pending`} onClick={()=>setTab("workorders")}/>
      </div>

      {/* ── Row 2: Activity ── */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        <KPI label="Customers"       value={customers.length}        accent="#3b82f6" sub="total on file"                               onClick={()=>setTab("customers")}/>
        <KPI label="Scheduled WOs"   value={scheduledWOs.length}    accent="#8b5cf6" sub={`${todayWOs.length} today`}                  onClick={()=>setTab("workorders")}/>
        <KPI label="Open Invoices"   value={fmtAmt(openInvTotal)}   accent="#f59e0b" sub={`${openInvoices.length} unpaid`}             onClick={()=>setTab("invoices")} warn={overdueInv.length>0}/>
        <KPI label="Proposals Out"   value={jobs.filter(j=>j.stage==="Proposal"||j.stage==="Site Survey").length} accent="#06b6d4" sub="site survey + proposal" onClick={()=>setTab("pipeline")}/>
      </div>

      {/* ── Charts row ── */}
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:16,marginBottom:16}}>
        <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,overflow:"hidden"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 18px",borderBottom:"1px solid #f0f1f5"}}>
            <div style={{fontWeight:700,fontSize:14,color:"#1a1d25"}}>Revenue — Last 6 Months</div>
            <div style={{display:"flex",gap:14,fontSize:10,color:"#9aa0b4"}}>
              <span><span style={{display:"inline-block",width:8,height:8,borderRadius:2,background:"#f0a500",marginRight:4}}/>Contract</span>
              <span><span style={{display:"inline-block",width:8,height:8,borderRadius:2,background:"#22c55e",marginRight:4}}/>Collected</span>
            </div>
          </div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead>
              <tr style={{background:"#f8f9fb"}}>
                <th style={{padding:"8px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em"}}>Month</th>
                <th style={{padding:"8px 14px",textAlign:"right",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em"}}>Contract</th>
                <th style={{padding:"8px 14px",textAlign:"right",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em"}}>Collected</th>
                <th style={{padding:"8px 14px",textAlign:"right",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em"}}>Balance</th>
                <th style={{padding:"8px 14px",textAlign:"center",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em"}}>Jobs</th>
              </tr>
            </thead>
            <tbody>
              {months.map((m,i)=>{
                const mJobs=jobs.filter(j=>(j.startDate||j.endDate||"").startsWith(m.key));
                const rev=mJobs.reduce((s,j)=>s+(j.contractValue||0),0);
                const pd=mJobs.reduce((s,j)=>s+(j.paid||0),0);
                const bal=rev-pd;
                const isCurrent=m.key===new Date().getFullYear()+"-"+String(new Date().getMonth()+1).padStart(2,"0");
                return(
                  <tr key={m.key} style={{borderBottom:"1px solid #f0f1f5",background:isCurrent?"#fffbeb":i%2===0?"#fff":"#fafbfc"}}>
                    <td style={{padding:"10px 14px",fontWeight:isCurrent?700:500,color:isCurrent?"#d4891f":"#1a1d25"}}>
                      {isCurrent&&<span style={{background:"#f0a500",color:"#000",borderRadius:3,padding:"1px 5px",fontSize:9,fontWeight:800,marginRight:6}}>NOW</span>}
                      {m.label}
                    </td>
                    <td style={{padding:"10px 14px",textAlign:"right",fontWeight:700,color:rev>0?"#f0a500":"#c0c4d0"}}>
                      {rev>0?"$"+rev.toLocaleString():"—"}
                    </td>
                    <td style={{padding:"10px 14px",textAlign:"right",fontWeight:700,color:pd>0?"#22c55e":"#c0c4d0"}}>
                      {pd>0?"$"+pd.toLocaleString():"—"}
                    </td>
                    <td style={{padding:"10px 14px",textAlign:"right",fontWeight:600,color:bal>0?"#ef4444":bal===0&&rev>0?"#22c55e":"#c0c4d0"}}>
                      {rev>0?(bal>0?"$"+bal.toLocaleString():"✓ Paid"):"—"}
                    </td>
                    <td style={{padding:"10px 14px",textAlign:"center"}}>
                      {mJobs.length>0
                        ?<span style={{background:"#f0f1f5",color:"#6a7080",borderRadius:10,padding:"1px 8px",fontSize:11,fontWeight:600}}>{mJobs.length}</span>
                        :<span style={{color:"#c0c4d0",fontSize:12}}>—</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"18px 20px"}}>
          <div style={{fontWeight:700,fontSize:14,color:"#1a1d25",marginBottom:14}}>Jobs by Stage</div>
          {Object.entries(stageCounts).sort((a,b)=>b[1]-a[1]).map(([stage,count])=>(
            <div key={stage} style={{marginBottom:7}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                <span style={{color:"#6a7080"}}>{stage}</span>
                <span style={{fontWeight:700,color:sc[stage]||"#6b7280"}}>{count}</span>
              </div>
              <div style={{height:4,background:"#f0f1f5",borderRadius:3}}>
                <div style={{height:"100%",width:Math.round(count/jobs.length*100)+"%",background:sc[stage]||"#6b7280",borderRadius:3}}/>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Upcoming WOs table ── */}
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,overflow:"hidden"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 18px",borderBottom:"1px solid #f0f1f5"}}>
          <div style={{fontWeight:700,fontSize:14,color:"#1a1d25"}}>Upcoming Work Orders</div>
          <button onClick={()=>setTab("workorders")} style={{fontSize:12,padding:"4px 12px",border:"1px solid #e0e3eb",borderRadius:6,background:"transparent",cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>View All →</button>
        </div>
        {upcomingWOs.length===0
          ? <div style={{textAlign:"center",color:"#9aa0b4",padding:"30px 0",fontSize:13}}>No upcoming work orders scheduled</div>
          : <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead>
                <tr style={{background:"#f8f9fb"}}>
                  {["WO #","Date","Customer","Address","Type","Status"].map(h=>(
                    <th key={h} style={{padding:"9px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".05em",whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {upcomingWOs.map((w,i)=>(
                  <tr key={w._dbId} style={{borderBottom:"1px solid #f0f1f5",background:w.date===today2?"#fffbeb":i%2===0?"#fff":"#fafbfc"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#f0f4ff"}
                    onMouseLeave={e=>e.currentTarget.style.background=w.date===today2?"#fffbeb":i%2===0?"#fff":"#fafbfc"}>
                    <td style={{padding:"9px 14px",fontFamily:"monospace",fontWeight:700,fontSize:11,color:"#1a1d25",whiteSpace:"nowrap"}}>
                      {w.date===today2&&<span style={{background:"#f0a500",color:"#000",borderRadius:4,padding:"1px 5px",fontSize:9,fontWeight:800,marginRight:5}}>TODAY</span>}
                      {w.woId||"—"}
                    </td>
                    <td style={{padding:"9px 14px",whiteSpace:"nowrap",color:"#6a7080",fontSize:12}}>{fmtD(w.date)}</td>
                    <td style={{padding:"9px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{w.customerName||"—"}</td>
                    <td style={{padding:"9px 14px",color:"#6a7080",fontSize:12,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.address||"—"}</td>
                    <td style={{padding:"9px 14px"}}>
                      <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
                        {(w.types||[]).slice(0,2).map(t=><span key={t} style={{background:"#f0f1f5",color:"#1a1d25",border:"1px solid #e0e3eb",borderRadius:4,padding:"1px 6px",fontSize:10,fontWeight:600,whiteSpace:"nowrap"}}>{t}</span>)}
                        {(w.types||[]).length>2&&<span style={{color:"#9aa0b4",fontSize:10}}>+{(w.types||[]).length-2}</span>}
                      </div>
                    </td>
                    <td style={{padding:"9px 14px",whiteSpace:"nowrap"}}>
                      <span style={{background:"#3b82f622",color:"#3b82f6",border:"1px solid #3b82f640",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{w.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        }
      </div>
    </div>
  );
}

function CustomerSearch({ customers, onSelect }) {
  const [q, setQ] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const matches = q.length > 0
    ? customers.filter(c => [c.name, c.phone, c.email, c.address, c.city].join(" ").toLowerCase().includes(q.toLowerCase())).slice(0, 8)
    : [];

  const select = (c) => { onSelect(c); setQ(c.name||""); setOpen(false); };

  return (
    <div ref={ref} style={{position:"relative", marginBottom:12}}>
      <div style={{position:"relative"}}>
        <svg style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",pointerEvents:"none"}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9aa0b4" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
        <input
          value={q}
          onChange={e=>{setQ(e.target.value);setOpen(true);}}
          onFocus={()=>setOpen(true)}
          placeholder="Search customers by name, phone, address…"
          style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 32px 8px 32px",fontSize:13,fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}
        />
        {q&&<button onClick={()=>{setQ("");setOpen(false);}} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"transparent",border:"none",cursor:"pointer",color:"#9aa0b4",fontSize:18,lineHeight:1,padding:0}}>×</button>}
      </div>
      {open && matches.length > 0 && (
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"#fff",border:"1px solid #e0e3eb",borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.1)",zIndex:999,overflow:"hidden"}}>
          {matches.map(c => (
            <div key={c._dbId} onMouseDown={()=>select(c)} style={{padding:"10px 14px",cursor:"pointer",borderBottom:"1px solid #f0f1f5",display:"flex",flexDirection:"column",gap:2}} onMouseEnter={e=>e.currentTarget.style.background="#f9f9fb"} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <span style={{fontWeight:600,fontSize:13,color:"#1a1d25"}}>{c.name}</span>
              <span style={{fontSize:11,color:"#9aa0b4"}}>{[c.phone, c.address, c.city].filter(Boolean).join(" · ")}</span>
            </div>
          ))}
        </div>
      )}
      {open && q.length > 0 && matches.length === 0 && (
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"#fff",border:"1px solid #e0e3eb",borderRadius:8,padding:"12px 14px",fontSize:12,color:"#9aa0b4",zIndex:999}}>No customers match "{q}"</div>
      )}
    </div>
  );
}

// ─── Proposals ────────────────────────────────────────────────────────────────
function Proposals({ proposals, setProposals, customers, jobs, suntrifyInfo }) {
  const [view, setView] = React.useState("list"); // list | form | detail
  const [editing, setEditing] = React.useState(null);
  const [statusFilter, setStatusFilter] = React.useState("All");
  const [search, setSearch] = React.useState("");

  const DEFAULT_TERMS = "Validity: This proposal is valid for 30 days from the date of issue.\nPayment: 50% deposit required to schedule. Balance due upon completion.\nWarranty: 1-year labor warranty on all work performed. Equipment warranties per manufacturer.\nLicense: All work performed by licensed personnel under CSLB #1055498 (B/C-10/C-46).";

  const emptyProposal = () => {
    const nums = proposals.map(p => parseInt((p.proposalNumber||"0").replace(/\D/g,""))||0);
    const next = (Math.max(0, ...nums) + 1).toString().padStart(3, "0");
    const today = new Date().toISOString().slice(0,10);
    const validUntil = new Date(Date.now() + 30*24*60*60*1000).toISOString().slice(0,10);
    return { proposalNumber: "PROP-"+next, proposalType:"General", date: today, validUntil, customerName:"", customerEmail:"", customerPhone:"", customerAddress:"", jobId:"", status:"Draft", scopeNote:"", items:[{description:"",qty:1,unit:"LS",unitPrice:0}], laborCost:0, materialCost:0, discount:0, taxRate:0, exclusions:"", notes:"", terms:DEFAULT_TERMS, createdAt: new Date().toISOString() };
  };

  const [form, setForm] = React.useState(emptyProposal);
  const sf = k => v => setForm(f => ({...f, [k]: v}));

  const calcTotals = (items, discount, taxRate) => {
    const subtotal = (items||[]).reduce((s,i) => s + (Number(i.qty||0) * Number(i.unitPrice||0)), 0);
    const discountAmt = Number(discount||0);
    const taxable = subtotal - discountAmt;
    const tax = taxable * (Number(taxRate||0) / 100);
    return { subtotal, discountAmt, tax, total: taxable + tax };
  };

  const fmt = n => "$" + Number(n||0).toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2});

  const STATUS_COLORS = { Draft:"#9aa0b4", Sent:"#3b82f6", Accepted:"#22c55e", Declined:"#ef4444", Expired:"#f0a500" };
  const STATUSES = ["Draft","Sent","Accepted","Declined","Expired"];
  const UNITS = ["LS","EA","Job","Each","Sq Ft","Linear Ft","Hour","System","Panel","kW"];
  const PROPOSAL_TYPES = ["General","Electrical","Solar"];

  const saveProposal = async (p) => {
    const { _dbId, ...data } = p;
    if (_dbId) {
      await dbSave("proposals", {...data, _dbId});
      setProposals(prev => prev.map(x => x._dbId === _dbId ? {...data, _dbId} : x));
    } else {
      const saved = await dbSave("proposals", {...data, id: Date.now()});
      setProposals(prev => [saved, ...prev]);
      return saved;
    }
    return {...data, _dbId};
  };

  const deleteProposal = async (p) => {
    if (!window.confirm("Delete proposal " + p.proposalNumber + "?")) return;
    if (p._dbId) await dbDelete("proposals", p._dbId);
    setProposals(prev => prev.filter(x => x._dbId !== p._dbId));
    setView("list"); setEditing(null);
  };

  const buildProposalHTML = (p, forEmail=false) => {
    const logo = (forEmail ? "https://solar-crm-suntrify.s3-website.us-east-2.amazonaws.com" : window.location.origin) + "/SUNTRIFY_LOGO.png";
    const { subtotal, discountAmt, tax, total } = calcTotals(p.items, p.discount, p.taxRate);
    const sc = STATUS_COLORS[p.status]||"#9aa0b4";
    const pageStyle = forEmail ? "max-width:680px;margin:0 auto;padding:24px;font-family:Arial,sans-serif;font-size:12px;color:#1a1d25" : "font-family:Arial,sans-serif;font-size:12px;color:#1a1d25;padding:0.6in";
    const propTypeLabel = p.proposalType && p.proposalType !== "General" ? p.proposalType.toUpperCase() + " PROPOSAL" : "PROPOSAL";
    const laborAmt = Number(p.laborCost||0);
    const materialAmt = Number(p.materialCost||0);
    const hasInvestmentSummary = laborAmt + materialAmt > 0;
    const investTotal = laborAmt + materialAmt;
    const fmtItem = (it) => Number(it.unitPrice||0) === 0 ? "Incl." : fmt(it.unitPrice);
    const fmtItemTotal = (it) => Number(it.unitPrice||0) === 0 ? "Incl." : fmt(Number(it.qty||0)*Number(it.unitPrice||0));
    const termsLines = (p.terms||DEFAULT_TERMS).split("\n").filter(Boolean);
    const exclusionLines = (p.exclusions||"").split("\n").filter(Boolean);
    return `<!DOCTYPE html><html><head><style>@page{size:letter;margin:0}*{margin:0;padding:0;box-sizing:border-box}body{${pageStyle}}.sec{font-weight:700;font-size:10px;text-transform:uppercase;color:#9aa0b4;margin:18px 0 7px;letter-spacing:.05em}</style></head><body>
    <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:3px solid #1a1d25;padding-bottom:14px;margin-bottom:20px">
      <img src="${logo}" height="44" style="display:block" onerror="this.style.display='none'"/>
      <div style="text-align:right;font-size:10px;line-height:1.9;color:#555">
        <div style="font-weight:700;font-size:13px;color:#1a1d25">${suntrifyInfo.company||"Suntrify Inc."}</div>
        <div>${suntrifyInfo.license||"CSLB #1055498"} | Lic. ${suntrifyInfo.licenseClass||"B, C-10, C-46"}</div>
        <div>${suntrifyInfo.phone||"(951) 866-2828"} | ${suntrifyInfo.website||"www.suntrify.com"}</div>
      </div>
    </div>
    <div style="display:flex;justify-content:space-between;margin-bottom:22px">
      <div>
        <div class="sec">Prepared For</div>
        <div style="font-weight:700;font-size:14px">${p.customerName||"—"}</div>
        ${p.customerAddress?`<div style="color:#555;font-size:11px;margin-top:2px">Site Address: ${p.customerAddress}</div>`:""}
        ${p.customerPhone?`<div style="color:#555;font-size:11px">${p.customerPhone}</div>`:""}
        ${p.customerEmail?`<div style="color:#555;font-size:11px">${p.customerEmail}</div>`:""}
      </div>
      <div style="text-align:right">
        <div style="font-size:22px;font-weight:800;letter-spacing:-.5px">${propTypeLabel}</div>
        <div style="font-size:12px;color:#555;margin:4px 0 2px">Proposal No. ${p.proposalNumber}</div>
        <div style="font-size:11px;line-height:1.8;color:#555">
          <div>Date: ${p.date||""}</div>
          <div>Valid Until: ${p.validUntil||""}</div>
        </div>
      </div>
    </div>
    ${p.scopeNote?`<div class="sec">Project Scope</div><div style="padding:10px 12px;background:#f9f9fb;border-left:3px solid #f0a500;font-size:12px;margin-bottom:4px;line-height:1.5">${p.scopeNote}</div>`:""}
    <div class="sec">Scope of Work</div>
    <table style="width:100%;border-collapse:collapse;margin-bottom:4px">
      <thead><tr style="background:#1a1d25;color:#fff">
        <th style="padding:7px 8px;font-size:10px;text-align:center;width:4%">#</th>
        <th style="padding:7px 10px;font-size:10px;text-align:left;width:52%">Description</th>
        <th style="padding:7px 8px;font-size:10px;text-align:center;width:8%">Qty</th>
        <th style="padding:7px 8px;font-size:10px;text-align:center;width:8%">Unit</th>
        <th style="padding:7px 10px;font-size:10px;text-align:right;width:14%">Unit Price</th>
        <th style="padding:7px 10px;font-size:10px;text-align:right;width:14%">Total</th>
      </tr></thead>
      <tbody>
        ${(p.items||[]).map((it,i) => `<tr style="background:${i%2===0?"#fff":"#f9f9fb"}">
          <td style="padding:8px 8px;border-bottom:1px solid #f0f1f5;text-align:center;color:#9aa0b4;font-size:11px">${i+1}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #f0f1f5;line-height:1.45">${(it.description||"").replace(/\n/g,"<br/>")}</td>
          <td style="padding:8px 8px;border-bottom:1px solid #f0f1f5;text-align:center">${it.qty||1}</td>
          <td style="padding:8px 8px;border-bottom:1px solid #f0f1f5;text-align:center">${it.unit||"LS"}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #f0f1f5;text-align:right">${fmtItem(it)}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #f0f1f5;text-align:right;font-weight:600">${fmtItemTotal(it)}</td>
        </tr>`).join("")}
      </tbody>
    </table>
    ${hasInvestmentSummary ? `
    <div class="sec">Investment Summary</div>
    <table style="width:100%;border-collapse:collapse;margin-bottom:16px;font-size:12px">
      <tr style="background:#f9f9fb"><td style="padding:8px 12px">Labor (Removal, Installation, Termination, Cleanup)</td><td style="padding:8px 12px;text-align:right;font-weight:600">${fmt(laborAmt)}</td></tr>
      <tr><td style="padding:8px 12px">Materials (Panel, Breakers, Hardware)</td><td style="padding:8px 12px;text-align:right;font-weight:600">${fmt(materialAmt)}</td></tr>
      ${discountAmt>0?`<tr style="background:#f9f9fb"><td style="padding:8px 12px;color:#22c55e">Discount</td><td style="padding:8px 12px;text-align:right;font-weight:600;color:#22c55e">-${fmt(discountAmt)}</td></tr>`:""}
      <tr style="border-top:2px solid #1a1d25"><td style="padding:10px 12px;font-weight:800;font-size:14px">TOTAL</td><td style="padding:10px 12px;text-align:right;font-weight:800;font-size:16px;color:#d4891f">${fmt(investTotal - discountAmt)}</td></tr>
    </table>` : `
    <div style="display:flex;justify-content:flex-end;margin:12px 0 20px">
      <table style="width:260px;border-collapse:collapse;font-size:12px">
        <tr><td style="padding:5px 10px;color:#555">Subtotal</td><td style="padding:5px 10px;text-align:right">${fmt(subtotal)}</td></tr>
        ${discountAmt>0?`<tr><td style="padding:5px 10px;color:#22c55e">Discount</td><td style="padding:5px 10px;text-align:right;color:#22c55e">-${fmt(discountAmt)}</td></tr>`:""}
        ${tax>0?`<tr><td style="padding:5px 10px;color:#555">Tax (${p.taxRate}%)</td><td style="padding:5px 10px;text-align:right">${fmt(tax)}</td></tr>`:""}
        <tr style="border-top:2px solid #1a1d25"><td style="padding:8px 10px;font-weight:700;font-size:13px">Total Investment</td><td style="padding:8px 10px;text-align:right;font-weight:800;font-size:15px;color:#d4891f">${fmt(total)}</td></tr>
      </table>
    </div>`}
    ${exclusionLines.length>0?`<div class="sec">Exclusions &amp; Clarifications</div><ul style="margin:0 0 4px 18px;font-size:11px;color:#555;line-height:1.75">${exclusionLines.map(l=>`<li>${l.replace(/^[•·\-*]\s*/,"")}</li>`).join("")}</ul>`:""}
    ${p.notes?`<div class="sec">Notes</div><div style="padding:10px 12px;background:#f9f9fb;border-radius:6px;font-size:11px;margin-bottom:4px;line-height:1.5">${p.notes}</div>`:""}
    <div class="sec">Terms &amp; Conditions</div>
    <div style="font-size:10px;color:#6a7080;line-height:1.75">${termsLines.map(l=>`<div>${l}</div>`).join("")}</div>
    <div style="margin-top:28px">
      <div style="margin-bottom:14px;font-size:11px;font-weight:700">Authorized by ${suntrifyInfo.company||"Suntrify Inc."}</div>
      <div style="display:flex;gap:40px">
        <div style="flex:1">
          <div style="border-top:1px solid #1a1d25;padding-top:8px">
            <div style="font-weight:700;font-size:11px">${suntrifyInfo.contact||"Jose Chacon"}, President</div>
            <div style="font-size:10px;color:#555;margin-top:2px">${suntrifyInfo.phone||"(951) 866-2828"} | ${suntrifyInfo.email||"jchacon@suntrify.com"}</div>
          </div>
        </div>
        <div style="flex:1">
          <div style="border-top:1px solid #1a1d25;padding-top:8px">
            <div style="font-size:10px;color:#9aa0b4;font-weight:700;text-transform:uppercase;letter-spacing:.05em">Customer Acceptance</div>
            <div style="font-size:10px;margin-top:10px">Print Name: _______________________________</div>
            <div style="font-size:10px;margin-top:8px">Date: ____________________________________</div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:24px;padding-top:10px;border-top:1px solid #ddd;font-size:10px;color:#9aa0b4;text-align:center">
      ${suntrifyInfo.company||"Suntrify Inc."} · ${suntrifyInfo.license||"CSLB #1055498"} · ${suntrifyInfo.email||"jchacon@suntrify.com"} · ${suntrifyInfo.phone||"(951) 866-2828"}
    </div>
    </body></html>`;
  };

  const handlePrint = (p) => {
    const win = window.open("","_blank","width=900,height=700");
    win.document.write(buildProposalHTML(p, false));
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 800);
  };

  const handleSend = async (p) => {
    if (!p.customerEmail) { alert("No customer email on this proposal."); return; }
    const html = buildProposalHTML(p, true);
    const subject = `Proposal #${p.proposalNumber} — ${p.customerName} — Suntrify Inc.`;
    const body = `Hi ${p.customerName},\n\nPlease find your proposal attached below.\n\nProposal #${p.proposalNumber}\nDate: ${p.date}\nValid Until: ${p.validUntil}\nTotal: ${fmt(calcTotals(p.items,p.discount,p.taxRate).total)}\n\nThank you for the opportunity to work with you.\n\nSuntrify Inc.\n${suntrifyInfo.phone||"(951) 866-2828"} | ${suntrifyInfo.website||"www.suntrify.com"}`;
    await sendViaSES([p.customerEmail, suntrifyInfo.email||"jchacon@suntrify.com"], subject, body, html);
    const updated = {...p, status:"Sent", sentAt: new Date().toISOString()};
    await saveProposal(updated);
    setEditing(updated);
    alert("✅ Proposal sent to " + p.customerEmail);
  };

  const filtered = proposals
    .filter(p => statusFilter === "All" || p.status === statusFilter)
    .filter(p => !search || [p.proposalNumber, p.customerName, p.customerAddress].join(" ").toLowerCase().includes(search.toLowerCase()))
    .sort((a,b) => (b.createdAt||"").localeCompare(a.createdAt||""));

  // ── List view ──────────────────────────────────────────────────────
  if (view === "list") return (
    <div style={{padding:"24px 28px",fontFamily:"'DM Sans',sans-serif",maxWidth:1100,margin:"0 auto"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
        <div>
          <h1 style={{fontFamily:"'DM Serif Display',serif",fontSize:22,color:"#1a1d25",margin:0}}>Proposals</h1>
          <div style={{fontSize:12,color:"#9aa0b4",marginTop:2}}>{proposals.length} total · {proposals.filter(p=>p.status==="Accepted").length} accepted</div>
        </div>
        <button onClick={()=>{setForm(emptyProposal());setView("form");setEditing(null);}} style={{background:"#f0a500",border:"none",borderRadius:8,padding:"10px 20px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#000"}}>+ New Proposal</button>
      </div>

      {/* Filters */}
      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        {["All",...STATUSES].map(s=>(
          <button key={s} onClick={()=>setStatusFilter(s)} style={{padding:"5px 14px",border:"1px solid "+(statusFilter===s?"#f0a500":"#e0e3eb"),borderRadius:20,background:statusFilter===s?"#f0a500":"#fff",color:statusFilter===s?"#000":"#6a7080",fontSize:12,fontWeight:statusFilter===s?700:400,cursor:"pointer",fontFamily:"inherit"}}>{s}</button>
        ))}
        <input placeholder="🔍 Search…" value={search} onChange={e=>setSearch(e.target.value)} style={{marginLeft:"auto",border:"1px solid #e0e3eb",borderRadius:8,padding:"6px 12px",fontSize:12,fontFamily:"inherit",width:200}}/>
      </div>

      {/* Table */}
      {filtered.length === 0 ? (
        <div style={{textAlign:"center",padding:"60px 20px",color:"#9aa0b4"}}>
          <div style={{fontSize:36,marginBottom:12}}>📄</div>
          <div style={{fontWeight:600,marginBottom:4}}>No proposals yet</div>
          <div style={{fontSize:12}}>Click "+ New Proposal" to create your first one</div>
        </div>
      ) : (
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #e0e3eb",overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{background:"#f9f9fb",borderBottom:"1px solid #e0e3eb"}}>
              {["Proposal #","Customer","Date","Valid Until","Total","Status",""].map(h=>(
                <th key={h} style={{padding:"10px 14px",fontSize:10,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",textAlign:h==="Total"?"right":"left",letterSpacing:".05em"}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {filtered.map(p => {
                const {total} = calcTotals(p.items, p.discount, p.taxRate);
                return (
                  <tr key={p._dbId||p.proposalNumber} onClick={()=>{setEditing(p);setView("detail");}} style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer",transition:"background .1s"}} onMouseEnter={e=>e.currentTarget.style.background="#f9f9fb"} onMouseLeave={e=>e.currentTarget.style.background=""}>
                    <td style={{padding:"11px 14px",fontWeight:700,fontSize:13,color:"#1a1d25"}}>{p.proposalNumber}</td>
                    <td style={{padding:"11px 14px"}}>
                      <div style={{fontWeight:600,fontSize:13,color:"#1a1d25"}}>{p.customerName||"—"}</div>
                      {p.customerAddress&&<div style={{fontSize:11,color:"#9aa0b4"}}>{p.customerAddress}</div>}
                    </td>
                    <td style={{padding:"11px 14px",fontSize:12,color:"#6a7080"}}>{p.date}</td>
                    <td style={{padding:"11px 14px",fontSize:12,color:"#6a7080"}}>{p.validUntil}</td>
                    <td style={{padding:"11px 14px",textAlign:"right",fontWeight:700,fontSize:13,color:"#d4891f"}}>{fmt(total)}</td>
                    <td style={{padding:"11px 14px"}}>
                      <span style={{background:(STATUS_COLORS[p.status]||"#9aa0b4")+"22",color:STATUS_COLORS[p.status]||"#9aa0b4",border:"1px solid "+(STATUS_COLORS[p.status]||"#9aa0b4")+"44",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{p.status}</span>
                    </td>
                    <td style={{padding:"11px 14px"}}>
                      <div style={{display:"flex",gap:6}} onClick={e=>e.stopPropagation()}>
                        <button onClick={()=>{setEditing(p);setView("detail");}} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:6,padding:"4px 10px",fontSize:11,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>View</button>
                        <button onClick={()=>handlePrint(p)} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:6,padding:"4px 10px",fontSize:11,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>PDF</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  // ── Detail view ────────────────────────────────────────────────────
  if (view === "detail" && editing) {
    const p = editing;
    const {subtotal, discountAmt, tax, total} = calcTotals(p.items, p.discount, p.taxRate);
    return (
      <div style={{padding:"24px 28px",fontFamily:"'DM Sans',sans-serif",maxWidth:900,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <button onClick={()=>setView("list")} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"7px 14px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>← Back</button>
          <div style={{flex:1}}>
            <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:20,margin:0,color:"#1a1d25"}}>{p.proposalNumber}</h2>
            <div style={{fontSize:12,color:"#9aa0b4"}}>{p.customerName} · {p.date}</div>
          </div>
          <span style={{background:(STATUS_COLORS[p.status]||"#9aa0b4")+"22",color:STATUS_COLORS[p.status]||"#9aa0b4",border:"1px solid "+(STATUS_COLORS[p.status]||"#9aa0b4")+"44",borderRadius:6,padding:"4px 12px",fontSize:12,fontWeight:700}}>{p.status}</span>
          <button onClick={()=>{setForm({...p});setView("form");}} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"7px 14px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>Edit</button>
          <button onClick={()=>handlePrint(p)} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"7px 14px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>🖨 PDF</button>
          <button onClick={()=>handleSend(p)} style={{background:"#1a1d25",border:"none",borderRadius:8,padding:"7px 16px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#fff",fontWeight:700}}>📧 Send to Customer</button>
        </div>

        {/* Status update */}
        <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"14px 18px",marginBottom:16,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <span style={{fontSize:12,color:"#9aa0b4",fontWeight:600}}>Update Status:</span>
          {STATUSES.map(s=>(
            <button key={s} onClick={async()=>{const updated={...p,status:s};await saveProposal(updated);setEditing(updated);}} style={{padding:"5px 14px",border:"1px solid "+(p.status===s?STATUS_COLORS[s]:"#e0e3eb"),borderRadius:20,background:p.status===s?(STATUS_COLORS[s]+"22"):"transparent",color:p.status===s?STATUS_COLORS[s]:"#6a7080",fontSize:12,fontWeight:p.status===s?700:400,cursor:"pointer",fontFamily:"inherit"}}>{s}</button>
          ))}
          {p.sentAt&&<span style={{marginLeft:"auto",fontSize:11,color:"#9aa0b4"}}>Sent {new Date(p.sentAt).toLocaleDateString()}</span>}
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
          <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"16px 18px"}}>
            <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",letterSpacing:".05em",marginBottom:10}}>Customer</div>
            <div style={{fontWeight:700,fontSize:15,color:"#1a1d25",marginBottom:4}}>{p.customerName}</div>
            {p.customerAddress&&<div style={{fontSize:12,color:"#6a7080"}}>{p.customerAddress}</div>}
            {p.customerPhone&&<div style={{fontSize:12,color:"#6a7080"}}>{p.customerPhone}</div>}
            {p.customerEmail&&<div style={{fontSize:12,color:"#3b82f6"}}>{p.customerEmail}</div>}
          </div>
          <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"16px 18px"}}>
            <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",letterSpacing:".05em",marginBottom:10}}>Proposal Details</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:12}}>
              <div><span style={{color:"#9aa0b4"}}>Number: </span><span style={{fontWeight:600}}>{p.proposalNumber}</span></div>
              <div><span style={{color:"#9aa0b4"}}>Date: </span><span style={{fontWeight:600}}>{p.date}</span></div>
              <div><span style={{color:"#9aa0b4"}}>Valid Until: </span><span style={{fontWeight:600}}>{p.validUntil}</span></div>
              <div><span style={{color:"#9aa0b4"}}>Total: </span><span style={{fontWeight:700,color:"#d4891f",fontSize:14}}>{fmt(total)}</span></div>
            </div>
          </div>
        </div>

        {p.scopeNote&&<div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"14px 18px",marginBottom:16}}><div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:8}}>Project Scope</div><div style={{fontSize:13,color:"#1a1d25"}}>{p.scopeNote}</div></div>}

        <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,overflow:"hidden",marginBottom:16}}>
          <div style={{padding:"12px 18px",borderBottom:"1px solid #f0f1f5",fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4"}}>Scope of Work</div>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{background:"#f9f9fb"}}>
              {["#","Description","Qty","Unit","Unit Price","Total"].map(h=><th key={h} style={{padding:"8px 10px",fontSize:10,color:"#9aa0b4",textAlign:h==="Unit Price"||h==="Total"?"right":h==="#"?"center":"left",fontWeight:700}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {(p.items||[]).map((it,i)=>(
                <tr key={i} style={{borderBottom:"1px solid #f0f1f5"}}>
                  <td style={{padding:"9px 10px",fontSize:12,textAlign:"center",color:"#9aa0b4"}}>{i+1}</td>
                  <td style={{padding:"9px 10px",fontSize:13,whiteSpace:"pre-wrap"}}>{it.description}</td>
                  <td style={{padding:"9px 10px",fontSize:13,textAlign:"center"}}>{it.qty}</td>
                  <td style={{padding:"9px 10px",fontSize:13,textAlign:"center"}}>{it.unit}</td>
                  <td style={{padding:"9px 10px",fontSize:13,textAlign:"right"}}>{Number(it.unitPrice||0)===0?"Incl.":fmt(it.unitPrice)}</td>
                  <td style={{padding:"9px 10px",fontSize:13,fontWeight:600,textAlign:"right"}}>{Number(it.unitPrice||0)===0?"Incl.":fmt(Number(it.qty||0)*Number(it.unitPrice||0))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(Number(p.laborCost||0)+Number(p.materialCost||0)>0)&&<div style={{display:"flex",justifyContent:"flex-end",padding:"12px 18px",borderTop:"2px solid #f0f1f5"}}>
            <div style={{width:260,fontSize:12}}>
              <div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#6a7080"}}><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
              {discountAmt>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#22c55e"}}><span>Discount</span><span>-{fmt(discountAmt)}</span></div>}
              {tax>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#6a7080"}}><span>Tax ({p.taxRate}%)</span><span>{fmt(tax)}</span></div>}
              <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",fontWeight:800,fontSize:15,borderTop:"2px solid #1a1d25",marginTop:4,color:"#d4891f"}}><span style={{color:"#1a1d25"}}>Total</span><span>{fmt(total)}</span></div>
            </div>
          </div>}
        </div>

        {(Number(p.laborCost||0)+Number(p.materialCost||0))>0&&<div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,overflow:"hidden",marginBottom:16}}>
          <div style={{padding:"12px 18px",borderBottom:"1px solid #f0f1f5",fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4"}}>Investment Summary</div>
          <div style={{padding:"12px 18px",fontSize:13}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #f0f1f5"}}><span style={{color:"#6a7080"}}>Labor</span><span style={{fontWeight:600}}>{fmt(p.laborCost)}</span></div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #f0f1f5"}}><span style={{color:"#6a7080"}}>Materials</span><span style={{fontWeight:600}}>{fmt(p.materialCost)}</span></div>
            {Number(p.discount||0)>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #f0f1f5",color:"#22c55e"}}><span>Discount</span><span style={{fontWeight:600}}>-{fmt(p.discount)}</span></div>}
            <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",fontWeight:800,fontSize:15,color:"#d4891f"}}><span style={{color:"#1a1d25"}}>Total</span><span>{fmt(Number(p.laborCost||0)+Number(p.materialCost||0)-Number(p.discount||0))}</span></div>
          </div>
        </div>}
        {p.exclusions&&<div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
          <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:8}}>Exclusions &amp; Clarifications</div>
          <ul style={{paddingLeft:18,fontSize:12,color:"#6a7080",lineHeight:1.7}}>{p.exclusions.split("\n").filter(Boolean).map((l,i)=><li key={i}>{l.replace(/^[•·\-*]\s*/,"")}</li>)}</ul>
        </div>}
        {(p.notes||p.terms)&&<div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
          {p.notes&&<><div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Notes</div><div style={{fontSize:12,color:"#1a1d25",marginBottom:14}}>{p.notes}</div></>}
          {p.terms&&<><div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Terms &amp; Conditions</div><div style={{fontSize:11,color:"#6a7080",lineHeight:1.6}}>{(p.terms).split("\n").filter(Boolean).map((l,i)=><div key={i}>{l}</div>)}</div></>}
        </div>}

        <button onClick={()=>deleteProposal(p)} style={{background:"transparent",border:"1px solid #ef444430",borderRadius:8,padding:"8px 16px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#ef4444"}}>🗑 Delete Proposal</button>
      </div>
    );
  }

  // ── Form (create / edit) ───────────────────────────────────────────
  const F = ({label,children,half}) => <div style={{marginBottom:12,gridColumn:half?"span 1":"span 2"}}><label style={{display:"block",fontSize:11,fontWeight:600,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:".04em",marginBottom:4}}>{label}</label>{children}</div>;
  const inp = (k, extra={}) => <input value={form[k]||""} onChange={e=>sf(k)(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box",...(extra.style||{})}} {...extra}/>;
  const txa = (k) => <textarea value={form[k]||""} onChange={e=>sf(k)(e.target.value)} rows={3} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>;

  const setItem = (i, k, v) => setForm(f => ({...f, items: f.items.map((it,idx) => idx===i ? {...it,[k]:v} : it)}));
  const addItem = () => setForm(f => ({...f, items:[...f.items,{description:"",qty:1,unit:"Job",unitPrice:0}]}));
  const removeItem = i => setForm(f => ({...f, items: f.items.filter((_,idx)=>idx!==i)}));

  const handleCustomerSelect = (c) => {
    setForm(f=>({...f, customerName:c.name||"", customerEmail:c.email||"", customerPhone:c.phone||"", customerAddress:[c.address,c.city,c.state,c.zip].filter(Boolean).join(", ")}));
  };

  const { subtotal: fSub, discountAmt: fDisc, tax: fTax, total: fTotal } = calcTotals(form.items, form.discount, form.taxRate);

  const handleSubmit = async () => {
    if (!form.customerName) { alert("Customer name is required."); return; }
    const saved = await saveProposal(form);
    setEditing(saved||form);
    setView("detail");
  };

  return (
    <div style={{padding:"24px 28px",fontFamily:"'DM Sans',sans-serif",maxWidth:900,margin:"0 auto"}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
        <button onClick={()=>setView("list")} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"7px 14px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>← Back</button>
        <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:20,margin:0,color:"#1a1d25"}}>{editing?"Edit Proposal":"New Proposal"}</h2>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:14}}>Customer</div>
        {customers.length>0&&<CustomerSearch customers={customers} onSelect={handleCustomerSelect}/>}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <F label="Customer Name *" half><input value={form.customerName||""} onChange={e=>sf("customerName")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/></F>
          <F label="Customer Email" half><input value={form.customerEmail||""} onChange={e=>sf("customerEmail")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}} type="email"/></F>
          <F label="Phone" half><input value={form.customerPhone||""} onChange={e=>sf("customerPhone")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/></F>
          <F label="Project Address" half><input value={form.customerAddress||""} onChange={e=>sf("customerAddress")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/></F>
        </div>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:14}}>Proposal Info</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr",gap:12}}>
          <div><label style={{display:"block",fontSize:11,fontWeight:600,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Type</label>
            <select value={form.proposalType||"General"} onChange={e=>sf("proposalType")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit"}}>{PROPOSAL_TYPES.map(t=><option key={t}>{t}</option>)}</select>
          </div>
          {[["Proposal #","proposalNumber"],["Date","date","date"],["Valid Until","validUntil","date"],["Status","status"]].map(([label,key,type])=>(
            <div key={key}><label style={{display:"block",fontSize:11,fontWeight:600,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>{label}</label>
              {key==="status"
                ? <select value={form.status||"Draft"} onChange={e=>sf("status")(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit"}}>{STATUSES.map(s=><option key={s}>{s}</option>)}</select>
                : <input value={form[key]||""} onChange={e=>sf(key)(e.target.value)} type={type||"text"} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/>
              }
            </div>
          ))}
        </div>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Project Overview (optional)</div>
        <textarea value={form.scopeNote||""} onChange={e=>sf("scopeNote")(e.target.value)} rows={2} placeholder="Brief summary of the project scope…" style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4"}}>Scope of Work / Line Items</div>
          <button onClick={addItem} style={{background:"#f0a500",border:"none",borderRadius:6,padding:"5px 14px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>+ Add Line</button>
        </div>
        <table style={{width:"100%",borderCollapse:"collapse",marginBottom:12}}>
          <thead><tr style={{background:"#f9f9fb"}}>
            {["#","Description","Qty","Unit","Unit Price","Total",""].map(h=><th key={h} style={{padding:"7px 8px",fontSize:10,color:"#9aa0b4",textAlign:h==="Unit Price"||h==="Total"?"right":h==="#"?"center":"left",fontWeight:700}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {form.items.map((it,i)=>(
              <tr key={i} style={{borderBottom:"1px solid #f0f1f5",verticalAlign:"top"}}>
                <td style={{padding:"8px 4px",width:28,textAlign:"center",color:"#9aa0b4",fontSize:11,paddingTop:14}}>{i+1}</td>
                <td style={{padding:"6px 4px"}}><textarea value={it.description||""} onChange={e=>setItem(i,"description",e.target.value)} placeholder="Description (supports multiple lines)" rows={2} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"inherit",boxSizing:"border-box",resize:"vertical"}}/></td>
                <td style={{padding:"6px 4px",width:60}}><input value={it.qty||1} onChange={e=>setItem(i,"qty",e.target.value)} type="number" min="0" style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:6,padding:"6px 6px",fontSize:12,fontFamily:"inherit",textAlign:"center",boxSizing:"border-box"}}/></td>
                <td style={{padding:"6px 4px",width:90}}><select value={it.unit||"LS"} onChange={e=>setItem(i,"unit",e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:6,padding:"6px 4px",fontSize:12,fontFamily:"inherit"}}>{UNITS.map(u=><option key={u}>{u}</option>)}</select></td>
                <td style={{padding:"6px 4px",width:110}}><input value={it.unitPrice||""} onChange={e=>setItem(i,"unitPrice",e.target.value)} type="number" min="0" placeholder="0 = Incl." style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"inherit",textAlign:"right",boxSizing:"border-box"}}/></td>
                <td style={{padding:"6px 8px",width:100,textAlign:"right",fontWeight:600,fontSize:12,color:"#1a1d25",paddingTop:14}}>{Number(it.unitPrice||0)===0?"Incl.":fmt(Number(it.qty||0)*Number(it.unitPrice||0))}</td>
                <td style={{padding:"6px 4px",width:28,paddingTop:12}}>{form.items.length>1&&<button onClick={()=>removeItem(i)} style={{background:"transparent",border:"none",color:"#ef4444",cursor:"pointer",fontSize:16,lineHeight:1,padding:"0 4px"}}>×</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{display:"flex",justifyContent:"flex-end",gap:16,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12}}>
            <span style={{color:"#9aa0b4"}}>Discount $</span>
            <input value={form.discount||""} onChange={e=>sf("discount")(e.target.value)} type="number" min="0" placeholder="0" style={{width:90,border:"1px solid #e0e3eb",borderRadius:6,padding:"5px 8px",fontSize:12,fontFamily:"inherit",textAlign:"right"}}/>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12}}>
            <span style={{color:"#9aa0b4"}}>Tax %</span>
            <input value={form.taxRate||""} onChange={e=>sf("taxRate")(e.target.value)} type="number" min="0" max="100" placeholder="0" style={{width:70,border:"1px solid #e0e3eb",borderRadius:6,padding:"5px 8px",fontSize:12,fontFamily:"inherit",textAlign:"right"}}/>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:12}}>
          <div style={{width:260,fontSize:12}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#6a7080"}}><span>Subtotal</span><span>{fmt(fSub)}</span></div>
            {fDisc>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#22c55e"}}><span>Discount</span><span>-{fmt(fDisc)}</span></div>}
            {fTax>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",color:"#6a7080"}}><span>Tax ({form.taxRate}%)</span><span>{fmt(fTax)}</span></div>}
            <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",fontWeight:800,fontSize:15,borderTop:"2px solid #1a1d25",marginTop:4,color:"#d4891f"}}><span style={{color:"#1a1d25"}}>Total</span><span>{fmt(fTotal)}</span></div>
          </div>
        </div>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Investment Summary (optional — replaces subtotal in PDF)</div>
        <div style={{fontSize:11,color:"#9aa0b4",marginBottom:12}}>Fill in labor and material costs to show an investment summary breakdown instead of line-item totals.</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div><label style={{display:"block",fontSize:11,fontWeight:600,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Labor Cost $</label>
            <input value={form.laborCost||""} onChange={e=>sf("laborCost")(e.target.value)} type="number" min="0" placeholder="0.00" style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",textAlign:"right",boxSizing:"border-box"}}/></div>
          <div><label style={{display:"block",fontSize:11,fontWeight:600,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Material Cost $</label>
            <input value={form.materialCost||""} onChange={e=>sf("materialCost")(e.target.value)} type="number" min="0" placeholder="0.00" style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",textAlign:"right",boxSizing:"border-box"}}/></div>
        </div>
        {(Number(form.laborCost||0)+Number(form.materialCost||0))>0&&<div style={{marginTop:10,textAlign:"right",fontWeight:700,fontSize:14,color:"#d4891f"}}>Total: {fmt(Number(form.laborCost||0)+Number(form.materialCost||0)-Number(form.discount||0))}</div>}
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Exclusions &amp; Clarifications (optional)</div>
        <textarea value={form.exclusions||""} onChange={e=>sf("exclusions")(e.target.value)} rows={4} placeholder={"• Permit fees — not included; add $150–$300 if applicable\n• Feeder conductor replacement\n• Meter base or utility-side work"} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
        <div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>One item per line. Each line becomes a bullet point on the proposal.</div>
      </div>

      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:12,padding:"20px 24px",marginBottom:16}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
          <div><div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Notes (shown on proposal)</div>
            <textarea value={form.notes||""} onChange={e=>sf("notes")(e.target.value)} rows={3} placeholder="Any additional notes for the customer…" style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/></div>
          <div><div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"#9aa0b4",marginBottom:6}}>Terms &amp; Conditions</div>
            <textarea value={form.terms||DEFAULT_TERMS} onChange={e=>sf("terms")(e.target.value)} rows={3} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/></div>
        </div>
      </div>

      <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
        <button onClick={()=>setView("list")} style={{background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px 20px",fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>Cancel</button>
        <button onClick={handleSubmit} style={{background:"#f0a500",border:"none",borderRadius:8,padding:"10px 24px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>Save Proposal</button>
      </div>
    </div>
  );
}

function App({ currentUser, onLogout, darkMode=false, setDarkMode, globalSearch=false, setGlobalSearch }) {
  const bg = darkMode ? "#0f1117" : "#f5f6fa";
  const card = darkMode ? "#1a1d25" : "#ffffff";
  const sidebarBg = darkMode ? "#070a0f" : "#ffffff";
  const textColor = darkMode ? "#e2e8f0" : "#1a1d25";
  const mutedColor = darkMode ? "#64748b" : "#9aa0b4";
  const borderColor = darkMode ? "#2d3748" : "#e0e3eb";
  const [jobs, setJobs] = useState([]);
  const [installReports, setInstallReports] = useState([]);
  const [workOrders, setWorkOrders] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [proposals, setProposals] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [epcPartners, setEpcPartners] = useState([]);
  const [subcontractors, setSubcontractors] = useState([]);
  const [suntrifyInfo, setSuntrifyInfo] = useState({ company:"Suntrify Inc.", contact:"Jose Chacon", phone:"(951) 866-2828", email:"jchacon@suntrify.com", address:"29336 Tournament", city:"Lake Elsinore", state:"CA", zip:"92530", license:"CSLB #1055498", licenseClass:"B, C-10, C-46", website:"www.suntrify.com" });
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("jobs");
  const [modal, setModal] = useState(null);
  const [woReportWO, setWoReportWO] = useState(null);
  const [selected2, setSelected2] = useState(null);
  const [selected, setSelected] = useState(null);
  const [pipelineView, setPipelineView] = useState("status");
  const [woCalView, setWoCalView] = useState(false);
  const [search, setSearch] = useState("");
  const [sortAZ, setSortAZ] = useState(false);
  const [showManageUsers, setShowManageUsers] = useState(false);
  const [mobile, setMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadAll = React.useCallback(async (silent=false) => {
    if(!silent) setLoading(true);
    const [j, c, e, s, w, inv, ests, irpts, ci, props] = await Promise.all([
      dbLoad("jobs"),
      dbLoad("customers"),
      dbLoad("epc_partners"),
      dbLoad("subcontractors"),
      dbLoad("work_orders"),
      dbLoad("invoices"),
      dbLoad("estimates"),
      dbLoad("installation_reports"),
      dbLoad("company_info"),
      dbLoad("proposals"),
    ]);
    setJobs(j);
    setCustomers(c);
    setEpcPartners(e);
    setSubcontractors(s);
    setWorkOrders(w);
    if(inv) setInvoices(inv);
    setEstimates(ests || []);
    setInstallReports(irpts || []);
    if(ci && ci.length > 0) setSuntrifyInfo(prev => ({...prev, ...ci[0]}));
    setProposals(props || []);
    if(!silent) setLoading(false);
  }, []);

  useEffect(() => {
    loadAll();
    // Auto-refresh every 30 seconds
    const interval = setInterval(() => loadAll(true), 30000);
    // Refresh when app comes back into focus
    const onFocus = () => loadAll(true);
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(interval); window.removeEventListener("focus", onFocus); };
  }, [loadAll]);

  const newId = () => Date.now();

  // One-time backfill: assign createdAt + sunJobId to any job that lacks them
  const jobBackfillDone = useRef(false);
  useEffect(() => {
    if (jobBackfillDone.current || jobs.length === 0) return;
    const needsUpdate = jobs.filter(j => !j.sunJobId);
    if (needsUpdate.length === 0) { jobBackfillDone.current = true; return; }
    jobBackfillDone.current = true;

    // Build day-count map from jobs that already have IDs
    const dayCount = {};
    jobs.filter(j => j.sunJobId && j.sunJobId.startsWith("SUN")).forEach(j => {
      const prefix = j.sunJobId.slice(0, 7); // e.g. "SUN0527"
      dayCount[prefix] = Math.max(dayCount[prefix] || 0, parseInt(j.sunJobId.slice(7)) || 0);
    });

    // Sort by _dbId ascending so oldest jobs get lowest sequence numbers
    [...needsUpdate]
      .sort((a, b) => (parseInt(a._dbId) || 0) - (parseInt(b._dbId) || 0))
      .forEach(j => {
        const ts = parseInt(j._dbId);
        // _dbId is Date.now() at creation time — derive date from it
        const d = ts > 1000000000000 ? new Date(ts) : new Date();
        const createdAt = j.createdAt || d.toISOString().slice(0, 10);
        const [, month, day] = createdAt.split("-");
        const prefix = `SUN${month}${day}`;
        dayCount[prefix] = (dayCount[prefix] || 0) + 1;
        const sunJobId = `${prefix}${String(dayCount[prefix]).padStart(2, "0")}`;
        dbSave("jobs", { ...j, createdAt, sunJobId }).then(() => {
          setJobs(prev => prev.map(x => (x._dbId === j._dbId ? { ...x, createdAt, sunJobId } : x)));
        });
      });
  }, [jobs]);

  // Backfill createdAt for customers missing it (_dbId is Date.now() at creation)
  const custBackfillDone = useRef(false);
  useEffect(() => {
    if (custBackfillDone.current || customers.length === 0) return;
    const needsUpdate = customers.filter(c => !c.createdAt);
    if (needsUpdate.length === 0) { custBackfillDone.current = true; return; }
    custBackfillDone.current = true;
    [...needsUpdate]
      .sort((a, b) => (parseInt(a._dbId) || 0) - (parseInt(b._dbId) || 0))
      .forEach(c => {
        const ts = parseInt(c._dbId);
        const d = ts > 1000000000000 ? new Date(ts) : new Date();
        const createdAt = d.toISOString().slice(0, 10);
        dbSave("customers", { ...c, createdAt }).then(() => {
          setCustomers(prev => prev.map(x => (x._dbId === c._dbId ? { ...x, createdAt } : x)));
        });
      });
  }, [customers]);

  // CRUD helpers
  const saveItem = async (table, setter, item, isNew) => {
    const saved = await dbSave(table, item);
    setter(prev => isNew ? [...prev, saved] : prev.map(x => x._dbId === saved._dbId ? saved : x));
    setModal(null);
    setSelected(null);
  };

  const deleteItem = async (table, setter, item) => {
    if (item._dbId) await dbDelete(table, item._dbId);
    setter(prev => prev.filter(x => x._dbId !== item._dbId));
    setSelected(null);
    setModal(null);
  };

  // Filtered lists
  const byNewest = (a, b) => {
    const da = a.createdAt || "", db = b.createdAt || "";
    if (da !== db) return db.localeCompare(da);          // newest date first
    return (b._dbId||0) - (a._dbId||0);                 // tie-break by DB id
  };

  const filteredJobs = jobs.filter(j => {
    const q = search.toLowerCase();
    return !q || [j.customerName, j.epcPartnerName, j.address, j.stage, j.notes, j.city].join(" ").toLowerCase().includes(q);
  }).sort((a, b) => sortAZ ? (a.customerName || "").localeCompare(b.customerName || "") : byNewest(a, b));

  const filteredCustomers = customers.filter(c => {
    const q = search.toLowerCase();
    return !q || [c.name, c.company, c.city, c.address, c.zip, c.phone, c.email, c.epcPartnerName, c.customerId, c.state].join(" ").toLowerCase().includes(q);
  }).sort((a, b) => sortAZ ? (a.name || "").localeCompare(b.name || "") : byNewest(a, b));

  const filteredEPC = epcPartners.filter(p => {
    const q = search.toLowerCase();
    return !q || [p.name, p.company].join(" ").toLowerCase().includes(q);
  }).sort((a, b) => sortAZ ? (a.company || a.name || "").localeCompare(b.company || b.name || "") : byNewest(a, b));

  const filteredSubs = subcontractors.filter(s => {
    const q = search.toLowerCase();
    return !q || [s.name, s.company, s.licenseClass, s.licenseNumber].join(" ").toLowerCase().includes(q);
  }).sort((a, b) => sortAZ ? (a.name || "").localeCompare(b.name || "") : byNewest(a, b));

  if (loading) return (
    <div style={{ minHeight: "100vh", background: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <SuntrifyLogo width={140} style={{margin:"0 auto 14px"}}/>
        <div style={{ color: "#9aa0b4", fontFamily: "'DM Sans',sans-serif", fontSize: 13 }}>Suntrify CRM</div>
        <div style={{ color: "#9aa0b4", fontSize: 13, marginTop: 8 }}>Loading...</div>
      </div>
    </div>
  );

  const addBtn = () => {
    const map = { jobs: "newJob", customers: "newCustomer", epc: "newEPC", subcontractors: "newSub", workorders: "newWO" };
    return map[tab] ? <Btn onClick={() => { setSelected(null); setModal(map[tab]); }}>+ {tab === "jobs" ? "Job" : tab === "customers" ? "Customer" : tab === "epc" ? "EPC Partner" : tab === "workorders" ? "Work Order" : "Subcontractor"}</Btn> : null;
  };

  const topBar = (
    <div style={{ WebkitAppRegion: "drag", background: "#fff", borderBottom: "1px solid #e0e3eb", padding: "10px 20px", display: "flex", alignItems: "center", gap: 8, minHeight: 52, flexWrap: "wrap" }}>
      {mobile && <div style={{ WebkitAppRegion: "no-drag", display:"flex", alignItems:"center", gap:6, flex:1 }}><SuntrifyLogo darkMode={darkMode} height={28}/><button onClick={onLogout} style={{ marginLeft:"auto", background:"transparent", border:"1px solid #ef444430", borderRadius:7, color:"#ef4444", fontSize:11, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>Sign Out</button></div>}
      <div style={{ flex: 1, display: "flex", gap: 8, alignItems: "center", WebkitAppRegion: "no-drag", flexWrap: "wrap" }}>
        {!mobile && (tab === "jobs" || tab === "customers" || tab === "epc" || tab === "subcontractors" || tab === "workorders") && (
          <>
            <input placeholder="🔍 Search…" value={search} onChange={e => setSearch(e.target.value)} style={{ ...IS, maxWidth: 200, WebkitAppRegion: "no-drag" }} />
          </>
        )}
        {tab === "pipeline" && (
          <div style={{ display: "flex", gap: 6, WebkitAppRegion: "no-drag" }}>
            <button onClick={() => setPipelineView("status")} style={{ background: pipelineView === "status" ? "#f0a500" : "transparent", border: "1px solid " + (pipelineView === "status" ? "#f0a500" : "#dde0ea"), borderRadius: 7, color: pipelineView === "status" ? "#000" : "#6a7080", fontWeight: 700, fontSize: 12, padding: "7px 12px", cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>By Status</button>
            <button onClick={() => setPipelineView("partner")} style={{ background: pipelineView === "partner" ? "#f0a500" : "transparent", border: "1px solid " + (pipelineView === "partner" ? "#f0a500" : "#dde0ea"), borderRadius: 7, color: pipelineView === "partner" ? "#000" : "#6a7080", fontWeight: 700, fontSize: 12, padding: "7px 12px", cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>By EPC Partner</button>
          </div>
        )}
      </div>
      <div style={{ WebkitAppRegion: "no-drag", display:"flex", gap:8, alignItems:"center" }}>
        {tab === "workorders" && (
          <button onClick={() => setWoCalView(v => !v)} style={{ display:"flex", alignItems:"center", gap:6, background: woCalView ? "#1a1d25" : "transparent", border:"1px solid " + (woCalView ? "#1a1d25" : "#dde0ea"), borderRadius:7, color: woCalView ? "#fff" : "#6a7080", fontWeight:600, fontSize:12, padding:"7px 12px", cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>
            <Icon name="calendar" size={13} color={woCalView ? "#fff" : "#6a7080"}/> {woCalView ? "List View" : "Calendar"}
          </button>
        )}
        {addBtn()}
      </div>
    </div>
  );

  const content = (
    <div style={{ flex: 1, overflowY: "auto", padding: "16px 20px", paddingBottom: mobile ? 120 : 16 }}>
      {tab === "dashboard" && (
        <Dashboard jobs={jobs} workOrders={workOrders} customers={customers} invoices={invoices} setTab={setTab}/>
      )}
      {tab === "jobs" && (
        <>
          {filteredJobs.length === 0 && <div style={{ textAlign: "center", color: "#9aa0b4", padding: "60px 0" }}>No jobs yet. Add your first job!</div>}
          {filteredJobs.length > 0 && (
            <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead>
                  <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                    <th style={{width:40,padding:"10px 12px"}}></th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Created</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Job #</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Stage</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Scope</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Customer</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Address</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>EPC Partner</th>
                    <th style={{padding:"10px 14px",textAlign:"right",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredJobs.map(j => {
                    const closed = j.stage === "Cancelled" || j.stage === "Closed";
                    const value = j.proposalAmount > 0 ? j.proposalAmount : j.contractValue > 0 ? j.contractValue : 0;
                    return (
                      <tr key={j._dbId}
                        onClick={() => { setSelected(j); setModal("viewJob"); }}
                        style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer",opacity:j.stage==="Cancelled"?0.5:1}}
                        onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                        onMouseLeave={e=>e.currentTarget.style.background=""}>
                        <td style={{padding:"8px 12px",textAlign:"center"}}>
                          <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                            <Icon name="eye" size={13} color="#6a7080"/>
                          </span>
                        </td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap",color:"#6a7080",fontSize:12}}>{j.createdAt ? (() => { const [y,m,d]=j.createdAt.split("-"); return `${m}-${d}-${y}`; })() : "—"}</td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:700,fontSize:11,color:"#1a1d25",fontFamily:"monospace"}}>{j.sunJobId||"—"}</td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap"}}>
                          <span style={{display:"inline-block",background:"#f0f1f5",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700,color:"#1a1d25"}}>{j.stage||"Lead"}</span>
                        </td>
                        <td style={{padding:"10px 14px"}}>
                          <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                            {(j.jobTypes||[]).map(t=><span key={t} style={{background:"#f0f1f5",color:"#1a1d25",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 7px",fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>{t}</span>)}
                            {j.estimatedKw>0&&<span style={{background:"#f0f1f5",color:"#6a7080",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 7px",fontSize:11,whiteSpace:"nowrap"}}>~{j.estimatedKw} kW</span>}
                          </div>
                        </td>
                        <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{j.customerName||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{j.address||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{j.epcPartnerName||"—"}</td>
                        <td style={{padding:"10px 14px",textAlign:"right",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{value>0?"$"+Number(value).toLocaleString():"—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {tab === "pipeline" && (
        <Pipeline jobs={filteredJobs} epcPartners={epcPartners} viewMode={pipelineView}
          onJobClick={j => { setSelected(j); setModal("viewJob"); }}
          onAddJob={stage => { setSelected(null); setModal("newJob"); }} />
      )}

      {tab === "customers" && (
        <>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12,flexWrap:"wrap"}}>
            <div style={{position:"relative",flex:1,maxWidth:360}}>
              <svg style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",pointerEvents:"none"}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9aa0b4" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
              <input placeholder="Search customers…" value={search} onChange={e=>setSearch(e.target.value)} style={{width:"100%",border:"1px solid #e0e3eb",borderRadius:8,padding:"8px 32px 8px 32px",fontSize:13,fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}/>
              {search&&<button onClick={()=>setSearch("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"transparent",border:"none",cursor:"pointer",color:"#9aa0b4",fontSize:16,lineHeight:1,padding:0}}>×</button>}
            </div>
            <div style={{fontSize:12,color:"#9aa0b4",whiteSpace:"nowrap"}}>{filteredCustomers.length} of {customers.length} customer{customers.length!==1?"s":""}</div>
          </div>
          {filteredCustomers.length === 0 && <div style={{ textAlign: "center", color: "#9aa0b4", padding: "60px 0" }}>No customers found.</div>}
          {filteredCustomers.length > 0 && (
            <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead>
                  <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                    <th style={{width:40,padding:"10px 12px"}}></th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Created</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Customer #</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Name</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Phone</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Email</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Address</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>EPC Partner</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.map(c => {
                    const fmtDate = d => { if(!d) return "—"; const [y,m,dy]=d.split("-"); return `${m}-${dy}-${y}`; };
                    const addr = [c.address, c.city, c.state, c.zip].filter(Boolean).join(", ");
                    return (
                      <tr key={c._dbId}
                        onClick={() => { setSelected(c); setModal("viewCustomer"); }}
                        style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer"}}
                        onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                        onMouseLeave={e=>e.currentTarget.style.background=""}>
                        <td style={{padding:"8px 12px",textAlign:"center"}}>
                          <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                            <Icon name="eye" size={13} color="#6a7080"/>
                          </span>
                        </td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap",color:"#6a7080",fontSize:12}}>{fmtDate(c.createdAt)}</td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:700,fontSize:11,color:"#1a1d25",fontFamily:"monospace"}}>{c.suntrifyId||"—"}</td>
                        <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{c.name||"—"}</td>
                        <td style={{padding:"10px 14px",whiteSpace:"nowrap",color:"#6a7080"}}>{c.phone||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{c.email||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{addr||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{c.epcPartnerName||"—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {tab === "epc" && (
        <>
          {filteredEPC.length === 0 && (() => { const dj = jobs.filter(j => j.contractType === "direct"); return dj.length === 0 ? <div style={{ textAlign: "center", color: "#9aa0b4", padding: "60px 0" }}>No EPC partners yet.</div> : null; })()}
          {(() => {
            const directJobs = jobs.filter(j => j.contractType === "direct");
            const directTotal = directJobs.reduce((s, j) => s + (j.contractValue || 0), 0);
            if (filteredEPC.length === 0 && directJobs.length === 0) return null;
            return (
              <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                  <thead>
                    <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                      <th style={{width:40,padding:"10px 12px"}}></th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Company</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Contact</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Phone</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Email</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>License #</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Jobs</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Volume</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Suntrify direct row — always first */}
                    <tr style={{borderBottom:"1px solid #f0f1f5",background:"#fffbf0",cursor:"pointer"}}
                      onMouseEnter={e=>e.currentTarget.style.background="#fff7e0"}
                      onMouseLeave={e=>e.currentTarget.style.background="#fffbf0"}
                      onClick={()=>{setSelected({...suntrifyInfo,_isSuntrify:true});setModal("editSuntrifyInfo");}}>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0a50020",border:"1px solid #f0a50060"}}>
                          <Icon name="eye" size={13} color="#d4891f"/>
                        </span>
                      </td>
                      <td style={{padding:"10px 14px",fontWeight:700,color:"#d4891f",whiteSpace:"nowrap"}}>{suntrifyInfo.company||"Suntrify Inc."}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{suntrifyInfo.contact||"—"}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{suntrifyInfo.phone||"—"}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{suntrifyInfo.email||"—"}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,fontFamily:"monospace"}}>{suntrifyInfo.license||"—"}{suntrifyInfo.licenseClass ? ` (${suntrifyInfo.licenseClass})` : ""}</td>
                      <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25"}}>{directJobs.length}</td>
                      <td style={{padding:"10px 14px",fontWeight:700,color:"#d4891f",fontSize:13}}>{directTotal > 0 ? `$${directTotal.toLocaleString()}` : "—"}</td>
                    </tr>
                    {filteredEPC.map(p => {
                      const partnerJobs = jobs.filter(j => String(j.epcPartnerId) === String(p.id));
                      const total = partnerJobs.reduce((s, j) => s + (j.contractValue || 0), 0);
                      return (
                        <tr key={p._dbId}
                          onClick={() => { setSelected(p); setModal("viewEPC"); }}
                          style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer"}}
                          onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                          onMouseLeave={e=>e.currentTarget.style.background=""}>
                          <td style={{padding:"8px 12px",textAlign:"center"}}>
                            <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                              <Icon name="eye" size={13} color="#6a7080"/>
                            </span>
                          </td>
                          <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{p.company || p.name || "—"}</td>
                          <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{p.company ? p.name : "—"}</td>
                          <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{p.phone || "—"}</td>
                          <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{p.email || "—"}</td>
                          <td style={{padding:"10px 14px",fontSize:12}}>
                            <div style={{display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                              {p.licenseNumber && <span style={{fontFamily:"monospace",color:"#6a7080",whiteSpace:"nowrap"}}>#{p.licenseNumber}</span>}
                              {p.licenseStatus && <span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:4,background:p.licenseStatus==="Active"?"#dcfce7":"#fee2e2",color:p.licenseStatus==="Active"?"#16a34a":"#dc2626"}}>{p.licenseStatus}</span>}
                              {p.licenseClass && p.licenseClass.split(",").map(c=>c.trim()).filter(Boolean).map(code=>(
                                <span key={code} style={{background:"#1d4ed8",color:"#fff",borderRadius:4,padding:"1px 6px",fontSize:10,fontWeight:700}}>{code}</span>
                              ))}
                              {!p.licenseNumber && !p.licenseClass && "—"}
                            </div>
                          </td>
                          <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25"}}>{partnerJobs.length}</td>
                          <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{total > 0 ? `$${total.toLocaleString()}` : "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })()}
        </>
      )}

      {tab === "subcontractors" && (
        <>
          {filteredSubs.length === 0 && <div style={{ textAlign: "center", color: "#9aa0b4", padding: "60px 0" }}>No subcontractors yet.</div>}
          {filteredSubs.length > 0 && (
            <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead>
                  <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                    <th style={{width:40,padding:"10px 12px"}}></th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Company</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Name</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Phone</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Email</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>License</th>
                    <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubs.map(s => {
                    const addr = [s.address, s.city, s.state, s.zip].filter(Boolean).join(", ");
                    return (
                      <tr key={s._dbId}
                        onClick={() => { setSelected(s); setModal("viewSub"); }}
                        style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer"}}
                        onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                        onMouseLeave={e=>e.currentTarget.style.background=""}>
                        <td style={{padding:"8px 12px",textAlign:"center"}}>
                          <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                            <Icon name="eye" size={13} color="#6a7080"/>
                          </span>
                        </td>
                        <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{s.company || "—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{s.name || "—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap"}}>{s.phone || "—"}</td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{s.email || "—"}</td>
                        <td style={{padding:"10px 14px",fontSize:12}}>
                          <div style={{display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                            {s.licenseNumber && <span style={{fontFamily:"monospace",fontSize:11,color:"#6a7080",whiteSpace:"nowrap"}}>#{s.licenseNumber}</span>}
                            {s.licenseStatus && <span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:4,background:s.licenseStatus==="Active"?"#dcfce7":"#fee2e2",color:s.licenseStatus==="Active"?"#16a34a":"#dc2626"}}>{s.licenseStatus}</span>}
                            {s.licenseClass && s.licenseClass.split(",").map(c=>c.trim()).filter(Boolean).map(code=>(
                              <span key={code} style={{background:"#1d4ed8",color:"#fff",borderRadius:4,padding:"1px 6px",fontSize:10,fontWeight:700}}>{code.split(" - ")[0]}</span>
                            ))}
                            {!s.licenseNumber && !s.licenseClass && "—"}
                          </div>
                        </td>
                        <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{addr || "—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {tab === "reports" && <Reports jobs={jobs} workOrders={workOrders} epcPartners={epcPartners}/>}
      {tab === "workorders" && woCalView && (
        <WOCalendar workOrders={workOrders} darkMode={darkMode} card={card} borderColor={borderColor} textColor={textColor} mutedColor={mutedColor} onWOClick={w=>{setSelected(w);setModal("viewWO");}}/>
      )}
      {tab === "workorders" && !woCalView && (
        <>
          {workOrders.length === 0 && <div style={{textAlign:"center",color:"#9aa0b4",padding:"60px 0"}}>No work orders yet. Click + Work Order to add one.</div>}
          {workOrders.length > 0 && (() => {
            const fmtDate = d => { if(!d) return "—"; const dt=new Date(d+"T12:00:00"); return dt.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",year:"numeric"}); };
            const fmtTime = t => { if(!t) return "—"; if(/[aApP][mM]/.test(t)) return t.toUpperCase(); const [h,m] = t.split(":"); const hr=parseInt(h); return `${hr%12||12}:${m||"00"} ${hr>=12?"PM":"AM"}`; };
            const rows = [...workOrders].sort((a,b)=>b.date>a.date?1:-1).filter(w=>!search||[w.customerName,w.address,(w.types||[]).join(" "),w.status,w.notes,w.epcPartnerName].join(" ").toLowerCase().includes(search.toLowerCase()));
            return (
              <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                  <thead>
                    <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                      <th style={{width:40,padding:"10px 12px"}}></th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>WO #</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Date</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Time</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Status</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Type</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>EPC Partner</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Customer</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Address</th>
                      <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Back Charge $</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map(w => {
                      const cancelled = w.status==="Cancelled"||w.status==="Canceled";
                      const baseAddr = w.address || "";
                      const addr = (w.zip && baseAddr.includes(w.zip))
                        ? baseAddr
                        : [baseAddr, w.city, [w.state, w.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
                      return (
                        <tr key={w._dbId}
                          onClick={()=>{setSelected(w);setModal("viewWO");}}
                          style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer",opacity:cancelled?0.5:1}}
                          onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                          onMouseLeave={e=>e.currentTarget.style.background=""}>
                          <td style={{padding:"8px 12px",textAlign:"center"}}>
                            <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                              <Icon name="eye" size={13} color="#6a7080"/>
                            </span>
                          </td>
                          <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:700,fontSize:11,color:"#1a1d25",fontFamily:"monospace"}}>{w.woId||"—"}</td>
                          <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:500,color:"#1a1d25"}}>{fmtDate(w.date)}</td>
                          <td style={{padding:"10px 14px",whiteSpace:"nowrap",color:"#6a7080"}}>{fmtTime(w.time)}</td>
                          <td style={{padding:"10px 14px",whiteSpace:"nowrap",fontWeight:600,fontSize:12,color:"#1a1d25"}}>{w.status||"Scheduled"}</td>
                          <td style={{padding:"10px 14px"}}>
                            <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                              {(w.types||[]).map(t=><span key={t} style={{background:"#f0f1f5",color:"#1a1d25",border:"1px solid #e0e3eb",borderRadius:4,padding:"2px 7px",fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>{t}</span>)}
                            </div>
                          </td>
                          <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{w.epcPartnerName||"—"}</td>
                          <td style={{padding:"10px 14px",fontWeight:600,color:"#1a1d25",whiteSpace:"nowrap"}}>{w.customerName||"—"}</td>
                          <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12}}>{addr||"—"}</td>
                          <td style={{padding:"10px 14px",whiteSpace:"nowrap"}}>
                            {(w.backCharge||w.billable)&&w.chargeAmount>0
                              ? <span style={{fontWeight:700,color:"#d4891f",fontSize:13}}>${(w.chargeAmount||0).toLocaleString()}</span>
                              : <span style={{color:"#c0c4d0",fontSize:12}}>—</span>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })()}
        </>
      )}
      {tab === "reminders" && (
        <Reminders jobs={jobs} customers={customers} onJobClick={j => { setSelected(j); setTab("jobs"); setModal("viewJob"); }} />
      )}
      {tab === "estimator" && (
        <div style={{paddingBottom: mobile ? 70 : 0, overflowY:"auto", flex:1}}>
          <MaterialEstimator
            estimatesProp={estimates}
            setEstimatesProp={setEstimates}
            jobs={jobs}
            onSave={async (data, isNew, editingDbId) => {
              try {
                const { _dbId, ...clean } = data;
                if (!isNew && editingDbId) {
                  await dbSave("estimates", { ...clean, _dbId: editingDbId });
                  const saved = { ...clean, _dbId: editingDbId };
                  setEstimates(prev => prev.map(e => e._dbId === editingDbId ? saved : e));
                  return saved;
                } else {
                  const saved = await dbSave("estimates", { ...clean, id: Date.now() });
                  setEstimates(prev => [saved, ...prev]);
                  return saved;
                }
              } catch(e) { console.error(e); return null; }
            }}
            onDelete={async (est) => {
              try {
                if (est._dbId) await dbDelete("estimates", est._dbId);
                setEstimates(prev => prev.filter(e => e._dbId !== est._dbId));
              } catch(e) { console.error(e); }
            }}
          />
        </div>
      )}
      {tab === "photos" && <PhotosGallery jobs={jobs} workOrders={workOrders} installReports={installReports}/>}
      {woReportWO && <WOReport wo={woReportWO} jobs={jobs} onClose={()=>setWoReportWO(null)}/>}
      {modal==="newWOFromJob"&&selected2&&(
        <Modal open={true} onClose={()=>{setModal("viewJob");setSelected2(null);}}>
          <WOForm title="New Work Order" initial={selected2} epcPartners={epcPartners} subcontractors={subcontractors} jobs={jobs}
            onSave={f=>{const rTok=Date.now().toString(36)+Math.random().toString(36).slice(2,8);const item={...f,id:newId(),woId:f.woId||genWOId(),reportToken:rTok};saveItem("work_orders",setWorkOrders,item,true);sendWOEmail(item,currentUser?.name,item.documents||[]);sendWOSMS(item);setModal("viewJob");setSelected2(null);}}
            onCancel={()=>{setModal("viewJob");setSelected2(null);}}/>
        </Modal>
      )}
      {globalSearch && <GlobalSearch jobs={jobs} workOrders={workOrders} customers={customers} invoices={invoices} onClose={() => { if(setGlobalSearch) setGlobalSearch(false); }} setTab={setTab} darkMode={darkMode}/>}
      {tab === "invoices" && <div style={{paddingBottom: mobile ? 70 : 0, overflowY:"auto", flex:1}}><Invoices workOrders={workOrders} epcPartners={epcPartners} jobs={jobs} invoicesProp={invoices} setInvoicesProp={setInvoices} /></div>}
      {tab === "proposals" && <div style={{paddingBottom: mobile ? 70 : 0, overflowY:"auto", flex:1}}><Proposals proposals={proposals} setProposals={setProposals} customers={customers} jobs={jobs} suntrifyInfo={suntrifyInfo}/></div>}
          </div>
  );

  // Detail modals
  const viewJob = selected && modal === "viewJob" && (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, color: "#1a1d25", margin: 0 }}>{selected.customerName}</h2>
          <AddressLink address={selected.address} style={{ fontSize: 13, color: "#6a7080" }}/>
        </div>
        <Pill label={selected.stage} color={STAGE_COLORS[selected.stage] || "#6b7280"} />
        {selected.contractType==="direct"
          ? <span style={{fontSize:11,padding:"2px 8px",borderRadius:4,fontWeight:700,background:"#22c55e22",color:"#22c55e",border:"1px solid #22c55e44"}}>🏠 Direct Sale</span>
          : <span style={{fontSize:11,padding:"2px 8px",borderRadius:4,fontWeight:700,background:"#3b82f622",color:"#3b82f6",border:"1px solid #3b82f644"}}>🤝 EPC Sub</span>}
      </div>
      {/* Job Timeline */}
      {(()=>{
        const stages=["Lead","Site Survey","Permit Submitted","Permit Approved","Installation","Final Inspection","PTO Submitted","Closed"];
        const sc={"Lead":"#6b7280","Site Survey":"#8b5cf6","Permit Submitted":"#f59e0b","Permit Approved":"#3b82f6","Installation":"#f0a500","Final Inspection":"#ec4899","PTO Submitted":"#06b6d4","Closed":"#22c55e"};
        const idx=stages.indexOf(selected.stage);
        return(
          <div style={{marginBottom:16,overflowX:"auto"}}>
            <div style={{display:"flex",alignItems:"center",minWidth:480}}>
              {stages.map((s,i)=>{
                const done=i<idx;const active=i===idx;const color=sc[s]||"#6b7280";
                return(<React.Fragment key={s}>
                  <div style={{display:"flex",flexDirection:"column",alignItems:"center",minWidth:60}}>
                    <div style={{width:24,height:24,borderRadius:"50%",background:done||active?color:"#f0f1f5",border:`2px solid ${done||active?color:"#e0e3eb"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:done||active?"#fff":"#9aa0b4",fontWeight:700,flexShrink:0}}>
                      {done?"✓":i+1}
                    </div>
                    <div style={{fontSize:8,color:active?color:"#9aa0b4",marginTop:3,textAlign:"center",fontWeight:active?700:400,maxWidth:56,lineHeight:1.2}}>{s}</div>
                  </div>
                  {i<stages.length-1&&<div style={{height:2,flex:1,background:done?color:"#e0e3eb",minWidth:8}}/>}
                </React.Fragment>);
              })}
            </div>
          </div>
        );
      })()}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14, fontSize: 12 }}>
        {selected.epcPartnerName && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>EPC Partner</div><div style={{ color: "#1a1d25", fontWeight: 700 }}>{selected.epcPartnerName}</div></div>}
        {(selected.jobTypes||[]).length > 0 && <div style={{gridColumn:"1/-1"}}><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Scope</div><div style={{display:"flex",flexWrap:"wrap",gap:5}}>{(selected.jobTypes||[]).map(t=><span key={t} style={{background:"#f0f1f5",borderRadius:4,padding:"2px 8px",fontSize:11,color:"#4a5060"}}>{t}</span>)}{selected.estimatedKw > 0 && <span style={{background:"#fff7ed",borderRadius:4,padding:"2px 8px",fontSize:11,color:"#d4891f",fontWeight:600}}>~{selected.estimatedKw} kW</span>}</div></div>}
        {selected.leadSource && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Lead Source</div><div style={{ color: "#1a1d25" }}>{selected.leadSource}</div></div>}
        {selected.assignedTo && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Assigned To</div><div style={{ color: "#1a1d25" }}>{selected.assignedTo}</div></div>}
        {selected.financingType && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Financing</div><div style={{ color: "#1a1d25" }}>{selected.financingType}</div></div>}
        {selected.utilityCompany && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Utility</div><div style={{ color: "#1a1d25" }}>{selected.utilityCompany}</div></div>}
        {selected.monthlyBill > 0 && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Monthly Bill</div><div style={{ color: "#1a1d25" }}>${Number(selected.monthlyBill).toLocaleString()}</div></div>}
        {selected.proposalAmount > 0 && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Proposal</div><div style={{ color: "#d4891f", fontWeight: 700, fontSize: 14 }}>${Number(selected.proposalAmount).toLocaleString()}</div></div>}
        {selected.followUpDate && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Follow-Up</div><div style={{ color: "#1a1d25" }}>{selected.followUpDate}</div></div>}
        {selected.startDate && <div><div style={{ color: "#9aa0b4", fontSize: 10, textTransform: "uppercase" }}>Dates</div><div style={{ color: "#1a1d25" }}>{selected.startDate}{selected.endDate ? " → " + selected.endDate : ""}</div></div>}
      </div>
      {selected.salesNotes && <div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:6,padding:"10px 12px",marginBottom:14,fontSize:12}}><div style={{color:"#9aa0b4",fontSize:10,textTransform:"uppercase",marginBottom:4}}>Sales Notes</div><div style={{color:"#1a1d25",lineHeight:1.5}}>{selected.salesNotes}</div></div>}
      {selected.contractValue > 0 && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
            <span style={{ color: "#22c55e" }}>${(selected.paid || 0).toLocaleString()} paid</span>
            <span style={{ color: "#f0a500" }}>${((selected.contractValue || 0) - (selected.paid || 0)).toLocaleString()} owed · ${(selected.contractValue || 0).toLocaleString()} total</span>
          </div>
          <div style={{ height: 6, background: "#f0f1f5", borderRadius: 3, marginBottom: 8 }}>
            <div style={{ height: "100%", width: Math.min(100, Math.round(((selected.paid || 0) / selected.contractValue) * 100)) + "%", background: "#22c55e", borderRadius: 3 }} />
          </div>

          {(()=>{
            const jobId = selected._dbId || selected.id;
            const bcWOs = workOrders.filter(w=>{
              const wJobId = w.jobId;
              return (w.backCharge||w.billable) && w.chargeAmount>0 &&
                (String(wJobId)===String(jobId));
            });
            if(!bcWOs.length) return null;
            return <div style={{marginTop:6}}>
              <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,marginBottom:4}}>Back Charge Breakdown</div>
              {bcWOs.map(w=>(
                <div key={w._dbId||w.id} style={{marginBottom:6,background:"#ef444408",border:"1px solid #ef444420",borderRadius:4,padding:"6px 10px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                    <span style={{color:"#ef4444",fontWeight:700,fontSize:11,display:"inline-flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:"50%",background:"#ef4444",display:"inline-block",flexShrink:0}}/> {w.woId} — {(w.types||[]).slice(0,2).join(", ")||"Work Order"}</span>{w.date&&<span style={{color:"#9aa0b4",fontSize:10,marginLeft:6,display:"inline-flex",alignItems:"center",gap:3}}><Icon name="calendar" size={10} color="#9aa0b4"/> {w.date}</span>}
                    <span style={{fontWeight:700,color:"#ef4444",fontSize:12}}>${(w.chargeAmount||0).toLocaleString()}</span>
                  </div>
                  {Object.entries(w.woAdders||{}).map(([k,v])=>{
                    const ad=ESP_ADDERS.find(x=>x.label===k);
                    if(!ad||!v) return null;
                    const amt=ad.type==="flat"?ad.rate:ad.rate*Number(v);
                    return <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"#6a7080",marginBottom:1}}>
                      <span>· {k}{ad.unit!=="Per Project"?" x"+v:""}</span><span>${amt.toLocaleString()}</span>
                    </div>;
                  })}
                  {Object.entries(w.woBattery||{}).map(([k])=>{
                    const bat=ESP_BATTERY.find(x=>x.label===k);
                    if(!bat) return null;
                    return <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"#6a7080",marginBottom:1}}>
                      <span>· {k}</span><span>${bat.rate.toLocaleString()}</span>
                    </div>;
                  })}
                  {(w.woMiscLines||[]).map(l=>(
                    <div key={l.id} style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"#6a7080",marginBottom:1}}>
                      <span>· {l.type||"Misc"} x{l.qty}</span><span>${(l.total||0).toLocaleString()}</span>
                    </div>
                  ))}
                  {w.chargeNotes&&<div style={{fontSize:10,color:"#9aa0b4",marginTop:2,fontStyle:"italic"}}>{w.chargeNotes}</div>}
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,fontWeight:700,borderTop:"1px solid #e0e3eb",paddingTop:5,marginTop:4}}>
                <span style={{color:"#1a1d25"}}>Total Back Charged</span>
                <span style={{color:"#ef4444"}}>${bcWOs.reduce((s,w)=>s+(w.chargeAmount||0),0).toLocaleString()}</span>
              </div>
            </div>;
          })()}
        </div>
      )}
      {(()=>{
        const jobId = selected._dbId || selected.id;
        const bcWOs = workOrders.filter(w=>{
          const wJobId = w.jobId;
          return (w.backCharge||w.billable) && w.chargeAmount>0 &&
            (String(wJobId)===String(jobId));
        });
        if(!bcWOs.length||selected.contractValue>0) return null;
        return <div style={{marginBottom:14,background:"#ef444408",border:"1px solid #ef444420",borderRadius:8,padding:"10px 12px"}}>
          <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,marginBottom:6}}>Back Charge Breakdown</div>
          {bcWOs.map(w=>(
            <div key={w._dbId||w.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:11,marginBottom:3}}>
              <div style={{flex:1}}>
                <span style={{color:"#ef4444",fontWeight:700,display:"inline-flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:"50%",background:"#ef4444",display:"inline-block",flexShrink:0}}/> {w.woId}</span>
                <span style={{color:"#6a7080",marginLeft:6}}>{(w.types||[]).slice(0,2).join(", ")||"Work Order"}</span>
              </div>
              <span style={{fontWeight:700,color:"#ef4444"}}>${(w.chargeAmount||0).toLocaleString()}</span>
            </div>
          ))}
        </div>;
      })()}
      {selected.milestones?.length > 0 && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: "#9aa0b4", textTransform: "uppercase", marginBottom: 8 }}>Milestones</div>
          {selected.milestones.map(m => (
            <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <div style={{ width: 14, height: 14, borderRadius: "50%", background: m.done ? "#22c55e" : "#f0f1f5", border: "2px solid " + (m.done ? "#22c55e" : "#dde0ea"), display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, flexShrink: 0 }}>{m.done ? "✓" : ""}</div>
              <span style={{ fontSize: 12, color: m.done ? "#9aa0b4" : "#1a1d25", textDecoration: m.done ? "line-through" : "none" }}>{m.label}</span>
            </div>
          ))}
        </div>
      )}
      {selected.notes && <div style={{ background: "#f9f9fb", border: "1px solid #e0e3eb", borderRadius: 8, padding: "10px 12px", color: "#6a7080", fontSize: 12, marginBottom: 14, lineHeight: 1.6 }}>{selected.notes}</div>}
      {(() => {
        const jobId = selected._dbId || selected.id;
        const jobEsts = estimates.filter(e => String(e.jobDbId) === String(jobId));
        if (!jobEsts.length) return null;
        return jobEsts.map(est => (
          <div key={est._dbId} style={{ marginBottom: 14, border: "1px solid #e0e3eb", borderRadius: 8, overflow: "hidden" }}>
            <div style={{ background: "#1F3864", color: "#fff", padding: "8px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.04em" }}>🔧 MATERIAL ESTIMATE</span>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 11, opacity: 0.7 }}>{est.jobDate || ""}</span>
                <button onClick={() => {
                  const win = window.open("", "_blank", "width=950,height=750");
                  const fmtN = n => "$" + parseFloat(n||0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  const rows = [...(est.lines||[])].sort((a,b)=>a.cat.localeCompare(b.cat));
                  let tableRows="", lastCat="";
                  rows.forEach((l,i)=>{
                    if(l.cat!==lastCat){lastCat=l.cat;tableRows+=`<tr class="cat-row"><td colspan="5">${l.cat}</td></tr>`;}
                    tableRows+=`<tr><td>${l.desc}</td><td style="color:#888;font-size:11px">${l.code}</td><td style="text-align:center">${l.qty} ${l.unit}</td><td style="text-align:right">${fmtN(l.price)}</td><td style="text-align:right;font-weight:600">${fmtN(l.ext)}</td></tr>`;
                  });
                  win.document.write(`<!DOCTYPE html><html><head><title>Estimate — ${selected.customerName}</title>
                  <style>
                    *{box-sizing:border-box;margin:0;padding:0}
                    body{font-family:Arial,sans-serif;padding:40px;color:#1a1d25;font-size:12px}
                    .top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px}
                    .co-info{font-size:12px;color:#1a1d25;line-height:1.9}
                    .co-info strong{font-size:14px;color:#1a1d25;font-weight:700}
                    .logo{max-height:30px;width:auto}
                    .title-bar{background:#1F3864;color:#fff;font-size:22px;font-weight:900;letter-spacing:1px;padding:10px 20px;margin-bottom:24px;display:inline-block}
                    .info-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:0;margin-bottom:28px;border:1px solid #e0e3eb;border-radius:4px;overflow:hidden}
                    .info-col{padding:14px 16px;border-right:1px solid #e0e3eb}
                    .info-col:last-child{border-right:none}
                    .info-col label{display:block;font-size:9px;color:#1F3864;text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px;font-weight:700}
                    .info-col .val{font-size:13px;font-weight:700;color:#1a1d25}
                    .info-row{display:flex;justify-content:flex-start;align-items:center;margin-bottom:5px;font-size:12px}
                    .info-row label{color:#444;font-weight:600;white-space:nowrap;width:110px;text-align:left}
                    table{width:100%;border-collapse:collapse}
                    thead tr{background:#1F3864;color:#fff}
                    th{padding:9px 12px;text-align:left;font-size:11px;letter-spacing:.05em;text-transform:uppercase;font-weight:600}
                    td{padding:8px 12px;border-bottom:1px solid #eee;font-size:12px}
                    .cat-row td{background:#e8ecf3;color:#1F3864;font-weight:700;font-size:11px;padding:6px 12px;text-transform:uppercase;letter-spacing:.05em}
                    .totals-row{display:flex;justify-content:flex-end;margin-top:0}
                    .totals-box{width:260px;border:1px solid #e0e3eb;border-top:none}
                    .totals-line{display:flex;justify-content:space-between;padding:7px 14px;font-size:13px;border-bottom:1px solid #f0f2f5}
                    .totals-final{display:flex;justify-content:space-between;padding:10px 14px;border-top:2px solid #1F3864}
                    .totals-final span:first-child{font-weight:700;font-size:14px}
                    .totals-final span:last-child{font-weight:900;font-size:16px;color:#1F3864}
                    .footer{margin-top:40px;text-align:center;font-size:11px;color:#444;border-top:1px solid #e0e3eb;padding-top:14px}
                    .btnbar{position:fixed;top:16px;right:16px;display:flex;gap:8px}
                    .bprint{background:#1F3864;color:#fff;border:none;padding:8px 16px;border-radius:7px;cursor:pointer;font-size:13px;font-weight:600}
                    .bsave{background:#22c55e;color:#fff;border:none;padding:8px 16px;border-radius:7px;cursor:pointer;font-size:13px;font-weight:600}
                    .bclose{background:transparent;color:#6a7080;border:1px solid #dde0ea;padding:8px 16px;border-radius:7px;cursor:pointer;font-size:13px;font-weight:600}
                    @media print{.btnbar{display:none}body{padding:20px}}
                  </style></head><body>
                  <div class="btnbar"><button class="bprint" onclick="window.print()">🖨 Print</button><button class="bsave" onclick="window.print()">💾 Save to PDF</button><button class="bclose" onclick="window.close()">✕ Close</button></div>
                  <div class="top">
                    <div class="co-info"><strong>Suntrify Inc.</strong><br>29336 Tournament<br>Lake Elsinore, CA 92530<br>(951) 866-2828<br>jchacon@suntrify.com<br>www.suntrify.com</div>
                    <img src="https://crm.suntrify.com/SUNTRIFY_LOGO.png" class="logo" alt="Suntrify">
                  </div>
                  <div class="title-bar">MATERIAL ESTIMATE</div>
                  <div class="info-grid">
                    <div class="info-col"><label>Bill To</label><div class="val">${est.epcPartner||"—"}</div></div>
                    <div class="info-col"><label>Project / Customer</label><div class="val">${selected.customerName||"—"}</div><div style="font-size:11px;color:#444;margin-top:2px">${selected.address||""}</div></div>
                    <div class="info-col"><label>Estimate Info</label>
                      <div class="info-row"><label>Date</label><span>${est.jobDate||"—"}</span></div>
                      <div class="info-row"><label>EPC Job #</label><span>${est.epcJobNum||"—"}</span></div>
                      <div class="info-row"><label>Suntrify Job #</label><span>${est.suntrifyId||"—"}</span></div>
                    </div>
                  </div>
                  <table><thead><tr><th>Description</th><th>Code</th><th style="text-align:center">Qty / Unit</th><th style="text-align:right">Unit $</th><th style="text-align:right">Amount</th></tr></thead><tbody>${tableRows}</tbody></table>
                  <div class="totals-row"><div class="totals-box">
                    <div class="totals-line"><span>Subtotal</span><span>${fmtN(est.sub)}</span></div>
                    <div class="totals-line"><span>Markup (${est.markup}%)</span><span>${fmtN(est.mkamt)}</span></div>
                    <div class="totals-final"><span>Balance Due</span><span>${fmtN(est.total)}</span></div>
                  </div></div>
                  <div class="footer">Suntrify Inc. · CSLB #1055498 (B, C-10, C-46) · jchacon@suntrify.com · Thank you for your business!</div>
                  </body></html>`);
                  win.document.close();
                }} style={{ background: "transparent", border: "1px solid rgba(255,255,255,0.5)", borderRadius: 5, color: "#fff", fontSize: 11, padding: "3px 10px", cursor: "pointer" }}>🖨 Print</button>
              </div>
            </div>
            <div style={{ padding: "10px 14px", background: "#f9fafc" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 10 }}>
                <div><div style={{ fontSize: 10, color: "#9aa0b4", textTransform: "uppercase" }}>EPC Partner</div><div style={{ fontSize: 12, fontWeight: 600 }}>{est.epcPartner || "—"}</div></div>
                <div><div style={{ fontSize: 10, color: "#9aa0b4", textTransform: "uppercase" }}>EPC Job #</div><div style={{ fontSize: 12, fontWeight: 600 }}>{est.epcJobNum || "—"}</div></div>
                <div><div style={{ fontSize: 10, color: "#9aa0b4", textTransform: "uppercase" }}>Suntrify Job #</div><div style={{ fontSize: 12, fontWeight: 600 }}>{est.suntrifyId || "—"}</div></div>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #e0e3eb" }}>
                    <th style={{ textAlign: "left", padding: "3px 6px", color: "#9aa0b4", fontWeight: 600 }}>Description</th>
                    <th style={{ textAlign: "center", padding: "3px 6px", color: "#9aa0b4", fontWeight: 600 }}>Unit</th>
                    <th style={{ textAlign: "right", padding: "3px 6px", color: "#9aa0b4", fontWeight: 600 }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "3px 6px", color: "#9aa0b4", fontWeight: 600 }}>Unit $</th>
                    <th style={{ textAlign: "right", padding: "3px 6px", color: "#9aa0b4", fontWeight: 600 }}>Ext.</th>
                  </tr>
                </thead>
                <tbody>
                  {[...(est.lines||[])].sort((a,b)=>a.cat.localeCompare(b.cat)||a.desc.localeCompare(b.desc)).map((l, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f0f2f5" }}>
                      <td style={{ padding: "3px 6px" }}><span style={{ color: "#9aa0b4", marginRight: 6 }}>{i+1}</span>{l.desc}</td>
                      <td style={{ padding: "3px 6px", textAlign: "center", color: "#9aa0b4" }}>{l.unit}</td>
                      <td style={{ padding: "3px 6px", textAlign: "right" }}>{l.qty}</td>
                      <td style={{ padding: "3px 6px", textAlign: "right" }}>${parseFloat(l.price||0).toFixed(2)}</td>
                      <td style={{ padding: "3px 6px", textAlign: "right", fontWeight: 600 }}>${parseFloat(l.ext||0).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr><td colSpan={4} style={{ padding: "4px 6px", textAlign: "right", color: "#6a7080" }}>Subtotal</td><td style={{ padding: "4px 6px", textAlign: "right", fontWeight: 600 }}>${parseFloat(est.sub||0).toFixed(2)}</td></tr>
                  <tr><td colSpan={4} style={{ padding: "2px 6px", textAlign: "right", color: "#9aa0b4", fontSize: 10 }}>Markup ({est.markup}%)</td><td style={{ padding: "2px 6px", textAlign: "right", color: "#9aa0b4" }}>${parseFloat(est.mkamt||0).toFixed(2)}</td></tr>
                  <tr style={{ borderTop: "2px solid #e0e3eb" }}>
                    <td colSpan={4} style={{ padding: "5px 6px", textAlign: "right", fontWeight: 700 }}>TOTAL</td>
                    <td style={{ padding: "5px 6px", textAlign: "right", fontWeight: 700, color: "#1a56db", fontSize: 13 }}>${parseFloat(est.total||0).toFixed(2)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        ));
      })()}

      )}
      <FileUpload
        folder={`jobs/${(selected.customerName||"job").replace(/[^a-z0-9]/gi,"_")}`}
        existingFiles={selected.documents||[]}
        onFilesChange={urls=>{const updated={...selected,documents:urls};setSelected(updated);saveItem("jobs",setJobs,updated,false);}}
      />
      <div style={{ display: "flex", gap: 8 }}>
        {/* Work Orders linked to this job */}
        {(()=>{
          const jobWOs = workOrders.filter(w=>w.customerName===selected.customerName).sort((a,b)=>(b.date||"").localeCompare(a.date||""));
          const statusColor = s => s==="Complete"?"#22c55e":s==="In Progress"?"#f59e0b":"#3b82f6";
          return(
            <div style={{marginBottom:14}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase"}}>Work Orders ({jobWOs.length})</div>
                <button onClick={()=>{
                  const newWO = {...emptyWO, customerName:selected.customerName, address:selected.address, city:selected.city||"", state:selected.state||"", zip:selected.zip||"", phone:selected.phone||"", epcPartnerName:selected.epcPartnerName||"", woId:genWOId(), date:new Date().toISOString().slice(0,10)};
                  setSelected2(newWO);
                  setModal("newWOFromJob");
                }} style={{background:"#f0a500",border:"none",borderRadius:6,padding:"4px 12px",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"inherit",color:"#000"}}>+ New WO</button>
              </div>
              {jobWOs.length===0&&<div style={{textAlign:"center",color:"#9aa0b4",fontSize:12,padding:"10px 0"}}>No work orders yet</div>}
              {jobWOs.map(w=>(
                <div key={w._dbId} onClick={()=>{setWoReportWO(null);setSelected(w);setModal("viewWO");}} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,marginBottom:4,cursor:"pointer"}}>
                  <div>
                    <div style={{fontSize:12,fontWeight:700,color:"#d4891f"}}>{w.woId}</div>
                    <div style={{fontSize:11,color:"#9aa0b4"}}>{(w.types||[]).slice(0,2).join(", ")} · {w.date}</div>
                  </div>
                  <span style={{background:statusColor(w.status)+"22",color:statusColor(w.status),borderRadius:10,padding:"2px 8px",fontSize:10,fontWeight:700}}>{w.status}</span>
                </div>
              ))}
            </div>
          );
        })()}
        <Btn onClick={() => setModal("editJob")} style={{ flex: 1 }}>✏️ Edit</Btn>
        <Btn onClick={() => deleteItem("jobs", setJobs, selected)} variant="danger">🗑</Btn>
        <Btn onClick={() => { setModal(null); setSelected(null); }} variant="ghost">✕</Btn>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: mobile ? "column" : "row", height: "100vh", overflow: "hidden", background: "#f5f6fa", fontFamily: "'DM Sans',sans-serif" }}>
      {!mobile && <Sidebar tab={tab} setTab={t => { setTab(t); setSelected(null); setSearch(""); }} darkMode={darkMode} setDarkMode={setDarkMode} setGlobalSearch={setGlobalSearch} jobs={jobs} epcPartners={epcPartners} customers={customers} subcontractors={subcontractors} workOrders={workOrders} currentUser={currentUser} onLogout={onLogout} onManageUsers={() => setShowManageUsers(true)} />}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {topBar}
        {content}
      </div>
      {mobile && (
        <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTop: "1px solid #e0e3eb", zIndex: 200 }}>
          {/* Search bar row */}
          <div style={{ padding: "8px 12px 4px", borderBottom: "1px solid #f0f1f5" }}>
            <div style={{ position: "relative" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9aa0b4" strokeWidth="2" style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", pointerEvents:"none" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input
                placeholder="Search…"
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ width:"100%", border:"1px solid #e0e3eb", borderRadius:8, padding:"7px 32px 7px 30px", fontSize:13, fontFamily:"'DM Sans',sans-serif", boxSizing:"border-box", background:"#f9f9fb", outline:"none" }}
              />
              {search && <button onClick={()=>setSearch("")} style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"transparent", border:"none", cursor:"pointer", color:"#9aa0b4", fontSize:14, lineHeight:1 }}>✕</button>}
            </div>
          </div>
          {/* Tab buttons row */}
          <div style={{ display: "flex", height: 56, overflowX: "auto" }}>
            {[
              { id: "dashboard", icon: "reports", label: "Home" },
              { id: "photos", icon: "reports", label: "Photos" },
              { id: "jobs", icon: "jobs", label: "Jobs" },
              { id: "customers", icon: "customers", label: "Customers" },
              { id: "workorders", icon: "workorders", label: "WOs" },
              { id: "proposals", icon: "invoices", label: "Proposals" },
              { id: "estimator", icon: "reports", label: "Estimate" },
              { id: "invoices", icon: "invoices", label: "Invoices" },
              { id: "pipeline", icon: "pipeline", label: "Pipeline" },
              { id: "epc", icon: "epc", label: "EPC" },
              { id: "subcontractors", icon: "subcontractors", label: "Subs" },
              { id: "reminders", icon: "reminders", label: "Alerts" },
              { id: "reports", icon: "reports", label: "Reports" },
            ].map(item => (
              <button key={item.id} onClick={() => { setTab(item.id); setSelected(null); setSearch(""); }} style={{ minWidth: 64, flex: "0 0 64px", background: "transparent", border: "none", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, cursor: "pointer", color: tab === item.id ? "#d4891f" : "#9aa0b4", fontFamily: "'DM Sans',sans-serif" }}>
                <NavIcon name={item.icon}/>
                <span style={{ fontSize: 9, fontWeight: tab === item.id ? 700 : 400 }}>{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Modals */}
      <Modal open={modal === "newJob" || modal === "editJob"} onClose={() => setModal(null)} wide>
        <JobForm title={modal === "newJob" ? "New Job" : "Edit Job"} initial={modal === "editJob" ? selected : emptyJob} customers={customers} epcPartners={epcPartners}
          onSave={f => {
            if (modal === "newJob") {
              const createdAt = new Date().toISOString().slice(0, 10);
              const sunJobId = genSunJobId(jobs, createdAt);
              saveItem("jobs", setJobs, { ...f, id: newId(), createdAt, sunJobId }, true);
            } else {
              saveItem("jobs", setJobs, { ...f, _dbId: selected._dbId }, false);
            }
          }}
          onCancel={() => setModal(modal === "editJob" ? "viewJob" : null)} />
      </Modal>
      <Modal open={modal === "viewJob"} onClose={() => { setModal(null); setSelected(null); }} wide>{viewJob}</Modal>

      <Modal open={modal === "newCustomer" || modal === "editCustomer"} onClose={() => setModal(null)}>
        <CustomerForm title={modal === "newCustomer" ? "New Customer" : "Edit Customer"} initial={modal === "editCustomer" ? selected : emptyCustomer} epcPartners={epcPartners}
          onSave={async f => {
            if (modal === "newCustomer") {
              saveItem("customers", setCustomers, { ...f, id: newId(), suntrifyId: genSuntrifyId(customers), createdAt: new Date().toISOString().split("T")[0] }, true);
            } else {
              const oldName = selected.name;
              const newName = f.name;
              saveItem("customers", setCustomers, { ...f, _dbId: selected._dbId }, false);
              if (oldName && newName && oldName !== newName) {
                const epcId = selected.epcPartnerId;
                const affectedWOs = workOrders.filter(w => w.customerName === oldName && w.epcPartnerId && w.epcPartnerId === epcId);
                for (const w of affectedWOs) {
                  saveItem("work_orders", setWorkOrders, { ...w, customerName: newName }, false);
                }
                const affectedJobs = jobs.filter(j => j.customerName === oldName && j.epcPartnerId && j.epcPartnerId === epcId);
                for (const j of affectedJobs) {
                  saveItem("jobs", setJobs, { ...j, customerName: newName }, false);
                }
              }
            }
          }}
          onCancel={() => setModal(modal === "editCustomer" ? "viewCustomer" : null)} />
      </Modal>
      <Modal open={modal === "viewCustomer"} onClose={() => { setModal(null); setSelected(null); }}>
        {selected && modal === "viewCustomer" && (()=>{
          const custJobs = jobs.filter(j => j.customerName === selected.name);
          const custWOs = workOrders.filter(w => w.customerName === selected.name);
          const totalContract = custJobs.reduce((s,j)=>s+(j.contractValue||0),0);
          const totalPaid = custJobs.reduce((s,j)=>s+(j.paid||0),0);
          const stageColors = {"Lead":"#6b7280","Site Survey":"#8b5cf6","Permit Submitted":"#f59e0b","Permit Approved":"#3b82f6","Installation":"#f0a500","Final Inspection":"#ec4899","PTO Submitted":"#06b6d4","Closed":"#22c55e","Cancelled":"#ef4444"};
          return (
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
              <div>
                <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, margin:0 }}>{selected.name}</h2>
                {selected.suntrifyId&&<span style={{background:"#f0a50022",color:"#d4891f",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{selected.suntrifyId}</span>}
              </div>
              <div style={{textAlign:"right",fontSize:12,color:"#9aa0b4"}}>
                {custJobs.length} job{custJobs.length!==1?"s":""} · {custWOs.length} WO{custWOs.length!==1?"s":""}
              </div>
            </div>

            <div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px 12px",marginBottom:12,fontSize:12}}>
              <AddressLink address={[selected.address,selected.city,selected.state,selected.zip].filter(Boolean).join(", ")} style={{color:"#6a7080",marginBottom:4,display:"block"}}>📍 {selected.address}{selected.city?", "+selected.city:""}{selected.state?", "+selected.state:""}{selected.zip?" "+selected.zip:""}</AddressLink>
              {selected.phone&&<div style={{marginBottom:2}}>📞 {selected.phone}</div>}
              {selected.email&&<div style={{marginBottom:2}}>✉️ {selected.email}</div>}
              {selected.epcPartnerName&&<div>🤝 {selected.epcPartnerName}</div>}
            </div>

            {totalContract>0&&<div style={{marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:4}}>
                <span style={{color:"#22c55e",fontWeight:700}}>${totalPaid.toLocaleString()} paid</span>
                <span style={{color:"#9aa0b4"}}>${totalContract.toLocaleString()} total</span>
                <span style={{color:totalContract-totalPaid>0?"#ef4444":"#22c55e",fontWeight:700}}>${(totalContract-totalPaid).toLocaleString()} owed</span>
              </div>
              <div style={{height:6,background:"#f0f1f5",borderRadius:3}}>
                <div style={{height:"100%",width:Math.min(100,Math.round(totalPaid/totalContract*100))+"%",background:"#22c55e",borderRadius:3}}/>
              </div>
            </div>}

            {custJobs.length>0&&<div style={{marginBottom:14}}>
              <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>Jobs ({custJobs.length})</div>
              {custJobs.map(j=>(
                <div key={j._dbId} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:"#fff",border:"1px solid #e0e3eb",borderRadius:8,marginBottom:4}}>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:"#1a1d25"}}>{j.address||"No address"}</div>
                    <div style={{fontSize:11,color:"#9aa0b4"}}>{(j.jobTypes||[]).join(" · ")||"General"}{j.estimatedKw>0?" · ~"+j.estimatedKw+"kW":""}{j.proposalAmount>0?" · $"+Number(j.proposalAmount).toLocaleString():""}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <span style={{background:(stageColors[j.stage]||"#6b7280")+"22",color:stageColors[j.stage]||"#6b7280",border:"1px solid "+(stageColors[j.stage]||"#6b7280")+"44",borderRadius:10,padding:"2px 8px",fontSize:10,fontWeight:700}}>{j.stage}</span>
                    {j.contractValue>0&&<div style={{fontSize:10,color:"#9aa0b4",marginTop:2}}>${j.contractValue.toLocaleString()}</div>}
                  </div>
                </div>
              ))}
            </div>}

            {custWOs.length>0&&<div style={{marginBottom:14}}>
              <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>Work Orders ({custWOs.length})</div>
              {custWOs.sort((a,b)=>b.date?.localeCompare(a.date||"")||0).map(w=>(
                <div key={w._dbId} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:"#fff",border:"1px solid #e0e3eb",borderRadius:8,marginBottom:4}}>
                  <div>
                    <div style={{fontSize:11,color:"#d4891f",fontWeight:700}}>{w.woId}</div>
                    <div style={{fontSize:11,color:"#9aa0b4"}}>{(w.types||[]).slice(0,2).join(", ")} · {w.date}</div>
                  </div>
                  <span style={{background:w.status==="Complete"?"#22c55e22":w.status==="In Progress"?"#f59e0b22":"#3b82f622",color:w.status==="Complete"?"#22c55e":w.status==="In Progress"?"#f59e0b":"#3b82f6",borderRadius:10,padding:"2px 8px",fontSize:10,fontWeight:700}}>{w.status}</span>
                </div>
              ))}
            </div>}

            {selected.notes&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px",color:"#6a7080",fontSize:12,marginBottom:12}}>{selected.notes}</div>}
            <div style={{ display: "flex", gap: 8 }}>
              <Btn onClick={() => setModal("editCustomer")} style={{ flex: 1 }}>✏️ Edit</Btn>
              <Btn onClick={() => deleteItem("customers", setCustomers, selected)} variant="danger">🗑</Btn>
              <Btn onClick={() => { setModal(null); setSelected(null); }} variant="ghost">✕</Btn>
            </div>
          </div>
          );
        })()}
      </Modal>

      <Modal open={modal === "editSuntrifyInfo"} onClose={() => { setModal(null); setSelected(null); }}>
        {modal === "editSuntrifyInfo" && (
          <SuntrifyInfoForm
            initial={suntrifyInfo}
            onSave={async form => {
              const existing = await dbLoad("company_info");
              const record = existing && existing.length > 0
                ? {...form, _dbId: existing[0]._dbId}
                : {...form, id: newId()};
              await dbSave("company_info", record);
              setSuntrifyInfo(form);
              setModal(null); setSelected(null);
            }}
            onCancel={() => { setModal(null); setSelected(null); }}
          />
        )}
      </Modal>
      <Modal open={modal === "newEPC" || modal === "editEPC"} onClose={() => setModal(null)}>
        <EPCForm title={modal === "newEPC" ? "New EPC Partner" : "Edit EPC Partner"} initial={modal === "editEPC" ? selected : emptyEPC}
          onSave={f => saveItem("epc_partners", setEpcPartners, modal === "newEPC" ? { ...f, id: newId() } : { ...f, _dbId: selected._dbId }, modal === "newEPC")}
          onCancel={() => setModal(modal === "editEPC" ? "viewEPC" : null)} />
      </Modal>
      <Modal open={modal === "viewEPC"} onClose={() => { setModal(null); setSelected(null); }}>
        {selected && modal === "viewEPC" && (
          <div>
            <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, marginBottom: 4 }}>{selected.company || selected.name}</h2>
            {selected.company && <div style={{ fontSize: 13, color: "#6a7080", marginBottom: 12 }}>{selected.name}</div>}
            {selected.phone && <div style={{ fontSize: 13, marginBottom: 4 }}>📞 {selected.phone}</div>}
            {selected.email && <div style={{ fontSize: 13, marginBottom: 4 }}>✉️ {selected.email}</div>}
            {(selected.licenseNumber || selected.licenseClass) && (
              <div style={{marginBottom:10}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:4}}>
                  {selected.licenseNumber && <span style={{fontSize:13,fontFamily:"monospace",color:"#6a7080"}}>CSLB #{selected.licenseNumber}</span>}
                  {selected.licenseStatus && <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:4,background:selected.licenseStatus==="Active"?"#dcfce7":"#fee2e2",color:selected.licenseStatus==="Active"?"#16a34a":"#dc2626"}}>{selected.licenseStatus}</span>}
                  {selected.licenseExpiration && <span style={{fontSize:11,color:"#9aa0b4"}}>Exp {selected.licenseExpiration}</span>}
                </div>
                {selected.licenseClass && (
                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                    {selected.licenseClass.split(",").map(c=>c.trim()).filter(Boolean).map(code=>(
                      <span key={code} style={{background:"#1d4ed8",color:"#fff",borderRadius:4,padding:"2px 9px",fontSize:11,fontWeight:700}}>{code}</span>
                    ))}
                  </div>
                )}
              </div>
            )}
            {selected.serviceArea && <div style={{ fontSize: 13, marginBottom: 12 }}>📍 {selected.serviceArea}</div>}
            {selected.notes && <div style={{ background: "#f9f9fb", border: "1px solid #e0e3eb", borderRadius: 8, padding: "10px", color: "#6a7080", fontSize: 12, marginBottom: 14 }}>{selected.notes}</div>}
            <div style={{ display: "flex", gap: 8 }}>
              <Btn onClick={() => setModal("editEPC")} style={{ flex: 1 }}>✏️ Edit</Btn>
              <Btn onClick={() => deleteItem("epc_partners", setEpcPartners, selected)} variant="danger">🗑</Btn>
              <Btn onClick={() => { setModal(null); setSelected(null); }} variant="ghost">✕</Btn>
            </div>
          </div>
        )}
      </Modal>

      <Modal open={modal === "newSub" || modal === "editSub"} onClose={() => setModal(null)}>
        <SubcontractorForm title={modal === "newSub" ? "New Subcontractor" : "Edit Subcontractor"} initial={modal === "editSub" ? selected : emptySub}
          onSave={f => saveItem("subcontractors", setSubcontractors, modal === "newSub" ? { ...f, id: newId() } : { ...f, _dbId: selected._dbId }, modal === "newSub")}
          onCancel={() => setModal(modal === "editSub" ? "viewSub" : null)} />
      </Modal>
      <Modal open={modal === "viewSub"} onClose={() => { setModal(null); setSelected(null); }}>
        {selected && modal === "viewSub" && (
          <div>
            <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 18, marginBottom: 4 }}>{selected.name}</h2>
            {selected.company && <div style={{ fontSize: 13, color: "#6a7080", marginBottom: 8 }}>{selected.company}</div>}
            {selected.phone && <div style={{ fontSize: 13, marginBottom: 4, color:"#6a7080" }}>{selected.phone}</div>}
            {selected.email && <div style={{ fontSize: 13, marginBottom: 4, color:"#6a7080" }}>{selected.email}</div>}
            {(selected.address || selected.city) && (
              <div style={{ fontSize: 13, marginBottom: 8, color:"#6a7080" }}>
                {[selected.address, selected.city, selected.state, selected.zip].filter(Boolean).join(", ")}
              </div>
            )}
            {(selected.licenseNumber || selected.licenseClass) && (
              <div style={{marginBottom:10}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:4}}>
                  {selected.licenseNumber && <span style={{fontSize:13,fontFamily:"monospace",color:"#6a7080"}}>CSLB #{selected.licenseNumber}</span>}
                  {selected.licenseStatus && <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:4,background:selected.licenseStatus==="Active"?"#dcfce7":"#fee2e2",color:selected.licenseStatus==="Active"?"#16a34a":"#dc2626"}}>{selected.licenseStatus}</span>}
                  {selected.licenseExpiration && <span style={{fontSize:11,color:"#9aa0b4"}}>Exp {selected.licenseExpiration}</span>}
                </div>
                {selected.licenseClass && (
                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                    {selected.licenseClass.split(",").map(c=>c.trim()).filter(Boolean).map(code=>(
                      <span key={code} style={{background:"#1d4ed8",color:"#fff",borderRadius:4,padding:"2px 9px",fontSize:11,fontWeight:700}}>{code}</span>
                    ))}
                  </div>
                )}
              </div>
            )}
            {selected.notes && <div style={{ background: "#f9f9fb", border: "1px solid #e0e3eb", borderRadius: 8, padding: "10px", color: "#6a7080", fontSize: 12, marginBottom: 14 }}>{selected.notes}</div>}
            <div style={{ display: "flex", gap: 8 }}>
              <Btn onClick={() => setModal("editSub")} style={{ flex: 1 }}>✏️ Edit</Btn>
              <Btn onClick={() => deleteItem("subcontractors", setSubcontractors, selected)} variant="danger">🗑</Btn>
              <Btn onClick={() => { setModal(null); setSelected(null); }} variant="ghost">✕</Btn>
            </div>
          </div>
        )}
      </Modal>

      <Modal open={modal === "newWO" || modal === "editWO" || modal === "dupWO"} onClose={() => setModal(null)} wide>
        <WOForm title={modal === "newWO" ? "New Work Order" : modal === "dupWO" ? "Duplicate Work Order" : "Edit Work Order"} initial={modal === "editWO" ? selected : modal === "dupWO" ? selected : emptyWO} jobs={jobs} subcontractors={subcontractors}
          onSave={f => {
          const isNew = modal === "newWO" || modal === "dupWO";
          const reportToken = (isNew && !f.reportToken) ? (Date.now().toString(36) + Math.random().toString(36).slice(2,8)) : (f.reportToken || undefined);
          const item = isNew ? {...f, id: Date.now(), woId: genWOId(), reportToken} : {...f, _dbId: selected._dbId};
          saveItem("work_orders", setWorkOrders, item, isNew);
          if(isNew) { sendWOEmail(item, currentUser?.name, item.documents||[]); sendWOSMS(item); }
          if(item.notifySub && item.subcontractorEmail) {
            const subSubject = `Work Order Assignment — ${item.customerName || ""} — ${item.woId || ""}`;
            const reportUrl = item.reportToken ? "https://crm.suntrify.com?report=" + item.reportToken : null;
            const reportBtn = reportUrl ? '<a href="' + reportUrl + '" target="_blank" style="display:inline-block;background:#f0a500;color:#000;font-size:14px;font-weight:700;text-decoration:none;padding:14px 32px;border-radius:8px;margin-top:12px;">📷 Upload Field Report</a>' : "";
            const subHtml = buildWOEmailHTML({...item, crew: item.subcontractorName || item.crew}, currentUser?.name)
              .replace("</body></html>", "<div style='text-align:center;padding:0 0 28px;'>" + reportBtn + "</div></body></html>");
            const subBody = buildWOEmailBody({...item, crew: item.subcontractorName || item.crew}, currentUser?.name) + (reportUrl ? "\n\n📷 Upload Field Report:\n" + reportUrl : "");
            sendViaSES([item.subcontractorEmail, "jchacon@suntrify.com"], subSubject, subBody, subHtml)
              .then(() => alert("📧 WO + Report Link sent to " + item.subcontractorEmail))
              .catch(() => alert("⚠️ Failed to send email to " + item.subcontractorEmail));
          }
          if(item.jobId) {
            const linkedJob = jobs.find(j => String(j._dbId) === String(item.jobId));
            if(linkedJob) {
              const allJobWOs = isNew
                ? [...workOrders, item]
                : workOrders.map(w => w._dbId === item._dbId ? item : w);
              const woBC = allJobWOs
                .filter(w => (w.backCharge||w.billable) && w.chargeAmount > 0 && String(w.jobId) === String(item.jobId))
                .reduce((s,w) => s + (w.chargeAmount||0), 0);
              const updatedJob = {...linkedJob, contractValue: woBC};
              saveItem("jobs", setJobs, updatedJob, false);
            }
          }
        }}
          onCancel={() => setModal(modal === "editWO" ? "viewWO" : null)} customers={customers}/>
      </Modal>
      <Modal open={modal === "viewWO"} onClose={() => { setModal(null); setSelected(null); }} wide>
        {selected && modal === "viewWO" && <div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <div><div style={{display:"flex",alignItems:"center",gap:8}}><h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:18,margin:0}}>{selected.customerName}</h2>{selected.woId&&<span style={{fontSize:11,color:"#9aa0b4",fontWeight:700}}>{selected.woId}</span>}</div><AddressLink address={selected.address} style={{fontSize:13,color:"#6a7080"}}/></div>
            <span style={{background:selected.status==="Complete"?"#22c55e22":"#f0a50022",color:selected.status==="Complete"?"#22c55e":"#f0a500",border:"1px solid",borderColor:selected.status==="Complete"?"#22c55e44":"#f0a50044",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{selected.status}</span>
          </div>
          <div style={{fontSize:13,color:"#6a7080",marginBottom:12,display:"flex",alignItems:"center",gap:6}}><Icon name="calendar" size={13} color="#9aa0b4"/> {selected.date} at {selected.time}</div>
          {(selected.types||[]).length>0&&<div style={{marginBottom:12}}><div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",marginBottom:6}}>Work Types</div><div style={{display:"flex",flexWrap:"wrap",gap:4}}>{(selected.types||[]).map(t=><span key={t} style={{background:"#f0a50022",color:"#d4891f",border:"1px solid #f0a50044",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{t}</span>)}</div></div>}
          {selected.reportToken&&(()=>{
            const reportUrl = `https://crm.suntrify.com?report=${selected.reportToken}`;
            return (
              <div style={{background:"#f0a50010",border:"1px solid #f0a50033",borderRadius:8,padding:"10px 12px",marginBottom:12,display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontSize:11,fontWeight:700,color:"#d4891f"}}>📷 Field Report Link</span>
                <span style={{fontSize:11,color:"#6a7080",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{reportUrl}</span>
                <button onClick={()=>{navigator.clipboard.writeText(reportUrl);alert("✅ Report link copied!");}} style={{background:"#f0a500",border:"none",borderRadius:6,padding:"5px 12px",fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>Copy Link</button>
                <button onClick={async()=>{
                  const rUrl = reportUrl;
                  const sub = selected.subcontractorName || selected.crew || "Team";
                  const subEmail = selected.subcontractorEmail;
                  if (!subEmail) { alert("No sub email on this WO"); return; }
                  const body = `Hi ${sub},\n\nHere is your field report link for ${selected.customerName} (${selected.woId}):\n\n${rUrl}\n\nPlease upload all required photos when you arrive on site.\n\nThank you,\nSuntrify Inc.`;
                  await sendViaSES([subEmail,"jchacon@suntrify.com"], `Field Report — ${selected.customerName} — ${selected.woId}`, body);
                  alert("📧 Report link resent!");
                }} style={{background:"transparent",border:"1px solid #f0a500",borderRadius:6,padding:"5px 12px",fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"inherit",color:"#d4891f",whiteSpace:"nowrap"}}>Resend Email</button>
              </div>
            );
          })()}
          {selected.crew&&<div style={{fontSize:13,color:"#6a7080",marginBottom:8,display:"flex",alignItems:"center",gap:6}}><Icon name="users" size={13} color="#9aa0b4"/> {selected.crew}</div>}
          {(selected.billable||selected.backCharge)&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"12px",marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700}}>Billing</div>
                {selected.billable&&<span style={{background:"#22c55e22",color:"#22c55e",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>Billable</span>}
                {selected.backCharge&&<span style={{background:"#ef444422",color:"#ef4444",borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>Back Charge: {selected.epcPartnerName}</span>}
              </div>
              <span style={{fontWeight:700,fontSize:16,color:"#d4891f"}}>${(selected.chargeAmount||0).toLocaleString()}</span>
            </div>
            {Object.keys(selected.woAdders||{}).length>0&&<div style={{marginBottom:6}}>
              <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,marginBottom:4}}>Adders</div>
              {Object.entries(selected.woAdders||{}).map(([k,v])=>{
                const ad=ESP_ADDERS.find(x=>x.label===k);
                if(!ad||!v) return null;
                const amt=ad.type==="flat"?ad.rate:ad.rate*Number(v);
                return <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"3px 0",borderBottom:"1px solid #f0f1f5"}}>
                  <span style={{color:"#1a1d25"}}>{k}{ad.unit!=="Per Project"?<span style={{color:"#9aa0b4"}}> × {v}</span>:""}</span>
                  <span style={{fontWeight:700,color:"#1a1d25"}}>${amt.toLocaleString()}</span>
                </div>;
              })}
            </div>}
            {Object.keys(selected.woBattery||{}).length>0&&<div style={{marginBottom:6}}>
              <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,marginBottom:4}}>Battery</div>
              {Object.entries(selected.woBattery||{}).map(([k])=>{
                const bat=ESP_BATTERY.find(x=>x.label===k);
                if(!bat) return null;
                return <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"3px 0",borderBottom:"1px solid #f0f1f5"}}>
                  <span style={{color:"#1a1d25"}}>{k}</span>
                  <span style={{fontWeight:700,color:"#1a1d25"}}>${bat.rate.toLocaleString()}</span>
                </div>;
              })}
            </div>}
            {(selected.woMiscLines||[]).length>0&&<div style={{marginBottom:6}}>
              <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700,marginBottom:4}}>Misc / Other</div>
              {(selected.woMiscLines||[]).map((l,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"3px 0",borderBottom:"1px solid #f0f1f5"}}>
                  <span style={{color:"#1a1d25"}}>{l.type||"Item"} <span style={{color:"#9aa0b4"}}>× {l.qty} @ ${(l.unitPrice||0).toLocaleString()}</span></span>
                  <span style={{fontWeight:700,color:"#1a1d25"}}>${(l.total||0).toLocaleString()}</span>
                </div>
              ))}
            </div>}
            {selected.chargeNotes&&<div style={{fontSize:12,color:"#6a7080",marginTop:6,fontStyle:"italic",display:"flex",alignItems:"flex-start",gap:5}}><Icon name="file-text" size={12} color="#9aa0b4" style={{marginTop:1,flexShrink:0}}/> {selected.chargeNotes}</div>}
          </div>}
          {/* System detail panels */}
          {(selected.panels>0||selected.inverter||selected.kw>0)&&(
            <div style={{background:"#fff7ed",border:"1px solid #f0a50033",borderRadius:8,padding:"12px",marginBottom:10}}>
              <div style={{fontSize:10,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}><Icon name="sun" size={11} color="#d4891f"/> PV System</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
                {selected.panels>0&&<div><span style={{color:"#9aa0b4"}}>Panels: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.panels}</span></div>}
                {selected.kw>0&&<div><span style={{color:"#9aa0b4"}}>System: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.kw} kW</span></div>}
                {selected.panelWatts>0&&<div><span style={{color:"#9aa0b4"}}>Module: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.panelWatts}W</span></div>}
                {selected.inverter&&<div><span style={{color:"#9aa0b4"}}>Inverter: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.inverter}</span></div>}
                {selected.racking&&<div><span style={{color:"#9aa0b4"}}>Racking: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.racking}</span></div>}
                {selected.roofType&&<div><span style={{color:"#9aa0b4"}}>Roof: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.roofType}</span></div>}
              </div>
            </div>
          )}
          {(selected.batteryType||selected.batteryQty>0)&&(
            <div style={{background:"#eff6ff",border:"1px solid #3b82f633",borderRadius:8,padding:"12px",marginBottom:10}}>
              <div style={{fontSize:10,fontWeight:700,color:"#3b82f6",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}><Icon name="battery" size={11} color="#3b82f6"/> Battery</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
                {selected.batteryType&&<div><span style={{color:"#9aa0b4"}}>Type: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.batteryType}</span></div>}
                {selected.batteryQty>0&&<div><span style={{color:"#9aa0b4"}}>Qty: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.batteryQty}</span></div>}
              </div>
            </div>
          )}
          {(selected.inspectionResult&&selected.inspectionResult!=="-- Select --")&&(
            <div style={{background:selected.inspectionResult==="Passed"?"#f0fdf4":selected.inspectionResult==="Failed"?"#fef2f2":"#fffbeb",border:"1px solid "+(selected.inspectionResult==="Passed"?"#22c55e33":selected.inspectionResult==="Failed"?"#ef444433":"#f59e0b33"),borderRadius:8,padding:"12px",marginBottom:10}}>
              <div style={{fontSize:10,fontWeight:700,color:selected.inspectionResult==="Passed"?"#22c55e":selected.inspectionResult==="Failed"?"#ef4444":"#f59e0b",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}><Icon name="search" size={11} color={selected.inspectionResult==="Passed"?"#22c55e":selected.inspectionResult==="Failed"?"#ef4444":"#f59e0b"}/> Inspection</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,marginBottom:8}}>
                <div><span style={{color:"#9aa0b4"}}>Result: </span>
                  <span style={{fontWeight:700,color:selected.inspectionResult==="Passed"?"#22c55e":selected.inspectionResult==="Failed"?"#ef4444":"#f59e0b"}}>{selected.inspectionResult}</span>
                </div>
                {selected.lathInspection&&<div><span style={{color:"#9aa0b4"}}>Lath: </span><span style={{fontWeight:600,color:"#1a1d25"}}>{selected.lathResult||"Required"}</span></div>}
                {selected.lathNotes&&<div style={{gridColumn:"span 2"}}><span style={{color:"#9aa0b4"}}>Lath Notes: </span><span style={{color:"#1a1d25"}}>{selected.lathNotes}</span></div>}
              </div>
              {(selected.inspectionResult==="Failed"||selected.inspectionResult==="Corrections Required")&&(
                <FileUpload
                  folder={`workorders/${selected.woId||selected._dbId}/corrections`}
                  existingFiles={selected.correctionPhotos||[]}
                  onFilesChange={urls=>{const updated={...selected,correctionPhotos:urls};setSelected(updated);saveItem("work_orders",setWorkOrders,updated,false);}}
                />
              )}
            </div>
          )}
          {selected.startedAt&&<div style={{fontSize:11,color:"#9aa0b4",marginBottom:6,display:"flex",alignItems:"center",gap:5}}><Icon name="play" size={11} color="#9aa0b4"/> Started: {selected.startedAt}</div>}
          {selected.completedDate&&<div style={{fontSize:11,color:"#22c55e",marginBottom:6,display:"flex",alignItems:"center",gap:5}}><Icon name="check-circle" size={11} color="#22c55e"/> Completed: {selected.completedDate}</div>}
          {(selected.types||[]).some(t=>SALES_TYPES.includes(t))&&(selected.salesStage||selected.salesInterest||selected.leadSource||selected.followUpDate||selected.salesNotes||selected.proposalAmount)&&(
            <div style={{background:"#f5f3ff",border:"1px solid #8b5cf633",borderRadius:8,padding:"12px",marginBottom:10}}>
              <div style={{fontSize:10,fontWeight:700,color:"#8b5cf6",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}><Icon name="briefcase" size={11} color="#8b5cf6"/> Sales Details</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,marginBottom:6}}>
                {selected.salesStage&&<div><span style={{color:"#9aa0b4"}}>Stage: </span><span style={{fontWeight:700,color:"#8b5cf6"}}>{selected.salesStage}</span></div>}
                {selected.leadSource&&<div><span style={{color:"#9aa0b4"}}>Source: </span><span style={{fontWeight:600}}>{selected.leadSource}</span></div>}
                {selected.salesInterest&&<div><span style={{color:"#9aa0b4"}}>Interest: </span><span style={{fontWeight:600}}>{selected.salesInterest}</span></div>}
                {selected.followUpDate&&<div><span style={{color:"#9aa0b4"}}>Follow-up: </span><span style={{fontWeight:600,color:"#8b5cf6"}}>{selected.followUpDate}</span></div>}
                {selected.proposalAmount&&<div><span style={{color:"#9aa0b4"}}>Proposal: </span><span style={{fontWeight:600,color:"#22c55e"}}>${Number(selected.proposalAmount).toLocaleString()}</span></div>}
              </div>
              {selected.salesNotes&&<div style={{fontSize:12,color:"#6a7080",fontStyle:"italic",display:"flex",alignItems:"flex-start",gap:5}}><Icon name="file-text" size={12} color="#9aa0b4" style={{marginTop:1,flexShrink:0}}/> {selected.salesNotes}</div>}
            </div>
          )}
          {(selected.types||[]).some(t=>DESIGN_TYPES.includes(t))&&(selected.designStatus||selected.ahj||selected.permitNumber||selected.permitStatus||selected.interconnectStatus||selected.hoaStatus||selected.designNotes||selected.planSetVersion)&&(
            <div style={{background:"#f0fdf4",border:"1px solid #16a34a33",borderRadius:8,padding:"12px",marginBottom:10}}>
              <div style={{fontSize:10,fontWeight:700,color:"#16a34a",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}><Icon name="compass" size={11} color="#16a34a"/> Design & Engineering</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,marginBottom:6}}>
                {selected.designStatus&&<div><span style={{color:"#9aa0b4"}}>Status: </span><span style={{fontWeight:700,color:"#16a34a"}}>{selected.designStatus}</span></div>}
                {selected.planSetVersion&&<div><span style={{color:"#9aa0b4"}}>Plan Set: </span><span style={{fontWeight:600}}>{selected.planSetVersion}</span></div>}
                {selected.ahj&&<div><span style={{color:"#9aa0b4"}}>AHJ: </span><span style={{fontWeight:600}}>{selected.ahj}</span></div>}
                {selected.permitNumber&&<div><span style={{color:"#9aa0b4"}}>Permit #: </span><span style={{fontWeight:600}}>{selected.permitNumber}</span></div>}
                {selected.permitStatus&&<div><span style={{color:"#9aa0b4"}}>Permit: </span><span style={{fontWeight:600,color:selected.permitStatus==="Approved"||selected.permitStatus==="Permit Issued"?"#16a34a":selected.permitStatus==="Corrections Required"?"#ef4444":"#6a7080"}}>{selected.permitStatus}</span></div>}
                {selected.permitSubmitDate&&<div><span style={{color:"#9aa0b4"}}>Submitted: </span><span style={{fontWeight:600}}>{selected.permitSubmitDate}</span></div>}
                {selected.permitApprovalDate&&<div><span style={{color:"#9aa0b4"}}>Approved: </span><span style={{fontWeight:600,color:"#16a34a"}}>{selected.permitApprovalDate}</span></div>}
                {selected.interconnectStatus&&<div><span style={{color:"#9aa0b4"}}>Interconnect: </span><span style={{fontWeight:600,color:selected.interconnectStatus==="Approved"?"#16a34a":selected.interconnectStatus==="Rejected"?"#ef4444":"#6a7080"}}>{selected.interconnectStatus}</span></div>}
                {selected.hoaRequired&&<div><span style={{color:"#9aa0b4"}}>HOA: </span><span style={{fontWeight:600}}>{selected.hoaStatus||"Required"}</span></div>}
                {selected.structuralRequired&&<div><span style={{color:"#9aa0b4"}}>Structural Eng: </span><span style={{fontWeight:600,color:"#f59e0b"}}>Required</span></div>}
              </div>
              {selected.designNotes&&<div style={{fontSize:12,color:"#6a7080",fontStyle:"italic",display:"flex",alignItems:"flex-start",gap:5}}><Icon name="file-text" size={12} color="#9aa0b4" style={{marginTop:1,flexShrink:0}}/> {selected.designNotes}</div>}
            </div>
          )}
          {selected.notes&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px 12px",color:"#6a7080",fontSize:12,marginBottom:14}}>{selected.notes}</div>}
          {selected.companyCamUrl&&<div style={{marginBottom:8}}><a href={selected.companyCamUrl} target="_blank" rel="noopener noreferrer" style={{display:"inline-flex",alignItems:"center",gap:6,background:"#fff7ed",border:"1px solid #f97316",borderRadius:7,padding:"7px 14px",color:"#f97316",fontWeight:700,fontSize:12,textDecoration:"none"}}>📸 View CompanyCam Photos</a></div>}
          {(selected.documents||[]).length>0&&<div style={{marginBottom:10}}>
            <div style={{fontSize:10,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:6}}>Plan Set</div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {(selected.documents||[]).map((url,i)=>{
                const name=decodeURIComponent((url.split('?')[0]).split('/').pop().replace(/^\d+-/,'')).replace(/_/g,' ');
                return <span key={i} onClick={async()=>{try{const v=await getViewUrl(url);window.open(v,"_blank");}catch{window.open(url,"_blank");}}} style={{display:"inline-flex",alignItems:"center",gap:6,color:"#1d4ed8",fontSize:12,fontWeight:600,cursor:"pointer",padding:"5px 10px",background:"#eff6ff",borderRadius:6,border:"1px solid #bfdbfe"}}>📄 {name}</span>;
              })}
            </div>
          </div>}
          <FileUpload
            folder={`workorders/${selected.woId||selected._dbId}`}
            existingFiles={selected.documents||[]}
            onFilesChange={urls=>{const updated={...selected,documents:urls};setSelected(updated);saveItem("work_orders",setWorkOrders,updated,false);}}
          />
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            <div style={{display:"flex",gap:8}}>
              <Btn onClick={()=>setModal("editWO")} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}><Icon name="pencil" size={13} color="#000"/> Edit</Btn>
              <Btn onClick={()=>setWoReportWO(selected)} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}><Icon name="clipboard" size={13} color="#000"/> Report</Btn>
              <Btn onClick={async()=>{if(window.confirm("Resend the WO notification email for this work order?")){await sendWOEmail(selected,currentUser?.name,selected.documents||[]);alert("Email resent!");}}} variant="ghost" style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}><Icon name="mail" size={13} color="#6a7080"/> Resend Email</Btn>
              <Btn onClick={()=>{setSelected({...selected,_dbId:undefined,id:Date.now(),woId:genWOId(),date:"",status:"Scheduled"});setModal("dupWO");}} variant="ghost" style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}><Icon name="copy" size={13} color="#6a7080"/> Duplicate</Btn>
            </div>
            <div style={{display:"flex",gap:8}}>
              <Btn
                onClick={async()=>{
                  const flow = {"Scheduled":"In Progress","In Progress":"Complete"};
                  const nextStatus = flow[selected.status];
                  if(!nextStatus) return;
                  const ts = new Date().toISOString().slice(0,16).replace("T"," ");
                  const updatedWO = {
                    ...selected,
                    status: nextStatus,
                    ...(nextStatus==="In Progress" ? {startedAt: ts} : {}),
                    ...(nextStatus==="Complete" ? {completedDate: new Date().toISOString().slice(0,10)} : {}),
                  };
                  saveItem("work_orders", setWorkOrders, updatedWO, false);
                  setSelected(updatedWO);
                  // Auto-generate invoice when completing a back-charge WO
                  if(nextStatus==="Complete" && (updatedWO.backCharge||updatedWO.billable) && updatedWO.chargeAmount>0) {
                    const alreadyInvoiced = invoices.some(inv=>(inv.selectedWOs||[]).some(id=>String(id)===String(updatedWO._dbId||updatedWO.id)));
                    if(!alreadyInvoiced) {
                      const epcPartner = epcPartners.find(p=>(p.company||p.name)===updatedWO.epcPartnerName);
                      const invNums = invoices.map(i=>parseInt(i.invNumber)||0);
                      const nextNum = invNums.length ? String(Math.max(...invNums)+1) : "2329";
                      const newInv = { id:Date.now(), invNumber:nextNum, date:updatedWO.completedDate, epcPartnerId:epcPartner?String(epcPartner._dbId||epcPartner.id):"", epcPartnerName:updatedWO.epcPartnerName||"", epcPartnerInfo:epcPartner||{}, terms:"Net 30", selectedWOs:[updatedWO._dbId||updatedWO.id], woData:[updatedWO], total:updatedWO.chargeAmount||0, notes:"", status:"Unpaid", payments:[] };
                      try {
                        const saved = await dbSave("invoices", newInv);
                        setInvoices(prev=>[...prev, saved]);
                        alert("✅ WO marked complete & Invoice #"+nextNum+" created automatically!");
                      } catch(e) {
                        setInvoices(prev=>[...prev, newInv]);
                        alert("✅ WO marked complete & Invoice #"+nextNum+" created (sync error — will appear on next refresh)");
                      }
                    }
                  }
                }}
                variant="warning"
                style={{flex:1,display:selected.status==="In Progress"?"flex":"none"}}
              >
                <span style={{display:"flex",alignItems:"center",gap:6}}><Icon name="check-circle" size={13} color="#000"/> Complete</span>
              </Btn>
              <Btn onClick={()=>{
                if(selected.status === "Cancelled") return alert("This WO is already cancelled.");
                const reason = window.prompt("Cancellation reason (optional):");
                if(reason === null) return;
                const cancelledWO = {...selected, status: "Cancelled"};
                saveItem("work_orders", setWorkOrders, cancelledWO, false);
                sendCancelEmail(cancelledWO, currentUser?.name, reason);
              }} variant="ghost" style={{flex:1,borderColor:"#ef444450",color:"#ef4444"}}>Cancel WO</Btn>
              <Btn onClick={()=>deleteItem("work_orders",setWorkOrders,selected)} variant="danger">🗑</Btn>
              <Btn onClick={()=>{setModal(null);setSelected(null);}} variant="ghost">✕</Btn>
            </div>
          </div>
        </div>}
      </Modal>
      {showManageUsers && (
        <Modal open={true} onClose={() => setShowManageUsers(false)}>
          <ManageUsers onClose={() => setShowManageUsers(false)} />
        </Modal>
      )}
    </div>
  );
}

// ─── Manage Users ─────────────────────────────────────────────────────────
function ManageUsers({ onClose }) {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", name: "", role: "Team Member" });
  const [msg, setMsg] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(true);

  useEffect(() => {
    dbLoadUsers().then(dbUsers => {
      setUsers(dbUsers);
      setLoadingUsers(false);
    }).catch(() => {
      setUsers(loadUsers());
      setLoadingUsers(false);
    });
  }, []);

  const addUser = async () => {
    if (!form.username || !form.password || !form.name) { setMsg("Fill all fields"); return; }
    if (users.find(u => u.username.toLowerCase() === form.username.toLowerCase())) { setMsg("Username already taken"); return; }
    setMsg("Saving…");
    const saved = await dbSaveUser(form);
    const updated = [...users, saved];
    setUsers(updated);
    saveUsers(updated.map(({_dbId,...u})=>u)); // keep localStorage in sync (strip _dbId)
    setForm({ username: "", password: "", name: "", role: "Team Member" });
    setMsg("User added!");
    setTimeout(() => setMsg(""), 2500);
  };

  const removeUser = async (u) => {
    await dbRemoveUser(u);
    const updated = users.filter(x => x.username !== u.username);
    setUsers(updated);
    saveUsers(updated.map(({_dbId,...x})=>x));
  };

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16 }}>
        <Icon name="users" size={18} color="#d4891f"/>
        <h2 style={{ fontFamily: "'DM Serif Display',serif", color: "#d4891f", fontSize: 18, margin:0 }}>Manage Users</h2>
      </div>
      {loadingUsers
        ? <div style={{color:"#9aa0b4",fontSize:13,padding:"12px 0"}}>Loading users…</div>
        : users.map(u => (
          <div key={u.username} style={{ display: "flex", justifyContent: "space-between", alignItems:"center", background: "#f9f9fb", border: "1px solid #e0e3eb", borderRadius: 8, padding: "10px 13px", marginBottom: 8 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{u.name}</div>
              <div style={{ fontSize: 11, color: "#9aa0b4" }}>@{u.username} · {u.role}</div>
            </div>
            {u.username !== "jose" && <Btn small variant="danger" onClick={() => removeUser(u)}>Remove</Btn>}
          </div>
        ))
      }
      <div style={{ borderTop: "1px solid #e0e3eb", paddingTop: 14, marginTop: 8 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#9aa0b4", textTransform: "uppercase", marginBottom: 10 }}>Add New User</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
          <Inp label="Full Name" value={form.name} onChange={v => setForm(f => ({ ...f, name: v }))} />
          <Inp label="Username" value={form.username} onChange={v => setForm(f => ({ ...f, username: v.toLowerCase().replace(/\s/g,"") }))} />
          <Inp label="Password" value={form.password} onChange={v => setForm(f => ({ ...f, password: v }))} />
          <Sel label="Role" value={form.role} onChange={v => setForm(f => ({ ...f, role: v }))} options={["Team Member", "Admin", "View Only"]} />
        </div>
        {msg && <div style={{ fontSize: 12, color: msg.includes("!") ? "#22c55e" : msg === "Saving…" ? "#9aa0b4" : "#ef4444", marginBottom: 8 }}>{msg}</div>}
        <div style={{ display: "flex", gap: 8 }}>
          <Btn onClick={addUser} style={{ flex: 1 }}>Add User</Btn>
          <Btn onClick={onClose} variant="ghost" style={{ flex: 1 }}>Done</Btn>
        </div>
      </div>
    </div>
  );
}

// ─── Root ──────────────────────────────────────────────────────────────────

const emptyWO = { woId:"", jobId:"", customerName:"", phone:"", email:"", address:"", city:"", state:"", zip:"", epcPartnerName:"", date:"", time:"08:00", types:[], status:"Scheduled", crew:"", billable:false, backCharge:false, chargeAmount:0, chargeNotes:"", woAdders:{}, woBattery:{}, woMisc:0, woMiscLines:[], notes:"", photos:"", reportType:"", salesInterest:"", salesStage:"", leadSource:"", followUpDate:"", salesNotes:"", proposalAmount:"", extraEmails:"", designStatus:"", planSetVersion:"", ahj:"", permitNumber:"", permitStatus:"", permitSubmitDate:"", permitApprovalDate:"", interconnectStatus:"", hoaRequired:false, hoaStatus:"", structuralRequired:false, designNotes:"", companyCamUrl:"" };
function genWOId() { const n = Math.floor(Math.random()*90000)+10000; return "WO-"+n; }
function genSunJobId(existingJobs, createdAt) {
  const date = createdAt || new Date().toISOString().slice(0, 10);
  const [, month, day] = date.split("-");
  const prefix = `SUN${month}${day}`;
  const sameDay = (existingJobs || []).filter(j => (j.sunJobId || "").startsWith(prefix));
  return `${prefix}${String(sameDay.length + 1).padStart(2, "0")}`;
}

function WOForm({ initial, onSave, onCancel, title, jobs, customers, subcontractors=[] }) {
  const [f, setF] = useState({...emptyWO,...initial});
  const s = k => v => setF(x=>({...x,[k]:v}));
  const handleJob = id => {
    const j = jobs.find(x=>String(x._dbId)===String(id));
    if(j) {
      const cust = customers ? customers.find(c=>c.name===j.customerName) : null;
      setF(x=>({...x,
        jobId:id,
        customerName:j.customerName,
        address:j.address,
        epcPartnerName:j.epcPartnerName,
        phone: cust ? cust.phone||"" : "",
        email: cust ? cust.email||"" : "",
        city: cust ? cust.city||"" : "",
        state: cust ? cust.state||"" : "",
        zip: cust ? cust.zip||"" : "",
      }));
    } else setF(x=>({...x,jobId:id}));
  };
  const toggleType = t => setF(x => {
    const newTypes = x.types.includes(t) ? x.types.filter(v=>v!==t) : [...x.types,t];
    const hasSolar = newTypes.some(v=>["PV Install","Battery Install","Commissioning","Array Expansion","Solar Removal & Reinstall","Microinverter Swap","String Inverter Swap","Enphase IQ Gateway","Optimizer Install"].includes(v));
    const hasMPU = newTypes.some(v=>["Panel Upgrade (MPU)"].includes(v));
    const hasInspection = newTypes.some(v=>v.toLowerCase().includes("inspect"));
    const auto = hasSolar?"solar":hasMPU?"mpu":hasInspection?"inspection":"service";
    return {...x, types:newTypes, reportType: x.reportType||auto};
  });
  const [jobSearch, setJobSearch] = useState("");
  const [showJobList, setShowJobList] = useState(false);
  const filteredJobs = jobs.filter(j=>{
    if(!jobSearch) return true;
    const q = jobSearch.toLowerCase();
    return [j.customerName,j.address,j.city,j.epcPartnerName,j.epcCustomerId].join(" ").toLowerCase().includes(q);
  });
  return <div>
    <h2 style={{fontFamily:"'DM Serif Display',serif",color:"#d4891f",fontSize:18,marginBottom:18}}>{title}</h2>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Job *</div>
      <div style={{position:"relative"}}>
        <input
          value={(()=>{ if(!f.jobId) return jobSearch; const jj=jobs.find(j=>String(j._dbId)===String(f.jobId)); return jj?(jj.customerName+" · "+(jj.address||"")):jobSearch; })()}
          onChange={e=>{setJobSearch(e.target.value);setShowJobList(true);if(!e.target.value){setF(x=>({...x,jobId:"",customerName:"",address:"",epcPartnerName:"",phone:"",email:"",city:"",state:"",zip:""}));}}}
          onFocus={()=>setShowJobList(true)}
          placeholder="Search by customer, address, city, EPC..."
          style={{width:"100%",border:"1px solid #dde0ea",borderRadius:8,padding:"9px 12px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}
        />
        {f.jobId&&<button type="button" onClick={()=>{setF(x=>({...x,jobId:"",customerName:"",address:"",epcPartnerName:"",phone:"",email:"",city:"",state:"",zip:""}));setJobSearch("");setShowJobList(false);}} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"transparent",border:"none",color:"#9aa0b4",cursor:"pointer",fontSize:14}}>✕</button>}
        {showJobList&&!f.jobId&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1px solid #e0e3eb",borderRadius:8,boxShadow:"0 4px 16px rgba(0,0,0,0.1)",zIndex:100,maxHeight:220,overflowY:"auto",marginTop:2}}>
          {filteredJobs.length===0&&<div style={{padding:"12px",fontSize:12,color:"#9aa0b4",textAlign:"center"}}>No jobs found</div>}
          {filteredJobs.map(j=>(
            <div key={j._dbId} onClick={()=>{handleJob(String(j._dbId));setJobSearch("");setShowJobList(false);}}
              style={{padding:"10px 14px",cursor:"pointer",borderBottom:"1px solid #f0f1f5",fontSize:13}}
              onMouseEnter={e=>e.currentTarget.style.background="#f9f9fb"}
              onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
              <div style={{fontWeight:700,color:"#1a1d25"}}>{j.customerName}</div>
              <div style={{fontSize:11,color:"#9aa0b4",marginTop:2}}>{j.address}{j.city?", "+j.city:""} {j.epcPartnerName?"· "+j.epcPartnerName:""}{j.stage?"· "+j.stage:""}</div>
            </div>
          ))}
        </div>}
      </div>
    </div>
    {f.customerName&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px 12px",fontSize:12,color:"#6a7080",marginBottom:12}}><div style={{fontWeight:700,color:"#1a1d25",marginBottom:4}}>{f.customerName}</div>{f.address&&<div>📍 {f.address}{f.city?", "+f.city:""}{f.state?" "+f.state:""}{f.zip?" "+f.zip:""}</div>}{f.phone&&<div>📞 {f.phone}</div>}{f.email&&<div>✉️ {f.email}</div>}{f.epcPartnerName&&<div>🤝 {f.epcPartnerName}</div>}</div>}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
      <Inp label="Date *" value={f.date} onChange={s("date")} type="date"/>
      <Inp label="Time" value={f.time} onChange={s("time")} type="time"/>
    </div>
    <F label="Work Type (select all that apply)">
      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
        {WO_TYPE_CATEGORIES.map(cat=>(
        <div key={cat.label} style={{marginBottom:8}}>
          <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:4,display:"flex",alignItems:"center",gap:5}}><Icon name={cat.icon} size={12} color="#9aa0b4"/>{cat.label}</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {cat.types.map(t=><button key={t} onClick={()=>toggleType(t)} style={{background:f.types.includes(t)?"#f0a500":"transparent",border:"1px solid "+(f.types.includes(t)?"#f0a500":"#dde0ea"),borderRadius:6,padding:"5px 10px",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",color:f.types.includes(t)?"#000":"#6a7080",fontWeight:f.types.includes(t)?700:400}}>{t}</button>)}
          </div>
        </div>
      ))}
      </div>
    </F>
    {(f.types||[]).includes("Panel Upgrade (MPU)")&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>⚡ MPU Details</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
        <Sel label="Service Type" value={f.mpuServiceType||""} onChange={s("mpuServiceType")} options={["-- Select --",...MPU_SERVICE_TYPES]}/>
        <Sel label="Existing Service" value={f.mpuExisting||""} onChange={s("mpuExisting")} options={["-- Select --",...MPU_EXISTING]}/>
        <Sel label="New Service" value={f.mpuNew||""} onChange={s("mpuNew")} options={["-- Select --",...MPU_NEW]}/>
        <Sel label="Meter Spot Location" value={f.mpuMeterSpot||""} onChange={s("mpuMeterSpot")} options={["-- Select --","Same Location","Relocation"]}/>
      </div>
    </div>}
    {(f.types||[]).some(t=>["EV Charger","Electrical Correction","Line Transfer","Temporary Power","Load Calculation","Sub Panel","Meter Socket Repair"].includes(t))&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>⚡ Electrical Notes</div>
      <Txt label="Electrical Details / Scope" value={f.electricalNotes||""} onChange={v=>setF(x=>({...x,electricalNotes:v}))}/>
    </div>}
    {(f.types||[]).includes("PV Install")&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>☀️ PV Install Details</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
        <Inp label="Number of Panels" value={f.solarPanels||""} onChange={v=>{const p=Number(v);const w=Number(f.panelWatts||440);setF(x=>({...x,solarPanels:v,systemKw:p&&w?Math.round(p*w/100)/10:""}));}} type="number" placeholder="e.g. 25"/>
        <Inp label="Panel Wattage (W)" value={f.panelWatts||""} onChange={v=>{const w=Number(v);const p=Number(f.solarPanels||0);setF(x=>({...x,panelWatts:v,systemKw:p&&w?Math.round(p*w/100)/10:""}));}} type="number" placeholder="e.g. 440"/>
        <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>System Size (kW)</div><div style={{background:"#f0a50011",border:"1px solid #f0a50033",borderRadius:6,padding:"8px 10px",fontSize:14,fontWeight:700,color:"#d4891f"}}>{f.systemKw||"--"} kW</div></div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:10}}>
        <Inp label="Inverter / Equipment" value={f.solarInverter||""} onChange={v=>setF(x=>({...x,solarInverter:v}))} placeholder="e.g. Enphase IQ8A"/>
      </div>
    </div>}
    {(f.types||[]).some(t=>["Commissioning","Optimizer Install","Microinverter Swap","String Inverter Swap","Enphase IQ Gateway","Array Expansion","Solar Removal & Reinstall"].includes(t))&&!(f.types||[]).includes("PV Install")&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>☀️ Solar Details</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <Inp label="Panel Count" value={f.solarPanels||""} onChange={v=>setF(x=>({...x,solarPanels:v}))} type="number" placeholder="e.g. 25"/>
        <Inp label="Inverter / Equipment" value={f.solarInverter||""} onChange={v=>setF(x=>({...x,solarInverter:v}))} placeholder="e.g. Enphase IQ8A"/>
      </div>
    </div>}
    {(f.types||[]).includes("Battery Install")&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>🔋 Battery Details</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <Inp label="Number of Batteries" value={f.batteryQty||""} onChange={v=>setF(x=>({...x,batteryQty:v}))} type="number" placeholder="e.g. 2"/>
        <Sel label="Battery Type" value={f.batteryType||""} onChange={v=>setF(x=>({...x,batteryType:v}))} options={["-- Select --","Enphase IQ Battery 5P","Enphase IQ Battery 10T","Tesla Powerwall 3","Tesla Powerwall 2","Franklin aPower","SolarEdge Home Battery","Generac PWRcell","LG RESU","Other"]}/>
      </div>
    </div>}
    {(f.types||[]).includes("Panel Upgrade (MPU)")&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12,marginTop:-8}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:8,textTransform:"uppercase",display:"flex",alignItems:"center",gap:5}}><Icon name="bolt" size={12} color="#d4891f"/> MPU — Additional Details</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
        <Sel label="Utility Disconnect Type" value={f.mpuDisconnect||""} onChange={v=>setF(x=>({...x,mpuDisconnect:v}))} options={["-- Select --","Hot Disconnect","D&R (De-energize & Re-energize)","Not Required"]}/>
        <Sel label="Utility Scheduled?" value={f.mpuUtilityScheduled||""} onChange={v=>setF(x=>({...x,mpuUtilityScheduled:v}))} options={["-- Select --","Yes — Scheduled","No — Not Yet","Not Required"]}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginTop:4}}>
        <div>
          <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer",marginBottom:6}}>
            <input type="checkbox" checked={f.mpuLath||false} onChange={e=>setF(x=>({...x,mpuLath:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
            Lath Inspection Required
          </label>
          {f.mpuLath&&<div>
            <Sel label="Lath Result" value={f.mpuLathResult||""} onChange={v=>setF(x=>({...x,mpuLathResult:v}))} options={["-- Select --","Passed","Failed","Pending"]}/>
            {f.mpuLathResult&&<Txt label="Lath Notes" value={f.mpuLathNotes||""} onChange={v=>setF(x=>({...x,mpuLathNotes:v}))}/>}
          </div>}
        </div>
        <div>
          <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer",marginBottom:6}}>
            <input type="checkbox" checked={f.mpuRough||false} onChange={e=>setF(x=>({...x,mpuRough:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
            Rough Inspection Required
          </label>
          {f.mpuRough&&<div>
            <Sel label="Rough Result" value={f.mpuRoughResult||""} onChange={v=>setF(x=>({...x,mpuRoughResult:v}))} options={["-- Select --","Passed","Failed","Pending"]}/>
            {f.mpuRoughResult&&<Txt label="Rough Notes" value={f.mpuRoughNotes||""} onChange={v=>setF(x=>({...x,mpuRoughNotes:v}))}/>}
          </div>}
        </div>
      </div>
    </div>}
    {(f.types||[]).some(t=>["Service Call","Troubleshooting","Roof Repair","Stucco Repair","Punch List","Warranty Work","Other"].includes(t))&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>🔧 Service Details</div>
      <Txt label="Issue / Scope of Work" value={f.serviceNotes||""} onChange={v=>setF(x=>({...x,serviceNotes:v}))}/>
      <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer",marginTop:8}}>
        <input type="checkbox" checked={f.lathInspection||false} onChange={e=>setF(x=>({...x,lathInspection:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
        Lath Inspection Required
      </label>
      {f.lathInspection&&<div style={{marginTop:8}}>
        <Sel label="Lath Inspection Result" value={f.lathResult||""} onChange={v=>setF(x=>({...x,lathResult:v}))} options={["-- Select --","Passed","Failed","Pending"]}/>
        {f.lathResult&&<Txt label="Lath Notes" value={f.lathNotes||""} onChange={v=>setF(x=>({...x,lathNotes:v}))}/>}
      </div>}
    </div>}
    {(f.types||[]).some(t=>["Permit Inspection","Final Inspection"].includes(t))&&<div style={{background:"#f9f9fb",border:"1px solid #dde0ea",borderRadius:8,padding:"12px",marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#d4891f",marginBottom:10,textTransform:"uppercase"}}>📋 Inspection Details</div>
      <Sel label="Inspection Result" value={f.inspectionResult||""} onChange={v=>setF(x=>({...x,inspectionResult:v}))} options={["-- Select --","Passed","Failed","Corrections Required","Pending Re-Inspection"]}/>
      <Txt label="Inspector Notes" value={f.inspectionNotes||""} onChange={v=>setF(x=>({...x,inspectionNotes:v}))}/>
      {(f.types||[]).includes("Final Inspection")&&<label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer",marginTop:8}}>
        <input type="checkbox" checked={f.lathInspection||false} onChange={e=>setF(x=>({...x,lathInspection:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
        Lath Inspection Required
      </label>}
      {f.lathInspection&&<div style={{marginTop:8}}>
        <Sel label="Lath Inspection Result" value={f.lathResult||""} onChange={v=>setF(x=>({...x,lathResult:v}))} options={["-- Select --","Passed","Failed","Pending"]}/>
        {f.lathResult&&<Txt label="Lath Notes" value={f.lathNotes||""} onChange={v=>setF(x=>({...x,lathNotes:v}))}/>}
      </div>}
    </div>}
    <Sel label="Status" value={f.status} onChange={s("status")} options={WO_STATUS}/>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>📋 Report Type</div>
      <select value={f.reportType||""} onChange={e=>setF(x=>({...x,reportType:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:7,padding:"8px 11px",fontSize:13,fontFamily:"inherit",background:"#f9f9fb",color:"#1a1d25"}}>
        <option value="">-- Select Report Type --</option>
        <option value="solar">☀️ Solar + Battery Installation</option>
        <option value="mpu">⚡ MPU (Panel Upgrade)</option>
        <option value="inspection">🔍 Inspection</option>
        <option value="service">🔧 Service Call</option>
        <option value="inverter">🔌 Inverter Service</option>
      </select>
    </div>
    {(f.types||[]).some(t=>SALES_TYPES.includes(t))&&(
      <div style={{background:"#f5f3ff",border:"1px solid #8b5cf633",borderRadius:8,padding:"12px",marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:700,color:"#8b5cf6",marginBottom:12,textTransform:"uppercase",display:"flex",alignItems:"center",gap:6}}><Icon name="briefcase" size={13} color="#8b5cf6"/> Sales Details</div>

        {/* Stage + Lead Source */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Sales Stage</div>
            <select value={f.salesStage||""} onChange={e=>setF(x=>({...x,salesStage:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
              <option value="">-- Select Stage --</option>
              <option value="Lead">🔍 Lead</option>
              <option value="Site Survey">🏠 Site Survey</option>
              <option value="Sales Appointment">📅 Sales Appointment</option>
              <option value="Proposal Sent">📄 Proposal Sent</option>
              <option value="Contract Review">📝 Contract Review</option>
              <option value="Contract Signed">✅ Contract Signed</option>
              <option value="Follow-up">🔔 Follow-up</option>
              <option value="Lost / No Sale">❌ Lost / No Sale</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Lead Source</div>
            <select value={f.leadSource||""} onChange={e=>setF(x=>({...x,leadSource:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
              <option value="">-- Select Source --</option>
              {LEAD_SOURCES.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>

        {/* Interest + Follow-up */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Customer Interest Level</div>
            <select value={f.salesInterest||""} onChange={e=>setF(x=>({...x,salesInterest:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
              <option value="">-- Select --</option>
              <option value="Hot">🔥 Hot — Ready to sign</option>
              <option value="Warm">🌤 Warm — Interested</option>
              <option value="Cold">❄️ Cold — Just looking</option>
              <option value="Not Interested">❌ Not Interested</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Follow-up Date</div>
            <input type="date" value={f.followUpDate||""} onChange={e=>setF(x=>({...x,followUpDate:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
        </div>

        {/* Proposal amount */}
        <div style={{marginBottom:10}}>
          <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Proposal Amount $</div>
          <input type="number" value={f.proposalAmount||""} onChange={e=>setF(x=>({...x,proposalAmount:e.target.value}))} placeholder="0.00" style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
        </div>

        {/* Notes */}
        <div>
          <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Sales Notes / Next Steps</div>
          <textarea value={f.salesNotes||""} onChange={e=>setF(x=>({...x,salesNotes:e.target.value}))} rows={3} placeholder="What was discussed, customer concerns, next steps..." style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
        </div>
      </div>
    )}

    {/* ── Design & Engineering Panel ── */}
    {(f.types||[]).some(t=>DESIGN_TYPES.includes(t))&&(
      <div style={{background:"#f0fdf4",border:"1px solid #22c55e33",borderRadius:8,padding:"12px",marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:700,color:"#16a34a",marginBottom:12,textTransform:"uppercase",display:"flex",alignItems:"center",gap:6}}><Icon name="compass" size={13} color="#16a34a"/> Design & Engineering</div>

        {/* Status + Plan Set Version */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Design Status</div>
            <select value={f.designStatus||""} onChange={e=>setF(x=>({...x,designStatus:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
              <option value="">-- Select Status --</option>
              <option value="In Progress">🔄 In Progress</option>
              <option value="Under Review">👁 Under Review</option>
              <option value="Submitted">📤 Submitted</option>
              <option value="Corrections Required">⚠️ Corrections Required</option>
              <option value="Resubmitted">🔁 Resubmitted</option>
              <option value="Approved">✅ Approved</option>
              <option value="On Hold">⏸ On Hold</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Plan Set Version</div>
            <input value={f.planSetVersion||""} onChange={e=>setF(x=>({...x,planSetVersion:e.target.value}))} placeholder="e.g. v1, v2, Rev A" style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
        </div>

        {/* AHJ + Permit Number */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>AHJ (Authority Having Jurisdiction)</div>
            <input value={f.ahj||""} onChange={e=>setF(x=>({...x,ahj:e.target.value}))} placeholder="e.g. City of Riverside" style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Permit Number</div>
            <input value={f.permitNumber||""} onChange={e=>setF(x=>({...x,permitNumber:e.target.value}))} placeholder="e.g. B-2024-01234" style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
        </div>

        {/* Permit Status + Dates */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Permit Status</div>
            <select value={f.permitStatus||""} onChange={e=>setF(x=>({...x,permitStatus:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
              <option value="">-- Select --</option>
              {PERMIT_STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Submission Date</div>
            <input type="date" value={f.permitSubmitDate||""} onChange={e=>setF(x=>({...x,permitSubmitDate:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Approval Date</div>
            <input type="date" value={f.permitApprovalDate||""} onChange={e=>setF(x=>({...x,permitApprovalDate:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff",boxSizing:"border-box"}}/>
          </div>
        </div>

        {/* Interconnection */}
        <div style={{marginBottom:10}}>
          <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Interconnection / NEM Status</div>
          <select value={f.interconnectStatus||""} onChange={e=>setF(x=>({...x,interconnectStatus:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
            <option value="">-- Select --</option>
            {INTERCONNECT_STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
          </select>
        </div>

        {/* HOA + Structural checkboxes */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer",marginBottom:6}}>
              <input type="checkbox" checked={f.hoaRequired||false} onChange={e=>setF(x=>({...x,hoaRequired:e.target.checked}))} style={{accentColor:"#22c55e"}}/>
              HOA Approval Required
            </label>
            {f.hoaRequired&&(
              <select value={f.hoaStatus||""} onChange={e=>setF(x=>({...x,hoaStatus:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",background:"#fff"}}>
                <option value="">-- HOA Status --</option>
                <option value="Not Submitted">Not Submitted</option>
                <option value="Submitted">Submitted</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Changes Requested">Changes Requested</option>
              </select>
            )}
          </div>
          <div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer"}}>
              <input type="checkbox" checked={f.structuralRequired||false} onChange={e=>setF(x=>({...x,structuralRequired:e.target.checked}))} style={{accentColor:"#22c55e"}}/>
              Structural Engineering Required
            </label>
          </div>
        </div>

        {/* Design Notes */}
        <div>
          <div style={{fontSize:11,color:"#9aa0b4",marginBottom:4}}>Design Notes / Correction Details</div>
          <textarea value={f.designNotes||""} onChange={e=>setF(x=>({...x,designNotes:e.target.value}))} rows={3} placeholder="Plan check comments, corrections needed, revision notes..." style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
        </div>
      </div>
    )}

        <Txt label="Notes" value={f.notes} onChange={s("notes")}/>
    <Inp label="Photo URLs (comma separated)" value={f.photos} onChange={s("photos")} placeholder="https://..."/>
    <Inp label="Crew / Person Assigned" value={f.crew||""} onChange={v=>setF(x=>({...x,crew:v}))} placeholder="e.g. Miguel, John D."/>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Subcontractor (optional)</div>
      <select value={f.subcontractorId||""} onChange={e=>{
        const sub=subcontractors.find(s=>String(s._dbId||s.id)===String(e.target.value));
        setF(x=>({...x,subcontractorId:e.target.value,subcontractorName:sub?(sub.company||sub.name):"",subcontractorEmail:sub?sub.email||"":"",notifySub:false}));
      }} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:13,fontFamily:"inherit",marginBottom:6}}>
        <option value="">-- Select Subcontractor --</option>
        {subcontractors.map(s=>(
          <option key={s._dbId||s.id} value={String(s._dbId||s.id)}>{s.company||s.name}{s.licenseClass?" · "+s.licenseClass.split(" - ")[0]:""}</option>
        ))}
      </select>
      {f.subcontractorId&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:6,padding:"10px 12px"}}>
        {f.subcontractorEmail&&<div style={{fontSize:12,color:"#6a7080",marginBottom:6}}>📧 {f.subcontractorEmail}</div>}
        {f.subcontractorEmail
          ?<label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,cursor:"pointer"}}>
            <input type="checkbox" checked={f.notifySub||false} onChange={e=>setF(x=>({...x,notifySub:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
            Send WO notification to this subcontractor
          </label>
          :<div style={{fontSize:12,color:"#ef4444"}}>⚠️ No email on file — add one in Subcontractors tab</div>}
      </div>}
    </div>
    <F label="Additional Recipients">
      <input style={IS} type="text" placeholder="Extra emails (comma separated): name@example.com, name2@example.com" value={f.extraEmails||""} onChange={e=>setF(x=>({...x,extraEmails:e.target.value}))}/>
      <div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>These addresses will also receive the WO notification email.</div>
    </F>
    <F label="CompanyCam Album Link">
      <input style={IS} type="url" placeholder="https://app.companycam.com/projects/..." value={f.companyCamUrl||""} onChange={e=>setF(x=>({...x,companyCamUrl:e.target.value}))}/>
      <div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>Paste the shared CompanyCam project link — it will appear as a button in the WO email.</div>
    </F>
    <F label="Billing">
      <div style={{display:"flex",gap:16,alignItems:"center",marginBottom:8}}>
        <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,cursor:"pointer"}}>
          <input type="checkbox" checked={f.billable||false} onChange={e=>setF(x=>({...x,billable:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
          Billable
        </label>
        <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,cursor:"pointer"}}>
          <input type="checkbox" checked={f.backCharge||false} onChange={e=>setF(x=>({...x,backCharge:e.target.checked}))} style={{accentColor:"#f0a500"}}/>
          {f.epcPartnerName==="Suntrify (Direct)"?"Invoice to Customer":"Back Charge to EPC Partner"}{f.epcPartnerName&&f.epcPartnerName!=="Suntrify (Direct)"?" ("+f.epcPartnerName+")":""}
        </label>
      </div>
      {(f.billable||f.backCharge)&&<div>
        <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:6,letterSpacing:"0.05em"}}>Adder Rate Sheet</div>
        <div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px 12px",marginBottom:10}}>
          {ESP_ADDERS.map(a=>{
            const key=a.label; const val=(f.woAdders||{})[key]||0; const isPerUnit=a.unit!=="Per Project";
            return <div key={key} style={{display:"flex",alignItems:"center",gap:8,marginBottom:5,fontSize:12}}>
              <input type="checkbox" checked={val>0} onChange={e=>{
                const wa={...(f.woAdders||{})};
                if(e.target.checked){wa[key]=1;}else{delete wa[key];}
                const tot=Object.entries(wa).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                setF(x=>({...x,woAdders:wa,chargeAmount:tot+(x.woMisc||0)}));
              }} style={{accentColor:"#f0a500"}}/>
              <span style={{flex:1,color:"#1a1d25"}}>{a.label}</span>
              <span style={{fontSize:10,color:"#9aa0b4",marginRight:4}}>{a.unit}</span>
              {val>0&&isPerUnit&&<input type="number" value={val} min={1} onChange={e=>{
                const wa={...(f.woAdders||{})};wa[key]=Number(e.target.value);
                const tot=Object.entries(wa).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                setF(x=>({...x,woAdders:wa,chargeAmount:tot+(x.woMisc||0)}));
              }} style={{width:50,border:"1px solid #dde0ea",borderRadius:4,padding:"2px 4px",fontSize:11,fontFamily:"inherit"}}/>}
              <span style={{color:"#9aa0b4",fontSize:11,minWidth:60,textAlign:"right"}}>${(a.rate*(isPerUnit?(val||0):1)).toLocaleString()}</span>
            </div>;
          })}
          <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.05em",margin:"10px 0 6px"}}>🔋 Battery Adders</div>
          {ESP_BATTERY.map(b=>{
            const key=b.label; const checked=!!((f.woBattery||{})[key]);
            return <div key={key} style={{display:"flex",alignItems:"center",gap:8,marginBottom:5,fontSize:12}}>
              <input type="checkbox" checked={checked} onChange={e=>{
                const wb={...(f.woBattery||{})};
                if(e.target.checked){wb[key]=true;}else{delete wb[key];}
                const adderTot=Object.entries(f.woAdders||{}).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                const batTot=Object.entries(wb).reduce((s,[k])=>{const bat=ESP_BATTERY.find(x=>x.label===k);return s+(bat?bat.rate:0);},0);
                setF(x=>({...x,woBattery:wb,chargeAmount:adderTot+batTot+(x.woMisc||0)}));
              }} style={{accentColor:"#f0a500"}}/>
              <span style={{flex:1,color:"#1a1d25"}}>{b.label}</span>
              <span style={{color:"#9aa0b4",fontSize:11,minWidth:60,textAlign:"right"}}>${(b.rate||0).toLocaleString()}</span>
            </div>;
          })}
          <div style={{marginTop:10,paddingTop:8,borderTop:"1px solid #e0e3eb"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:12,fontWeight:700,color:"#1a1d25"}}>💡 Misc / Other Line Items</span>
              <button type="button" onClick={()=>{
                const lines=[...(f.woMiscLines||[]),{id:Date.now(),type:"",unitPrice:0,qty:1,total:0}];
                const miscTot=lines.reduce((s,l)=>s+l.total,0);
                const adderTot=Object.entries(f.woAdders||{}).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                const batTot=Object.entries(f.woBattery||{}).reduce((s,[k])=>{const bat=ESP_BATTERY.find(x=>x.label===k);return s+(bat?bat.rate:0);},0);
                setF(x=>({...x,woMiscLines:lines,woMisc:miscTot,chargeAmount:adderTot+batTot+miscTot}));
              }} style={{fontSize:11,padding:"3px 10px",borderRadius:5,border:"1px solid #f0a500",background:"#f0a50011",color:"#d4891f",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>+ Add Line</button>
            </div>
            {(f.woMiscLines||[]).length > 0 && (
              <div>
                <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 28px",gap:4,marginBottom:4}}>
                  {["Type / Description","Unit Price","Qty","Total",""].map(h=><div key={h} style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",fontWeight:700}}>{h}</div>)}
                </div>
                {(f.woMiscLines||[]).map((line,i)=>(
                  <div key={line.id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 28px",gap:4,marginBottom:5,alignItems:"center"}}>
                    <select value={line.type} onChange={e=>{
                      const lines=f.woMiscLines.map((l,j)=>j===i?{...l,type:e.target.value}:l);
                      setF(x=>({...x,woMiscLines:lines}));
                    }} style={{border:"1px solid #dde0ea",borderRadius:4,padding:"4px 6px",fontSize:11,fontFamily:"inherit",background:"#fff"}}>
                      <option value="">-- Select --</option>
                      {["Labor","Material","Equipment Rental","Permit Fee","Inspection Fee","Crane / Lift","Trench / Dig","Haul Away","Stucco / Patch","Engineering","Travel / Mileage","Other"].map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <input type="number" min={0} value={line.unitPrice} placeholder="$0" onChange={e=>{
                      const lines=f.woMiscLines.map((l,j)=>{if(j!==i)return l;const up=Number(e.target.value);return{...l,unitPrice:up,total:up*l.qty};});
                      const miscTot=lines.reduce((s,l)=>s+l.total,0);
                      const adderTot=Object.entries(f.woAdders||{}).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                      const batTot=Object.entries(f.woBattery||{}).reduce((s,[k])=>{const bat=ESP_BATTERY.find(x=>x.label===k);return s+(bat?bat.rate:0);},0);
                      setF(x=>({...x,woMiscLines:lines,woMisc:miscTot,chargeAmount:adderTot+batTot+miscTot}));
                    }} style={{border:"1px solid #dde0ea",borderRadius:4,padding:"4px 6px",fontSize:11,fontFamily:"inherit"}}/>
                    <input type="number" min={1} value={line.qty} onChange={e=>{
                      const lines=f.woMiscLines.map((l,j)=>{if(j!==i)return l;const q=Number(e.target.value);return{...l,qty:q,total:l.unitPrice*q};});
                      const miscTot=lines.reduce((s,l)=>s+l.total,0);
                      const adderTot=Object.entries(f.woAdders||{}).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                      const batTot=Object.entries(f.woBattery||{}).reduce((s,[k])=>{const bat=ESP_BATTERY.find(x=>x.label===k);return s+(bat?bat.rate:0);},0);
                      setF(x=>({...x,woMiscLines:lines,woMisc:miscTot,chargeAmount:adderTot+batTot+miscTot}));
                    }} style={{border:"1px solid #dde0ea",borderRadius:4,padding:"4px 6px",fontSize:11,fontFamily:"inherit"}}/>
                    <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",padding:"4px 0"}}>${(line.total||0).toLocaleString()}</div>
                    <button type="button" onClick={()=>{
                      const lines=f.woMiscLines.filter((_,j)=>j!==i);
                      const miscTot=lines.reduce((s,l)=>s+l.total,0);
                      const adderTot=Object.entries(f.woAdders||{}).reduce((s,[k,v])=>{const ad=ESP_ADDERS.find(x=>x.label===k);return s+(ad?ad.rate*(ad.unit==="Per Project"?1:Number(v)):0);},0);
                      const batTot=Object.entries(f.woBattery||{}).reduce((s,[k])=>{const bat=ESP_BATTERY.find(x=>x.label===k);return s+(bat?bat.rate:0);},0);
                      setF(x=>({...x,woMiscLines:lines,woMisc:miscTot,chargeAmount:adderTot+batTot+miscTot}));
                    }} style={{background:"transparent",border:"none",color:"#ef4444",cursor:"pointer",fontSize:14,padding:0}}>✕</button>
                  </div>
                ))}
                <div style={{display:"flex",justifyContent:"flex-end",fontSize:12,fontWeight:700,color:"#1a1d25",borderTop:"1px solid #e0e3eb",paddingTop:6,marginTop:4}}>
                  Misc Total: ${(f.woMisc||0).toLocaleString()}
                </div>
              </div>
            )}
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f0a50011",border:"1px solid #f0a50044",borderRadius:8,padding:"8px 14px",marginBottom:10}}>
          <span style={{fontSize:13,fontWeight:700,color:"#d4891f"}}>Total Charge</span>
          <span style={{fontSize:18,fontWeight:700,color:"#d4891f"}}>${(f.chargeAmount||0).toLocaleString()}</span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10}}>
          <Inp label="Override Amount $" value={f.chargeAmount} onChange={v=>setF(x=>({...x,chargeAmount:Number(v)}))} type="number"/>
          <Inp label="Charge Notes" value={f.chargeNotes} onChange={s("chargeNotes")} placeholder="e.g. Labor for panel corrections"/>
        </div>
      </div>}
    </F>
    <div style={{display:"flex",gap:8}}>
      <Btn onClick={()=>f.jobId&&f.date&&onSave(f)} style={{flex:1}}>Save Work Order</Btn>
      <Btn onClick={onCancel} variant="ghost" style={{flex:1}}>Cancel</Btn>
    </div>
  </div>;
}


function Invoices({ workOrders, epcPartners, jobs, invoicesProp=[], setInvoicesProp }) {
  const invoices = invoicesProp;
  const setInvoices = setInvoicesProp || (()=>{});
  const [viewInv, setViewInv] = React.useState(null);
  const [showAging, setShowAging] = React.useState(false);
  const [invSearch, setInvSearch] = React.useState("");
  const [invFilters, setInvFilters] = React.useState({status:"", partner:"", period:"", type:""});
  const [editingInv, setEditingInv] = React.useState(false);
  const [editInvForm, setEditInvForm] = React.useState({});
  const [payForm, setPayForm] = React.useState({date:"", amount:"", method:"Check", authId:"", note:""});
  const [showCreate, setShowCreate] = React.useState(false);
  const [form, setForm] = React.useState({
    invNumber: "2329", epcPartnerId: "", terms: "Due on Receipt", selectedWOs: [], notes: ""
  });

  const saveInvoices = (list) => {
    setInvoices(list);
    localStorage.setItem("suntrify_invoices", JSON.stringify(list));
  };

  const nextInvNumber = () => {
    if(!invoices.length) return "2329";
    const nums = invoices.map(i => parseInt(i.invNumber)||0);
    return String(Math.max(...nums) + 1);
  };

  const openCreate = () => {
    setForm({ invNumber: nextInvNumber(), epcPartnerId: "", terms: "Due on Receipt", selectedWOs: [], notes: "" });
    setShowCreate(true);
  };

  const isDirect = form.epcPartnerId && String(form.epcPartnerId).startsWith("direct-");
  const directJob = isDirect ? jobs.find(j => String(j._dbId||j.id) === String(form.epcPartnerId).replace("direct-","")) : null;
  const partner = !isDirect ? epcPartners.find(p => String(p._dbId||p.id) === String(form.epcPartnerId)) : null;
  const partnerWOs = workOrders.filter(w => {
    if(!(w.backCharge||w.billable) || !w.chargeAmount) return false;
    if(isDirect && directJob) return String(w.jobId) === String(directJob._dbId||directJob.id);
    return w.epcPartnerName && partner && (w.epcPartnerName === (partner.company||partner.name));
  });

  const selectedWOData = partnerWOs.filter(w => form.selectedWOs.includes(w._dbId||w.id));
  const invTotal = selectedWOData.reduce((s,w) => s + (w.chargeAmount||0), 0);

  const createInvoice = () => {
    if(!form.epcPartnerId || !form.selectedWOs.length) return;
    const inv = {
      id: Date.now(),
      invNumber: form.invNumber,
      date: new Date().toISOString().slice(0,10),
      epcPartnerId: form.epcPartnerId,
      epcPartnerName: isDirect && directJob ? directJob.customerName+" (Direct)" : partner ? (partner.company||partner.name) : "",
      epcPartnerInfo: isDirect && directJob ? {name:directJob.customerName,address:directJob.address,direct:true} : partner || {},
      contractType: isDirect ? "direct" : "epc",
      epcPartnerInfo: partner || {},
      terms: form.terms,
      selectedWOs: form.selectedWOs,
      woData: selectedWOData,
      total: invTotal,
      notes: form.notes,
      status: "Unpaid",
      payments: []
    };
    const newInv = {id: Date.now(), ...inv};
    sbFetch("invoices", {method:"POST", prefer:"return=representation", body:JSON.stringify({data:newInv})})
      .then(r=>r.json()).then(rows=>{ if(rows&&rows[0]) setInvoices(prev=>[...prev,{...newInv,_dbId:rows[0].id}]); else setInvoices(prev=>[...prev,newInv]); }).catch(()=>setInvoices(prev=>[...prev,newInv]));
    setShowCreate(false);
  };

  const printInvoice = (inv) => {
    const epc = inv.epcPartnerInfo || {};
    const liveWOData = (inv.selectedWOs||[]).map(id =>
      workOrders.find(w => String(w._dbId||w.id) === String(id))
    ).filter(Boolean);
    const woDataToUse = liveWOData.length ? liveWOData : (inv.woData||[]);

    // Build table rows — one row per line item across all WOs
    const rows = woDataToUse.map(wo => {
      const lines = [];
      // Adder lines
      Object.entries(wo.woAdders||{}).forEach(([k,v])=>{
        const ad = ESP_ADDERS.find(x=>x.label===k);
        if(!ad||!v) return;
        const qty = ad.unit==="Per Project" ? 1 : Number(v);
        const rate = ad.rate;
        const amt = rate * qty;
        lines.push({date:wo.date||"", desc:k, customer:wo.customerName||"", qty, rate, amt});
      });
      // Battery lines
      Object.entries(wo.woBattery||{}).forEach(([k])=>{
        const bat = ESP_BATTERY.find(x=>x.label===k);
        if(!bat) return;
        lines.push({date:wo.date||"", desc:k, customer:wo.customerName||"", qty:1, rate:bat.rate, amt:bat.rate});
      });
      // Misc lines
      (wo.woMiscLines||[]).forEach(l=>{
        lines.push({date:wo.date||"", desc:(l.type||"Misc")+(l.type?" - "+wo.customerName:wo.customerName), customer:wo.customerName||"", qty:l.qty||1, rate:l.unitPrice||0, amt:l.total||0});
      });
      // If no line items, show WO summary row
      if(!lines.length) {
        lines.push({date:wo.date||"", desc:(wo.types||[]).join(", ")||"Work Order", customer:wo.customerName||"", qty:1, rate:wo.chargeAmount||0, amt:wo.chargeAmount||0});
      }
      return lines;
    }).flat();

    const dueDate = (()=>{
      const d = new Date(inv.date);
      if(inv.terms==="Net 7") d.setDate(d.getDate()+7);
      else if(inv.terms==="Net 14") d.setDate(d.getDate()+14);
      else if(inv.terms==="Net 30") d.setDate(d.getDate()+30);
      return inv.terms==="Due on Receipt" ? inv.date : d.toISOString().slice(0,10);
    })();

    const w = window.open("","_blank");
    w.document.write(`<!DOCTYPE html><html><head><title>Invoice #${inv.invNumber}</title><style>
      *{box-sizing:border-box;margin:0;padding:0}
      body{font-family:'Helvetica Neue',Arial,sans-serif;padding:48px;color:#1a1d25;font-size:13px;background:#fff}
      .top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px}
      .from-name{font-weight:800;font-size:14px;margin-bottom:4px}
      .from-info{font-size:12px;color:#444;line-height:1.7}
      .logo{font-size:28px;font-weight:900;color:#d4891f;letter-spacing:-1px;display:flex;align-items:center;gap:8px}
      .logo svg{opacity:0.9}
      .inv-title{font-size:28px;font-weight:800;color:#d4891f;margin:24px 0 20px}
      .three-col{display:grid;grid-template-columns:1fr 1fr 1fr;gap:0;margin-bottom:32px}
      .col-label{font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#1a1d25;margin-bottom:8px;padding-bottom:4px;border-bottom:2px solid #f0a500}
      .col-val{font-size:12px;line-height:1.8;color:#333}
      .col-val strong{color:#1a1d25;font-weight:700}
      .inv-meta{display:grid;grid-template-columns:auto 1fr;gap:4px 16px;font-size:12px}
      .inv-meta .lbl{color:#9aa0b4;font-weight:600;text-align:right}
      .inv-meta .val{color:#1a1d25;font-weight:700}
      table{width:100%;border-collapse:collapse;margin-bottom:0}
      thead tr{background:#1a1d25}
      th{padding:10px 12px;font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#fff;font-weight:700;text-align:left}
      th:nth-child(3),th:nth-child(4),th:nth-child(5){text-align:right}
      tbody tr:nth-child(even){background:#f9f9fb}
      td{padding:10px 12px;font-size:12px;border-bottom:1px solid #f0f1f5;vertical-align:top}
      td:nth-child(3),td:nth-child(4),td:nth-child(5){text-align:right}
      .total-section{display:flex;justify-content:flex-end;margin-top:0;border-top:2px solid #e0e3eb;padding-top:16px}
      .total-grid{display:grid;grid-template-columns:1fr 1fr;gap:4px 24px;min-width:260px}
      .total-grid .lbl{font-size:12px;color:#6a7080;text-align:right}
      .total-grid .val{font-size:12px;font-weight:700;text-align:right}
      .total-grid .big-lbl{font-size:14px;font-weight:800;color:#1a1d25;text-align:right;margin-top:8px;padding-top:8px;border-top:2px solid #1a1d25}
      .total-grid .big-val{font-size:20px;font-weight:800;color:#d4891f;text-align:right;margin-top:8px;padding-top:8px;border-top:2px solid #1a1d25}
      .footer{margin-top:40px;font-size:10px;color:#9aa0b4;text-align:center;padding-top:16px;border-top:1px solid #e0e3eb}
      .save-btn{position:fixed;top:20px;right:20px;background:#f0a500;border:none;border-radius:8px;padding:10px 22px;font-weight:700;font-size:13px;cursor:pointer;font-family:inherit;color:#000;box-shadow:0 2px 8px rgba(0,0,0,0.2);z-index:100}
      @page{size:letter;margin:.5in}
      @media print{.save-btn{display:none}}
    </style></head><body>
    <button class="save-btn" onclick="window.print()">⬇ Save as PDF</button>

    <div class="top">
      <div>
        <div class="from-name">Suntrify Inc.</div>
        <div class="from-info">
          29336 Tournament Rd<br/>
          Lake Elsinore, CA 92530<br/>
          (951) 866-2828<br/>
          jchacon@suntrify.com<br/>
          www.suntrify.com
        </div>
      </div>
      <div style="text-align:right">
        <img src="${window.location.origin}/SUNTRIFY_LOGO.png" style="height:36px;object-fit:contain;display:block;margin-left:auto" onerror="this.style.display='none';this.nextElementSibling.style.display='block'"/>
        <div style="display:none;font-size:28px;font-weight:900;color:#d4891f;letter-spacing:-1px">⚡ SUNTRIFY</div>
        <div style="font-size:10px;color:#9aa0b4;margin-top:4px;letter-spacing:.1em;text-transform:uppercase">Solar &amp; Electrical</div>
      </div>
    </div>

    <div class="inv-title">INVOICE</div>

    <div class="three-col">
      <div>
        <div class="col-label">Bill To</div>
        <div class="col-val">
          <strong>${epc.company||epc.name||""}</strong><br/>
          ${epc.company&&epc.name?epc.name+"<br/>":""}
          ${epc.address||""}<br/>
          ${epc.phone||""}<br/>
          ${epc.email||""}
        </div>
      </div>
      <div>
        <div class="col-label">Project / Customer</div>
        <div class="col-val">
          ${woDataToUse.map(wo=>`<strong>${wo.customerName||""}</strong><br/>${wo.address||""}`).filter((v,i,a)=>a.indexOf(v)===i).join("<br/><br/>")}
        </div>
      </div>
      <div>
        <div class="col-label">Invoice Info</div>
        <div class="inv-meta">
          <span class="lbl">Invoice #</span><span class="val">${inv.invNumber}</span>
          <span class="lbl">Date</span><span class="val">${inv.date}</span>
          <span class="lbl">Due Date</span><span class="val">${dueDate}</span>
          <span class="lbl">Terms</span><span class="val">${inv.terms}</span>
        </div>
      </div>
    </div>

    <table>
      <thead><tr><th>Date</th><th>Description</th><th>Qty</th><th>Rate</th><th>Amount</th></tr></thead>
      <tbody>
        ${rows.map(r=>`<tr><td>${r.date}</td><td><strong>${r.desc}</strong></td><td>${r.qty}</td><td>$${(r.rate||0).toLocaleString()}</td><td>$${(r.amt||0).toLocaleString()}</td></tr>`).join("")}
      </tbody>
    </table>

    <div class="total-section">
      <div class="total-grid">
        <span class="big-lbl">Balance Due</span>
        <span class="big-val">$${(inv.total||0).toLocaleString()}</span>
      </div>
    </div>

    ${inv.notes?`<div style="margin-top:20px;padding:12px 16px;background:#f9f9fb;border-radius:8px;font-size:12px;color:#6a7080"><strong>Notes:</strong> ${inv.notes}</div>`:""}
    <div class="footer">Suntrify Inc. · CSLB #1055498 (B, C-10, C-46) · jchacon@suntrify.com · Thank you for your business!</div>
    </body></html>`);
    w.document.close();
    setTimeout(() => { w.focus(); w.print(); }, 800);
  };

  return (
    <div style={{padding:"20px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontFamily:"'DM Serif Display',serif",fontSize:22,fontWeight:700,color:"#1a1d25",display:"flex",alignItems:"center",gap:8}}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#d4891f" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            Invoices
          </div>
          <div style={{fontSize:12,color:"#9aa0b4",marginTop:2}}>{invoices.length} invoice{invoices.length!==1?"s":""} · <span style={{color:"#22c55e",fontWeight:700}}>${invoices.filter(i=>i.status==="Paid").reduce((s,i)=>s+(i.total||0),0).toLocaleString()} collected</span> · <span style={{color:"#ef4444",fontWeight:700}}>${invoices.filter(i=>i.status!=="Paid").reduce((s,i)=>s+(i.total||0),0).toLocaleString()} outstanding</span></div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setShowAging(a=>!a)} style={{background:"transparent",border:"1px solid #dde0ea",borderRadius:8,padding:"9px 16px",fontWeight:600,fontSize:12,cursor:"pointer",color:"#6a7080",fontFamily:"inherit"}}>⏱ Aging</button>
          <button onClick={openCreate} style={{background:"#f0a500",border:"none",borderRadius:8,padding:"10px 20px",fontWeight:700,fontSize:13,cursor:"pointer",color:"#000",fontFamily:"inherit"}}>+ New Invoice</button>
        </div>
      </div>

      {showAging&&(()=>{
        const today = new Date();
        const getDays = inv => inv.date ? Math.floor((today - new Date(inv.date))/86400000) : 0;
        const getOwed = inv => (inv.total||0) - (inv.payments||[]).reduce((s,p)=>s+(p.amount||0),0);
        const unpaid = invoices.filter(inv => inv.status !== "Paid" && getOwed(inv) > 0);
        const buckets = [
          {label:"Current (0-30d)", color:"#22c55e", items: unpaid.filter(i=>getDays(i)<=30)},
          {label:"31-60 Days",      color:"#f59e0b", items: unpaid.filter(i=>getDays(i)>30&&getDays(i)<=60)},
          {label:"61-90 Days",      color:"#f0a500", items: unpaid.filter(i=>getDays(i)>60&&getDays(i)<=90)},
          {label:"Over 90 Days",    color:"#ef4444", items: unpaid.filter(i=>getDays(i)>90)},
        ];
        return (
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {buckets.map(b=>(
              <div key={b.label} style={{background:"#fff",border:`1px solid ${b.color}33`,borderRadius:10,padding:"12px 14px"}}>
                <div style={{fontSize:10,fontWeight:700,color:b.color,textTransform:"uppercase",marginBottom:6}}>{b.label}</div>
                <div style={{fontSize:22,fontWeight:800,color:b.color,fontFamily:"'DM Serif Display',serif"}}>${b.items.reduce((s,i)=>s+getOwed(i),0).toLocaleString()}</div>
                <div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>{b.items.length} invoice{b.items.length!==1?"s":""}</div>
                {b.items.slice(0,3).map(inv=>(
                  <div key={inv._dbId} onClick={()=>setViewInv(inv)} style={{fontSize:10,color:b.color,padding:"3px 0",borderBottom:`1px solid ${b.color}22`,cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    #{inv.invNumber} · {inv.epcPartnerName} · ${getOwed(inv).toLocaleString()}
                  </div>
                ))}
                {b.items.length>3&&<div style={{fontSize:10,color:"#9aa0b4",marginTop:3}}>+{b.items.length-3} more</div>}
              </div>
            ))}
          </div>
        );
      })()}

      <div style={{marginBottom:14,position:"relative"}}>
        <input value={invSearch} onChange={e=>setInvSearch(e.target.value)} placeholder="Search by invoice # or customer name..." style={{width:"100%",border:"1px solid #dde0ea",borderRadius:8,padding:"9px 12px 9px 36px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa0b4" strokeWidth="2" style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)"}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        {invSearch&&<button onClick={()=>setInvSearch("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"transparent",border:"none",cursor:"pointer",color:"#9aa0b4",fontSize:16}}>✕</button>}
      </div>
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
        <select value={invFilters.status} onChange={e=>setInvFilters(x=>({...x,status:e.target.value}))} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",background:invFilters.status?"#f0a50015":"#fff",color:invFilters.status?"#d4891f":"#6a7080",cursor:"pointer"}}>
          <option value="">All Statuses</option>
          <option value="Unpaid">Unpaid</option>
          <option value="Partial">Partial</option>
          <option value="Paid">Paid</option>
        </select>
        <select value={invFilters.partner} onChange={e=>setInvFilters(x=>({...x,partner:e.target.value}))} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",background:invFilters.partner?"#f0a50015":"#fff",color:invFilters.partner?"#d4891f":"#6a7080",cursor:"pointer"}}>
          <option value="">All Partners</option>
          {[...new Set(invoices.map(i=>i.epcPartnerName).filter(Boolean))].map(p=><option key={p} value={p}>{p}</option>)}
        </select>
        <select value={invFilters.period} onChange={e=>setInvFilters(x=>({...x,period:e.target.value}))} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",background:invFilters.period?"#f0a50015":"#fff",color:invFilters.period?"#d4891f":"#6a7080",cursor:"pointer"}}>
          <option value="">All Dates</option>
          <option value="month">This Month</option>
          <option value="quarter">This Quarter</option>
          <option value="year">This Year</option>
        </select>
        <select value={invFilters.type} onChange={e=>setInvFilters(x=>({...x,type:e.target.value}))} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",background:invFilters.type?"#f0a50015":"#fff",color:invFilters.type?"#d4891f":"#6a7080",cursor:"pointer"}}>
          <option value="">All Types</option>
          <option value="epc">🤝 EPC Sub</option>
          <option value="direct">🏠 Direct Sale</option>
        </select>
        {(invFilters.status||invFilters.partner||invFilters.period||invFilters.type)&&
          <button onClick={()=>setInvFilters({status:"",partner:"",period:"",type:""})} style={{fontSize:11,padding:"7px 12px",border:"1px solid #ef444430",borderRadius:6,background:"#fff",cursor:"pointer",color:"#ef4444",fontFamily:"inherit",fontWeight:700}}>✕ Clear</button>}
      </div>
      {invoices.length===0&&<div style={{textAlign:"center",padding:"60px 20px",color:"#9aa0b4",background:"#fff",borderRadius:12,border:"1px solid #e0e3eb"}}>No invoices yet. Create your first invoice from WO back charges.</div>}

      {invoices.length>0&&(()=>{
        const fmtDate = d => { if(!d) return "—"; const [y,m,dy]=d.split("-"); return `${m}-${dy}-${y}`; };
        const filtered = [...invoices].sort((a,b)=>parseInt(b.invNumber||0)-parseInt(a.invNumber||0)).filter(inv=>{
          const now = new Date(); const invDate = new Date(inv.date);
          if(invSearch){ const q=invSearch.toLowerCase(); const custs=(inv.woData||[]).map(w=>w.customerName||"").join(" ").toLowerCase(); if(!inv.invNumber?.toLowerCase().includes(q)&&!custs.includes(q)&&!(inv.epcPartnerName||"").toLowerCase().includes(q)) return false; }
          if(invFilters.status && inv.status!==invFilters.status) return false;
          if(invFilters.partner && inv.epcPartnerName!==invFilters.partner) return false;
          if(invFilters.type){ if(invFilters.type==="direct"&&inv.contractType!=="direct") return false; if(invFilters.type==="epc"&&inv.contractType==="direct") return false; }
          if(invFilters.period){ if(invFilters.period==="month"&&(invDate.getMonth()!==now.getMonth()||invDate.getFullYear()!==now.getFullYear())) return false; if(invFilters.period==="quarter"&&Math.floor(invDate.getMonth()/3)!==Math.floor(now.getMonth()/3)) return false; if(invFilters.period==="year"&&invDate.getFullYear()!==now.getFullYear()) return false; }
          return true;
        });
        if(filtered.length===0) return <div style={{textAlign:"center",padding:"40px 20px",color:"#9aa0b4"}}>No invoices match your filters.</div>;
        const totalValue   = filtered.reduce((s,i)=>s+(i.total||0),0);
        const totalPaid    = filtered.reduce((s,i)=>s+(i.payments||[]).reduce((p,x)=>p+(x.amount||0),0),0);
        const totalOwed    = totalValue - totalPaid;
        return (
          <>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:14}}>
            <div style={{background:"#fff",border:"1px solid #e0e3eb",borderLeft:"4px solid #d4891f",borderRadius:10,padding:"14px 18px"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#d4891f",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:4}}>Total Value</div>
              <div style={{fontSize:22,fontWeight:800,color:"#1a1d25",fontFamily:"'DM Serif Display',serif"}}>${totalValue.toLocaleString()}</div>
              <div style={{fontSize:11,color:"#9aa0b4",marginTop:2}}>{filtered.length} invoice{filtered.length!==1?"s":""}</div>
            </div>
            <div style={{background:"#fff",border:"1px solid #e0e3eb",borderLeft:"4px solid #22c55e",borderRadius:10,padding:"14px 18px"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#22c55e",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:4}}>Paid</div>
              <div style={{fontSize:22,fontWeight:800,color:"#1a1d25",fontFamily:"'DM Serif Display',serif"}}>${totalPaid.toLocaleString()}</div>
              <div style={{fontSize:11,color:"#9aa0b4",marginTop:2}}>{totalValue>0?Math.round(totalPaid/totalValue*100):0}% collected</div>
            </div>
            <div style={{background:"#fff",border:`1px solid ${totalOwed>0?"#ef444433":"#e0e3eb"}`,borderLeft:`4px solid ${totalOwed>0?"#ef4444":"#22c55e"}`,borderRadius:10,padding:"14px 18px"}}>
              <div style={{fontSize:10,fontWeight:700,color:totalOwed>0?"#ef4444":"#22c55e",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:4}}>Outstanding Balance</div>
              <div style={{fontSize:22,fontWeight:800,color:totalOwed>0?"#ef4444":"#22c55e",fontFamily:"'DM Serif Display',serif"}}>${totalOwed.toLocaleString()}</div>
              <div style={{fontSize:11,color:"#9aa0b4",marginTop:2}}>{filtered.filter(i=>i.status!=="Paid").length} unpaid</div>
            </div>
          </div>
          <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e0e3eb",background:"#fff"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead>
                <tr style={{borderBottom:"2px solid #e0e3eb",background:"#f8f9fb"}}>
                  <th style={{width:40,padding:"10px 12px"}}></th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Invoice #</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Date</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Status</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Partner</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em"}}>Customer(s)</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Value</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Paid</th>
                  <th style={{padding:"10px 14px",textAlign:"left",fontWeight:700,fontSize:11,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",whiteSpace:"nowrap"}}>Balance</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(inv => {
                  const paidAmt = (inv.payments||[]).reduce((s,p)=>s+(p.amount||0),0);
                  const owedAmt = (inv.total||0) - paidAmt;
                  const today = new Date();
                  const invDate = inv.date ? new Date(inv.date) : null;
                  const daysSince = invDate ? Math.floor((today-invDate)/(1000*60*60*24)) : null;
                  const fullyPaid = owedAmt<=0 && paidAmt>0;
                  const overdue = !fullyPaid && daysSince!==null && (()=>{
                    if(inv.terms==="Due on Receipt") return daysSince>0;
                    if(inv.terms==="Net 7") return daysSince>7;
                    if(inv.terms==="Net 14") return daysSince>14;
                    if(inv.terms==="Net 30") return daysSince>30;
                    return false;
                  })();
                  const statusBg = inv.status==="Paid"?"#22c55e22":inv.status==="Partial"?"#f0a50022":"#ef444422";
                  const statusColor = inv.status==="Paid"?"#22c55e":inv.status==="Partial"?"#d4891f":"#ef4444";
                  const customers = [...new Set((inv.woData||[]).map(w=>w.customerName).filter(Boolean))].join(", ");
                  return (
                    <tr key={inv._dbId||inv.id}
                      onClick={()=>{setViewInv(inv);setPayForm({date:"",amount:"",method:"Check",authId:"",note:""}); }}
                      style={{borderBottom:"1px solid #f0f1f5",cursor:"pointer"}}
                      onMouseEnter={e=>e.currentTarget.style.background="#f8f9fb"}
                      onMouseLeave={e=>e.currentTarget.style.background=""}>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:"50%",background:"#f0f1f5",border:"1px solid #e0e3eb"}}>
                          <Icon name="eye" size={13} color="#6a7080"/>
                        </span>
                      </td>
                      <td style={{padding:"10px 14px",fontWeight:700,color:"#1a1d25",fontFamily:"monospace",whiteSpace:"nowrap"}}>#{inv.invNumber}</td>
                      <td style={{padding:"10px 14px",whiteSpace:"nowrap",color:"#6a7080",fontSize:12}}>{fmtDate(inv.date)}</td>
                      <td style={{padding:"10px 14px",whiteSpace:"nowrap"}}>
                        <span style={{background:statusBg,color:statusColor,border:`1px solid ${statusColor}44`,borderRadius:4,padding:"2px 8px",fontSize:11,fontWeight:700}}>{inv.status}</span>
                        {overdue&&<span style={{marginLeft:5,background:"#ef444418",color:"#ef4444",borderRadius:4,padding:"2px 6px",fontSize:10,fontWeight:700}}>Overdue</span>}
                      </td>
                      <td style={{padding:"10px 14px",color:"#6a7080",whiteSpace:"nowrap",fontSize:12}}>{inv.epcPartnerName||"—"}</td>
                      <td style={{padding:"10px 14px",color:"#1a1d25",fontWeight:600,fontSize:12,whiteSpace:"nowrap",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{customers||"—"}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>${(inv.total||0).toLocaleString()}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>${paidAmt.toLocaleString()}</td>
                      <td style={{padding:"10px 14px",color:"#6a7080",fontSize:12,whiteSpace:"nowrap"}}>{owedAmt>0?`$${owedAmt.toLocaleString()}`:"Paid in full"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          </>
        );
      })()}

      {viewInv&&<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:1000,overflowY:"auto",padding:"20px 16px"}}>
        <div style={{background:"#fff",borderRadius:12,maxWidth:680,margin:"0 auto",padding:24}}>
          {(()=>{
            const livePartner = epcPartners.find(p=>String(p._dbId||p.id)===String(viewInv.epcPartnerId));
            const displayName = livePartner?(livePartner.company||livePartner.name):viewInv.epcPartnerName;
            const needsUpdate = livePartner && displayName !== viewInv.epcPartnerName;
            return <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
              <div>
                <h3 style={{fontFamily:"'DM Serif Display',serif",fontSize:18,color:"#d4891f",margin:0}}>Invoice #{viewInv.invNumber}</h3>
                <div style={{fontSize:12,color:"#6a7080",marginTop:3}}>{displayName} · {viewInv.date} · {viewInv.terms}</div>
                {needsUpdate&&<button onClick={()=>{
                  const updated={...viewInv,epcPartnerName:displayName,epcPartnerInfo:livePartner};
                  if(updated._dbId)sbFetch("invoices?id=eq."+updated._dbId,{method:"PATCH",prefer:"return=minimal",body:JSON.stringify({data:updated})});
                  setInvoices(prev=>prev.map(i=>i._dbId===updated._dbId?updated:i));
                  setViewInv(updated);
                }} style={{fontSize:11,marginTop:4,padding:"2px 8px",border:"1px solid #f0a500",borderRadius:4,background:"#f0a50011",color:"#d4891f",cursor:"pointer",fontFamily:"inherit"}}>↻ Update to "{displayName}"</button>}
              </div>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>{setEditingInv(true);setEditInvForm({invNumber:viewInv.invNumber,date:viewInv.date,terms:viewInv.terms,notes:viewInv.notes||""});}} style={{fontSize:11,padding:"4px 10px",border:"1px solid #dde0ea",borderRadius:6,background:"#fff",cursor:"pointer",fontFamily:"inherit"}}>✏️ Edit</button>
                <button onClick={()=>setViewInv(null)} style={{background:"transparent",border:"none",fontSize:18,cursor:"pointer",color:"#9aa0b4"}}>✕</button>
              </div>
            </div>;
          })()}
          {editingInv&&<div style={{background:"#f9f9fb",border:"1px solid #e0e3eb",borderRadius:8,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:10}}>Edit Invoice Details</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Invoice #</div>
                <input value={editInvForm.invNumber||""} onChange={e=>setEditInvForm(x=>({...x,invNumber:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit",boxSizing:"border-box"}}/></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Invoice Date</div>
                <input type="date" value={editInvForm.date||""} onChange={e=>setEditInvForm(x=>({...x,date:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}}/></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Terms</div>
                <select value={editInvForm.terms||"Due on Receipt"} onChange={e=>setEditInvForm(x=>({...x,terms:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}}>
                  {["Due on Receipt","Net 7","Net 14","Net 30"].map(t=><option key={t}>{t}</option>)}
                </select></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Notes</div>
                <input value={editInvForm.notes||""} onChange={e=>setEditInvForm(x=>({...x,notes:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}} placeholder="Payment instructions..."/></div>
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>{
                const updated={...viewInv,...editInvForm};
                if(updated._dbId)sbFetch("invoices?id=eq."+updated._dbId,{method:"PATCH",prefer:"return=minimal",body:JSON.stringify({data:updated})});
                setInvoices(prev=>prev.map(i=>i._dbId===updated._dbId?updated:i));
                setViewInv(updated);
                setEditingInv(false);
              }} style={{flex:1,background:"#f0a500",border:"none",borderRadius:6,padding:"8px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>Save Changes</button>
              <button onClick={()=>setEditingInv(false)} style={{flex:1,background:"transparent",border:"1px solid #e0e3eb",borderRadius:6,padding:"8px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>Cancel</button>
            </div>
          </div>}

          {/* Summary bar */}
          {(()=>{
            const paid=(viewInv.payments||[]).reduce((s,p)=>s+(p.amount||0),0);
            const owed=(viewInv.total||0)-paid;
            const pct=viewInv.total>0?Math.min(100,Math.round(paid/viewInv.total*100)):0;
            const invDate = viewInv.date ? new Date(viewInv.date) : null;
            const today = new Date();
            const daysSinceInvoice = invDate ? Math.floor((today-invDate)/(1000*60*60*24)) : null;
            const payments = viewInv.payments||[];
            const lastPayment = payments.length ? payments[payments.length-1] : null;
            const fullyPaid = owed<=0 && paid>0;
            const daysToFullPay = fullyPaid && invDate && lastPayment
              ? Math.floor((new Date(lastPayment.date)-invDate)/(1000*60*60*24))
              : null;
            const overdue = !fullyPaid && daysSinceInvoice !== null && (()=>{
              if(viewInv.terms==="Due on Receipt") return daysSinceInvoice>0;
              if(viewInv.terms==="Net 7") return daysSinceInvoice>7;
              if(viewInv.terms==="Net 14") return daysSinceInvoice>14;
              if(viewInv.terms==="Net 30") return daysSinceInvoice>30;
              return false;
            })();
            return <div style={{marginBottom:16}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:10}}>
                <div style={{background:"#fff",border:"1px solid #e0e3eb",borderLeft:"4px solid #d4891f",borderRadius:10,padding:"12px 16px"}}>
                  <div style={{fontSize:9,fontWeight:700,color:"#d4891f",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:3}}>Invoice Value</div>
                  <div style={{fontSize:20,fontWeight:800,color:"#1a1d25",fontFamily:"'DM Serif Display',serif"}}>${(viewInv.total||0).toLocaleString()}</div>
                </div>
                <div style={{background:"#fff",border:"1px solid #e0e3eb",borderLeft:"4px solid #22c55e",borderRadius:10,padding:"12px 16px"}}>
                  <div style={{fontSize:9,fontWeight:700,color:"#22c55e",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:3}}>Paid</div>
                  <div style={{fontSize:20,fontWeight:800,color:"#22c55e",fontFamily:"'DM Serif Display',serif"}}>${paid.toLocaleString()}</div>
                  <div style={{fontSize:10,color:"#9aa0b4",marginTop:2}}>{pct}% collected</div>
                </div>
                <div style={{background:"#fff",border:`1px solid ${owed>0?"#ef444433":"#e0e3eb"}`,borderLeft:`4px solid ${owed>0?"#ef4444":"#22c55e"}`,borderRadius:10,padding:"12px 16px"}}>
                  <div style={{fontSize:9,fontWeight:700,color:owed>0?"#ef4444":"#22c55e",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:3}}>Balance Owed</div>
                  <div style={{fontSize:20,fontWeight:800,color:owed>0?"#ef4444":"#22c55e",fontFamily:"'DM Serif Display',serif"}}>{owed>0?`$${owed.toLocaleString()}`:"Paid ✓"}</div>
                </div>
              </div>
              <div style={{height:7,background:"#e0e3eb",borderRadius:4,marginBottom:10}}>
                <div style={{height:"100%",width:pct+"%",background:"#22c55e",borderRadius:4,transition:"width 0.3s"}}/>
              </div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8,fontSize:11}}>
                {daysSinceInvoice!==null&&<span style={{padding:"3px 10px",borderRadius:12,background:"#f0f1f5",color:"#6a7080"}}>📅 Invoiced {daysSinceInvoice} day{daysSinceInvoice!==1?"s":""} ago</span>}
                {fullyPaid && daysToFullPay!==null&&<span style={{padding:"3px 10px",borderRadius:12,background:"#22c55e22",color:"#22c55e",fontWeight:700}}>✅ Paid in full in {daysToFullPay} day{daysToFullPay!==1?"s":""}</span>}
                {!fullyPaid && overdue&&<span style={{padding:"3px 10px",borderRadius:12,background:"#ef444422",color:"#ef4444",fontWeight:700}}>⚠️ Overdue by {daysSinceInvoice} days</span>}
                {!fullyPaid && !overdue && daysSinceInvoice!==null&&<span style={{padding:"3px 10px",borderRadius:12,background:"#f0a50011",color:"#d4891f",fontWeight:700}}>🕐 {(()=>{
                  let due=0;
                  if(viewInv.terms==="Net 7") due=7;
                  else if(viewInv.terms==="Net 14") due=14;
                  else if(viewInv.terms==="Net 30") due=30;
                  const remaining=due-daysSinceInvoice;
                  return remaining>0?remaining+" day"+( remaining!==1?"s":"")+" until due":"Due today";
                })()}</span>}
                {payments.length>0&&<span style={{padding:"3px 10px",borderRadius:12,background:"#3b82f622",color:"#3b82f6"}}>{payments.length} payment{payments.length!==1?"s":""} received</span>}
              </div>
            </div>;
          })()}

          {/* Payments list */}
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>Payment History</div>
            {(viewInv.payments||[]).length===0&&<div style={{fontSize:12,color:"#9aa0b4",padding:"10px",background:"#f9f9fb",borderRadius:6,textAlign:"center"}}>No payments recorded yet.</div>}
            {(viewInv.payments||[]).map((p,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 12px",border:"1px solid #e0e3eb",borderRadius:6,marginBottom:5,background:"#f9f9fb"}}>
                <div>
                  <div style={{fontSize:12,fontWeight:700,color:"#1a1d25"}}>{p.method} {p.authId?"· Auth: "+p.authId:""}</div>
                  <div style={{fontSize:11,color:"#9aa0b4"}}>{p.date}{p.note?" · "+p.note:""}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontWeight:700,color:"#22c55e",fontSize:14}}>${(p.amount||0).toLocaleString()}</span>
                  <button onClick={()=>{
                    const updated={...viewInv,payments:(viewInv.payments||[]).filter((_,j)=>j!==i)};
                    const paid=updated.payments.reduce((s,p)=>s+(p.amount||0),0);
                    updated.status=paid>=updated.total?"Paid":paid>0?"Partial":"Unpaid";
                    if(updated._dbId)sbFetch("invoices?id=eq."+updated._dbId,{method:"PATCH",prefer:"return=minimal",body:JSON.stringify({data:updated})});
                    setInvoices(prev=>prev.map(i=>i._dbId===updated._dbId?updated:i));
                    setViewInv(updated);
                  }} style={{background:"transparent",border:"none",color:"#ef4444",cursor:"pointer",fontSize:12}}>✕</button>
                </div>
              </div>
            ))}
          </div>

          {/* Add payment form */}
          <div style={{background:"#f0a50008",border:"1px solid #f0a50033",borderRadius:8,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:10}}>+ Add Payment</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Date</div>
                <input type="date" value={payForm.date} onChange={e=>setPayForm(x=>({...x,date:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}}/></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Amount $</div>
                <input type="number" value={payForm.amount} onChange={e=>setPayForm(x=>({...x,amount:Number(e.target.value)}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}} placeholder="0"/></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Payment Method</div>
                <select value={payForm.method} onChange={e=>setPayForm(x=>({...x,method:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}}>
                  {["Check","ACH / Wire","Credit Card","Zelle","Cash","Other"].map(m=><option key={m}>{m}</option>)}
                </select></div>
              <div><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Authorization / Check #</div>
                <input value={payForm.authId} onChange={e=>setPayForm(x=>({...x,authId:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}} placeholder="e.g. 1042 or ACH ref"/></div>
            </div>
            <div style={{marginBottom:10}}><div style={{fontSize:11,color:"#9aa0b4",marginBottom:3}}>Note (optional)</div>
              <input value={payForm.note} onChange={e=>setPayForm(x=>({...x,note:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"7px 10px",fontSize:12,fontFamily:"inherit"}} placeholder="e.g. Milestone 1 of 3"/></div>
            <button onClick={()=>{
              if(!payForm.date||!payForm.amount) return;
              const newPayment={date:payForm.date,amount:Number(payForm.amount),method:payForm.method,authId:payForm.authId,note:payForm.note};
              const updated={...viewInv,payments:[...(viewInv.payments||[]),newPayment]};
              const paid=updated.payments.reduce((s,p)=>s+(p.amount||0),0);
              updated.status=paid>=(updated.total||0)?"Paid":paid>0?"Partial":"Unpaid";
              if(updated._dbId)sbFetch("invoices?id=eq."+updated._dbId,{method:"PATCH",prefer:"return=minimal",body:JSON.stringify({data:updated})});
              setInvoices(prev=>prev.map(i=>i._dbId===updated._dbId?updated:i));
              setViewInv(updated);
              setPayForm({date:"",amount:"",method:"Check",authId:"",note:""});
            }} style={{width:"100%",background:"#f0a500",border:"none",borderRadius:8,padding:"9px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>Record Payment</button>
          </div>

          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>printInvoice(viewInv)} style={{flex:1,padding:"9px",border:"1px solid #e0e3eb",borderRadius:8,background:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:12}}>🖨 Print Invoice</button>
            <button onClick={()=>{if(window.confirm("Delete invoice #"+viewInv.invNumber+"?")){if(viewInv._dbId)dbDelete("invoices",viewInv._dbId);setInvoices(prev=>prev.filter(i=>i._dbId!==viewInv._dbId));setViewInv(null);}}} style={{flex:1,padding:"9px",border:"1px solid #ef444430",borderRadius:8,background:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:12,color:"#ef4444"}}>🗑 Delete</button>
          </div>
        </div>
      </div>}

      {showCreate&&<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:1000,overflowY:"auto",padding:"20px 16px"}}>
        <div style={{background:"#fff",borderRadius:12,maxWidth:680,margin:"0 auto",padding:24}}>
          <h3 style={{fontFamily:"'DM Serif Display',serif",fontSize:18,marginBottom:20,color:"#d4891f"}}>New Invoice</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
            <div><div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Invoice Number</div>
              <input value={form.invNumber} onChange={e=>setForm(x=>({...x,invNumber:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/></div>
            <div><div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Terms</div>
              <select value={form.terms} onChange={e=>setForm(x=>({...x,terms:e.target.value}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:13,fontFamily:"inherit"}}>
                {["Due on Receipt","Net 7","Net 14","Net 30"].map(t=><option key={t}>{t}</option>)}
              </select></div>
          </div>
          <div style={{marginBottom:14}}>
            <div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Bill To</div>
            <select value={form.epcPartnerId} onChange={e=>setForm(x=>({...x,epcPartnerId:e.target.value,selectedWOs:[]}))} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:13,fontFamily:"inherit"}}>
              <option value="">-- Select --</option>
              <optgroup label="🏠 Direct Sale (Customer)">
                {jobs.filter(j=>j.contractType==="direct").map(j=><option key={"direct-"+( j._dbId||j.id)} value={"direct-"+(j._dbId||j.id)}>🏠 {j.customerName} · {j.address}</option>)}
              </optgroup>
              <optgroup label="🤝 EPC Partners">
                {epcPartners.map(p=><option key={p._dbId||p.id} value={String(p._dbId||p.id)}>{p.company||p.name}</option>)}
              </optgroup>
            </select>
          </div>
          {form.epcPartnerId&&<div style={{marginBottom:14}}>
            <div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:8}}>Select Work Orders</div>
            {partnerWOs.length===0?<div style={{fontSize:12,color:"#9aa0b4",padding:"12px",background:"#f9f9fb",borderRadius:6,textAlign:"center"}}>No billable WOs found.</div>:
            partnerWOs.map(w=>{
              const checked=form.selectedWOs.includes(w._dbId||w.id);
              return <div key={w._dbId||w.id} onClick={()=>setForm(x=>({...x,selectedWOs:checked?x.selectedWOs.filter(id=>id!==(w._dbId||w.id)):[...x.selectedWOs,w._dbId||w.id]}))}
                style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",border:"1px solid "+(checked?"#f0a500":"#e0e3eb"),borderRadius:6,marginBottom:5,cursor:"pointer",background:checked?"#f0a50008":"#fff"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <input type="checkbox" checked={checked} readOnly style={{accentColor:"#f0a500"}}/>
                  <div><div style={{fontSize:12,fontWeight:700,color:"#1a1d25"}}>{w.woId} · {w.customerName}</div>
                  <div style={{fontSize:11,color:"#9aa0b4"}}>{(w.types||[]).slice(0,2).join(", ")} · 📅 {w.date}</div></div>
                </div>
                <span style={{fontWeight:700,color:"#d4891f"}}>${(w.chargeAmount||0).toLocaleString()}</span>
              </div>;
            })}
          </div>}
          {form.selectedWOs.length>0&&<div style={{background:"#f0a50011",border:"1px solid #f0a50033",borderRadius:8,padding:"10px 16px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,color:"#d4891f"}}>Invoice Total</span>
            <span style={{fontWeight:800,fontSize:16,color:"#d4891f"}}>${invTotal.toLocaleString()}</span>
          </div>}
          <div style={{marginBottom:14}}>
            <div style={{fontSize:11,color:"#9aa0b4",textTransform:"uppercase",marginBottom:4}}>Notes</div>
            <textarea value={form.notes} onChange={e=>setForm(x=>({...x,notes:e.target.value}))} rows={2} placeholder="Payment instructions, remittance info..." style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"8px 10px",fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={createInvoice} disabled={!form.epcPartnerId||!form.selectedWOs.length} style={{flex:1,background:"#f0a500",border:"none",borderRadius:8,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",opacity:(!form.epcPartnerId||!form.selectedWOs.length)?0.4:1}}>Create Invoice</button>
            <button onClick={()=>setShowCreate(false)} style={{flex:1,background:"transparent",border:"1px solid #e0e3eb",borderRadius:8,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"inherit",color:"#6a7080"}}>Cancel</button>
          </div>
        </div>
      </div>}
    </div>
  );
}

// ─── Reports ─────────────────────────────────────────────────────────────
function Reports({ jobs, workOrders, epcPartners }) {
  const [period, setPeriod] = React.useState("all");
  const now = new Date();
  const filterByPeriod = (job) => {
    if(period === "all") return true;
    const d = job.startDate || job.endDate || "";
    if(!d) return false;
    const date = new Date(d);
    if(period === "month") return date.getMonth()===now.getMonth()&&date.getFullYear()===now.getFullYear();
    if(period === "quarter") return Math.floor(date.getMonth()/3)===Math.floor(now.getMonth()/3)&&date.getFullYear()===now.getFullYear();
    if(period === "year") return date.getFullYear()===now.getFullYear();
    return true;
  };
  const filtered = jobs.filter(filterByPeriod);
  const totalContract = filtered.reduce((s,j)=>s+(j.contractValue||0),0);
  const totalPaid = filtered.reduce((s,j)=>s+(j.paid||0),0);
  const totalOwed = totalContract - totalPaid;
  const totalWOBC = workOrders.filter(w=>w.backCharge&&w.chargeAmount>0).reduce((s,w)=>s+(w.chargeAmount||0),0);
  const outstanding = jobs.filter(j=>(j.contractValue||0)>(j.paid||0)&&j.stage!=="Cancelled"&&j.stage!=="Lead").sort((a,b)=>((b.contractValue||0)-(b.paid||0))-((a.contractValue||0)-(a.paid||0)));
  const byEPC = epcPartners.map(p=>{
    const pj=filtered.filter(j=>String(j.epcPartnerId)===String(p._dbId));
    return {name:p.company||p.name,jobs:pj.length,contract:pj.reduce((s,j)=>s+(j.contractValue||0),0),paid:pj.reduce((s,j)=>s+(j.paid||0),0)};
  }).filter(p=>p.jobs>0).sort((a,b)=>b.contract-a.contract);
  const stages=["Lead","Proposal","Scheduled","Installation","Service/Corrections","MPU","Inspection","Commissioning","Punch List","Closed","Cancelled"];
  const byStage=stages.map(s=>({stage:s,count:filtered.filter(j=>j.stage===s).length,value:filtered.filter(j=>j.stage===s).reduce((t,j)=>t+(j.contractValue||0),0)})).filter(s=>s.count>0);
  const monthlyMap={};
  filtered.forEach(j=>{
    const d=j.startDate||j.endDate||"";
    if(!d) return;
    const key=d.substring(0,7);
    if(!monthlyMap[key]) monthlyMap[key]={contract:0,paid:0,count:0};
    monthlyMap[key].contract+=(j.contractValue||0);
    monthlyMap[key].paid+=(j.paid||0);
    monthlyMap[key].count++;
  });
  const monthly=Object.entries(monthlyMap).sort((a,b)=>a[0].localeCompare(b[0])).slice(-12);
  const exportCSV=()=>{
    let csv="Suntrify CRM - Revenue Report\n";
    csv+=`Period: ${period}\n\nSUMMARY\n`;
    csv+=`Total Contract Value,$${totalContract.toLocaleString()}\nTotal Collected,$${totalPaid.toLocaleString()}\nTotal Owed,$${totalOwed.toLocaleString()}\nWO Back Charges,$${totalWOBC.toLocaleString()}\n\n`;
    csv+="BY EPC PARTNER\nPartner,Jobs,Contract Value,Collected,Owed\n";
    byEPC.forEach(p=>{ csv+=`${p.name},${p.jobs},$${p.contract.toLocaleString()},$${p.paid.toLocaleString()},$${(p.contract-p.paid).toLocaleString()}\n`; });
    csv+="\nBY STAGE\nStage,Jobs,Value\n";
    byStage.forEach(s=>{ csv+=`${s.stage},${s.count},$${s.value.toLocaleString()}\n`; });
    csv+="\nOUTSTANDING PAYMENTS\nCustomer,EPC Partner,Contract,Paid,Owed,Stage\n";
    outstanding.forEach(j=>{ csv+=`${j.customerName},${j.epcPartnerName},$${(j.contractValue||0).toLocaleString()},$${(j.paid||0).toLocaleString()},$${((j.contractValue||0)-(j.paid||0)).toLocaleString()},${j.stage}\n`; });
    csv+="\nMONTHLY BREAKDOWN\nMonth,Jobs,Contract Value,Collected\n";
    monthly.forEach(([m,d])=>{ csv+=`${m},${d.count},$${d.contract.toLocaleString()},$${d.paid.toLocaleString()}\n`; });
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");
    a.href=url; a.download=`Suntrify_Report_${new Date().toISOString().split("T")[0]}.csv`; a.click();
    URL.revokeObjectURL(url);
  };
  const Card=({label,value,color="#1a1d25",sub})=>(
    <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:"14px 16px",flex:1,minWidth:120}}>
      <div style={{fontSize:10,color:"#9aa0b4",textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>{label}</div>
      <div style={{fontSize:20,fontWeight:700,color,fontFamily:"'DM Serif Display',serif"}}>${value.toLocaleString()}</div>
      {sub&&<div style={{fontSize:11,color:"#9aa0b4",marginTop:4}}>{sub}</div>}
    </div>
  );
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:8}}>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        {["all","month","quarter","year"].map(p=>(
          <button key={p} onClick={()=>setPeriod(p)} style={{background:period===p?"#f0a500":"transparent",border:"1px solid "+(period===p?"#f0a500":"#dde0ea"),borderRadius:6,padding:"5px 12px",fontSize:12,cursor:"pointer",fontFamily:"inherit",color:period===p?"#000":"#6a7080",fontWeight:period===p?700:400}}>
            {p==="all"?"All Time":p==="month"?"This Month":p==="quarter"?"This Quarter":"This Year"}
          </button>
        ))}
      </div>
      <button onClick={exportCSV} style={{background:"#22c55e",border:"none",borderRadius:7,color:"#fff",fontWeight:700,fontSize:12,padding:"8px 16px",cursor:"pointer",fontFamily:"inherit"}}>⬇ Export CSV</button>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:20}}>
      <Card label="Total Pipeline" value={totalContract} color="#f0a500" sub={filtered.length+" jobs"}/>
      <Card label="Collected" value={totalPaid} color="#22c55e" sub={Math.round(totalContract>0?totalPaid/totalContract*100:0)+"% collected"}/>
      <Card label="Outstanding" value={totalOwed} color="#ef4444" sub={outstanding.length+" jobs unpaid"}/>
      <Card label="WO Back Charges" value={totalWOBC} color="#8b5cf6" sub={workOrders.filter(w=>w.backCharge&&w.chargeAmount>0).length+" WOs"}/>
    </div>
    {/* Revenue by Month Chart */}
    {(()=>{
      const months=[];
      for(let i=11;i>=0;i--){const d=new Date();d.setMonth(d.getMonth()-i);months.push({key:d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0"),label:d.toLocaleString("default",{month:"short"})});}
      const data=months.map(m=>{
        const mj=jobs.filter(j=>(j.startDate||j.endDate||"").startsWith(m.key));
        return{...m,contract:mj.reduce((s,j)=>s+(j.contractValue||0),0),paid:mj.reduce((s,j)=>s+(j.paid||0),0),count:mj.length};
      });
      const maxVal=Math.max(...data.map(d=>d.contract),1);
      return(
        <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginBottom:16}}>
          <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:16}}>📊 Revenue by Month (12 months)</div>
          <div style={{display:"flex",alignItems:"flex-end",gap:6,height:120,marginBottom:8}}>
            {data.map(m=>(
              <div key={m.key} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                <div style={{fontSize:9,color:"#9aa0b4",marginBottom:2}}>{m.contract>0?"$"+(m.contract/1000).toFixed(0)+"k":""}</div>
                <div style={{width:"100%",display:"flex",gap:1,alignItems:"flex-end",height:80}}>
                  <div style={{flex:1,background:"#f0a50066",borderRadius:"3px 3px 0 0",height:Math.max(m.contract/maxVal*100,m.contract>0?2:0)+"%"}} title={"Contract: $"+m.contract.toLocaleString()}/>
                  <div style={{flex:1,background:"#22c55e",borderRadius:"3px 3px 0 0",height:Math.max(m.paid/maxVal*100,m.paid>0?2:0)+"%"}} title={"Collected: $"+m.paid.toLocaleString()}/>
                </div>
                <div style={{fontSize:9,color:"#9aa0b4"}}>{m.label}</div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:16,fontSize:11,color:"#9aa0b4"}}>
            <span><span style={{display:"inline-block",width:10,height:10,background:"#f0a50066",borderRadius:2,marginRight:4}}/>Contract</span>
            <span><span style={{display:"inline-block",width:10,height:10,background:"#22c55e",borderRadius:2,marginRight:4}}/>Collected</span>
          </div>
        </div>
      );
    })()}
    {/* EPC Partner Chart */}
    {byEPC.length>0&&(
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginBottom:16}}>
        <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:12}}>📊 Revenue by EPC Partner</div>
        {(()=>{
          const maxC=Math.max(...byEPC.map(p=>p.contract),1);
          return byEPC.map(p=>(
            <div key={p.name} style={{marginBottom:10}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:2}}>
                <span style={{fontWeight:600,color:"#1a1d25"}}>{p.name}</span>
                <span style={{color:"#f0a500",fontWeight:700}}>${p.contract.toLocaleString()}</span>
              </div>
              <div style={{height:16,background:"#f0f1f5",borderRadius:4,position:"relative",overflow:"hidden"}}>
                <div style={{position:"absolute",left:0,top:0,height:"100%",width:(p.contract/maxC*100)+"%",background:"#f0a50044",borderRadius:4}}/>
                <div style={{position:"absolute",left:0,top:0,height:"100%",width:(p.paid/maxC*100)+"%",background:"#22c55e",borderRadius:4}}/>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"#9aa0b4",marginTop:2}}>
                <span>{p.jobs} jobs · ${p.paid.toLocaleString()} paid</span>
                <span style={{color:"#ef4444"}}>${(p.contract-p.paid).toLocaleString()} owed</span>
              </div>
            </div>
          ));
        })()}
      </div>
    )}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:16,marginBottom:20}}>
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16}}>
        <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:12}}>By EPC Partner</div>
        {byEPC.map(p=>(
          <div key={p.name} style={{marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}><span style={{fontWeight:700}}>{p.name}</span><span style={{color:"#22c55e",fontWeight:700}}>${p.contract.toLocaleString()}</span></div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#9aa0b4",marginBottom:4}}><span>{p.jobs} jobs · ${p.paid.toLocaleString()} paid</span><span style={{color:"#ef4444"}}>${(p.contract-p.paid).toLocaleString()} owed</span></div>
            <div style={{height:4,background:"#f0f1f5",borderRadius:2}}><div style={{height:"100%",width:(p.contract>0?Math.min(100,Math.round(p.paid/p.contract*100)):0)+"%",background:"#22c55e",borderRadius:2}}/></div>
          </div>
        ))}
      </div>
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16}}>
        <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:12}}>By Stage</div>
        {byStage.map(s=>(
          <div key={s.stage} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,fontSize:12}}>
            <span style={{color:"#6a7080"}}>{s.stage}</span>
            <div style={{display:"flex",gap:12}}><span style={{color:"#9aa0b4"}}>{s.count} jobs</span><span style={{fontWeight:700,color:"#1a1d25",minWidth:80,textAlign:"right"}}>${s.value.toLocaleString()}</span></div>
          </div>
        ))}
      </div>
    </div>
    <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginBottom:20}}>
      <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:12}}>Monthly Breakdown</div>
      <div style={{overflowX:"auto"}}>
      {monthly.length===0&&<div style={{color:"#9aa0b4",fontSize:12}}>No data with dates available.</div>}
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr style={{borderBottom:"1px solid #e0e3eb"}}>{["Month","Jobs","Contract Value","Collected","Collection %"].map(h=><th key={h} style={{textAlign:"left",padding:"6px 8px",color:"#9aa0b4",fontSize:10,textTransform:"uppercase",fontWeight:700}}>{h}</th>)}</tr></thead>
        <tbody>{monthly.map(([m,d])=><tr key={m} style={{borderBottom:"1px solid #f0f1f5"}}><td style={{padding:"8px",fontWeight:700}}>{m}</td><td style={{padding:"8px",color:"#6a7080"}}>{d.count}</td><td style={{padding:"8px",color:"#f0a500",fontWeight:700}}>${d.contract.toLocaleString()}</td><td style={{padding:"8px",color:"#22c55e",fontWeight:700}}>${d.paid.toLocaleString()}</td><td style={{padding:"8px",color:"#6a7080"}}>{d.contract>0?Math.round(d.paid/d.contract*100):0}%</td></tr>)}</tbody>
      </table></div>
    </div>
    <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16}}>
      <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:12}}>Outstanding Payments ({outstanding.length})</div>
      {outstanding.slice(0,15).map(j=>(
        <div key={j._dbId} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #f0f1f5",fontSize:12}}>
          <div><div style={{fontWeight:700,color:"#1a1d25"}}>{j.customerName}</div><div style={{fontSize:11,color:"#9aa0b4"}}>{j.epcPartnerName} · {j.stage}</div></div>
          <div style={{textAlign:"right"}}><div style={{color:"#ef4444",fontWeight:700}}>${((j.contractValue||0)-(j.paid||0)).toLocaleString()} owed</div><div style={{fontSize:11,color:"#9aa0b4"}}>${(j.contractValue||0).toLocaleString()} total</div></div>
        </div>
      ))}
    </div>

    <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginTop:16}}>
      <div style={{fontSize:12,fontWeight:700,color:"#1a1d25",marginBottom:14}}>🔍 Inspection Tracker</div>
      {(()=>{
        const inspWOs = workOrders.filter(w=>(w.types||[]).some(t=>t.toLowerCase().includes("inspect")));
        const results = {
          "Passed":    inspWOs.filter(w=>w.inspectionResult==="Passed"),
          "Failed":    inspWOs.filter(w=>w.inspectionResult==="Failed"),
          "Corrections Required": inspWOs.filter(w=>w.inspectionResult==="Corrections Required"),
          "Pending":   inspWOs.filter(w=>!w.inspectionResult||w.inspectionResult==="Pending Re-Inspection"||w.inspectionResult==="-- Select --"),
        };
        const colors = {"Passed":"#22c55e","Failed":"#ef4444","Corrections Required":"#f59e0b","Pending":"#3b82f6"};
        return(<>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
            {Object.entries(results).map(([label,items])=>(
              <div key={label} style={{background:colors[label]+"11",border:"1px solid "+colors[label]+"33",borderRadius:8,padding:"10px 12px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:800,color:colors[label],fontFamily:"'DM Serif Display',serif"}}>{items.length}</div>
                <div style={{fontSize:10,fontWeight:700,color:colors[label],textTransform:"uppercase",marginTop:2}}>{label}</div>
              </div>
            ))}
          </div>
          {inspWOs.length===0&&<div style={{textAlign:"center",color:"#9aa0b4",padding:"20px 0",fontSize:13}}>No inspection WOs found</div>}
          {inspWOs.length>0&&<table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead><tr style={{borderBottom:"1px solid #e0e3eb"}}>
              {["Customer","Address","Date","Type","Result"].map(h=><th key={h} style={{textAlign:"left",padding:"6px 8px",color:"#9aa0b4",fontSize:10,textTransform:"uppercase",fontWeight:700}}>{h}</th>)}
            </tr></thead>
            <tbody>{inspWOs.sort((a,b)=>(b.date||"").localeCompare(a.date||"")).map(w=>{
              const res = w.inspectionResult||"Pending";
              const col = res==="Passed"?"#22c55e":res==="Failed"?"#ef4444":res==="Corrections Required"?"#f59e0b":"#3b82f6";
              return(<tr key={w._dbId} style={{borderBottom:"1px solid #f0f1f5"}}>
                <td style={{padding:"8px",fontWeight:600,color:"#1a1d25"}}>{w.customerName}</td>
                <td style={{padding:"8px",color:"#6a7080",fontSize:11}}>{w.address}</td>
                <td style={{padding:"8px",color:"#9aa0b4"}}>{w.date||"—"}</td>
                <td style={{padding:"8px",color:"#9aa0b4",fontSize:11}}>{(w.types||[]).join(", ")}</td>
                <td style={{padding:"8px"}}><span style={{background:col+"22",color:col,borderRadius:6,padding:"2px 8px",fontWeight:700,fontSize:11}}>{res}</span></td>
              </tr>);
            })}</tbody>
          </table>}
        </>);
      })()}
    </div>

  </div>;
}


const PRINT_STYLE = `
  @media print {
    body * { visibility: hidden; }
    #install-report-print, #install-report-print * { visibility: visible; }
    #install-report-print { position: absolute; left: 0; top: 0; width: 100%; padding: 20px; }
    .no-print { display: none !important; }
    .page-break { page-break-before: always; }
    img { max-width: 120px; max-height: 120px; object-fit: cover; }
    h2 { font-size: 18px; margin-bottom: 4px; }
    button { display: none !important; }
    input, select, textarea { border: 1px solid #ccc !important; }
    .print-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
    .print-section { margin-bottom: 16px; border: 1px solid #ddd; border-radius: 8px; padding: 12px; }
    .print-section-title { font-size: 11px; font-weight: bold; text-transform: uppercase; color: #d4891f; margin-bottom: 8px; }
    .print-row { display: flex; justify-content: space-between; font-size: 11px; padding: 3px 0; border-bottom: 1px solid #f0f0f0; }
    .print-photos { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px; }
    .print-photo { width: 100px; height: 100px; object-fit: cover; border-radius: 4px; }
  }
`;


const ESP_CHECKLIST = [
  {key:"engNotes", label:"Engineering notes - Reviewed"},
  {key:"moduleCount", label:"Module Count Matches Plan Set"},
  {key:"inverterCount", label:"Inverter Type/Count Matches Plan Set"},
  {key:"materials", label:"Verify materials received match the plan set and Purchase Order"},
  {key:"measurements", label:"Verify Measurement on plan set match actual"},
  {key:"roofFraming", label:"Check existing roof framing and roof condition. Verify they match plan set"},
  {key:"rafters", label:"Verify rafters direction and spacing match plan set"},
  {key:"pointOfConnection", label:"Verify Point of Connection"},
  {key:"mspCondition", label:"Verify MSP condition - If not MPU was scoped"},
  {key:"solarBreaker", label:"Verify the solar Breaker amperage match the amperage on the plan set"},
  {key:"mainServiceGround", label:"Check existing Main service ground, EGC - GEC"},
  {key:"existingSolarGround", label:"Check existing solar system ground - If applicable"},
  {key:"serviceGrounding", label:"Service Grounding if unlocked"},
  {key:"preExisting", label:"Other pre-existing conditions on site that could interfere with install or inspection?"},
];

const PHOTO_SECTIONS = [
  "Home Address","Photo of Crew Truck","Photo of Exclusion Zone",
  "Array Flashings","Rail Grounding","Rail Side Profile","Rail Splice Label",
  "Wire Management Pre-Panels","Module Labels","Optimizer Labels",
  "Wire Management Under Array","Array Photos","Array Fire Setback",
  "Glass Level (panels flush)","Module Clamp","Optimizer Attachment",
  "Module Grounding","J-Box Interior/Exterior","EGC Path",
  "Conduit Support","Conduit Penetrations","Conduit Run",
  "BOS Pullback","Inverter Location","Inverter Label/Serial",
  "Voltage Measurements","Inverter Interior","GEC Path To Ground",
  "AC Disco Exterior/Interior","MSP Breakers","Solar & Main Breaker",
  "MSP Label","MSP Wiring Pullback","Battery Label/Serial",
  "Consumption Meter","Battery Communications","CT Photos",
  "Fully Wired Inverter","Optimizer Map","Pitch Finder",
  "Existing Ground/UFER","Conduit Color Match"
];

const POST_CHECKLIST = [
  {key:"arrayLayout", label:"Does the installed array layout match the plans?"},
  {key:"acDisco", label:"Is there an AC Disco?"},
  {key:"subPanel", label:"Sub Panel Required?"},
  {key:"mpu", label:"Is there an MPU?"},
  {key:"mpuComplete", label:"Is the MPU Complete?"},
  {key:"mspLabel", label:"Main Service Panel Label (If present)"},
  {key:"batteryJob", label:"Battery Job"},
  {key:"teslaBattery", label:"Tesla Battery?"},
  {key:"commissioned", label:"Was the system commissioned on site?"},
  {key:"cellKit", label:"Cell Kit/Zigbee Installed?"},
  {key:"deadfront", label:"Is Deadfront missing?"},
  {key:"inspectionReady", label:"Is the install inspection ready?"},
  {key:"tilesBroken", label:"Were any tiles broken during install?"},
  {key:"yardSign", label:"Did you receive a jobsite yard sign?"},
  {key:"propertyDamage", label:"Was there any damage done to the homeowner property during the installation?"},
];

async function uploadPhoto(file, jobId, section) {
  try {
    const url = await uploadToS3(file, `install-reports/${jobId}/${section.replace(/[^a-z0-9]/gi,'_')}`);
    return url;
  } catch(e) {
    console.error("Photo upload failed:", e);
    return null;
  }
}

async function saveInstallReport(reportData) {
  const existing = await fetch(
    `${AWS_API}/installation_reports?data->>jobId=eq.${reportData.jobId}&select=id`,
    { headers: {} }
  ).then(r=>r.json());
  
  if(existing && existing.length > 0) {
    await fetch(`${AWS_API}/installation_reports?id=eq.${existing[0].id}`, {
      method: "PATCH",
      headers: {"Content-Type": "application/json", Prefer: "return=minimal" },
      body: JSON.stringify({ data: reportData })
    });
  } else {
    await fetch(`${AWS_API}/installation_reports`, {
      method: "POST",
      headers: {"Content-Type": "application/json", Prefer: "return=minimal" },
      body: JSON.stringify({ data: reportData })
    });
  }
}

async function loadInstallReport(jobId) {
  const res = await fetch(
    `${AWS_API}/installation_reports?data->>jobId=eq.${jobId}&select=data`,
    { headers: {} }
  ).then(r=>r.json());
  return res && res.length > 0 ? res[0].data : null;
}

function InstallReport({ job, wo, onClose, onSaved }) {
  const [report, setReport] = React.useState({ jobId: String(job._dbId), checklist:{}, postChecklist:{}, batteryConfig:"Self Consumption", existingPV:"No", notes:"", photos:{} });
  const [saving, setSaving] = React.useState(false);
  const [saved, setSaved] = React.useState(false);
  const [uploading, setUploading] = React.useState({});
  const [activeSection, setActiveSection] = React.useState("pre");

  React.useEffect(() => {
    loadInstallReport(String(job._dbId)).then(data => {
      if(data) setReport(data);
      else if(wo) {
        setReport(r => ({...r,
          woId: wo.woId || "",
          woTypes: (wo.types||[]).join(", "),
          crew: wo.crew || "",
          date: wo.date || "",
        }));
      }
    });
  }, [job._dbId]);

  const setField = (key, val) => setReport(r => ({...r, [key]: val}));
  const setCheck = (key, val) => setReport(r => ({...r, checklist: {...r.checklist, [key]: val}}));
  const setPostCheck = (key, val) => setReport(r => ({...r, postChecklist: {...r.postChecklist, [key]: val}}));

  const handlePhotoUpload = async (section, files) => {
    setUploading(u => ({...u, [section]: true}));
    const urls = [];
    for(const file of files) {
      const url = await uploadPhoto(file, String(job._dbId), section);
      if(url) urls.push(url);
    }
    setReport(r => ({...r, photos: {...r.photos, [section]: [...(r.photos[section]||[]), ...urls]}}));
    setUploading(u => ({...u, [section]: false}));
  };

  const handleSave = async () => {
    setSaving(true);
    await saveInstallReport(report);
    setSaving(false);
    setSaved(true);
    if(onSaved) onSaved();
    setTimeout(() => setSaved(false), 2000);
  };

  const handlePrint = () => {
    const PH = report.photos || {};
    const C = report.checklist || {};
    const PC = report.postChecklist || {};
    const chkRow = (label, val) => "<tr><td style='padding:5px 8px;border-bottom:1px solid #eee;font-size:11px;width:60%'>"+label+"</td><td style='padding:5px 8px;border-bottom:1px solid #eee;font-size:11px;font-weight:bold'>"+(val||"-")+"</td></tr>";
    const win = window.open("","_blank","width=900,height=700");
    win.document.write("<!DOCTYPE html><html><head><title>Installation Report - "+job.customerName+"</title><style>*{margin:0;padding:0;box-sizing:border-box;}body{font-family:Arial,sans-serif;font-size:12px;color:#000;background:#fff;}@page{size:letter;margin:0.6in;}.page{page-break-after:always;padding-bottom:20px;}.page:last-child{page-break-after:auto;}.header{border-bottom:3px solid #000;padding-bottom:10px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:flex-start;}.customer-name{font-size:20px;font-weight:bold;margin-bottom:2px;}.customer-sub{font-size:11px;color:#333;}.section-title{background:#000;color:#fff;padding:5px 10px;font-size:11px;font-weight:bold;text-transform:uppercase;margin:12px 0 6px;}.two-col{display:grid;grid-template-columns:1fr 1fr;gap:0;}.info-table{width:100%;border-collapse:collapse;}.info-table td{padding:5px 8px;border-bottom:1px solid #eee;font-size:11px;vertical-align:top;}.info-table td:first-child{color:#555;width:55%;}.photo-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}.photo-block{break-inside:avoid;margin-bottom:6px;}.photo-label{font-size:9px;font-weight:bold;color:#555;margin-bottom:3px;text-transform:uppercase;letter-spacing:0.04em;}.photo-img-grid{display:grid;grid-template-columns:1fr 1fr;gap:3px;}.photo-img-grid img{width:100%;height:110px;object-fit:cover;border-radius:2px;display:block;}.no-photo{height:60px;background:#f5f5f5;display:flex;align-items:center;justify-content:center;font-size:10px;color:#aaa;border-radius:2px;}</style></head><body>");

    const logoUrl = window.location.origin + "/SUNTRIFY_LOGO.png";
    const hdr = (sub) => "<div class='header'><div style='display:flex;align-items:center;gap:12px'><img src='"+logoUrl+"' style='height:40px;width:auto'/><div><div class='customer-name'>"+job.customerName+"</div><div class='customer-sub'>"+(job.epcCustomerId||"")+" &bull; "+job.address+"</div></div></div><div style='text-align:right;font-size:10px;color:#555'>CSLB #1055498<br>(951) 866-2828<br>"+new Date().toLocaleDateString()+"</div></div>";

    // PAGE 1
    win.document.write("<div class='page'>"+hdr());
    win.document.write("<div class='section-title'>Customer Information</div><div class='two-col'><table class='info-table'><tr><td>Job ID</td><td><strong>"+(job.epcCustomerId||job._dbId)+"</strong></td></tr><tr><td>Customer</td><td><strong>"+job.customerName+"</strong></td></tr><tr><td>Address</td><td>"+job.address+"</td></tr></table><table class='info-table'><tr><td>EPC Partner</td><td>"+(job.epcPartnerName||"")+"</td></tr></table></div>");
    win.document.write("<div class='section-title'>System Information</div><div class='two-col'><table class='info-table'><tr><td>Modules</td><td><strong>"+job.panels+"</strong></td></tr><tr><td>Module Wattage</td><td>"+(job.panelWatts||440)+"W</td></tr><tr><td>System Size</td><td><strong>"+job.kw+" kW</strong></td></tr></table><table class='info-table'><tr><td>Inverter</td><td><strong>"+job.inverter+"</strong></td></tr><tr><td>Battery</td><td>"+job.battery+" x"+job.batteryQty+"</td></tr><tr><td>Battery Config</td><td>"+(report.batteryConfig||"N/A")+"</td></tr></table></div>");
    win.document.write("<div class='section-title'>Existing PV Installation</div><table class='info-table' style='width:50%'><tr><td>Is there an existing PV installation?</td><td><strong>"+(report.existingPV||"No")+"</strong></td></tr></table>");
    win.document.write("<div class='section-title'>Pre-Installation Checklist</div><div class='two-col'><table class='info-table'>"+chkRow("Engineering notes - Reviewed",C.engNotes)+chkRow("Module Count Matches Plan Set",C.moduleCount)+chkRow("Inverter Type/Count Matches Plan Set",C.inverterCount)+chkRow("Verify materials received match plan set",C.materials)+chkRow("Verify Measurement on plan set match actual",C.measurements)+chkRow("Check existing roof framing and condition",C.roofFraming)+chkRow("Verify rafters direction and spacing",C.rafters)+"</table><table class='info-table'>"+chkRow("Verify Point of Connection",C.pointOfConnection)+chkRow("Verify MSP condition",C.mspCondition)+chkRow("Verify solar Breaker amperage",C.solarBreaker)+chkRow("Check existing Main service ground EGC-GEC",C.mainServiceGround)+chkRow("Check existing solar system ground",C.existingSolarGround)+chkRow("Service Grounding if unlocked",C.serviceGrounding)+chkRow("Other pre-existing conditions on site?",C.preExisting)+"</table></div>");
    if(report.preNotes) win.document.write("<div style='margin-top:8px;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px'><strong>Notes:</strong> "+report.preNotes+"</div>");
    win.document.write("</div>");

    // PAGE 2+ - Installation Photos first
    const allSections = ["Home Address","Photo of Crew Truck","Photo of Exclusion Zone","Array Flashings","Rail Grounding","Rail Side Profile","Rail Splice Label","Wire Management Pre-Panels","Module Labels","Optimizer Labels","Wire Management Under Array","Array Photos","Array Fire Setback","Glass Level (panels flush)","Module Clamp","Optimizer Attachment","Module Grounding","J-Box Interior/Exterior","EGC Path","Conduit Support","Conduit Penetrations","Conduit Run","BOS Pullback","Inverter Location","Inverter Label/Serial","Voltage Measurements","Inverter Interior","GEC Path To Ground","AC Disco Exterior/Interior","MSP Breakers","Solar & Main Breaker","MSP Label","MSP Wiring Pullback","Battery Label/Serial","Consumption Meter","Battery Communications","CT Photos","Fully Wired Inverter","Optimizer Map","Pitch Finder","Existing Ground/UFER","Conduit Color Match"];
    for(let i=0; i<allSections.length; i+=8) {
      const pageSections = allSections.slice(i, i+8);
      win.document.write("<div class='page'>"+hdr()+"<div class='section-title'>Installation Photos</div><div class='photo-grid'>");
      pageSections.forEach(s => {
        const urls = PH[s] || [];
        win.document.write("<div class='photo-block'><div class='photo-label'>"+s+"</div>");
        if(urls.length) {
          win.document.write("<div class='photo-img-grid'>");
          urls.slice(0,4).forEach(u => win.document.write("<img src='"+u+"'/>")); 
          win.document.write("</div>");
        } else {
          win.document.write("<div class='no-photo'>No photos</div>");
        }
        win.document.write("</div>");
      });
      win.document.write("</div></div>");
    }

    // POST INSTALL PAGE
    win.document.write("<div class='page'>"+hdr());
    win.document.write("<div class='section-title' style='background:#333'>Post Installation Review</div>");
    win.document.write("<div class='two-col'><table class='info-table'>"+chkRow("Does installed array layout match plans?",PC.arrayLayout)+chkRow("Is there an AC Disco?",PC.acDisco)+chkRow("Sub Panel Required?",PC.subPanel)+chkRow("Is there an MPU?",PC.mpu)+chkRow("Is the MPU Complete?",PC.mpuComplete)+chkRow("Main Service Panel Label present?",PC.mspLabel)+chkRow("Battery Job",PC.batteryJob)+chkRow("Tesla Battery?",PC.teslaBattery)+"</table><table class='info-table'>"+chkRow("Was the system commissioned on site?",PC.commissioned)+chkRow("Cell Kit/Zigbee Installed?",PC.cellKit)+chkRow("Is Deadfront missing?",PC.deadfront)+chkRow("Is the install inspection ready?",PC.inspectionReady)+chkRow("Were any tiles broken during install?",PC.tilesBroken)+chkRow("Did you receive a jobsite yard sign?",PC.yardSign)+chkRow("Was there any property damage?",PC.propertyDamage)+"</table></div>");
    if(report.tilesBrokenQty) win.document.write("<p style='font-size:11px;margin-top:6px'><strong>Tiles broken:</strong> "+report.tilesBrokenQty+"</p>");
    if(report.returnDate) win.document.write("<p style='font-size:11px;margin-top:4px'><strong>Return Date:</strong> "+report.returnDate+"</p>");
    if(report.ctNotes) win.document.write("<div style='margin-top:8px;padding:8px;background:#f5f5f5;border-left:3px solid #999;font-size:11px'><strong>CT Notes:</strong> "+report.ctNotes+"</div>");
    if(report.damageNotes) win.document.write("<div style='margin-top:8px;padding:8px;background:#fff0f0;border-left:3px solid #c00;font-size:11px'><strong>Property Damage:</strong> "+report.damageNotes+"</div>");

    // Post-install photos
    const postPhotoKeys = [
      ["post_arrayLayout","Array Layout"],["post_acDisco","AC Disco"],["post_subPanel","Sub Panel"],
      ["post_mpu","MPU"],["post_mpuComplete","MPU Complete"],["post_mspLabel","MSP Label"],
      ["post_batteryJob","Battery Job"],["post_teslaBattery","Tesla Battery"],
      ["post_commissioned","Commissioned"],["post_cellKit","Cell Kit/Zigbee"],
      ["post_deadfront","Deadfront"],["post_inspectionReady","Inspection Ready"],
      ["post_tilesBroken","Tiles Broken"],["post_yardSign","Yard Sign"],["post_propertyDamage","Property Damage"]
    ];
    const postPhotosWithContent = postPhotoKeys.filter(([key]) => PH[key] && PH[key].length > 0);
    if(postPhotosWithContent.length > 0) {
      win.document.write("<div class='section-title' style='background:#555'>Post-Install Photos</div><div class='photo-grid'>");
      postPhotosWithContent.forEach(([key, label]) => {
        const urls = PH[key] || [];
        win.document.write("<div class='photo-block'><div class='photo-label'>"+label+"</div><div class='photo-img-grid'>");
        urls.slice(0,4).forEach(u => win.document.write("<img src='"+u+"'/>"));
        win.document.write("</div></div>");
      });
      win.document.write("</div>");
    }
    win.document.write("</div>");

    win.document.write(`<div id='printbar' style='position:fixed;top:0;left:0;right:0;background:#f0a500;padding:12px;text-align:center;z-index:9999;font-family:Arial,sans-serif;font-size:14px;font-weight:bold'>
      <span id='loadmsg'>Loading photos...</span>
      <button id='printbtn' onclick="document.getElementById('printbar').style.display='none';window.print()" style="display:none;background:#000;color:#fff;border:none;padding:8px 24px;border-radius:6px;font-size:14px;font-weight:bold;cursor:pointer;margin-left:16px">🖨 Print / Save PDF</button>
    </div><div style='height:52px'></div>
    <script>
      window.addEventListener('load', function() {
        var imgs = document.querySelectorAll('img');
        var total = imgs.length;
        if(total === 0) { document.getElementById('printbtn').style.display='inline-block'; document.getElementById('loadmsg').textContent='Ready!'; return; }
        var loaded = 0;
        function onLoad() {
          loaded++;
          document.getElementById('loadmsg').textContent = 'Loaded ' + loaded + ' of ' + total + ' photos...';
          if(loaded >= total) {
            document.getElementById('loadmsg').textContent = 'All ' + total + ' photos ready!';
            document.getElementById('printbtn').style.display='inline-block';
          }
        }
        imgs.forEach(function(img) {
          if(img.complete && img.naturalWidth > 0) { onLoad(); }
          else { img.addEventListener('load', onLoad); img.addEventListener('error', onLoad); }
        });
      });
    </script>`);
    win.document.close();
  };

  const ToggleField = ({label, val, onChange, photoKey}) => (
    <div style={{borderBottom:"1px solid #f0f1f5"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",fontSize:12}}>
        <span style={{color:"#6a7080",flex:1,paddingRight:12}}>{label}</span>
        <div style={{display:"flex",gap:4}}>
          {["Yes","No","N/A"].map(opt=>(
            <button key={opt} onClick={()=>onChange(opt)} style={{padding:"3px 10px",borderRadius:5,border:"1px solid "+(val===opt?"#f0a500":"#dde0ea"),background:val===opt?"#f0a500":"transparent",color:val===opt?"#000":"#9aa0b4",fontSize:11,fontWeight:val===opt?700:400,cursor:"pointer",fontFamily:"inherit"}}>
              {opt}
            </button>
          ))}
        </div>
      </div>
      {val==="Yes"&&photoKey&&<div style={{paddingLeft:8,paddingBottom:8,display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
        <label style={{background:"#f0a50022",border:"1px solid #f0a50044",borderRadius:6,color:"#854F0B",fontWeight:700,fontSize:11,padding:"4px 10px",cursor:"pointer",fontFamily:"inherit",display:"inline-block"}}>
          {uploading[photoKey]?"Uploading...":"Add Photo"}
          <input type="file" accept="image/*"  multiple onChange={e=>handlePhotoUpload(photoKey,Array.from(e.target.files))} style={{display:"none"}}/>
        </label>
        {(report.photos[photoKey]||[]).length===0&&<span style={{fontSize:11,color:"#ef4444"}}>Photo required</span>}
        {(report.photos[photoKey]||[]).map((url,i)=>(
          <div key={i} style={{position:"relative"}}>
            <img src={url} alt={label} style={{width:60,height:60,objectFit:"cover",borderRadius:6,border:"1px solid #e0e3eb"}}/>
            <button onClick={()=>setReport(r=>({...r,photos:{...r.photos,[photoKey]:(r.photos[photoKey]||[]).filter((_,j)=>j!==i)}}))} style={{position:"absolute",top:-5,right:-5,background:"#ef4444",border:"none",borderRadius:"50%",color:"#fff",width:16,height:16,fontSize:9,cursor:"pointer",lineHeight:"16px",padding:0}}>x</button>
          </div>
        ))}
      </div>}
    </div>
  );

  return <div id="install-report-print" style={{maxWidth:700,margin:"0 auto"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:8}}>
      <div>
        <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:18,margin:0}}>{job.customerName}</h2>
        <div style={{fontSize:12,color:"#9aa0b4"}}>{job.address} · Installation Report{wo ? " · WO: " + wo.woId : ""}</div>
      </div>
      <div style={{display:"flex",gap:8}}>
        <button onClick={handleSave} style={{background:"#f0a500",border:"none",borderRadius:7,color:"#000",fontWeight:700,fontSize:12,padding:"8px 16px",cursor:"pointer",fontFamily:"inherit"}}>{saving?"Saving...":saved?"Saved!":"💾 Save"}</button>
        <button onClick={handlePrint} style={{background:"#22c55e",border:"none",borderRadius:7,color:"#fff",fontWeight:700,fontSize:12,padding:"8px 16px",cursor:"pointer",fontFamily:"inherit"}}>🖨 Print / PDF</button>
        <button onClick={onClose} style={{background:"transparent",border:"1px solid #dde0ea",borderRadius:7,color:"#6a7080",fontWeight:700,fontSize:12,padding:"8px 16px",cursor:"pointer",fontFamily:"inherit"}}>✕ Close</button>
      </div>
    </div>

    <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
      {[["pre","Pre-Install"],["photos","Photos"],["post","Post-Install"]].map(([id,label])=>(
        <button key={id} onClick={()=>setActiveSection(id)} style={{background:activeSection===id?"#1a1d25":"transparent",border:"1px solid "+(activeSection===id?"#1a1d25":"#dde0ea"),borderRadius:7,color:activeSection===id?"#fff":"#6a7080",fontWeight:700,fontSize:12,padding:"8px 16px",cursor:"pointer",fontFamily:"inherit"}}>
          {label}
        </button>
      ))}
    </div>

    {activeSection==="pre"&&<div>
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:12}}>Customer & System Info</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:12,marginBottom:12}}>
          <div><span style={{color:"#9aa0b4"}}>Job ID: </span><strong>{job.epcCustomerId||job._dbId}</strong></div>
          <div><span style={{color:"#9aa0b4"}}>Customer: </span><strong>{job.customerName}</strong></div>
          <div><span style={{color:"#9aa0b4"}}>Address: </span><strong>{job.address}</strong></div>
          <div><span style={{color:"#9aa0b4"}}>Panels: </span><strong>{job.panels} · {job.kw}kW</strong></div>
          <div><span style={{color:"#9aa0b4"}}>Inverter: </span><strong>{job.inverter}</strong></div>
          <div><span style={{color:"#9aa0b4"}}>Battery: </span><strong>{job.battery}</strong></div>
        </div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:150}}>
            <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Existing PV</div>
            <div style={{display:"flex",gap:4}}>
              {["Yes","No","N/A"].map(opt=>(
                <button key={opt} onClick={()=>setField("existingPV",opt)} style={{padding:"3px 10px",borderRadius:5,border:"1px solid "+(report.existingPV===opt?"#f0a500":"#dde0ea"),background:report.existingPV===opt?"#f0a500":"transparent",color:report.existingPV===opt?"#000":"#9aa0b4",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>{opt}</button>
              ))}
            </div>
          </div>
          <div style={{flex:1,minWidth:150}}>
            <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Battery Config</div>
            <select value={report.batteryConfig||"Self Consumption"} onChange={e=>setField("batteryConfig",e.target.value)} style={{border:"1px solid #dde0ea",borderRadius:6,padding:"4px 8px",fontSize:12,fontFamily:"inherit"}}>
              {["Self Consumption","Partial Home Backup","Whole Home Backup","Tesla Backup Switch","Enphase Meter Collar","N/A"].map(o=><option key={o}>{o}</option>)}
            </select>
          </div>
        </div>
      </div>
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16}}>
        <div style={{fontSize:11,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:12}}>Pre-Installation Checklist</div>
        {ESP_CHECKLIST.map(item=>(
          <ToggleField key={item.key} label={item.label} val={report.checklist[item.key]} onChange={v=>setCheck(item.key,v)}/>
        ))}
        <div style={{marginTop:12}}>
          <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Pre-existing conditions notes</div>
          <textarea value={report.preNotes||""} onChange={e=>setField("preNotes",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:8,fontSize:12,fontFamily:"inherit",resize:"vertical",minHeight:60}}/>
        </div>
      </div>
    </div>}

    {activeSection==="photos"&&<div>
      {PHOTO_SECTIONS.map(section=>(
        <div key={section} style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:14,marginBottom:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div style={{fontSize:12,fontWeight:700,color:"#1a1d25"}}>{section}</div>
            <label style={{background:"#f0a500",border:"none",borderRadius:6,color:"#000",fontWeight:700,fontSize:11,padding:"5px 12px",cursor:"pointer",fontFamily:"inherit"}}>
              {uploading[section]?"Uploading...":"📷 Add Photo"}
              <input type="file" accept="image/*"  multiple onChange={e=>handlePhotoUpload(section,Array.from(e.target.files))} style={{display:"none"}}/>
            </label>
          </div>
          {(report.photos[section]||[]).length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {(report.photos[section]||[]).map((url,i)=>(
              <div key={i} style={{position:"relative"}}>
                <img src={url} alt={section} style={{width:80,height:80,objectFit:"cover",borderRadius:6,border:"1px solid #e0e3eb"}}/>
                <button onClick={()=>setReport(r=>({...r,photos:{...r.photos,[section]:(r.photos[section]||[]).filter((_,j)=>j!==i)}}))} style={{position:"absolute",top:-6,right:-6,background:"#ef4444",border:"none",borderRadius:"50%",color:"#fff",width:18,height:18,fontSize:10,cursor:"pointer",lineHeight:"18px",padding:0}}>✕</button>
              </div>
            ))}
          </div>}
        </div>
      ))}
    </div>}

    {activeSection==="post"&&<div>
      <div style={{background:"#fff",border:"1px solid #e0e3eb",borderRadius:10,padding:16,marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,color:"#d4891f",textTransform:"uppercase",marginBottom:12}}>Post-Installation Review</div>
        {POST_CHECKLIST.map(item=>(
          <ToggleField key={item.key} label={item.label} val={report.postChecklist[item.key]} onChange={v=>setPostCheck(item.key,v)} photoKey={"post_"+item.key}/>
        ))}
        <div style={{marginTop:12,display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <div>
            <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Tiles broken (qty)</div>
            <input type="number" value={report.tilesBrokenQty||0} onChange={e=>setField("tilesBrokenQty",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"inherit"}}/>
          </div>
          <div>
            <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Return date (if needed)</div>
            <input type="date" value={report.returnDate||""} onChange={e=>setField("returnDate",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"inherit"}}/>
          </div>
        </div>
        <div style={{marginTop:10}}>
          <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>Property damage comments</div>
          <textarea value={report.damageNotes||""} onChange={e=>setField("damageNotes",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:8,fontSize:12,fontFamily:"inherit",resize:"vertical",minHeight:60}}/>
        </div>
        <div style={{marginTop:10}}>
          <div style={{fontSize:10,color:"#9aa0b4",marginBottom:4}}>CT Notes</div>
          <textarea value={report.ctNotes||""} onChange={e=>setField("ctNotes",e.target.value)} style={{width:"100%",border:"1px solid #dde0ea",borderRadius:6,padding:8,fontSize:12,fontFamily:"inherit",resize:"vertical",minHeight:60}}/>
        </div>
      </div>
    </div>}
  </div>;
}


function InstallReportsList({ jobs, workOrders, installReports, setInstallReports }) {
  const [view, setView] = React.useState("list"); // list | form
  const [selectedJob, setSelectedJob] = React.useState(null);
  const [selectedWO, setSelectedWO] = React.useState(null);

  const getJob = (report) => jobs.find(j => String(j._dbId) === String(report.jobId));

  const s = {
    wrap: { padding: 20, fontFamily: "Arial, sans-serif", maxWidth: 1100 },
    row: { background: "#fff", border: "1px solid #e0e3eb", borderRadius: 10, padding: "14px 16px", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" },
    lbl: { fontSize: 10, color: "#9aa0b4", textTransform: "uppercase", letterSpacing: ".04em" },
    val: { fontSize: 13, fontWeight: 600, color: "#1a1d25" },
    btn: { padding: "5px 12px", border: "1px solid #dde0ea", borderRadius: 6, background: "transparent", cursor: "pointer", fontSize: 12, fontFamily: "inherit" },
    btnP: { padding: "5px 12px", border: "none", borderRadius: 6, background: "#1F3864", color: "#fff", cursor: "pointer", fontSize: 12, fontFamily: "inherit" },
  };

  if (view === "form" && selectedJob) {
    return (
      <div style={{ padding: 20 }}>
        <button style={{ ...s.btn, marginBottom: 16 }} onClick={() => { setView("list"); setSelectedJob(null); setSelectedWO(null); }}>← Back to Reports</button>
        <InstallReport job={selectedJob} wo={selectedWO}
          onSaved={async () => {
            const res = await dbLoad("installation_reports");
            if(res) setInstallReports(res);
          }}
          onClose={() => { setView("list"); setSelectedJob(null); setSelectedWO(null); }} />
      </div>
    );
  }

  return (
    <div style={s.wrap}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ color: "#1F3864", margin: 0 }}>📋 Installation Reports</h2>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 12, color: "#6a7080" }}>{installReports.length} reports on file</span>
          <select style={{ fontSize: 13, padding: "7px 12px", border: "1px solid #dde0ea", borderRadius: 7, fontFamily: "inherit" }}
            value=""
            onChange={e => {
              const wo = workOrders.find(w => String(w._dbId) === e.target.value);
              if(wo) {
                const job = jobs.find(j => String(j._dbId) === String(wo.jobId));
                if(job) { setSelectedJob(job); setSelectedWO(wo); setView("form"); }
                else alert("No job linked to this Work Order. Please link a job first.");
              }
            }}>
            <option value="">+ New Install Report from WO</option>
            {[...workOrders].sort((a,b)=>(a.woId||"").localeCompare(b.woId||"")).map(w => (
              <option key={w._dbId} value={w._dbId}>{w.woId} — {w.customerName}{w.date ? " · " + w.date : ""}</option>
            ))}
          </select>
        </div>
      </div>

      {installReports.length === 0 && (
        <div style={{ textAlign: "center", color: "#9aa0b4", padding: 60, border: "2px dashed #dde0ea", borderRadius: 10 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
          <div style={{ fontSize: 14, marginBottom: 4 }}>No installation reports yet</div>
          <div style={{ fontSize: 12, marginBottom: 16 }}>Select a job below to create one</div>
          <div style={{ fontSize: 12, color: "#9aa0b4" }}>Use the dropdown in the top right to start</div>
        </div>
      )}

      {[...installReports].reverse().map((report, i) => {
        const job = getJob(report);
        const photoCount = Object.values(report.photos || {}).reduce((s, arr) => s + (arr||[]).length, 0);
        const checkCount = Object.values(report.checklist || {}).filter(Boolean).length;
        return (
          <div key={i} style={s.row}>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1.5fr 1fr 1fr 1fr", gap: 16, flex: 1 }}>
              <div>
                <div style={s.lbl}>Customer</div>
                <div style={s.val}>{job ? job.customerName : report.jobId}</div>
                {job && <div style={{ fontSize: 11, color: "#6a7080" }}>{job.address}</div>}
              </div>
              <div>
                <div style={s.lbl}>EPC Partner</div>
                <div style={s.val}>{job ? (job.epcPartnerName || "—") : "—"}</div>
                {job && job.epcCustomerId && <div style={{ fontSize: 11, color: "#6a7080" }}>Job # {job.epcCustomerId}</div>}
              </div>
              <div>
                <div style={s.lbl}>Checklist</div>
                <div style={s.val}>{checkCount} items</div>
              </div>
              <div>
                <div style={s.lbl}>Photos</div>
                <div style={s.val}>{photoCount} photos</div>
              </div>
              <div>
                <div style={s.lbl}>Status</div>
                <span style={{ background: "#22c55e20", color: "#15803d", borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>✓ On File</span>
              </div>
            </div>
            <div style={{ display: "flex", gap: 6, marginLeft: 16 }}>
              <button style={s.btnP} onClick={() => { if(job) { setSelectedJob(job); setView("form"); } }}>📋 Open</button>
            </div>
          </div>
        );
      })}
        </div>
  );
}

// ── Field Report (public, no login) — loads WO by token, renders real WOReport
function FieldReportPage({ token }) {
  const [wo, setWo] = React.useState(null);
  const [jobs, setJobs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notFound, setNotFound] = React.useState(false);

  React.useEffect(() => {
    async function load() {
      try {
        const [wos, allJobs] = await Promise.all([dbLoad("work_orders"), dbLoad("jobs")]);
        const found = wos.find(w => w.reportToken === token);
        if (!found) { setNotFound(true); setLoading(false); return; }
        setWo(found);
        setJobs(allJobs);
      } catch(e) { setNotFound(true); }
      setLoading(false);
    }
    load();
  }, [token]);

  const center = { minHeight:"100vh", background:"#f5f6fa", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif" };

  if (loading) return <div style={center}><div style={{textAlign:"center",color:"#6a7080"}}><div style={{fontSize:36,marginBottom:12}}>⏳</div><div style={{fontWeight:600}}>Loading your report...</div></div></div>;
  if (notFound) return (
    <div style={center}>
      <div style={{textAlign:"center",background:"#fff",borderRadius:16,padding:40,boxShadow:"0 4px 20px rgba(0,0,0,0.08)",maxWidth:360,margin:"0 20px"}}>
        <div style={{fontSize:48,marginBottom:12}}>🔗</div>
        <div style={{fontWeight:700,fontSize:18,color:"#1a1d25",marginBottom:6}}>Invalid Link</div>
        <div style={{fontSize:13,color:"#6a7080"}}>This report link is invalid or has expired. Contact Suntrify for a new link.</div>
      </div>
    </div>
  );

  // Render the exact same WOReport used inside the CRM, no login needed
  return <WOReport wo={wo} jobs={jobs} onClose={()=>{}} publicMode={true} />;
}


function AppWrapperInner() {
  const [darkMode, setDarkMode] = React.useState(() => localStorage.getItem("suntrify_dark") === "1");
  const [globalSearch, setGlobalSearch] = React.useState(false);
  React.useEffect(() => {
    localStorage.setItem("suntrify_dark", darkMode ? "1" : "0");
    document.body.style.background = darkMode ? "#0f1117" : "#f5f6fa";
    document.body.style.color = darkMode ? "#e2e8f0" : "#1a1d25";
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    // Inject/update dark mode styles
    let s = document.getElementById("suntrify-dark-css");
    if (!s) { s = document.createElement("style"); s.id = "suntrify-dark-css"; document.head.appendChild(s); }
    s.textContent = darkMode ? `
      body.dark-mode, body.dark-mode #root { background: #0f1117 !important; }
      body.dark-mode [style*="background: rgb(255, 255, 255)"],
      body.dark-mode [style*="background: white"] { background: #1a1d25 !important; }
      body.dark-mode [style*="background: rgb(245, 246, 250)"],
      body.dark-mode [style*="background: rgb(249, 249, 251)"] { background: #131720 !important; }
      body.dark-mode [style*="background: rgb(240, 241, 245)"] { background: #1e2433 !important; }
      body.dark-mode [style*="color: rgb(26, 29, 37)"] { color: #e2e8f0 !important; }
      body.dark-mode [style*="color: rgb(106, 112, 128)"],
      body.dark-mode [style*="color: rgb(154, 160, 180)"] { color: #64748b !important; }
      body.dark-mode [style*="border: 1px solid rgb(224, 227, 235)"],
      body.dark-mode [style*="border-right: 1px solid rgb(224, 227, 235)"],
      body.dark-mode [style*="border-bottom: 1px solid rgb(224, 227, 235)"] { border-color: #2d3748 !important; }
      body.dark-mode input, body.dark-mode select, body.dark-mode textarea {
        background: #1a1d25 !important; color: #e2e8f0 !important; border-color: #2d3748 !important;
      }
    ` : "";
  }, [darkMode]);
  const [currentUser, setCurrentUser] = useState(() => loadSession());

  if (!currentUser) return <LoginScreen onLogin={user => setCurrentUser(user)} />;

  return <App currentUser={currentUser} onLogout={() => { clearSession(); setCurrentUser(null); }} darkMode={darkMode} setDarkMode={setDarkMode} globalSearch={globalSearch} setGlobalSearch={setGlobalSearch}/>;
}
function DocViewerPage({ docKey }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const logo = "https://crm.suntrify.com/SUNTRIFY_LOGO.png";

  const handleOpen = async () => {
    if (!username || !password) { setError("Enter your username and password"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch("https://x01zwa0olf.execute-api.us-east-2.amazonaws.com/prod/docs/view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, key: docKey }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Invalid credentials"); return; }
      window.location.href = data.url;
    } catch(e) { setError("Network error — try again"); }
    finally { setLoading(false); }
  };

  const IS = { width:"100%", padding:"10px 12px", border:"1px solid #dde0ea", borderRadius:7, fontSize:14, fontFamily:"inherit", boxSizing:"border-box", marginBottom:10 };
  return (
    <div style={{ minHeight:"100vh", background:"#f0f2f5", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Helvetica,Arial,sans-serif" }}>
      <div style={{ background:"#fff", borderRadius:12, padding:"36px 32px", width:"100%", maxWidth:380, boxShadow:"0 4px 24px rgba(0,0,0,0.10)" }}>
        <img src={logo} alt="Suntrify" style={{ height:44, display:"block", margin:"0 auto 20px" }} />
        <div style={{ fontSize:15, fontWeight:700, color:"#1a1d25", textAlign:"center", marginBottom:4 }}>Secure Document Access</div>
        <div style={{ fontSize:12, color:"#9aa0b4", textAlign:"center", marginBottom:24 }}>Enter your Suntrify CRM credentials to view this document.</div>
        {error && <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:7, padding:"10px 14px", fontSize:13, color:"#dc2626", marginBottom:14 }}>{error}</div>}
        <input style={IS} placeholder="Username" value={username} onChange={e=>setUsername(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleOpen()} autoFocus />
        <input style={IS} type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleOpen()} />
        <button onClick={handleOpen} disabled={loading} style={{ width:"100%", padding:"11px 0", background:"#f0a500", color:"#000", border:"none", borderRadius:7, fontWeight:700, fontSize:14, cursor:"pointer", opacity:loading?0.6:1 }}>
          {loading ? "Verifying…" : "View Document"}
        </button>
        <div style={{ fontSize:11, color:"#9aa0b4", textAlign:"center", marginTop:14 }}>This link expires after 15 minutes once opened.</div>
      </div>
    </div>
  );
}

export default function AppWrapper() {
  const params = new URLSearchParams(window.location.search);
  const reportToken = params.get("report");
  const docKey = params.get("doc");
  if (reportToken) return <FieldReportPage token={reportToken} />;
  if (docKey) return <DocViewerPage docKey={decodeURIComponent(docKey)} />;
  return <AppWrapperInner />;
}
